(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire31b8"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire31b8"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("loChl", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $f939883a526529ee$export$ffb0004e005737fa; }, function (v) { return $f939883a526529ee$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "StrictMode", function () { return $f939883a526529ee$export$5f8d39834fd61797; }, function (v) { return $f939883a526529ee$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Profiler", function () { return $f939883a526529ee$export$e2c29f18771995cb; }, function (v) { return $f939883a526529ee$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "Suspense", function () { return $f939883a526529ee$export$74bf444e3cd11ea5; }, function (v) { return $f939883a526529ee$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "Children", function () { return $f939883a526529ee$export$dca3b0875bd9a954; }, function (v) { return $f939883a526529ee$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $f939883a526529ee$export$16fa2f45be04daa8; }, function (v) { return $f939883a526529ee$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "PureComponent", function () { return $f939883a526529ee$export$221d75b3f55bb0bd; }, function (v) { return $f939883a526529ee$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $f939883a526529ee$export$ae55be85d98224ed; }, function (v) { return $f939883a526529ee$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $f939883a526529ee$export$e530037191fcd5d7; }, function (v) { return $f939883a526529ee$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $f939883a526529ee$export$fd42f52fd3ae1109; }, function (v) { return $f939883a526529ee$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $f939883a526529ee$export$c8a8987d4410bf2d; }, function (v) { return $f939883a526529ee$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $f939883a526529ee$export$d38cd72104c1f0e9; }, function (v) { return $f939883a526529ee$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $f939883a526529ee$export$7d1e3a5e95ceca43; }, function (v) { return $f939883a526529ee$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $f939883a526529ee$export$257a8862b851cb5b; }, function (v) { return $f939883a526529ee$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $f939883a526529ee$export$a8257692ac88316c; }, function (v) { return $f939883a526529ee$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $f939883a526529ee$export$488013bae63b21da; }, function (v) { return $f939883a526529ee$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $f939883a526529ee$export$7c73462e0d25e514; }, function (v) { return $f939883a526529ee$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $f939883a526529ee$export$35808ee640e87ca7; }, function (v) { return $f939883a526529ee$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $f939883a526529ee$export$fae74005e78b1a27; }, function (v) { return $f939883a526529ee$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $f939883a526529ee$export$dc8fbce3eb94dc1e; }, function (v) { return $f939883a526529ee$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $f939883a526529ee$export$6d9c69b0de29b591; }, function (v) { return $f939883a526529ee$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $f939883a526529ee$export$d5a552a76deda3c2; }, function (v) { return $f939883a526529ee$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $f939883a526529ee$export$e5c5a5f917a5871c; }, function (v) { return $f939883a526529ee$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $f939883a526529ee$export$1538c33de8887b59; }, function (v) { return $f939883a526529ee$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $f939883a526529ee$export$13e3392192263954; }, function (v) { return $f939883a526529ee$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $f939883a526529ee$export$b8f5890fc79d6aca; }, function (v) { return $f939883a526529ee$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $f939883a526529ee$export$60241385465d0a34; }, function (v) { return $f939883a526529ee$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $f939883a526529ee$export$83d89fbfd8236492; }, function (v) { return $f939883a526529ee$export$83d89fbfd8236492 = v; });
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f939883a526529ee$export$ffb0004e005737fa;
var $f939883a526529ee$export$5f8d39834fd61797;
var $f939883a526529ee$export$e2c29f18771995cb;
var $f939883a526529ee$export$74bf444e3cd11ea5;
var $f939883a526529ee$export$dca3b0875bd9a954;
var $f939883a526529ee$export$16fa2f45be04daa8;
var $f939883a526529ee$export$221d75b3f55bb0bd;
var $f939883a526529ee$export$ae55be85d98224ed;
var $f939883a526529ee$export$e530037191fcd5d7;
var $f939883a526529ee$export$fd42f52fd3ae1109;
var $f939883a526529ee$export$c8a8987d4410bf2d;
var $f939883a526529ee$export$d38cd72104c1f0e9;
var $f939883a526529ee$export$7d1e3a5e95ceca43;
var $f939883a526529ee$export$257a8862b851cb5b;
var $f939883a526529ee$export$a8257692ac88316c;
var $f939883a526529ee$export$488013bae63b21da;
var $f939883a526529ee$export$7c73462e0d25e514;
var $f939883a526529ee$export$35808ee640e87ca7;
var $f939883a526529ee$export$fae74005e78b1a27;
var $f939883a526529ee$export$dc8fbce3eb94dc1e;
var $f939883a526529ee$export$6d9c69b0de29b591;
var $f939883a526529ee$export$d5a552a76deda3c2;
var $f939883a526529ee$export$e5c5a5f917a5871c;
var $f939883a526529ee$export$1538c33de8887b59;
var $f939883a526529ee$export$13e3392192263954;
var $f939883a526529ee$export$b8f5890fc79d6aca;
var $f939883a526529ee$export$60241385465d0a34;
var $f939883a526529ee$export$83d89fbfd8236492;
"use strict";

var $d5wuQ = parcelRequire("d5wuQ");
var $f939883a526529ee$var$n = 60103, $f939883a526529ee$var$p = 60106;
$f939883a526529ee$export$ffb0004e005737fa = 60107;
$f939883a526529ee$export$5f8d39834fd61797 = 60108;
$f939883a526529ee$export$e2c29f18771995cb = 60114;
var $f939883a526529ee$var$q = 60109, $f939883a526529ee$var$r = 60110, $f939883a526529ee$var$t = 60112;
$f939883a526529ee$export$74bf444e3cd11ea5 = 60113;
var $f939883a526529ee$var$u = 60115, $f939883a526529ee$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $f939883a526529ee$var$w = Symbol.for;
    $f939883a526529ee$var$n = $f939883a526529ee$var$w("react.element");
    $f939883a526529ee$var$p = $f939883a526529ee$var$w("react.portal");
    $f939883a526529ee$export$ffb0004e005737fa = $f939883a526529ee$var$w("react.fragment");
    $f939883a526529ee$export$5f8d39834fd61797 = $f939883a526529ee$var$w("react.strict_mode");
    $f939883a526529ee$export$e2c29f18771995cb = $f939883a526529ee$var$w("react.profiler");
    $f939883a526529ee$var$q = $f939883a526529ee$var$w("react.provider");
    $f939883a526529ee$var$r = $f939883a526529ee$var$w("react.context");
    $f939883a526529ee$var$t = $f939883a526529ee$var$w("react.forward_ref");
    $f939883a526529ee$export$74bf444e3cd11ea5 = $f939883a526529ee$var$w("react.suspense");
    $f939883a526529ee$var$u = $f939883a526529ee$var$w("react.memo");
    $f939883a526529ee$var$v = $f939883a526529ee$var$w("react.lazy");
}
var $f939883a526529ee$var$x = "function" === typeof Symbol && Symbol.iterator;
function $f939883a526529ee$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $f939883a526529ee$var$x && a[$f939883a526529ee$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $f939883a526529ee$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $f939883a526529ee$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $f939883a526529ee$var$B = {};
function $f939883a526529ee$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $f939883a526529ee$var$B;
    this.updater = c || $f939883a526529ee$var$A;
}
$f939883a526529ee$var$C.prototype.isReactComponent = {};
$f939883a526529ee$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($f939883a526529ee$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$f939883a526529ee$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $f939883a526529ee$var$D() {}
$f939883a526529ee$var$D.prototype = $f939883a526529ee$var$C.prototype;
function $f939883a526529ee$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $f939883a526529ee$var$B;
    this.updater = c || $f939883a526529ee$var$A;
}
var $f939883a526529ee$var$F = $f939883a526529ee$var$E.prototype = new $f939883a526529ee$var$D;
$f939883a526529ee$var$F.constructor = $f939883a526529ee$var$E;
$d5wuQ($f939883a526529ee$var$F, $f939883a526529ee$var$C.prototype);
$f939883a526529ee$var$F.isPureReactComponent = !0;
var $f939883a526529ee$var$G = {
    current: null
}, $f939883a526529ee$var$H = Object.prototype.hasOwnProperty, $f939883a526529ee$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $f939883a526529ee$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$f939883a526529ee$var$H.call(b, e) && !$f939883a526529ee$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $f939883a526529ee$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $f939883a526529ee$var$G.current
    };
}
function $f939883a526529ee$var$K(a, b) {
    return {
        $$typeof: $f939883a526529ee$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $f939883a526529ee$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $f939883a526529ee$var$n;
}
function $f939883a526529ee$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $f939883a526529ee$var$M = /\/+/g;
function $f939883a526529ee$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $f939883a526529ee$var$escape("" + a.key) : b.toString(36);
}
function $f939883a526529ee$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $f939883a526529ee$var$n:
                case $f939883a526529ee$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $f939883a526529ee$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($f939883a526529ee$var$M, "$&/") + "/"), $f939883a526529ee$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($f939883a526529ee$var$L(d) && (d = $f939883a526529ee$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($f939883a526529ee$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $f939883a526529ee$var$N(k, g);
        h += $f939883a526529ee$var$O(k, b, c, f, d);
    }
    else if (f = $f939883a526529ee$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $f939883a526529ee$var$N(k, g++), h += $f939883a526529ee$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($f939883a526529ee$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $f939883a526529ee$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $f939883a526529ee$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $f939883a526529ee$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $f939883a526529ee$var$R = {
    current: null
};
function $f939883a526529ee$var$S() {
    var a = $f939883a526529ee$var$R.current;
    if (null === a) throw Error($f939883a526529ee$var$z(321));
    return a;
}
var $f939883a526529ee$var$T = {
    ReactCurrentDispatcher: $f939883a526529ee$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $f939883a526529ee$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $d5wuQ
};
$f939883a526529ee$export$dca3b0875bd9a954 = {
    map: $f939883a526529ee$var$P,
    forEach: function(a, b, c) {
        $f939883a526529ee$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $f939883a526529ee$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $f939883a526529ee$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$f939883a526529ee$var$L(a)) throw Error($f939883a526529ee$var$z(143));
        return a;
    }
};
$f939883a526529ee$export$16fa2f45be04daa8 = $f939883a526529ee$var$C;
$f939883a526529ee$export$221d75b3f55bb0bd = $f939883a526529ee$var$E;
$f939883a526529ee$export$ae55be85d98224ed = $f939883a526529ee$var$T;
$f939883a526529ee$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($f939883a526529ee$var$z(267, a));
    var e = $d5wuQ({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $f939883a526529ee$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$f939883a526529ee$var$H.call(b, f) && !$f939883a526529ee$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $f939883a526529ee$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$f939883a526529ee$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $f939883a526529ee$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $f939883a526529ee$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$f939883a526529ee$export$c8a8987d4410bf2d = $f939883a526529ee$var$J;
$f939883a526529ee$export$d38cd72104c1f0e9 = function(a) {
    var b = $f939883a526529ee$var$J.bind(null, a);
    b.type = a;
    return b;
};
$f939883a526529ee$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$f939883a526529ee$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $f939883a526529ee$var$t,
        render: a
    };
};
$f939883a526529ee$export$a8257692ac88316c = $f939883a526529ee$var$L;
$f939883a526529ee$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $f939883a526529ee$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $f939883a526529ee$var$Q
    };
};
$f939883a526529ee$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $f939883a526529ee$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$f939883a526529ee$export$35808ee640e87ca7 = function(a, b) {
    return $f939883a526529ee$var$S().useCallback(a, b);
};
$f939883a526529ee$export$fae74005e78b1a27 = function(a, b) {
    return $f939883a526529ee$var$S().useContext(a, b);
};
$f939883a526529ee$export$dc8fbce3eb94dc1e = function() {};
$f939883a526529ee$export$6d9c69b0de29b591 = function(a, b) {
    return $f939883a526529ee$var$S().useEffect(a, b);
};
$f939883a526529ee$export$d5a552a76deda3c2 = function(a, b, c) {
    return $f939883a526529ee$var$S().useImperativeHandle(a, b, c);
};
$f939883a526529ee$export$e5c5a5f917a5871c = function(a, b) {
    return $f939883a526529ee$var$S().useLayoutEffect(a, b);
};
$f939883a526529ee$export$1538c33de8887b59 = function(a, b) {
    return $f939883a526529ee$var$S().useMemo(a, b);
};
$f939883a526529ee$export$13e3392192263954 = function(a, b, c) {
    return $f939883a526529ee$var$S().useReducer(a, b, c);
};
$f939883a526529ee$export$b8f5890fc79d6aca = function(a) {
    return $f939883a526529ee$var$S().useRef(a);
};
$f939883a526529ee$export$60241385465d0a34 = function(a) {
    return $f939883a526529ee$var$S().useState(a);
};
$f939883a526529ee$export$83d89fbfd8236492 = "17.0.2";

});
parcelRegister("d5wuQ", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $9874f32010f8a739$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $9874f32010f8a739$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $9874f32010f8a739$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $9874f32010f8a739$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $9874f32010f8a739$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $9874f32010f8a739$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $9874f32010f8a739$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($9874f32010f8a739$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($9874f32010f8a739$var$getOwnPropertySymbols) {
            symbols = $9874f32010f8a739$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($9874f32010f8a739$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});


parcelRegister("h6zfF", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";

var $5zKJZ = parcelRequire("5zKJZ");

var $d5wuQ = parcelRequire("d5wuQ");

var $3BU8Z = parcelRequire("3BU8Z");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$5zKJZ) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $5zKJZ.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $d5wuQ({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $5zKJZ.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $d5wuQ({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $d5wuQ({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $d5wuQ({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $3BU8Z.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $3BU8Z.unstable_scheduleCallback($3BU8Z.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $3BU8Z.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $3BU8Z.unstable_UserBlockingPriority, ed = $3BU8Z.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $d5wuQ(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $d5wuQ({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $d5wuQ({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $d5wuQ({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $d5wuQ({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $d5wuQ({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $d5wuQ({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $d5wuQ({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $d5wuQ({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $d5wuQ({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $d5wuQ({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $d5wuQ({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $d5wuQ({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $d5wuQ({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $3BU8Z.unstable_runWithPriority, Of = $3BU8Z.unstable_scheduleCallback, Pf = $3BU8Z.unstable_cancelCallback, Qf = $3BU8Z.unstable_shouldYield, Rf = $3BU8Z.unstable_requestPaint, Sf = $3BU8Z.unstable_now, Tf = $3BU8Z.unstable_getCurrentPriorityLevel, Uf = $3BU8Z.unstable_ImmediatePriority, Vf = $3BU8Z.unstable_UserBlockingPriority, Wf = $3BU8Z.unstable_NormalPriority, Xf = $3BU8Z.unstable_LowPriority, Yf = $3BU8Z.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $d5wuQ({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $d5wuQ({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $5zKJZ.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $d5wuQ({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $d5wuQ({}, e, {
                    value: void 0
                });
                d = $d5wuQ({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $d5wuQ({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("5zKJZ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("loChl"));

});

parcelRegister("3BU8Z", function(module, exports) {
"use strict";

module.exports = (parcelRequire("iYR6w"));

});
parcelRegister("iYR6w", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $dd1705fafd2b54d3$export$c4744153514ff05d; }, function (v) { return $dd1705fafd2b54d3$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $dd1705fafd2b54d3$export$b5836b71941fa3ed; }, function (v) { return $dd1705fafd2b54d3$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $dd1705fafd2b54d3$export$d66a1c1c77bd778b; }, function (v) { return $dd1705fafd2b54d3$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $dd1705fafd2b54d3$export$3e506c1ccc9cc1a7; }, function (v) { return $dd1705fafd2b54d3$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $dd1705fafd2b54d3$export$e26fe2ed2fa76875; }, function (v) { return $dd1705fafd2b54d3$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $dd1705fafd2b54d3$export$502329bbf4b505b1; }, function (v) { return $dd1705fafd2b54d3$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $dd1705fafd2b54d3$export$6e3807111c4874c4; }, function (v) { return $dd1705fafd2b54d3$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $dd1705fafd2b54d3$export$c27134553091fb3a; }, function (v) { return $dd1705fafd2b54d3$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $dd1705fafd2b54d3$export$33ee1acdc04fd2a2; }, function (v) { return $dd1705fafd2b54d3$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $dd1705fafd2b54d3$export$b00a404bbd5edef2; }, function (v) { return $dd1705fafd2b54d3$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $dd1705fafd2b54d3$export$8352ce38b91d0c62; }, function (v) { return $dd1705fafd2b54d3$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $dd1705fafd2b54d3$export$d3dfb8e4810cb555; }, function (v) { return $dd1705fafd2b54d3$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $dd1705fafd2b54d3$export$839f9183b0465a69; }, function (v) { return $dd1705fafd2b54d3$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $dd1705fafd2b54d3$export$72fdf0e06517287b; }, function (v) { return $dd1705fafd2b54d3$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $dd1705fafd2b54d3$export$4b844e58a3e414b4; }, function (v) { return $dd1705fafd2b54d3$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $dd1705fafd2b54d3$export$816d2913ae6b83b1; }, function (v) { return $dd1705fafd2b54d3$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $dd1705fafd2b54d3$export$61bcfe829111a1d0; }, function (v) { return $dd1705fafd2b54d3$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $dd1705fafd2b54d3$export$7ee8c9beb337bc3f; }, function (v) { return $dd1705fafd2b54d3$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $dd1705fafd2b54d3$export$cf845f2c119da08a; }, function (v) { return $dd1705fafd2b54d3$export$cf845f2c119da08a = v; });
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dd1705fafd2b54d3$export$c4744153514ff05d;
var $dd1705fafd2b54d3$export$b5836b71941fa3ed;
var $dd1705fafd2b54d3$export$d66a1c1c77bd778b;
var $dd1705fafd2b54d3$export$3e506c1ccc9cc1a7;
var $dd1705fafd2b54d3$export$e26fe2ed2fa76875;
var $dd1705fafd2b54d3$export$502329bbf4b505b1;
var $dd1705fafd2b54d3$export$6e3807111c4874c4;
var $dd1705fafd2b54d3$export$c27134553091fb3a;
var $dd1705fafd2b54d3$export$33ee1acdc04fd2a2;
var $dd1705fafd2b54d3$export$b00a404bbd5edef2;
var $dd1705fafd2b54d3$export$8352ce38b91d0c62;
var $dd1705fafd2b54d3$export$d3dfb8e4810cb555;
var $dd1705fafd2b54d3$export$839f9183b0465a69;
var $dd1705fafd2b54d3$export$72fdf0e06517287b;
var $dd1705fafd2b54d3$export$4b844e58a3e414b4;
var $dd1705fafd2b54d3$export$816d2913ae6b83b1;
var $dd1705fafd2b54d3$export$61bcfe829111a1d0;
var $dd1705fafd2b54d3$export$7ee8c9beb337bc3f;
var $dd1705fafd2b54d3$export$cf845f2c119da08a;
"use strict";
var $dd1705fafd2b54d3$var$f, $dd1705fafd2b54d3$var$g, $dd1705fafd2b54d3$var$h, $dd1705fafd2b54d3$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $dd1705fafd2b54d3$var$l = performance;
    $dd1705fafd2b54d3$export$c4744153514ff05d = function() {
        return $dd1705fafd2b54d3$var$l.now();
    };
} else {
    var $dd1705fafd2b54d3$var$p = Date, $dd1705fafd2b54d3$var$q = $dd1705fafd2b54d3$var$p.now();
    $dd1705fafd2b54d3$export$c4744153514ff05d = function() {
        return $dd1705fafd2b54d3$var$p.now() - $dd1705fafd2b54d3$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $dd1705fafd2b54d3$var$t = null, $dd1705fafd2b54d3$var$u = null, $dd1705fafd2b54d3$var$w = function() {
        if (null !== $dd1705fafd2b54d3$var$t) try {
            var a = $dd1705fafd2b54d3$export$c4744153514ff05d();
            $dd1705fafd2b54d3$var$t(!0, a);
            $dd1705fafd2b54d3$var$t = null;
        } catch (b) {
            throw setTimeout($dd1705fafd2b54d3$var$w, 0), b;
        }
    };
    $dd1705fafd2b54d3$var$f = function(a) {
        null !== $dd1705fafd2b54d3$var$t ? setTimeout($dd1705fafd2b54d3$var$f, 0, a) : ($dd1705fafd2b54d3$var$t = a, setTimeout($dd1705fafd2b54d3$var$w, 0));
    };
    $dd1705fafd2b54d3$var$g = function(a, b) {
        $dd1705fafd2b54d3$var$u = setTimeout(a, b);
    };
    $dd1705fafd2b54d3$var$h = function() {
        clearTimeout($dd1705fafd2b54d3$var$u);
    };
    $dd1705fafd2b54d3$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $dd1705fafd2b54d3$var$k = $dd1705fafd2b54d3$export$d66a1c1c77bd778b = function() {};
} else {
    var $dd1705fafd2b54d3$var$x = window.setTimeout, $dd1705fafd2b54d3$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $dd1705fafd2b54d3$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $dd1705fafd2b54d3$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $dd1705fafd2b54d3$var$A = !1, $dd1705fafd2b54d3$var$B = null, $dd1705fafd2b54d3$var$C = -1, $dd1705fafd2b54d3$var$D = 5, $dd1705fafd2b54d3$var$E = 0;
    $dd1705fafd2b54d3$export$b5836b71941fa3ed = function() {
        return $dd1705fafd2b54d3$export$c4744153514ff05d() >= $dd1705fafd2b54d3$var$E;
    };
    $dd1705fafd2b54d3$var$k = function() {};
    $dd1705fafd2b54d3$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $dd1705fafd2b54d3$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $dd1705fafd2b54d3$var$F = new MessageChannel, $dd1705fafd2b54d3$var$G = $dd1705fafd2b54d3$var$F.port2;
    $dd1705fafd2b54d3$var$F.port1.onmessage = function() {
        if (null !== $dd1705fafd2b54d3$var$B) {
            var a = $dd1705fafd2b54d3$export$c4744153514ff05d();
            $dd1705fafd2b54d3$var$E = a + $dd1705fafd2b54d3$var$D;
            try {
                $dd1705fafd2b54d3$var$B(!0, a) ? $dd1705fafd2b54d3$var$G.postMessage(null) : ($dd1705fafd2b54d3$var$A = !1, $dd1705fafd2b54d3$var$B = null);
            } catch (b) {
                throw $dd1705fafd2b54d3$var$G.postMessage(null), b;
            }
        } else $dd1705fafd2b54d3$var$A = !1;
    };
    $dd1705fafd2b54d3$var$f = function(a) {
        $dd1705fafd2b54d3$var$B = a;
        $dd1705fafd2b54d3$var$A || ($dd1705fafd2b54d3$var$A = !0, $dd1705fafd2b54d3$var$G.postMessage(null));
    };
    $dd1705fafd2b54d3$var$g = function(a, b) {
        $dd1705fafd2b54d3$var$C = $dd1705fafd2b54d3$var$x(function() {
            a($dd1705fafd2b54d3$export$c4744153514ff05d());
        }, b);
    };
    $dd1705fafd2b54d3$var$h = function() {
        $dd1705fafd2b54d3$var$y($dd1705fafd2b54d3$var$C);
        $dd1705fafd2b54d3$var$C = -1;
    };
}
function $dd1705fafd2b54d3$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $dd1705fafd2b54d3$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $dd1705fafd2b54d3$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $dd1705fafd2b54d3$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $dd1705fafd2b54d3$var$I(n, c)) void 0 !== r && 0 > $dd1705fafd2b54d3$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $dd1705fafd2b54d3$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $dd1705fafd2b54d3$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $dd1705fafd2b54d3$var$L = [], $dd1705fafd2b54d3$var$M = [], $dd1705fafd2b54d3$var$N = 1, $dd1705fafd2b54d3$var$O = null, $dd1705fafd2b54d3$var$P = 3, $dd1705fafd2b54d3$var$Q = !1, $dd1705fafd2b54d3$var$R = !1, $dd1705fafd2b54d3$var$S = !1;
function $dd1705fafd2b54d3$var$T(a) {
    for(var b = $dd1705fafd2b54d3$var$J($dd1705fafd2b54d3$var$M); null !== b;){
        if (null === b.callback) $dd1705fafd2b54d3$var$K($dd1705fafd2b54d3$var$M);
        else if (b.startTime <= a) $dd1705fafd2b54d3$var$K($dd1705fafd2b54d3$var$M), b.sortIndex = b.expirationTime, $dd1705fafd2b54d3$var$H($dd1705fafd2b54d3$var$L, b);
        else break;
        b = $dd1705fafd2b54d3$var$J($dd1705fafd2b54d3$var$M);
    }
}
function $dd1705fafd2b54d3$var$U(a) {
    $dd1705fafd2b54d3$var$S = !1;
    $dd1705fafd2b54d3$var$T(a);
    if (!$dd1705fafd2b54d3$var$R) {
        if (null !== $dd1705fafd2b54d3$var$J($dd1705fafd2b54d3$var$L)) $dd1705fafd2b54d3$var$R = !0, $dd1705fafd2b54d3$var$f($dd1705fafd2b54d3$var$V);
        else {
            var b = $dd1705fafd2b54d3$var$J($dd1705fafd2b54d3$var$M);
            null !== b && $dd1705fafd2b54d3$var$g($dd1705fafd2b54d3$var$U, b.startTime - a);
        }
    }
}
function $dd1705fafd2b54d3$var$V(a, b) {
    $dd1705fafd2b54d3$var$R = !1;
    $dd1705fafd2b54d3$var$S && ($dd1705fafd2b54d3$var$S = !1, $dd1705fafd2b54d3$var$h());
    $dd1705fafd2b54d3$var$Q = !0;
    var c = $dd1705fafd2b54d3$var$P;
    try {
        $dd1705fafd2b54d3$var$T(b);
        for($dd1705fafd2b54d3$var$O = $dd1705fafd2b54d3$var$J($dd1705fafd2b54d3$var$L); null !== $dd1705fafd2b54d3$var$O && (!($dd1705fafd2b54d3$var$O.expirationTime > b) || a && !$dd1705fafd2b54d3$export$b5836b71941fa3ed());){
            var d = $dd1705fafd2b54d3$var$O.callback;
            if ("function" === typeof d) {
                $dd1705fafd2b54d3$var$O.callback = null;
                $dd1705fafd2b54d3$var$P = $dd1705fafd2b54d3$var$O.priorityLevel;
                var e = d($dd1705fafd2b54d3$var$O.expirationTime <= b);
                b = $dd1705fafd2b54d3$export$c4744153514ff05d();
                "function" === typeof e ? $dd1705fafd2b54d3$var$O.callback = e : $dd1705fafd2b54d3$var$O === $dd1705fafd2b54d3$var$J($dd1705fafd2b54d3$var$L) && $dd1705fafd2b54d3$var$K($dd1705fafd2b54d3$var$L);
                $dd1705fafd2b54d3$var$T(b);
            } else $dd1705fafd2b54d3$var$K($dd1705fafd2b54d3$var$L);
            $dd1705fafd2b54d3$var$O = $dd1705fafd2b54d3$var$J($dd1705fafd2b54d3$var$L);
        }
        if (null !== $dd1705fafd2b54d3$var$O) var m = !0;
        else {
            var n = $dd1705fafd2b54d3$var$J($dd1705fafd2b54d3$var$M);
            null !== n && $dd1705fafd2b54d3$var$g($dd1705fafd2b54d3$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $dd1705fafd2b54d3$var$O = null, $dd1705fafd2b54d3$var$P = c, $dd1705fafd2b54d3$var$Q = !1;
    }
}
var $dd1705fafd2b54d3$var$W = $dd1705fafd2b54d3$var$k;
$dd1705fafd2b54d3$export$3e506c1ccc9cc1a7 = 5;
$dd1705fafd2b54d3$export$e26fe2ed2fa76875 = 1;
$dd1705fafd2b54d3$export$502329bbf4b505b1 = 4;
$dd1705fafd2b54d3$export$6e3807111c4874c4 = 3;
$dd1705fafd2b54d3$export$c27134553091fb3a = null;
$dd1705fafd2b54d3$export$33ee1acdc04fd2a2 = 2;
$dd1705fafd2b54d3$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$dd1705fafd2b54d3$export$8352ce38b91d0c62 = function() {
    $dd1705fafd2b54d3$var$R || $dd1705fafd2b54d3$var$Q || ($dd1705fafd2b54d3$var$R = !0, $dd1705fafd2b54d3$var$f($dd1705fafd2b54d3$var$V));
};
$dd1705fafd2b54d3$export$d3dfb8e4810cb555 = function() {
    return $dd1705fafd2b54d3$var$P;
};
$dd1705fafd2b54d3$export$839f9183b0465a69 = function() {
    return $dd1705fafd2b54d3$var$J($dd1705fafd2b54d3$var$L);
};
$dd1705fafd2b54d3$export$72fdf0e06517287b = function(a) {
    switch($dd1705fafd2b54d3$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $dd1705fafd2b54d3$var$P;
    }
    var c = $dd1705fafd2b54d3$var$P;
    $dd1705fafd2b54d3$var$P = b;
    try {
        return a();
    } finally{
        $dd1705fafd2b54d3$var$P = c;
    }
};
$dd1705fafd2b54d3$export$4b844e58a3e414b4 = function() {};
$dd1705fafd2b54d3$export$816d2913ae6b83b1 = $dd1705fafd2b54d3$var$W;
$dd1705fafd2b54d3$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $dd1705fafd2b54d3$var$P;
    $dd1705fafd2b54d3$var$P = a;
    try {
        return b();
    } finally{
        $dd1705fafd2b54d3$var$P = c;
    }
};
$dd1705fafd2b54d3$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $dd1705fafd2b54d3$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $dd1705fafd2b54d3$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $dd1705fafd2b54d3$var$H($dd1705fafd2b54d3$var$M, a), null === $dd1705fafd2b54d3$var$J($dd1705fafd2b54d3$var$L) && a === $dd1705fafd2b54d3$var$J($dd1705fafd2b54d3$var$M) && ($dd1705fafd2b54d3$var$S ? $dd1705fafd2b54d3$var$h() : $dd1705fafd2b54d3$var$S = !0, $dd1705fafd2b54d3$var$g($dd1705fafd2b54d3$var$U, c - d))) : (a.sortIndex = e, $dd1705fafd2b54d3$var$H($dd1705fafd2b54d3$var$L, a), $dd1705fafd2b54d3$var$R || $dd1705fafd2b54d3$var$Q || ($dd1705fafd2b54d3$var$R = !0, $dd1705fafd2b54d3$var$f($dd1705fafd2b54d3$var$V)));
    return a;
};
$dd1705fafd2b54d3$export$cf845f2c119da08a = function(a) {
    var b = $dd1705fafd2b54d3$var$P;
    return function() {
        var c = $dd1705fafd2b54d3$var$P;
        $dd1705fafd2b54d3$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $dd1705fafd2b54d3$var$P = c;
        }
    };
};

});



parcelRegister("7w8Ih", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $a5lr1 = parcelRequire("a5lr1");
function $579247cca877df20$var$emptyFunction() {}
function $579247cca877df20$var$emptyFunctionWithReset() {}
$579247cca877df20$var$emptyFunctionWithReset.resetWarningCache = $579247cca877df20$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $a5lr1) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $579247cca877df20$var$emptyFunctionWithReset,
        resetWarningCache: $579247cca877df20$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("a5lr1", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $757aff8b46fb2b7e$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $757aff8b46fb2b7e$var$ReactPropTypesSecret;

});


parcelRegister("dP366", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $a10270dc51ce7eb3$export$2b8d127b894957b9; }, function (v) { return $a10270dc51ce7eb3$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $a10270dc51ce7eb3$export$cea3a54a6425200c; }, function (v) { return $a10270dc51ce7eb3$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $a10270dc51ce7eb3$export$a7c73072b1a182ae; }, function (v) { return $a10270dc51ce7eb3$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $a10270dc51ce7eb3$export$9f27bc3417b4524d; }, function (v) { return $a10270dc51ce7eb3$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $a10270dc51ce7eb3$export$db77ccec0bb4ccac; }, function (v) { return $a10270dc51ce7eb3$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $a10270dc51ce7eb3$export$8392c0c9d3dcbd35; }, function (v) { return $a10270dc51ce7eb3$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $a10270dc51ce7eb3$export$ffb0004e005737fa; }, function (v) { return $a10270dc51ce7eb3$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $a10270dc51ce7eb3$export$b624eff549462981; }, function (v) { return $a10270dc51ce7eb3$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $a10270dc51ce7eb3$export$7897aa7841a5380c; }, function (v) { return $a10270dc51ce7eb3$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $a10270dc51ce7eb3$export$602eac185826482c; }, function (v) { return $a10270dc51ce7eb3$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $a10270dc51ce7eb3$export$e2c29f18771995cb; }, function (v) { return $a10270dc51ce7eb3$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $a10270dc51ce7eb3$export$5f8d39834fd61797; }, function (v) { return $a10270dc51ce7eb3$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $a10270dc51ce7eb3$export$74bf444e3cd11ea5; }, function (v) { return $a10270dc51ce7eb3$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $a10270dc51ce7eb3$export$92387174baf9b227; }, function (v) { return $a10270dc51ce7eb3$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $a10270dc51ce7eb3$export$ec112efeb987d9c6; }, function (v) { return $a10270dc51ce7eb3$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $a10270dc51ce7eb3$export$b706b080d889d2c9; }, function (v) { return $a10270dc51ce7eb3$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $a10270dc51ce7eb3$export$5be5a87408f70ddc; }, function (v) { return $a10270dc51ce7eb3$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $a10270dc51ce7eb3$export$45a5e7f76e0caa8d; }, function (v) { return $a10270dc51ce7eb3$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $a10270dc51ce7eb3$export$455c2e768291efa6; }, function (v) { return $a10270dc51ce7eb3$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $a10270dc51ce7eb3$export$9522e17588c12572; }, function (v) { return $a10270dc51ce7eb3$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $a10270dc51ce7eb3$export$2110ac352bb060b9; }, function (v) { return $a10270dc51ce7eb3$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $a10270dc51ce7eb3$export$56885ab8b9c456ab; }, function (v) { return $a10270dc51ce7eb3$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $a10270dc51ce7eb3$export$d927fcb6adf8f9de; }, function (v) { return $a10270dc51ce7eb3$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $a10270dc51ce7eb3$export$b82d16f27459e05a; }, function (v) { return $a10270dc51ce7eb3$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $a10270dc51ce7eb3$export$522c17b4f5e123e8; }, function (v) { return $a10270dc51ce7eb3$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $a10270dc51ce7eb3$export$1aabd8a0274ecfd6; }, function (v) { return $a10270dc51ce7eb3$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $a10270dc51ce7eb3$export$9b621391a187a31a; }, function (v) { return $a10270dc51ce7eb3$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $a10270dc51ce7eb3$export$f5bbd400c2f4426f; }, function (v) { return $a10270dc51ce7eb3$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a10270dc51ce7eb3$export$2b8d127b894957b9;
var $a10270dc51ce7eb3$export$cea3a54a6425200c;
var $a10270dc51ce7eb3$export$a7c73072b1a182ae;
var $a10270dc51ce7eb3$export$9f27bc3417b4524d;
var $a10270dc51ce7eb3$export$db77ccec0bb4ccac;
var $a10270dc51ce7eb3$export$8392c0c9d3dcbd35;
var $a10270dc51ce7eb3$export$ffb0004e005737fa;
var $a10270dc51ce7eb3$export$b624eff549462981;
var $a10270dc51ce7eb3$export$7897aa7841a5380c;
var $a10270dc51ce7eb3$export$602eac185826482c;
var $a10270dc51ce7eb3$export$e2c29f18771995cb;
var $a10270dc51ce7eb3$export$5f8d39834fd61797;
var $a10270dc51ce7eb3$export$74bf444e3cd11ea5;
var $a10270dc51ce7eb3$export$92387174baf9b227;
var $a10270dc51ce7eb3$export$ec112efeb987d9c6;
var $a10270dc51ce7eb3$export$b706b080d889d2c9;
var $a10270dc51ce7eb3$export$5be5a87408f70ddc;
var $a10270dc51ce7eb3$export$45a5e7f76e0caa8d;
var $a10270dc51ce7eb3$export$455c2e768291efa6;
var $a10270dc51ce7eb3$export$9522e17588c12572;
var $a10270dc51ce7eb3$export$2110ac352bb060b9;
var $a10270dc51ce7eb3$export$56885ab8b9c456ab;
var $a10270dc51ce7eb3$export$d927fcb6adf8f9de;
var $a10270dc51ce7eb3$export$b82d16f27459e05a;
var $a10270dc51ce7eb3$export$522c17b4f5e123e8;
var $a10270dc51ce7eb3$export$1aabd8a0274ecfd6;
var $a10270dc51ce7eb3$export$9b621391a187a31a;
var $a10270dc51ce7eb3$export$f5bbd400c2f4426f;
"use strict";
var $a10270dc51ce7eb3$var$b = "function" === typeof Symbol && Symbol.for, $a10270dc51ce7eb3$var$c = $a10270dc51ce7eb3$var$b ? Symbol.for("react.element") : 60103, $a10270dc51ce7eb3$var$d = $a10270dc51ce7eb3$var$b ? Symbol.for("react.portal") : 60106, $a10270dc51ce7eb3$var$e = $a10270dc51ce7eb3$var$b ? Symbol.for("react.fragment") : 60107, $a10270dc51ce7eb3$var$f = $a10270dc51ce7eb3$var$b ? Symbol.for("react.strict_mode") : 60108, $a10270dc51ce7eb3$var$g = $a10270dc51ce7eb3$var$b ? Symbol.for("react.profiler") : 60114, $a10270dc51ce7eb3$var$h = $a10270dc51ce7eb3$var$b ? Symbol.for("react.provider") : 60109, $a10270dc51ce7eb3$var$k = $a10270dc51ce7eb3$var$b ? Symbol.for("react.context") : 60110, $a10270dc51ce7eb3$var$l = $a10270dc51ce7eb3$var$b ? Symbol.for("react.async_mode") : 60111, $a10270dc51ce7eb3$var$m = $a10270dc51ce7eb3$var$b ? Symbol.for("react.concurrent_mode") : 60111, $a10270dc51ce7eb3$var$n = $a10270dc51ce7eb3$var$b ? Symbol.for("react.forward_ref") : 60112, $a10270dc51ce7eb3$var$p = $a10270dc51ce7eb3$var$b ? Symbol.for("react.suspense") : 60113, $a10270dc51ce7eb3$var$q = $a10270dc51ce7eb3$var$b ? Symbol.for("react.suspense_list") : 60120, $a10270dc51ce7eb3$var$r = $a10270dc51ce7eb3$var$b ? Symbol.for("react.memo") : 60115, $a10270dc51ce7eb3$var$t = $a10270dc51ce7eb3$var$b ? Symbol.for("react.lazy") : 60116, $a10270dc51ce7eb3$var$v = $a10270dc51ce7eb3$var$b ? Symbol.for("react.block") : 60121, $a10270dc51ce7eb3$var$w = $a10270dc51ce7eb3$var$b ? Symbol.for("react.fundamental") : 60117, $a10270dc51ce7eb3$var$x = $a10270dc51ce7eb3$var$b ? Symbol.for("react.responder") : 60118, $a10270dc51ce7eb3$var$y = $a10270dc51ce7eb3$var$b ? Symbol.for("react.scope") : 60119;
function $a10270dc51ce7eb3$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $a10270dc51ce7eb3$var$c:
                switch(a = a.type, a){
                    case $a10270dc51ce7eb3$var$l:
                    case $a10270dc51ce7eb3$var$m:
                    case $a10270dc51ce7eb3$var$e:
                    case $a10270dc51ce7eb3$var$g:
                    case $a10270dc51ce7eb3$var$f:
                    case $a10270dc51ce7eb3$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $a10270dc51ce7eb3$var$k:
                            case $a10270dc51ce7eb3$var$n:
                            case $a10270dc51ce7eb3$var$t:
                            case $a10270dc51ce7eb3$var$r:
                            case $a10270dc51ce7eb3$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $a10270dc51ce7eb3$var$d:
                return u;
        }
    }
}
function $a10270dc51ce7eb3$var$A(a) {
    return $a10270dc51ce7eb3$var$z(a) === $a10270dc51ce7eb3$var$m;
}
$a10270dc51ce7eb3$export$2b8d127b894957b9 = $a10270dc51ce7eb3$var$l;
$a10270dc51ce7eb3$export$cea3a54a6425200c = $a10270dc51ce7eb3$var$m;
$a10270dc51ce7eb3$export$a7c73072b1a182ae = $a10270dc51ce7eb3$var$k;
$a10270dc51ce7eb3$export$9f27bc3417b4524d = $a10270dc51ce7eb3$var$h;
$a10270dc51ce7eb3$export$db77ccec0bb4ccac = $a10270dc51ce7eb3$var$c;
$a10270dc51ce7eb3$export$8392c0c9d3dcbd35 = $a10270dc51ce7eb3$var$n;
$a10270dc51ce7eb3$export$ffb0004e005737fa = $a10270dc51ce7eb3$var$e;
$a10270dc51ce7eb3$export$b624eff549462981 = $a10270dc51ce7eb3$var$t;
$a10270dc51ce7eb3$export$7897aa7841a5380c = $a10270dc51ce7eb3$var$r;
$a10270dc51ce7eb3$export$602eac185826482c = $a10270dc51ce7eb3$var$d;
$a10270dc51ce7eb3$export$e2c29f18771995cb = $a10270dc51ce7eb3$var$g;
$a10270dc51ce7eb3$export$5f8d39834fd61797 = $a10270dc51ce7eb3$var$f;
$a10270dc51ce7eb3$export$74bf444e3cd11ea5 = $a10270dc51ce7eb3$var$p;
$a10270dc51ce7eb3$export$92387174baf9b227 = function(a) {
    return $a10270dc51ce7eb3$var$A(a) || $a10270dc51ce7eb3$var$z(a) === $a10270dc51ce7eb3$var$l;
};
$a10270dc51ce7eb3$export$ec112efeb987d9c6 = $a10270dc51ce7eb3$var$A;
$a10270dc51ce7eb3$export$b706b080d889d2c9 = function(a) {
    return $a10270dc51ce7eb3$var$z(a) === $a10270dc51ce7eb3$var$k;
};
$a10270dc51ce7eb3$export$5be5a87408f70ddc = function(a) {
    return $a10270dc51ce7eb3$var$z(a) === $a10270dc51ce7eb3$var$h;
};
$a10270dc51ce7eb3$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $a10270dc51ce7eb3$var$c;
};
$a10270dc51ce7eb3$export$455c2e768291efa6 = function(a) {
    return $a10270dc51ce7eb3$var$z(a) === $a10270dc51ce7eb3$var$n;
};
$a10270dc51ce7eb3$export$9522e17588c12572 = function(a) {
    return $a10270dc51ce7eb3$var$z(a) === $a10270dc51ce7eb3$var$e;
};
$a10270dc51ce7eb3$export$2110ac352bb060b9 = function(a) {
    return $a10270dc51ce7eb3$var$z(a) === $a10270dc51ce7eb3$var$t;
};
$a10270dc51ce7eb3$export$56885ab8b9c456ab = function(a) {
    return $a10270dc51ce7eb3$var$z(a) === $a10270dc51ce7eb3$var$r;
};
$a10270dc51ce7eb3$export$d927fcb6adf8f9de = function(a) {
    return $a10270dc51ce7eb3$var$z(a) === $a10270dc51ce7eb3$var$d;
};
$a10270dc51ce7eb3$export$b82d16f27459e05a = function(a) {
    return $a10270dc51ce7eb3$var$z(a) === $a10270dc51ce7eb3$var$g;
};
$a10270dc51ce7eb3$export$522c17b4f5e123e8 = function(a) {
    return $a10270dc51ce7eb3$var$z(a) === $a10270dc51ce7eb3$var$f;
};
$a10270dc51ce7eb3$export$1aabd8a0274ecfd6 = function(a) {
    return $a10270dc51ce7eb3$var$z(a) === $a10270dc51ce7eb3$var$p;
};
$a10270dc51ce7eb3$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $a10270dc51ce7eb3$var$e || a === $a10270dc51ce7eb3$var$m || a === $a10270dc51ce7eb3$var$g || a === $a10270dc51ce7eb3$var$f || a === $a10270dc51ce7eb3$var$p || a === $a10270dc51ce7eb3$var$q || "object" === typeof a && null !== a && (a.$$typeof === $a10270dc51ce7eb3$var$t || a.$$typeof === $a10270dc51ce7eb3$var$r || a.$$typeof === $a10270dc51ce7eb3$var$h || a.$$typeof === $a10270dc51ce7eb3$var$k || a.$$typeof === $a10270dc51ce7eb3$var$n || a.$$typeof === $a10270dc51ce7eb3$var$w || a.$$typeof === $a10270dc51ce7eb3$var$x || a.$$typeof === $a10270dc51ce7eb3$var$y || a.$$typeof === $a10270dc51ce7eb3$var$v);
};
$a10270dc51ce7eb3$export$f5bbd400c2f4426f = $a10270dc51ce7eb3$var$z;

});


var $5zKJZ = parcelRequire("5zKJZ");
var $aa49bf5e460995f3$exports = {};
"use strict";
function $aa49bf5e460995f3$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($aa49bf5e460995f3$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$aa49bf5e460995f3$var$checkDCE();

$aa49bf5e460995f3$exports = (parcelRequire("h6zfF"));



var $5zKJZ = parcelRequire("5zKJZ");

var $5zKJZ = parcelRequire("5zKJZ");

var $5zKJZ = parcelRequire("5zKJZ");
const $d148c52a5de812dc$export$bd2518280c2f05c1 = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 60 60"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M15.26,32.61h0a1.39,1.39,0,0,0,.08,2l9.86,9.16L44.82,18.51a1.39,1.39,0,0,0-.25-2h0a1.39,1.39,0,0,0-2,.24L24.86,39.62l-7.62-7.09A1.4,1.4,0,0,0,15.26,32.61Z"
    }));
};
const $d148c52a5de812dc$export$830dad7b282f77fd = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 60 60"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M28.32,30l-11-11A1.19,1.19,0,0,1,19,17.27L30,28.32l11-11A1.19,1.19,0,1,1,42.73,19L31.68,30l11,11a1.19,1.19,0,1,1-1.68,1.68l-11-11-11,11a1.19,1.19,0,1,1-1.68-1.68Z"
    }));
};
const $d148c52a5de812dc$export$4930a69c53a0063 = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 60 60"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M30,49.5A19.5,19.5,0,1,1,49.5,30,19.53,19.53,0,0,1,30,49.5Zm0-38A18.5,18.5,0,1,0,48.5,30,18.52,18.52,0,0,0,30,11.5ZM24.5,30.14a.68.68,0,0,0,.16.39l7.71,8.56a.6.6,0,0,0,.44.23.68.68,0,0,0,.48-.16.66.66,0,0,0,.21-.45.62.62,0,0,0-.18-.47L26,30.1,33.32,22a.62.62,0,0,0,.18-.47.66.66,0,0,0-.21-.45.64.64,0,0,0-.48-.16.6.6,0,0,0-.44.23l-7.71,8.56a.63.63,0,0,0-.16.46Z"
    }));
};
const $d148c52a5de812dc$export$2baabfc57bf5919a = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 39 39"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M19.5,39C8.73,39,0,30.27,0,19.5S8.73,0,19.5,0S39,8.73,39,19.5C38.98,30.26,30.26,38.98,19.5,39z M19.5,1 C9.28,1,1,9.28,1,19.5S9.28,38,19.5,38S38,29.72,38,19.5C37.99,9.29,29.71,1.01,19.5,1z M14,19.64c0.01,0.14,0.07,0.28,0.16,0.39 l7.71,8.56c0.11,0.14,0.27,0.22,0.44,0.23c0.17,0.01,0.35-0.05,0.48-0.16c0.13-0.12,0.2-0.28,0.21-0.45 c0.01-0.18-0.06-0.35-0.18-0.47L15.5,19.6l7.32-8.1c0.12-0.12,0.19-0.29,0.18-0.47c-0.01-0.17-0.08-0.33-0.21-0.45 c-0.13-0.12-0.3-0.17-0.48-0.16c-0.17,0.01-0.33,0.09-0.44,0.23l-7.71,8.56c-0.11,0.13-0.17,0.29-0.16,0.46L14,19.64z"
    }));
};
const $d148c52a5de812dc$export$8775cfa3ec2fac83 = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 50 50"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "m25,50C11.21,50,0,38.78,0,25S11.21,0,25,0s25,11.22,25,25-11.22,25-25,25Zm0-46.58C13.1,3.42,3.42,13.1,3.42,25s9.68,21.58,21.58,21.58,21.58-9.68,21.58-21.58S36.9,3.42,25,3.42Zm0,28.19c-.41,0-.8-.15-1.11-.41l-8.58-7.35c-.35-.3-.56-.71-.59-1.16-.04-.46.11-.9.41-1.25.32-.38.8-.6,1.3-.6.41,0,.8.15,1.11.41l7.47,6.4,7.47-6.4c.31-.27.71-.41,1.11-.41.5,0,.97.22,1.3.6.61.72.53,1.8-.18,2.41l-8.58,7.35c-.31.27-.7.41-1.11.41Z"
    }));
};
const $d148c52a5de812dc$export$9645f8076f429e5c = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 60 60"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M30,17.69a.65.65,0,1,1-.65.65A.64.64,0,0,1,30,17.69Zm-5.24-5.2-.08,0a.64.64,0,0,0-.51.45.65.65,0,0,0,.18.66l3.91,3.91a1.86,1.86,0,0,0-.2.81A1.94,1.94,0,1,0,30,16.4a1.86,1.86,0,0,0-.81.2l-3.91-3.91a.64.64,0,0,0-.52-.2ZM30,8.62a9.72,9.72,0,1,1-9.72,9.72A9.7,9.7,0,0,1,30,8.62Zm0-1.29a11,11,0,0,0-9.33,5.18H12.51a3.24,3.24,0,0,0-3.24,3.24V49.44a3.24,3.24,0,0,0,3.24,3.23h35a3.24,3.24,0,0,0,3.24-3.23V15.75a3.24,3.24,0,0,0-3.24-3.24H43.6a.62.62,0,0,0-.46.19.64.64,0,0,0-.19.46.66.66,0,0,0,.19.46.61.61,0,0,0,.46.18h3.89a1.93,1.93,0,0,1,1.95,1.95V49.44a1.93,1.93,0,0,1-1.95,1.94h-35a1.93,1.93,0,0,1-1.95-1.94V15.75a1.93,1.93,0,0,1,1.95-1.95H20A11,11,0,1,0,30,7.33Z"
    }));
};
const $d148c52a5de812dc$export$c0b625f57a647728 = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 60 60"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M41.81,23.9H34L39.31,9.65a.6.6,0,0,0-.57-.83H26.4a.6.6,0,0,0-.58.42L18.58,31.4a.63.63,0,0,0,.08.55.64.64,0,0,0,.5.25h7.42l-6,18.18a.62.62,0,0,0,.29.73.65.65,0,0,0,.29.07.6.6,0,0,0,.48-.23L42.29,24.89a.61.61,0,0,0-.48-1Zm-19,23.59L28,31.78a.6.6,0,0,0-.09-.55.58.58,0,0,0-.49-.25H20L26.84,10h11L32.49,24.3a.62.62,0,0,0,.07.56.61.61,0,0,0,.5.27h7.49Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M11.31,28.74a.61.61,0,0,0-.61-.61H3.12a.61.61,0,0,0-.61.61.61.61,0,0,0,.61.61H10.7A.61.61,0,0,0,11.31,28.74Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M15,17.76,9.11,14.32a.61.61,0,0,0-.61,1l5.93,3.44a.55.55,0,0,0,.3.09A.61.61,0,0,0,15,17.76Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M14.43,38.66,8.5,42.1a.62.62,0,0,0-.22.84.6.6,0,0,0,.52.3.68.68,0,0,0,.31-.08L15,39.72a.62.62,0,0,0,.22-.84A.61.61,0,0,0,14.43,38.66Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M56.88,28.13H49.3a.61.61,0,0,0-.61.61.61.61,0,0,0,.61.61h7.58a.61.61,0,0,0,.61-.61A.61.61,0,0,0,56.88,28.13Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M45.27,18.9a.55.55,0,0,0,.3-.09l5.93-3.44a.61.61,0,1,0-.61-1L45,17.76a.61.61,0,0,0,.31,1.14Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M51.5,42.1l-5.93-3.44a.61.61,0,0,0-.83.22.62.62,0,0,0,.22.84l5.93,3.44a.68.68,0,0,0,.31.08.6.6,0,0,0,.52-.3A.62.62,0,0,0,51.5,42.1Z"
    }));
};
const $d148c52a5de812dc$export$4e113aba5b63d4e4 = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 60 60"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M29.93,53.38a.52.52,0,0,1-.27-.07A66.05,66.05,0,0,1,20,47.56c-4.58-3.29-10-8.4-10-14.08V10.57a.67.67,0,0,1,.21-.48.66.66,0,0,1,.5-.16,42.65,42.65,0,0,0,4.29.21c5.12,0,9.88-1.7,13.7-3.06l.56-.21.54-.2a.66.66,0,0,1,.48,0l.54.2.58.22c3.8,1.35,8.56,3.05,13.68,3.05,1.44,0,2.81-.07,4.3-.21a.64.64,0,0,1,.49.16.67.67,0,0,1,.21.48V33.48c0,4.41-3.34,9.08-9.91,13.89a70.32,70.32,0,0,1-9.91,5.94A.73.73,0,0,1,29.93,53.38ZM11.24,11.27V33.48c0,5.13,5.17,9.93,9.51,13A66,66,0,0,0,29.92,52a68,68,0,0,0,9.45-5.69c6.23-4.55,9.39-8.88,9.39-12.85V11.27c-1.26.1-2.49.15-3.72.15-5.34,0-10.21-1.73-14.13-3.13l-.57-.21L30,8l-.34.13-.55.2C25.17,9.69,20.3,11.42,15,11.42,13.7,11.42,12.45,11.37,11.24,11.27Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M33.63,39.93H26.37a.64.64,0,0,1-.64-.64V33.23H19.68a.64.64,0,0,1-.64-.64V25.34a.64.64,0,0,1,.64-.64h6.05V18.65a.64.64,0,0,1,.64-.64h7.26a.64.64,0,0,1,.64.64V24.7h6a.64.64,0,0,1,.64.64v7.25a.64.64,0,0,1-.64.64h-6v6.06A.64.64,0,0,1,33.63,39.93ZM27,38.64h6v-6a.65.65,0,0,1,.65-.64h6V26h-6a.64.64,0,0,1-.65-.64V19.29H27v6.05a.64.64,0,0,1-.65.64H20.32v6h6.05a.65.65,0,0,1,.65.64Z"
    }));
};
const $d148c52a5de812dc$export$807a7eae502106e7 = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 60 60"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M52.9,30a8.55,8.55,0,0,0-4.81-7.71,7,7,0,0,0,.21-1.71,7.24,7.24,0,0,0-6.92-7.22A6.1,6.1,0,0,0,30,12.46a6.1,6.1,0,0,0-11.38.9,7.24,7.24,0,0,0-6.92,7.22,7,7,0,0,0,.21,1.71,8.58,8.58,0,0,0,0,15.42,7,7,0,0,0-.21,1.71,7.24,7.24,0,0,0,6.92,7.22,6.1,6.1,0,0,0,11.38.9,6.1,6.1,0,0,0,11.38-.9,7.24,7.24,0,0,0,6.92-7.22,7,7,0,0,0-.21-1.71A8.55,8.55,0,0,0,52.9,30ZM29.41,45a4.92,4.92,0,0,1-9.56,1.64,7.24,7.24,0,0,0,6.4-7.17.59.59,0,1,0-1.18,0,6.06,6.06,0,0,1-6,6h-.16a6.05,6.05,0,0,1-6-6,6.18,6.18,0,0,1,.29-1.86c0-.08,0-.14.05-.2A6,6,0,0,1,16.5,34,.59.59,0,0,0,16,32.87a7.14,7.14,0,0,0-3.76,3.71,7.4,7.4,0,0,1,.08-13.2A7.19,7.19,0,0,0,19,27.81h0a4.74,4.74,0,0,1,4.18,4.66A4.64,4.64,0,0,1,20,36.91a.59.59,0,0,0-.38.74.58.58,0,0,0,.55.41l.18,0A5.82,5.82,0,0,0,21.4,27.4a7.24,7.24,0,0,0,4.85-6.82.59.59,0,0,0-1.18,0A6.06,6.06,0,0,1,19,26.64a6.15,6.15,0,0,1-5.85-4.24l0,0a6,6,0,0,1,5.24-7.81A5.51,5.51,0,0,0,21.24,20a.55.55,0,0,0,.28.07.56.56,0,0,0,.51-.31.58.58,0,0,0-.23-.79,4.37,4.37,0,0,1-2.2-4.67s0,0,0,0a.34.34,0,0,0,.06-.15,4.93,4.93,0,0,1,9.75,1Zm18.3-8.36a7.14,7.14,0,0,0-3.77-3.74.59.59,0,0,0-.77.31.58.58,0,0,0,.31.77,6,6,0,0,1,3.3,3.47.43.43,0,0,0,0,.07s0,.06,0,.09a5.88,5.88,0,0,1,.29,1.86,6.05,6.05,0,0,1-6,6h-.15a6.05,6.05,0,0,1-6-6,.58.58,0,0,0-.59-.59.59.59,0,0,0-.59.59,7.24,7.24,0,0,0,6.4,7.17A4.92,4.92,0,0,1,30.59,45V15.05a4.93,4.93,0,0,1,9.75-1,.47.47,0,0,0,.06.15s0,0,0,0a4.37,4.37,0,0,1-2.2,4.67.58.58,0,0,0-.23.79.56.56,0,0,0,.51.31.55.55,0,0,0,.28-.07,5.5,5.5,0,0,0,2.85-5.4,6.06,6.06,0,0,1,5.51,6,5.91,5.91,0,0,1-.28,1.82h0A6.05,6.05,0,0,1,35,20.58a.58.58,0,0,0-.59-.58.59.59,0,0,0-.59.58,7.23,7.23,0,0,0,4.78,6.79A5.83,5.83,0,0,0,39.7,38a.55.55,0,0,0,.18,0,.58.58,0,0,0,.17-1.14,4.66,4.66,0,0,1,1.41-9.1h0a7.17,7.17,0,0,0,6.23-4.38,7.41,7.41,0,0,1,0,13.18Z"
    }));
};
const $d148c52a5de812dc$export$aa6504bc3c7c25a1 = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 60 60"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M41.61,16.21l0,0v-.05a7.88,7.88,0,0,0-1.78-5.74c-1.78-2-4.7-3.05-8.66-3.05-.36,0-.74,0-1.13,0s-.77,0-1.14,0c-4,0-6.87,1-8.65,3.05a7.81,7.81,0,0,0-1.78,5.75v.05l0,0c-6.9,4.61-6.67,12.51-5.26,18.32a1.37,1.37,0,0,0,1,1h0v.06a24,24,0,0,0,7.54,13.3c2.56,2.33,5.15,3.59,7.69,3.73h.5c2.08,0,5.33-.74,8.94-4.3a24.37,24.37,0,0,0,6.85-12.72v-.06h.05a1.41,1.41,0,0,0,1.09-1C48.28,28.72,48.51,20.81,41.61,16.21Zm-5.93-7a6.24,6.24,0,0,1,4.54,6.07v.11l-.11,0a35.38,35.38,0,0,0-4.21-.89h-.09l0-.09a8.46,8.46,0,0,0-.26-5.05l-.06-.17ZM26,9l.06-.11V8.79h.07a17.48,17.48,0,0,1,2.71-.21l1.14,0,1.23,0a16.34,16.34,0,0,1,2.62.21h.07v.07A.38.38,0,0,1,34,9a7.63,7.63,0,0,1,.48,5.26v.07h-.08a41,41,0,0,0-8.72,0h-.06l0-.06A5.75,5.75,0,0,1,26,9Zm-6.24,6.34a6.23,6.23,0,0,1,4.54-6.06l.17-.06-.06.17a8.49,8.49,0,0,0-.26,5.06l0,.09-.1,0a35.45,35.45,0,0,0-4.22.86l-.11,0ZM44.39,35.24A23,23,0,0,1,37.86,47.5h0c-1.48,1.46-4.48,3.91-7.93,3.91l-.42,0c-2.19-.12-4.48-1.25-6.8-3.37A22.66,22.66,0,0,1,15.54,35.3v0l0,0A1.24,1.24,0,0,0,16,34c0-.05-.91-5.13,2.32-8.66,2.2-2.42,5.87-3.64,10.91-3.64h1.56c5,0,8.72,1.23,10.93,3.65C44.93,28.93,44,34,44,34a1.23,1.23,0,0,0,.36,1.13l0,0Zm1.14-1-.17,0c0-.06,1-5.33-2.28-9.3-2.45-3-6.58-4.47-12.3-4.47H29.22c-5.72,0-9.86,1.51-12.3,4.47-3.27,4-2.29,9.24-2.28,9.3l-.17,0c-1.1-4.56-1-8.44.21-11.54a12,12,0,0,1,5.21-5.94v0l0-.07.08,0a39,39,0,0,1,20.1,0l.07,0v.08h0a12,12,0,0,1,5.23,5.95C46.57,25.84,46.63,29.72,45.53,34.28Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M33,45.17a18.22,18.22,0,0,1-3.23.29,11.7,11.7,0,0,1-2.92-.34h0a.59.59,0,0,0-.74.39.61.61,0,0,0,.4.77,11.85,11.85,0,0,0,3.09.4h.18a19.73,19.73,0,0,0,3.44-.31A.61.61,0,0,0,33,45.17Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M38.59,34.43A8.3,8.3,0,0,1,36,34.8a13.87,13.87,0,0,1-2.88-.3.6.6,0,0,0-.71.46.61.61,0,0,0,.46.72A16.26,16.26,0,0,0,36,36h.17a9.27,9.27,0,0,0,2.82-.43.6.6,0,1,0-.35-1.15Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M27.09,29.4a.6.6,0,1,0,.44-1.12c-.17-.07-4.17-1.56-8.12,2.14a.61.61,0,0,0,0,.85.6.6,0,0,0,.44.2.63.63,0,0,0,.42-.17C23.64,28.11,27,29.35,27.09,29.4Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M32.47,28.28a.6.6,0,1,0,.44,1.12c.14,0,3.44-1.3,6.85,1.9a.63.63,0,0,0,.42.17.59.59,0,0,0,.43-.19.61.61,0,0,0,0-.86C36.63,26.71,32.64,28.21,32.47,28.28Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M27.64,35a.61.61,0,0,0-.72-.46,13.78,13.78,0,0,1-2.87.3,8.26,8.26,0,0,1-2.62-.37.59.59,0,0,0-.75.4.6.6,0,0,0,.39.75A9.39,9.39,0,0,0,23.9,36h.16a16.26,16.26,0,0,0,3.11-.33A.61.61,0,0,0,27.64,35Z"
    }));
};
const $d148c52a5de812dc$export$c42ab4f9cd72fed3 = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 60 60"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M50.27,35.52a27.38,27.38,0,0,0-41.18,0,9.92,9.92,0,0,1-.84.83.63.63,0,0,0-.27.51.61.61,0,0,0,.28.51,8.86,8.86,0,0,1,.8.79c2.48,2.56,9.08,9.37,20.62,9.37s18-6.73,20.48-9.26a9.71,9.71,0,0,1,.93-.88.64.64,0,0,0,.29-.52.6.6,0,0,0-.27-.52A9.92,9.92,0,0,1,50.27,35.52Zm-29.9,1.34a9.31,9.31,0,1,1,9.31,9.31A9.32,9.32,0,0,1,20.37,36.86ZM10,37.29c-.17-.16-.31-.31-.43-.43l.46-.48a27.29,27.29,0,0,1,13.9-8.32,10.53,10.53,0,0,0,0,17.58A27.64,27.64,0,0,1,10,37.29Zm39.33.12a27.14,27.14,0,0,1-13.8,8.25,10.53,10.53,0,0,0,0-17.6,27.29,27.29,0,0,1,13.89,8.32l.45.47C49.67,37,49.49,37.19,49.28,37.41Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M29.68,32.27a4.59,4.59,0,1,0,4.59,4.59A4.6,4.6,0,0,0,29.68,32.27Zm0,7.94A3.35,3.35,0,1,1,33,36.86,3.31,3.31,0,0,1,29.68,40.21Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M53.54,20.86c-3.27-4.55-8.16-7.28-14.54-8.12-12-1.59-26.8,4.2-32.43,8.8A.62.62,0,0,0,7,22.64a.57.57,0,0,0,.39-.14C12.81,18,27.17,12.43,38.84,14c6,.8,10.63,3.36,13.7,7.62a.62.62,0,0,0,1-.72Z"
    }));
};
const $d148c52a5de812dc$export$bb054b93339f5c0f = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 60 60"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M30.4,43.27a19.45,19.45,0,0,1-13.78-5.44,1.22,1.22,0,0,1,1.73-1.73,17.06,17.06,0,0,0,12,4.7,17.17,17.17,0,0,0,12.06-4.7,1.22,1.22,0,0,1,1.73,1.73A19.47,19.47,0,0,1,30.4,43.27Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M25.21,22.45a1.19,1.19,0,0,1-.86-.38c-2-2-4-3-5.94-2.84a7.17,7.17,0,0,0-4.51,2.66,1.24,1.24,0,0,1-2-1.42,9.36,9.36,0,0,1,6.3-3.71c2.66-.25,5.32,1,7.92,3.52a1.2,1.2,0,0,1,0,1.73,1.1,1.1,0,0,1-.87.44Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M47.09,22.45a1.3,1.3,0,0,1-1-.5,6.82,6.82,0,0,0-4.51-2.66c-1.92-.12-3.89.81-5.93,2.85a1.23,1.23,0,0,1-1.74-1.73c2.6-2.6,5.26-3.77,7.92-3.53a9.22,9.22,0,0,1,6.3,3.71,1.28,1.28,0,0,1-.31,1.73,3.1,3.1,0,0,1-.74.13Z"
    }));
};
const $d148c52a5de812dc$export$dd7722943dfbf00b = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 60 60"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M44.08,45.9H35.5A2.09,2.09,0,0,0,33.41,48v5A1.51,1.51,0,0,1,33,54a1.54,1.54,0,0,1-1.07.44A1.5,1.5,0,0,1,30.85,54,1.52,1.52,0,0,1,30.41,53V48A5.1,5.1,0,0,1,35.5,42.9h8.58a2.32,2.32,0,1,0,0-4.63H15.79a5.09,5.09,0,0,1-5.09-5.09v-.24h0a5.1,5.1,0,0,1,5.09-5.09H44.3a2.08,2.08,0,0,0,2.09-2.11,2.11,2.11,0,0,0-2.09-2.09H15.7a5.09,5.09,0,0,1,0-10.18H27.25a2.09,2.09,0,0,0,2.09-2.09V7.05a1.5,1.5,0,1,1,3,0v4.33a5.1,5.1,0,0,1-5.09,5.09H15.7a2.09,2.09,0,0,0,0,4.18H44.3a5.1,5.1,0,0,1,3.62,8.69,5.07,5.07,0,0,1-3.62,1.51H15.79a2.1,2.1,0,0,0-2.1,2.09v.25h0a2.11,2.11,0,0,0,2.1,2.1H44.08a5.31,5.31,0,1,1,0,10.62Zm0-11.45H15.79a1.27,1.27,0,0,1-1.27-1.26v-.25h0a1.27,1.27,0,0,1,1.27-1.26H44.3a5.93,5.93,0,0,0,0-11.86H15.7a1.26,1.26,0,1,1,0-2.52H27.25a5.92,5.92,0,0,0,5.91-5.92V7.05a2.33,2.33,0,1,0-4.65,0v4.33a1.25,1.25,0,0,1-1.26,1.26H15.7a5.92,5.92,0,1,0,0,11.84H44.3a1.27,1.27,0,0,1,1.26,1.27,1.21,1.21,0,0,1-.36.9,1.27,1.27,0,0,1-.9.38H15.79A5.92,5.92,0,0,0,9.87,33v.24h0a5.92,5.92,0,0,0,5.92,5.91H44.08a1.49,1.49,0,0,1,0,3H35.5A5.94,5.94,0,0,0,29.58,48v5a2.33,2.33,0,0,0,4.66,0V48a1.26,1.26,0,0,1,1.26-1.26h8.58a6.14,6.14,0,1,0,0-12.28Z"
    }));
};
const $d148c52a5de812dc$export$2367fa6760bbf24f = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 71.24 71.75"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M34.35,38.2l6.22,3.44a.91.91,0,0,0,.42.11.88.88,0,0,0,.43-1.64l-5.77-3.19v-12a.88.88,0,1,0-1.75,0V37.44A.86.86,0,0,0,34.35,38.2Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M1.74,41.7A.88.88,0,1,0,0,42a35.37,35.37,0,0,0,1.23,5,.88.88,0,0,0,.83.61.86.86,0,0,0,.27,0,.87.87,0,0,0,.56-1.1A33.51,33.51,0,0,1,1.74,41.7Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M5.18,51.8a.88.88,0,0,0-1.55.82A37.46,37.46,0,0,0,6.34,57a.86.86,0,0,0,.71.36.8.8,0,0,0,.51-.17.88.88,0,0,0,.2-1.22A33.94,33.94,0,0,1,5.18,51.8Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M11.58,60.34a.88.88,0,0,0-1.22,1.26,35.28,35.28,0,0,0,3.92,3.3.87.87,0,0,0,.51.17.88.88,0,0,0,.52-1.59A33.86,33.86,0,0,1,11.58,60.34Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M24.82,68.34a34.61,34.61,0,0,1-4.51-1.83.86.86,0,0,0-1.17.39.88.88,0,0,0,.39,1.18A35.47,35.47,0,0,0,24.28,70a.86.86,0,0,0,.27,0,.88.88,0,0,0,.27-1.71Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M35.37,0A35.73,35.73,0,0,0,4.49,17.6V9.38a.88.88,0,1,0-1.75,0V20.12a.87.87,0,0,0,.88.88H14.37a.88.88,0,0,0,0-1.75H5.58A34.12,34.12,0,1,1,35.37,70a35.75,35.75,0,0,1-4.86-.34.87.87,0,1,0-.25,1.73,35.91,35.91,0,0,0,41-35.51A35.91,35.91,0,0,0,35.37,0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M35.37,53.88a18,18,0,1,0-18-18A18,18,0,0,0,35.37,53.88Zm0-34.26A16.25,16.25,0,1,1,19.12,35.88,16.27,16.27,0,0,1,35.37,19.62Z"
    }));
};
const $d148c52a5de812dc$export$def5cd084dfd2c36 = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 74.59 58.12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M69.29,5.29a18.13,18.13,0,0,0-25.6,0l-2,2-2-2A18.09,18.09,0,0,0,11.5,27.53h2.09a16.35,16.35,0,0,1,24.91-21l2.59,2.6a.88.88,0,0,0,1.24,0l2.59-2.6A16.36,16.36,0,0,1,68.05,29.66l-.17.17a.78.78,0,0,0-.22,0H56.37l-2.5-8.25a.88.88,0,0,0-.82-.62.84.84,0,0,0-.84.58l-6.77,19L36.09,14.78a.89.89,0,0,0-.88-.58.88.88,0,0,0-.8.68L31,29.79H.88a.88.88,0,1,0,0,1.75H31.7a.88.88,0,0,0,.85-.68l2.91-12.7,9.16,25.19a.88.88,0,0,0,.82.58h0a.91.91,0,0,0,.82-.59L53,24.59l1.92,6.32a.88.88,0,0,0,.84.63H66.18L41.71,56,19.9,34.19H17.42L41.09,57.86a.85.85,0,0,0,.62.26.87.87,0,0,0,.62-.26l27-27A18.13,18.13,0,0,0,69.29,5.29Z"
    }));
};
const $d148c52a5de812dc$export$10faa5aa86038e33 = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 60 60"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M22,21.55A10.25,10.25,0,0,1,26.91,23c1,.42,2.08,1.53,3.09,1.55s2.14-1,3.09-1.55A10.25,10.25,0,0,1,38,21.55c4.14,0,8.95,4.16,8.95,12.93a13.84,13.84,0,0,1-5.35,10.67A18.54,18.54,0,0,1,30,49.4a18.54,18.54,0,0,1-11.56-4.25,13.84,13.84,0,0,1-5.35-10.67C13.09,25.71,17.9,21.55,22,21.55ZM40.26,10.7c-.81,3.79-2.49,5.41-4.56,6.36-1.84.84-4,1.18-5.89,2.05,1-3.22,2.28-5.21,4-6.42a13.27,13.27,0,0,1,6.48-2Zm.63-1.09c-3,.25-5.6.76-7.7,2.27-1.92,1.37-3.36,3.57-4.37,7-.18-.25-.36-.48-.56-.71a38.59,38.59,0,0,0-4.91-4,.5.5,0,0,0-.62.79,42.23,42.23,0,0,1,4.8,3.84,8.25,8.25,0,0,1,1.83,4.43c-.69-.36-1.41-.81-2-1.13A11.06,11.06,0,0,0,22,20.55c-4.8,0-9.94,4.79-9.94,13.93a14.86,14.86,0,0,0,5.72,11.43A19.39,19.39,0,0,0,30,50.39a19.39,19.39,0,0,0,12.18-4.48A14.86,14.86,0,0,0,47.9,34.48c0-9.14-5.14-13.93-9.94-13.93a11.06,11.06,0,0,0-5.33,1.56c-.77.41-1.49.89-2.23,1.26a14,14,0,0,0-.8-3.07c1.82-1,4.24-1.3,6.51-2.34s4.56-3.18,5.33-7.77a.53.53,0,0,0-.55-.58Z"
    }));
};
const $d148c52a5de812dc$export$c93a55722a55728f = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 60 60"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M55.36,38.62c-2.4-1.2-5.92-2.7-6.76-3L39.41,20.09a.21.21,0,0,0-.06-.08,5.08,5.08,0,0,0-4.53-1.89,4.48,4.48,0,0,0-2.53,1.2,16.1,16.1,0,0,1-4-2,4.65,4.65,0,0,1-2.47-3.05,1,1,0,0,1,.22-.9.64.64,0,0,0,.17-.47.62.62,0,0,0-.25-.44,3.29,3.29,0,0,0-4.46.75l-.06.1L14.92,26.25a3.09,3.09,0,0,0-.44,2.34,3.19,3.19,0,0,0,1.3,2c.6.47,19.48,13.89,24.83,17.34a.62.62,0,0,0,.32.09H51.57c3.67,0,6.64-1.69,7.21-4.12C59.25,41.9,58,39.93,55.36,38.62Zm-15.1-14.8,1.6,2.7H37.07l-1.49-2.69h4.68Zm2.3,3.88,1.6,2.7H39.22l-1.49-2.7Zm2.27,3.88h0l1.86,3.14-6.79-3.13ZM35,19.29a4,4,0,0,1,3.47,1.45l1.13,1.91H34.92L33.4,19.92A3.35,3.35,0,0,1,35,19.29ZM22.47,13.91a2.13,2.13,0,0,1,2.31-.71,2.6,2.6,0,0,0-.13,1.23,5.81,5.81,0,0,0,3,3.93c3.06,1.81,4.2,2.15,4.7,2.16l6.53,11.76a.59.59,0,0,0,.27.25l8.76,4h0s4.18,1.75,6.86,3.09a1.86,1.86,0,0,0,.19.11c-2.42,1.76-2.7,2-2.7,3.75H43C37.94,39.93,18,25.7,17,24.84ZM57.63,43.62c-.37,1.6-2.58,3.21-6.06,3.21H41.1c-5.52-3.57-24-16.72-24.62-17.2a2.06,2.06,0,0,1-.85-1.28,1.87,1.87,0,0,1,.29-1.46l0-.07.46-.91C19,27.82,38.47,41.75,42.5,44.6a.61.61,0,0,0,.35.11H52.91a.58.58,0,0,0,.59-.59v-.4c0-1.38,0-1.38,2.45-3.16l.12-.12C57.33,41.38,57.9,42.5,57.63,43.62Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M19.82,38.06a.59.59,0,0,0-.59-.59H1.71a.59.59,0,0,0,0,1.18H19.23A.59.59,0,0,0,19.82,38.06Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M26.56,42.78a.59.59,0,0,0-.59-.59H8.45a.59.59,0,1,0,0,1.17H26A.59.59,0,0,0,26.56,42.78Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M32.7,46.9H15.19a.59.59,0,0,0-.59.59.58.58,0,0,0,.59.59H32.7a.58.58,0,0,0,.59-.59A.59.59,0,0,0,32.7,46.9Z"
    }));
};
const $d148c52a5de812dc$export$418b5b912aaff436 = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 60 60"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M22.5,19a5.52,5.52,0,0,0-3.88,2.76.25.25,0,0,1-.21.12.23.23,0,0,1-.12,0,.24.24,0,0,1-.09-.33,6,6,0,0,1,4.21-3,.23.23,0,0,1,.28.2.24.24,0,0,1-.19.27Zm1-2.95a8.42,8.42,0,1,0,8.42,8.42A8.43,8.43,0,0,0,23.46,16Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M50.53,10c-2.55.42-5.14.89-7.7,1.4A12.22,12.22,0,0,0,33.56,27a.26.26,0,0,0,.14.15,10.48,10.48,0,0,0,13.62-5.83,10.75,10.75,0,0,0,.7-2.8,19.39,19.39,0,0,1,2.76-8.11.23.23,0,0,0,0-.26.25.25,0,0,0-.24-.11Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M16.64,36.12a5.51,5.51,0,0,0-3.88,2.76.24.24,0,0,1-.21.12.27.27,0,0,1-.12,0,.25.25,0,0,1-.09-.33,6,6,0,0,1,4.22-3,.22.22,0,0,1,.27.19.24.24,0,0,1-.19.28Zm1-3A8.42,8.42,0,1,0,26,41.58,8.43,8.43,0,0,0,17.61,33.16Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M34.9,33.45A5.51,5.51,0,0,0,31,36.21a.24.24,0,0,1-.21.12.27.27,0,0,1-.12,0A.25.25,0,0,1,30.6,36a6,6,0,0,1,4.22-3,.22.22,0,0,1,.27.19.24.24,0,0,1-.19.28Zm1-3a8.42,8.42,0,1,0,8.43,8.42A8.42,8.42,0,0,0,35.86,30.49Z"
    }));
};
const $d148c52a5de812dc$export$3d7c840e09ca691b = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 60 60"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M51.72,38.48c-.17-1.21-.6-2.35-1.14-3.43-.37-.73-.78-1.42-1.3-2.06-.56-.72-1.23-1.31-2.02-1.77-1.09-.62-2.28-.83-3.51-.89-.3-.01-.61,.02-.9,.04-.46,.03-.91,.05-1.36,.13-.75,.12-1.49,.26-2.23,.43-.67,.15-1.32,.36-2,.54-.02-.04-.04-.09-.07-.14-.31-.61-.62-1.23-.93-1.85-.53-1.06-1.06-2.14-1.6-3.2-.03-.06-.05-.17-.02-.22,.28-.29,.59-.55,.85-.86,.29-.36,.6-.72,.84-1.12,.48-.82,.92-1.66,1.37-2.52,.37-.72,.72-1.44,1.06-2.17,.26-.53,.53-1.06,.77-1.61,.36-.85,.71-1.68,1.02-2.54,.23-.65,.43-1.3,.39-2.01-.02-.36-.27-.56-.62-.47-.39,.11-.79,.24-1.19,.35-1.51,.4-3.02,.78-4.52,1.23-.8,.23-1.59,.55-2.37,.86-.93,.37-1.82,.84-2.66,1.39-.75,.5-1.47,1.04-2.04,1.76-.31,.39-.64,.78-.88,1.23-.63,1.13-1.05,2.35-1.24,3.65-.11,.77-.14,1.54,.09,2.31,.24,.83,.75,1.39,1.56,1.69,.72,.26,1.44,.41,2.2,.49,.77,.08,1.54,.07,2.3-.12,.45-.11,.88-.26,1.34-.39,.8,1.62,1.62,3.26,2.43,4.91-.49,.21-.97,.38-1.41,.6-.91,.43-1.8,.9-2.62,1.49-.77,.55-1.48,1.17-2.11,1.89-.59,.67-1.07,1.42-1.45,2.24-.4,.88-.63,1.8-.72,2.76-.04,.52,.01,1.05,.03,1.57,.04,.73,.23,1.43,.46,2.13,.23,.74,.54,1.44,.92,2.12,.39,.67,.83,1.3,1.36,1.87,.37,.4,.78,.77,1.21,1.13,.59,.51,1.24,.92,1.93,1.28,.74,.39,1.51,.72,2.32,.91,.69,.16,1.42,.27,2.14,.39,.24,.04,.49,.08,.74,.08,.34,.01,.67-.01,1.01-.02,.22,0,.46-.04,.66,.02,.28,.09,.52,.27,.79,.4,.6,.28,1.25,.37,1.91,.38,.3,.01,.61-.07,.91-.11,.93-.16,1.75-.58,2.45-1.19,.77-.68,1.3-1.53,1.52-2.55,.02-.09,.08-.18,.15-.25,.2-.2,.42-.37,.62-.56,.61-.64,1.18-1.3,1.67-2.05,.53-.81,.96-1.66,1.29-2.57,.41-1.07,.64-2.19,.68-3.34,.03-.74-.02-1.5-.12-2.24Zm-16.98,7.42c-.45-.1-.68-.43-.87-.81-.29-.63-.43-1.3-.49-1.99-.07-.75-.12-1.5-.16-2.25-.02-.31-.07-.62-.04-.92,.03-.48,.1-.96,.17-1.42,.02-.18,.12-.36,.22-.52,.21-.33,.71-.33,1.02-.05,.29,.24,.39,.58,.43,.92,.04,.24,.04,.48,.06,.71-.01,0-.02,.01-.03,.01-.02,.81-.05,1.63-.06,2.45,0,.59,.14,1.15,.3,1.73,.13,.43,.23,.88,.36,1.31,.21,.72-.43,.96-.91,.84Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M23.11,30.72c.02-.05,.04-.12,.08-.18,.27-.52,.55-1.05,.79-1.6,.15-.33,.37-.56,.67-.76,.29-.2,.55-.43,.85-.66-.45-.17-.86-.33-1.26-.49-.67-.26-1.36-.51-2.02-.8-.79-.35-1.52-.81-2.18-1.38-.6-.52-1.12-1.11-1.55-1.77-.54-.8-.94-1.67-1.23-2.59-.23-.74-.39-1.5-.47-2.27-.03-.29-.07-.59-.11-.9-.5,.03-1,.05-1.49,.1-.63,.07-1.26,.16-1.89,.25-.59,.08-1.18,.16-1.78,.25-.63,.08-1.27,.16-1.9,.24-.29,.03-.52,.16-.51,.37,0,.2,.02,.4,.11,.59,.27,.58,.69,1.06,1.13,1.54,.42,.47,.88,.9,1.34,1.34,.41,.4,.83,.78,1.24,1.16,.6,.53,1.19,1.06,1.8,1.6,.59,.5,1.16,1.02,1.76,1.51,.78,.64,1.57,1.26,2.44,1.79,.85,.52,1.72,.94,2.71,1.06,0,.03,.01,.07,0,.09-.21,.42-.41,.85-.64,1.26-.02,.04-.1,.09-.15,.09-.28-.01-.58-.04-.86-.03-.84,.02-1.67,.05-2.51,.12-.56,.05-1.14,.14-1.69,.26-1.06,.23-2.07,.6-3.04,1.12-.62,.34-1.21,.74-1.73,1.21-.94,.84-1.65,1.85-2.13,3.01-.47,1.14-.7,2.32-.74,3.54-.01,.55,.01,1.11,.09,1.65,.1,.66,.23,1.31,.41,1.95,.29,1.04,.77,2,1.39,2.9,.52,.76,1.12,1.45,1.8,2.07,.62,.55,1.27,1.04,1.98,1.48,.72,.45,1.49,.78,2.27,1.1,.2,.08,.41,.08,.55,.28,.33,.48,.74,.88,1.23,1.19,.94,.63,1.98,.89,3.11,.83,.85-.04,1.63-.27,2.36-.69,.47-.28,.88-.64,1.22-1.07,.11-.14,.22-.33,.38-.4,.38-.18,.8-.28,1.19-.47,.61-.29,1.19-.62,1.81-.93-.08-.11-.11-.16-.15-.22-.39-.6-.8-1.16-1.15-1.77-.62-1.1-1.06-2.26-1.3-3.49-.12-.69-.22-1.4-.26-2.11-.05-.68,.03-1.37,.15-2.05,.15-.93,.45-1.83,.86-2.69,.42-.88,.96-1.7,1.61-2.43,.56-.63,1.15-1.23,1.81-1.74,.16-.12,.31-.25,.49-.39-2.13-1.31-4.49-1.72-6.88-2.03Zm-6,6.64c-.36,.86-.76,1.7-1.09,2.57-.15,.42-.17,.9-.25,1.36-.08,.49-.12,.98-.23,1.45-.11,.45-.39,.48-.77,.39-.58-.13-.77-.63-.81-1.1-.01-.13,0-.25,0-.37-.02-.75,.16-1.47,.39-2.16,.25-.81,.54-1.62,.85-2.41,.23-.59,.49-1.16,.92-1.65,.26-.27,.51-.38,.81-.27,.29,.1,.51,.43,.53,.76,.03,.52-.16,.97-.36,1.42Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M28.36,15.05c-3.39,2.25-4.81,5.56-5.03,9.52-.27-.12-.55-.24-.83-.39-.65-.36-1.24-.79-1.74-1.35-.45-.5-.81-1.04-1.12-1.63-.34-.67-.58-1.38-.73-2.11-.11-.51-.17-1.04-.24-1.56-.07-.54-.11-1.09-.16-1.63-.02-.2-.03-.39-.04-.59-.03-.51-.05-1.02-.08-1.53-.03-.55-.08-1.12-.09-1.67-.02-.99-.07-1.99-.03-2.98,.02-.67,.07-1.35,.31-1.99,.05-.12,.11-.24,.17-.34,.14-.21,.46-.24,.66-.08,.59,.45,1.15,.91,1.74,1.36,.61,.46,1.23,.9,1.83,1.37,.42,.33,.84,.65,1.24,1.01,.67,.6,1.35,1.18,1.98,1.82,.81,.83,1.54,1.72,2.14,2.75Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M50.5,12.66c0,.64-.18,1.24-.41,1.82-.34,.87-.68,1.74-1.09,2.58-.48,1.02-1.01,2.03-1.53,3.04-.31,.62-.64,1.24-.97,1.85-.51,.94-1.07,1.86-1.81,2.64-.69,.73-1.47,1.32-2.38,1.73-.66,.3-1.35,.49-2.07,.54-.2,.01-.39,.03-.59,.04-.88,.03-1.73-.11-2.56-.35-.25-.08-.49-.15-.78-.25,.79-.46,1.43-1.02,2.01-1.65,.56-.61,1.04-1.27,1.44-2,.71-1.26,1.19-2.62,1.68-3.96,.54-1.45,1.06-2.93,1.56-4.4,.1-.31,.23-.49,.55-.56,1.36-.34,2.7-.71,4.05-1.06,.72-.18,1.42-.38,2.14-.55,.43-.1,.74-.04,.75,.54Z"
    }));
};
const $d148c52a5de812dc$export$a8e2843f0fe527f4 = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 60 60"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M22.45,42.58a1,1,0,1,1-1,1A1,1,0,0,1,22.45,42.58Zm-6.55-3a1,1,0,1,1-1,1A1,1,0,0,1,15.9,39.56Zm4.53-1.51a1,1,0,1,1-1,1A1,1,0,0,1,20.43,38.05Zm-6.54-1a1,1,0,1,1-1,1A1,1,0,0,1,13.89,37ZM23,32.5a1,1,0,1,1-1,1A1,1,0,0,1,23,32.5Zm6.55-9.57a20.41,20.41,0,0,0,5,11.59C29.5,30,28.49,27.46,29.5,22.93ZM29.06,7.85C24,8,18.92,12.28,13.38,19.9,24,12.17,30,15.54,35.35,11a10.43,10.43,0,0,1,2.54,1,25.68,25.68,0,0,0-7.65,7.83,16.63,16.63,0,1,0,11.05,19,22,22,0,0,1-5.68-16,16.94,16.94,0,0,0-3.47-2.22,23.39,23.39,0,0,1,4.72-5.31,26.93,26.93,0,0,0,.46,3.39c-2.8,10.1,2.26,19.18,11.09,25,6.56-11.46,3.15-20.45-10.22-26a14.51,14.51,0,0,1-.27-3.21,22.89,22.89,0,0,1,5.52-3.1l-.69-1.89a23.69,23.69,0,0,0-3.93,1.93A9.67,9.67,0,0,0,35.5,9.94a10.92,10.92,0,0,0-6.44-2.09Z"
    }));
};
const $d148c52a5de812dc$export$e253430465890a3 = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 60 60"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M35.41,37.64c-.5.51-2.27,1.45-2.78,1s.44-2.28.95-2.78a1.29,1.29,0,1,1,1.83,1.83ZM26.9,40.48c-.51.5-2.28,1.45-2.79.94s.44-2.27.95-2.78a1.3,1.3,0,0,1,1.84,1.84ZM21.28,27.22c-.51-.5.44-2.27.94-2.78a1.3,1.3,0,1,1,1.84,1.84c-.51.5-2.28,1.45-2.78.94Zm-.06,7.58c-.51.51-2.28,1.45-2.78.94s.44-2.27.94-2.78a1.32,1.32,0,0,1,1.84,0,1.3,1.3,0,0,1,0,1.84Zm-2.84,8.52c-.51.5-2.28,1.45-2.78.94s.44-2.27.94-2.78a1.3,1.3,0,1,1,1.84,1.84Zm23.05-5.24a1.59,1.59,0,0,1-2.68,0,50.16,50.16,0,0,1-3.82-7.14c-2.64.88-5.52,1.51-5.67,1.55a1.6,1.6,0,0,1-1.46-.43,1.58,1.58,0,0,1-.43-1.47c0-.15.67-3,1.55-5.67a49,49,0,0,1-7.14-3.82,1.6,1.6,0,0,1-.73-1.34,1.56,1.56,0,0,1,.73-1.33,51.73,51.73,0,0,1,5.14-2.94,13,13,0,0,0-10.46,3.57C12.52,23,10.64,37.08,9.88,45a4.58,4.58,0,0,0,5,5c7.88-.76,22-2.64,25.9-6.58a13.05,13.05,0,0,0,3.58-10.47,58,58,0,0,1-2.94,5.15Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M23.93,19a.91.91,0,0,0-.45.79.93.93,0,0,0,.45.8c1.85,1.11,5.22,3,7.06,3.34a47.34,47.34,0,0,0-1.7,5.48,1,1,0,0,0,.26.93,1,1,0,0,0,.92.25A43.23,43.23,0,0,0,36,28.86c.33,1.84,2.24,5.22,3.35,7.07a.93.93,0,0,0,1.59,0,45.49,45.49,0,0,0,2.66-5c1.7.79,3.85,1.59,5.35,2.12a.92.92,0,0,0,1-.22.9.9,0,0,0,.22-1c-.86-2.48-2.46-6.74-3.51-7.79a3.82,3.82,0,0,0-2.51-1.11,6.47,6.47,0,0,0-2-5,6.53,6.53,0,0,0-4.84-2,3.83,3.83,0,0,0-1.09-2.38c-1.05-1-5.31-2.64-7.79-3.51a.93.93,0,0,0-1.18,1.19c.5,1.4,1.23,3.37,2,5A46.85,46.85,0,0,0,23.93,19Z"
    }));
};
const $d148c52a5de812dc$export$b7e6b5d1de1ef699 = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 60 60"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M27.77,24.76h-.31c-2.91,0-3.66.67-5.64,1L23.38,23a.66.66,0,0,1,.42-.33.68.68,0,0,1,.54.07Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M36.21,22.3a1,1,0,1,1-2.1,0,1,1,0,0,1,2.1,0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M32.71,17.4a1,1,0,0,1-2.1,0,1,1,0,0,1,2.1,0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M26.41,14.6a1,1,0,1,1-2.1,0,1,1,0,1,1,2.1,0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M31,11.8a1.4,1.4,0,1,1-2.8,0,1.4,1.4,0,1,1,2.8,0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M43.09,20.9l-.63,3.85h-.3a12.3,12.3,0,0,0-2.5.22l.48-4.07Zm-2,7.7a.71.71,0,0,1-.65-.43.73.73,0,0,1,.15-.77.71.71,0,0,1,.77-.15.7.7,0,0,1,.43.65.67.67,0,0,1-.21.49.69.69,0,0,1-.49.21Zm-3.25,4-4,3.95a.7.7,0,0,1-1,0L29,32.6a.7.7,0,0,1,0-1l3.95-4a.7.7,0,0,1,1,0l4,4A.72.72,0,0,1,37.86,32.6Zm-4.45,6.5a.7.7,0,0,1,1.19-.5.73.73,0,0,1,.16.77.71.71,0,0,1-.65.43.7.7,0,0,1-.7-.7Zm1.37,6.53-4.84,2.8a.71.71,0,0,1-1-.26l-2.8-4.84a.73.73,0,0,1-.07-.54.66.66,0,0,1,.33-.42l4.84-2.8a.68.68,0,0,1,.54-.07.66.66,0,0,1,.42.33L35,44.67a.7.7,0,0,1,.07.53.72.72,0,0,1-.33.43ZM23.61,47.85a1,1,0,1,1,1.05-1.05,1,1,0,0,1-1.05,1.05Zm-3.5-8.75V33.5a.7.7,0,0,1,.7-.7h5.6a.7.7,0,0,1,.49.2.67.67,0,0,1,.21.5v5.6a.72.72,0,0,1-.7.7h-5.6a.7.7,0,0,1-.7-.7Zm9.1-4.2a.7.7,0,1,1-.7.7.7.7,0,0,1,.7-.7ZM17.49,25.57l-.76-4.67h22l-.52,4.45a11.47,11.47,0,0,1-3.54.49c-3.71,0-3.5-1.09-7.21-1.09h.32l1.4.81a.7.7,0,0,1,.33.42.73.73,0,0,1-.07.54l-2.8,4.84a.71.71,0,0,1-1,.26l-4.84-2.8a.7.7,0,0,1-.26-1l1.25-2.16.16,0h0a13.09,13.09,0,0,1-2.16.16,9.24,9.24,0,0,1-2.34-.27ZM48,10l-7.7,1.8a.71.71,0,0,0-.57.61l-.82,7.08h-23a.67.67,0,0,0-.53.25.64.64,0,0,0-.16.56L16,25.05l4.13,25.36a.75.75,0,0,0,.69.59H39a.75.75,0,0,0,.69-.59l4.16-25.56.74-4.54h0a.7.7,0,0,0-.15-.57.73.73,0,0,0-.54-.24H40.3l.75-6.41,7.19-1.7A.7.7,0,0,0,48,10Z"
    }));
};
const $d148c52a5de812dc$export$c95748fd3bdade58 = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 60 60"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("polygon", {
        points: "29.4 33.68 25.27 29.43 21.14 33.68 25.27 37.93 29.4 33.68"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("polygon", {
        points: "34.13 28.81 30 24.56 25.87 28.81 30 33.06 34.13 28.81"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("polygon", {
        points: "34.73 37.93 38.86 33.68 34.73 29.43 30.6 33.68 34.73 37.93"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("polygon", {
        points: "30 34.3 25.87 38.55 30 42.79 34.13 38.55 30 34.3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M42.75,40.64l-2.69,2.77,1.85,1.91a.43.43,0,0,1,0,.61.46.46,0,0,1-.3.12.4.4,0,0,1-.31-.13L39.46,44l-4.13,4.25,2.06,2.12a.43.43,0,0,1,0,.61.42.42,0,0,1-.29.12.4.4,0,0,1-.31-.13l-2.05-2.1-3.61,3.71a.39.39,0,0,1-.3.13.42.42,0,0,1-.3-.12.43.43,0,0,1,0-.61l3.63-3.73L30,44l-4.13,4.25L29.5,52a.43.43,0,0,1-.31.73.43.43,0,0,1-.31-.13L25.27,48.9l-2,2.1a.43.43,0,0,1-.31.13.42.42,0,0,1-.3-.12.44.44,0,0,1,0-.61l2.06-2.12L20.54,44l-1.83,1.89a.48.48,0,0,1-.31.13.42.42,0,0,1-.3-.12.44.44,0,0,1,0-.61L20,43.41l-2.7-2.77a.43.43,0,0,1,.62-.6l2.68,2.75,4.13-4.25-4.13-4.25-2.68,2.76a.46.46,0,0,1-.31.13.43.43,0,0,1-.3-.13.42.42,0,0,1,0-.6L20,33.68l-1.45-1.5a.43.43,0,0,1,0-.61.44.44,0,0,1,.61,0l1.43,1.48,4.13-4.25-3.15-3.24a.43.43,0,0,1,.62-.6l3.13,3.22,4.13-4.25-3-3.11a.44.44,0,0,1,0-.61.43.43,0,0,1,.61,0l3,3.1,3-3.1a.43.43,0,0,1,.62.6l-3,3.11,4.13,4.25L37.86,25a.43.43,0,0,1,.61,0,.44.44,0,0,1,0,.61l-3.15,3.23,4.13,4.25,1.44-1.47a.42.42,0,0,1,.6,0,.43.43,0,0,1,0,.61l-1.45,1.49,2.7,2.77a.43.43,0,0,1-.31.73.42.42,0,0,1-.31-.13L39.46,34.3l-4.13,4.25,4.13,4.25L42.14,40a.43.43,0,0,1,.61.6ZM30,18.78c-7.63,0-13.77,11.42-13.77,20.89,0,8.47,5.15,13.52,13.77,13.52s13.77-5,13.77-13.52C43.77,30.21,37.63,18.78,30,18.78Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("polygon", {
        points: "30.6 43.41 34.73 47.66 38.86 43.41 34.73 39.16 30.6 43.41"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M18.1,18.08a8.28,8.28,0,0,1,4.24,3.55c2.23-2.28,4.85-3.71,7.66-3.71a10.85,10.85,0,0,1,7.65,3.71,8.36,8.36,0,0,1,4.24-3.55.86.86,0,0,0,0-1.63,8.3,8.3,0,0,0-5.81.14,12.7,12.7,0,0,1,3.38-5.13.87.87,0,0,0-.42-1.5,6.83,6.83,0,0,0-6.25,2.17,12,12,0,0,0-2.13-5,.88.88,0,0,0-1.34,0,12,12,0,0,0-2.14,5,7,7,0,0,0-5-2.27A7,7,0,0,0,21,10a.86.86,0,0,0-.42,1.5,12.8,12.8,0,0,1,3.38,5.13,8.25,8.25,0,0,0-5.81-.14.86.86,0,0,0,0,1.63Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("polygon", {
        points: "21.14 43.41 25.27 47.66 29.4 43.41 25.27 39.16 21.14 43.41"
    }));
};
const $d148c52a5de812dc$export$631a1297e3dadc04 = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 60 60"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M38.07,10.16a2.15,2.15,0,0,1,1.69.82L49.82,23.59a2.16,2.16,0,0,1,.42,1.83L46.65,41.15a2.16,2.16,0,0,1-1.17,1.47l-14.54,7a2.12,2.12,0,0,1-1.88,0l-14.54-7a2.16,2.16,0,0,1-1.17-1.47L9.76,25.42a2.16,2.16,0,0,1,.42-1.83L20.24,11a2.15,2.15,0,0,1,1.69-.82Zm0-2.31H21.93a4.47,4.47,0,0,0-3.5,1.69L8.37,22.15a4.46,4.46,0,0,0-.86,3.79L11.1,41.67a4.48,4.48,0,0,0,2.42,3l14.54,7a4.5,4.5,0,0,0,3.88,0l14.54-7a4.48,4.48,0,0,0,2.42-3l3.59-15.73a4.46,4.46,0,0,0-.86-3.79L41.57,9.54a4.47,4.47,0,0,0-3.5-1.69Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M40.28,18.55v22.9H38L24.27,27.26V41.45H19.72V18.55H22L35.73,32.74V18.55Z"
    }));
};
const $d148c52a5de812dc$export$d747a27c388f98fc = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 60 60"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M30.95,16.36c.04,.35,.34,.65,.69,.65,2.24,.13,4.39-.47,6.2-2.02,1.85-1.51,2.89-3.62,3.1-5.81,.04-.34-.22-.65-.56-.65-2.2-.17-4.48,.47-6.29,2.02-.95,.78-1.68,1.72-2.2,2.76-.09,.17-.35,.17-.43,0-.65-1.38-1.55-2.63-2.58-3.71-.17-.21-.47-.3-.73-.3h-.99c-.13,0-.17,.13-.09,.22,1.9,1.81,3.62,4.61,3.88,6.85h0Zm1.59,1.98c-.39,0-.73,0-1.12,.04-.56,.04-1.03,.34-1.38,.78-.26,.34-.52,.69-.77,1.03-3.53,5.04-4.78,11.02-4.05,16.71,.04,.26-.34,.34-.39,.09-1.42-5.69-.78-11.93,2.2-17.31,.35-.6-.13-1.34-.77-1.29-7.28,.78-12.96,7.88-12.96,16.54,0,9.17,6.37,16.58,14.25,16.58,.34,0,.69,0,.99-.04,.99-.09,1.98-.09,2.93,0,.34,.04,.69,.04,.99,.04,7.88,0,14.25-7.41,14.25-16.58,.09-9.17-6.29-16.58-14.17-16.58h0Z"
    }));
};
const $d148c52a5de812dc$export$1dcf734be4e793d = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 60 60"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M26.24,20.18c.87,0,1.59,.87,1.59,1.95s-.71,1.93-1.59,1.93-1.59-.86-1.59-1.93,.71-1.95,1.59-1.95Zm6.32-1.79c.87,0,1.59,.86,1.59,1.93s-.71,1.93-1.59,1.93-1.6-.86-1.6-1.93,.72-1.93,1.6-1.93Zm1.82,5.36c.87,0,1.59,.86,1.59,1.93s-.71,1.95-1.59,1.95-1.59-.87-1.59-1.95,.71-1.93,1.59-1.93Zm-24.76,10.28c11.58,13.93,29.38,14.42,41.04,.32,.61,.75,1.24,1.5,1.85,2.25,.47,.86,.38,1.63-.03,2.34-12.3,15.69-32.34,14.57-44.95-.07-.36-.47-.5-1.06-.14-1.95,.74-.96,1.49-1.92,2.23-2.89h0Zm2.48-3.19c5.66-6.85,11.31-13.69,16.97-20.53,.81-.89,1.36-.67,1.84,0,5.75,7,11.49,14.01,17.22,21.02-10.15,11.7-26.32,12.34-36.03-.49h0Z"
    }));
};
const $d148c52a5de812dc$export$e3fccb5d29105673 = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 60 60"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M22.39,42.65c-.2,.24-.52,.32-.8,.32s-.56-.12-.76-.32c-7.29-7.09-3.94-16.58-3.19-18.41,.24-.56,.88-.84,1.44-.6,.56,.24,.84,.88,.6,1.43-.68,1.59-3.63,9.88,2.67,15.98,.44,.44,.44,1.15,.04,1.59h0Zm23.15-20.56s-.04-.04-.04-.08c-1.08-1.95-3.19-3.27-5.58-3.27-1.12,0-2.15,.32-3.03,.8l.04-.04c-1.59,.92-4.98,1.55-6.93,1.55s-5.26-.56-6.93-1.55l.04,.04c-.92-.52-1.95-.8-3.07-.8-2.23,0-4.14,1.12-5.3,2.83-.24,.4-.48,.8-.64,1.23-1.24,2.63-1.91,5.54-1.91,8.65,0,7.41,3.98,13.87,9.88,17.45,.36,.24,.72,.48,1.12,.64,.6,.24,1.28,.4,1.99,.4,.68,0,1.36-.16,1.95-.4,.28-.2,.6-.36,.95-.48,.6-.24,1.24-.4,1.91-.4s1.36,.16,1.95,.4c.32,.12,.64,.28,.92,.48,.6,.24,1.28,.4,1.99,.4s1.36-.16,1.95-.4c.4-.16,.8-.4,1.12-.64,5.9-3.59,9.88-10.04,9.88-17.45,0-3.39-.8-6.57-2.27-9.36h0Zm-21.56-4.82c2.03,1.67,4.38,2.39,6.89,2.23,.4-.04,.72-.32,.76-.72,.28-2.51,2.23-5.58,4.22-7.61,.08-.08,.04-.24-.12-.24h-1.08c-.32,0-.6,.12-.8,.32-1.16,1.2-2.11,2.59-2.87,4.11-.08,.2-.36,.2-.44,0-.6-1.16-1.39-2.19-2.43-3.03-2.03-1.67-4.54-2.43-6.97-2.23-.36,.04-.64,.36-.6,.72,.24,2.43,1.39,4.78,3.43,6.45h0Z"
    }));
};
const $d148c52a5de812dc$export$e76f05f5f778b829 = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm1.25 17c0 .69-.559 1.25-1.25 1.25-.689 0-1.25-.56-1.25-1.25s.561-1.25 1.25-1.25c.691 0 1.25.56 1.25 1.25zm1.393-9.998c-.608-.616-1.515-.955-2.551-.955-2.18 0-3.59 1.55-3.59 3.95h2.011c0-1.486.829-2.013 1.538-2.013.634 0 1.307.421 1.364 1.226.062.847-.39 1.277-.962 1.821-1.412 1.343-1.438 1.993-1.432 3.468h2.005c-.013-.664.03-1.203.935-2.178.677-.73 1.519-1.638 1.536-3.022.011-.924-.284-1.719-.854-2.297z"
    }));
};
const $d148c52a5de812dc$export$33b26d5f51359e1b = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm1 18h-2v-8h2v8zm-1-12.25c.69 0 1.25.56 1.25 1.25s-.56 1.25-1.25 1.25-1.25-.56-1.25-1.25.56-1.25 1.25-1.25z"
    }));
};
const $d148c52a5de812dc$export$343c7a79674dcea0 = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 70 70"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M57.76,63.7H12.24a4.82,4.82,0,0,1-4.8-4.81V28.36H62.56V58.89a4.82,4.82,0,0,1-4.8,4.81ZM12.24,14.22h2.12v3.25a.86.86,0,0,0,.86.85H25.81a.82.82,0,0,0,.6-.25.86.86,0,0,0,.25-.6V14.22H43.34v3.25a.86.86,0,0,0,.25.6.82.82,0,0,0,.6.25H54.78a.86.86,0,0,0,.86-.85V14.22h2.12a4.86,4.86,0,0,1,4.8,4.87v7.57H7.44V19.09a4.86,4.86,0,0,1,4.8-4.87Zm8.27-7.91A4.45,4.45,0,0,1,25,10.76v5.87h-8.9V13.72c0-.09.05-.19.05-.29s-.05-.19-.05-.28V10.76a4.45,4.45,0,0,1,4.45-4.45ZM45,10.76a4.45,4.45,0,1,1,8.9,0v5.87H45Zm12.72,1.77H55.64V10.76a6.15,6.15,0,1,0-12.3,0v1.77H26.66V10.76a6.15,6.15,0,1,0-12.3,0v1.77H12.24a6.56,6.56,0,0,0-6.5,6.55V58.89a6.5,6.5,0,0,0,6.5,6.5H57.76a6.5,6.5,0,0,0,6.5-6.5V19.08a6.56,6.56,0,0,0-6.5-6.55Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M17.42,42.05a2.12,2.12,0,0,1-3.29-2.64l1.79-2.79,1.78,2.79a2.13,2.13,0,0,1-.28,2.64Zm-.79-7.47a.84.84,0,0,0-.71-.39.87.87,0,0,0-.72.39L12.7,38.5a3.82,3.82,0,1,0,6.43,0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M30.14,42.05a2.12,2.12,0,0,1-3.29-2.64l1.79-2.79,1.79,2.79a2.13,2.13,0,0,1-.29,2.64Zm-.79-7.47a.84.84,0,0,0-.71-.39.87.87,0,0,0-.72.39l-2.5,3.92a3.82,3.82,0,1,0,6.43,0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M44.71,42.39a3.82,3.82,0,1,1-6.56-3.89l2.5-3.92a.85.85,0,0,1,.71-.39.87.87,0,0,1,.72.39l2.5,3.92A3.82,3.82,0,0,1,44.71,42.39Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M57.43,42.39a3.82,3.82,0,1,1-6.56-3.89l2.5-3.92a.87.87,0,0,1,.72-.39.85.85,0,0,1,.71.39l2.5,3.92A3.82,3.82,0,0,1,57.43,42.39Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M19.27,57.09A3.82,3.82,0,1,1,12.7,53.2l2.51-3.92a.84.84,0,0,1,.71-.39.87.87,0,0,1,.72.39l2.49,3.92A3.8,3.8,0,0,1,19.27,57.09Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M30.14,56.75a2.12,2.12,0,0,1-3.29-2.64l1.79-2.79,1.79,2.79a2.13,2.13,0,0,1-.29,2.64Zm-.79-7.47a.84.84,0,0,0-.71-.39.87.87,0,0,0-.72.39l-2.5,3.92a3.82,3.82,0,1,0,6.43,0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M42.86,56.75a2.12,2.12,0,0,1-3.29-2.64l1.79-2.79,1.79,2.79a2.13,2.13,0,0,1-.29,2.64Zm-.78-7.47a.87.87,0,0,0-.72-.39.84.84,0,0,0-.71.39L38.14,53.2a3.82,3.82,0,1,0,6.44,0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M55.58,56.75a2.12,2.12,0,0,1-3.28-2.64l1.78-2.79,1.79,2.79a2.13,2.13,0,0,1-.29,2.64Zm-.78-7.47a.87.87,0,0,0-.72-.39.84.84,0,0,0-.71.39l-2.5,3.92a3.82,3.82,0,1,0,6.43,0Z"
    }));
};
const $d148c52a5de812dc$export$6bed359a46fab1ef = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 70 70"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M64.86,47.43h-6a.06.06,0,0,0-.06.07.07.07,0,0,0-.07.07l-.27.26-.07.07s0,.07-.06.07v.47l.46,3.44a4.72,4.72,0,0,1-.86,3.52,4.79,4.79,0,0,1-3.12,1.85,4.72,4.72,0,0,1-5.37-4l-.73-5V48s0-.07-.06-.07a.07.07,0,0,0-.07-.07l-.07-.06-.2-.2a.07.07,0,0,1-.07-.07.21.21,0,0,0-.13-.07H48c-.06,0-.06,0-.13-.07h-6.7c-.13,0-.2.07-.33.14h-.06c-.07.06-.2.13-.27.19a.48.48,0,0,0-.13.27.57.57,0,0,0-.07.33v.2l.47,3.31a4.73,4.73,0,0,1-9.35,1.4l-.73-4.91V48.1a.07.07,0,0,0-.07-.07V48a.26.26,0,0,0-.06-.13c0-.07-.07-.07-.14-.13l-.13-.13c-.07-.07-.07-.07-.13-.07a.24.24,0,0,0-.2-.07H23.14a.25.25,0,0,0-.2.07.24.24,0,0,0-.13.07c-.07,0-.07.07-.13.07a.26.26,0,0,1-.13.06l-.07.07c0,.07-.07.07-.07.13s-.06.07-.06.13a.6.6,0,0,0-.07.34v.13l.53,3.44A4.72,4.72,0,0,1,22,55.46a4.75,4.75,0,0,1-8.49-2.12l-.73-4.91V48.3c0-.07,0-.13-.06-.13V48.1c0-.07,0-.07-.07-.13a.07.07,0,0,0-.07-.07l-.13-.13-.14-.14a.06.06,0,0,1-.06-.06l-.07-.07h-.07c-.07,0-.07,0-.13-.07H5.08a1,1,0,1,0,0,2h5.7l.59,4.17A6.77,6.77,0,0,0,18,59.36a4.86,4.86,0,0,0,1-.07,6.77,6.77,0,0,0,4.44-2.65,6.65,6.65,0,0,0,1.25-5l-.32-2.25h4.44l.59,4.17A6.75,6.75,0,0,0,36,59.36a4.72,4.72,0,0,0,1-.07,6.73,6.73,0,0,0,5.7-7.62l-.33-2.25h4.38l.59,4.17A6.75,6.75,0,0,0,54,59.36a4.72,4.72,0,0,0,1-.07,6.74,6.74,0,0,0,4.44-2.65,6.65,6.65,0,0,0,1.26-5l-.33-2.25h4.57a1,1,0,0,0,1-1,1.08,1.08,0,0,0-1.06-1Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M17.21,53.79v.07A1.3,1.3,0,0,0,19.66,53v-.07a57.62,57.62,0,0,1-2.12-8.42,47.51,47.51,0,0,1-.8-8.68,37.78,37.78,0,0,1,.87-8.68,28.34,28.34,0,0,1,3.05-8.22A30,30,0,0,0,16.94,27a39.93,39.93,0,0,0-1.52,8.82,51.19,51.19,0,0,0,.2,9,58.08,58.08,0,0,0,1.59,8.95Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M53.46,53.79v.07A1.3,1.3,0,0,0,55.91,53v-.07a57.62,57.62,0,0,1-2.12-8.42,47.51,47.51,0,0,1-.8-8.68,37.78,37.78,0,0,1,.87-8.68,28.34,28.34,0,0,1,3-8.22A30,30,0,0,0,53.19,27a39.93,39.93,0,0,0-1.52,8.82,51.19,51.19,0,0,0,.2,9,58.08,58.08,0,0,0,1.59,8.95Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M34.84,53.73v.06a1.35,1.35,0,0,0,1.59,1,1.31,1.31,0,0,0,1-1.59v-.07a52.87,52.87,0,0,1-1-5.83c-.07-1-.2-2-.27-3s-.13-2-.13-3-.07-2,0-3l.13-3,.27-3c.06-1,.26-2,.39-3l.2-1.53.27-1.46c.2-1,.33-2,.59-3,.53-1.92,1-3.91,1.66-5.83L40,16.15c.14-.46.34-.93.53-1.39L41.73,12a21.19,21.19,0,0,1,1.32-2.71l1.4-2.72L42.92,9.19a20.7,20.7,0,0,0-1.46,2.65l-1.32,2.72a11.9,11.9,0,0,0-.6,1.39L39,17.41a56,56,0,0,0-2,5.76c-.33,1-.53,2-.8,3l-.4,1.45-.26,1.53c-.2,1-.4,2-.53,3l-.4,3.05-.26,3c-.07,1-.14,2.05-.14,3.05s0,2,0,3.11.07,2.06.14,3.12a28.05,28.05,0,0,0,.53,6.16Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M57.84,57.82a32.32,32.32,0,0,1-45.24.43L58.26,12.58a32.33,32.33,0,0,1-.42,45.24ZM12.15,12.14a32.33,32.33,0,0,1,44.76-.88L11.27,56.89a32.35,32.35,0,0,1,.88-44.75ZM10.82,10.8A34.26,34.26,0,1,0,35,.81,34.2,34.2,0,0,0,10.82,10.8Z"
    }));
};
const $d148c52a5de812dc$export$3543d1682e6cc172 = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 70 70"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M57.9,25.73c2.13-4.17,2.55-7.83,1.77-10.86a12.41,12.41,0,0,1,3.27-1,1,1,0,0,0,.85-.68l.05-.24V12.7l0-.09A.94.94,0,0,0,63,12c-4.91-.82-7.66-3.57-8.65-8.61a1,1,0,0,0-.82-.87h-.28a1,1,0,0,0-.83.8,13.53,13.53,0,0,1-1,3.13A20.79,20.79,0,0,0,31.66,9.7h0C20.2,1.71,8.73,17,14,25.85c-5.55,4.09-7.84,9.43-6.36,14.29a6.18,6.18,0,0,1-3.16,1.4.87.87,0,0,0-.79.68l0,.1v.44l.12.12a.83.83,0,0,0,.64.43,5.78,5.78,0,0,1,5.15,5.11.89.89,0,0,0,.81.8h.1a.87.87,0,0,0,.85-.73,8.13,8.13,0,0,1,.72-2.17,20,20,0,0,0,2.26,1.58c-3.49,1.91-2.37,6.51,1.27,7.69C10.76,71.77,29.91,72,32.76,53.38a.75.75,0,0,0-.53-.82c-7.54-2.94-9.44-12.18-8.73-19.4,5-2.23,6.14-5.34,7.56-10.34,1.35,2.05,4,5.49,7.17,6,3.43.58,9.34,1.54,9.84,5.83C49,42.09,47,48.47,40,52.07a.8.8,0,0,0-.42.73c-.72,6.5.8,10.44,3,12.34,3.84,3.33,9.12.62,10.13-4.15,8.66-1,8.42-7.82,4.83-14.18C68.58,41.51,69.77,30.67,57.9,25.73ZM53.38,5.55a13.57,13.57,0,0,0,.95,2.26A10.08,10.08,0,0,0,58.5,12a12.38,12.38,0,0,0,2.1.89,13.58,13.58,0,0,0-1.4.54,12.94,12.94,0,0,0-1.33.72,10.83,10.83,0,0,0-4.48,6.11,10.61,10.61,0,0,0-7.22-7.36,10.32,10.32,0,0,0,6-4.62A10.78,10.78,0,0,0,52.83,7,11.64,11.64,0,0,0,53.38,5.55ZM10.48,46.21a6.85,6.85,0,0,0-3.71-3.78,6.7,6.7,0,0,0,1.45-.84A5.93,5.93,0,0,0,9.37,40.5a7.19,7.19,0,0,0,1.1-1.85,6.83,6.83,0,0,0,3.71,3.77,6.64,6.64,0,0,0-2.37,1.68,6.18,6.18,0,0,0-.88,1.2A7,7,0,0,0,10.48,46.21Zm45.73-.41a.74.74,0,0,0-.34,1.06c3.46,5.72,4.52,12-3.72,12.69a.76.76,0,0,0-.78.65c-.56,3.89-4.65,6.55-7.8,3.83-1.86-1.61-3.13-5-2.53-10.82,7.27-4,9.43-10.83,8.5-18.72-.62-5.22-6.82-6.4-11.08-7.11-3.58-.59-6.7-6.17-7-6.73a.75.75,0,0,0-1.41.14c-1.18,5-2.31,9.11-7.46,11.15a.74.74,0,0,0-.53.63c-.88,7.83,1.17,17.7,9.13,21.17-2.81,15.95-18.91,16.39-13.94,1.57a.74.74,0,0,0-.58-1c-3.54-.66-4.17-4.84-.45-5.56a.74.74,0,0,0,.25-1.4,19.34,19.34,0,0,1-3.56-2.3,5.85,5.85,0,0,1,3.54-1.77.87.87,0,0,0,.71-.48l.11-.11v-.31l0-.22a.88.88,0,0,0-.73-.65,5.78,5.78,0,0,1-5.15-5.11.88.88,0,0,0-.69-.78l-.35,0-.06,0a.86.86,0,0,0-.66.71,8.22,8.22,0,0,1-.77,2.26c-.7-4,1.5-8.36,6.46-11.86.39-.27.69-.67.34-1.16C10.39,18.4,20.45,3.42,31,11.07c.35.26.71.5,1.14.13a19.47,19.47,0,0,1,18.6-3.49,9.41,9.41,0,0,1-6.92,4.23,1,1,0,0,0-.78.49l-.12.13v.29l0,.3a.94.94,0,0,0,.8.73c4.91.81,7.67,3.57,8.65,8.61a1,1,0,0,0,.89.87h.12a1,1,0,0,0,.92-.81c.62-3.17,1.91-5.44,4-6.88.57,2.72.07,6-1.92,9.73-.25.47-.53,1.13.2,1.4C68.29,31.2,67,41,56.21,45.8Z"
    }));
};
const $d148c52a5de812dc$export$5cb3920d094765b3 = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 70 70"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M35,50.59a1.25,1.25,0,0,0-1.25,1.25V63.06a1.25,1.25,0,0,0,2.5,0V51.84A1.25,1.25,0,0,0,35,50.59Zm11.91-4.93A1.25,1.25,0,0,0,46,46a1.23,1.23,0,0,0,0,1.75L54,55.71A1.24,1.24,0,0,0,55.71,54L47.78,46a1.23,1.23,0,0,0-.87-.37Zm-23.82,0a1.23,1.23,0,0,0-.87.37L14.29,54A1.24,1.24,0,0,0,16,55.71L24,47.78A1.23,1.23,0,0,0,24,46a1.25,1.25,0,0,0-.88-.37ZM51.84,33.75a1.25,1.25,0,0,0,0,2.5H63.06a1.25,1.25,0,0,0,0-2.5Zm-44.9,0a1.25,1.25,0,1,0,0,2.5H18.16a1.25,1.25,0,0,0,0-2.5Zm28.06-5A6.24,6.24,0,1,1,28.76,35,6.22,6.22,0,0,1,35,28.76Zm0-2.49A8.73,8.73,0,1,0,43.73,35,8.74,8.74,0,0,0,35,26.27ZM54.84,13.92a1.21,1.21,0,0,0-.88.37L46,22.22A1.24,1.24,0,0,0,47.78,24L55.71,16a1.23,1.23,0,0,0,0-1.75,1.19,1.19,0,0,0-.87-.37Zm-39.68,0a1.19,1.19,0,0,0-.87.37,1.23,1.23,0,0,0,0,1.75L22.22,24A1.24,1.24,0,0,0,24,22.22L16,14.29a1.21,1.21,0,0,0-.88-.37ZM35,5.69a1.25,1.25,0,0,0-1.25,1.25V18.16a1.25,1.25,0,0,0,2.5,0V6.94A1.25,1.25,0,0,0,35,5.69Z"
    }));
};
const $d148c52a5de812dc$export$6d708b0d320d59 = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 70 70"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M40.31,19.59a13.45,13.45,0,0,0-19.3,0,14.19,14.19,0,0,0,0,19.75,13.45,13.45,0,0,0,19.3,0,14.19,14.19,0,0,0,0-19.75Zm-9.65-6a15.34,15.34,0,0,1,10.59,4.24L51.6,7.47h-9V5.54H54.9V17.86H53v-9L42.58,19.23A16.13,16.13,0,0,1,41.7,40.7a15.35,15.35,0,0,1-10.06,4.63V55.81h7v1.93h-7v6.72H29.71V57.74H23V55.81h6.69V45.33a15.35,15.35,0,0,1-10-4.63,16.11,16.11,0,0,1,0-22.46,15.36,15.36,0,0,1,11-4.66Z"
    }));
};
const $d148c52a5de812dc$export$127fba7ec6c5c4a6 = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 63.18 60.67"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M30.28,34.86H21.7l9.44-10h0a1.18,1.18,0,0,0,.23-1.29,1.2,1.2,0,0,0-1.09-.72H18.94a1.19,1.19,0,0,0,0,2.38h8.57l-9.44,10a1.22,1.22,0,0,0-.23,1.29,1.19,1.19,0,0,0,1.1.72H30.28a1.19,1.19,0,0,0,0-2.38ZM55.44,25.7H41.84L56.3,10.42a1.19,1.19,0,0,0-.86-2H39.08a1.19,1.19,0,1,0,0,2.38H52.67L38.21,26.08A1.18,1.18,0,0,0,38,27.37a1.21,1.21,0,0,0,1.1.72H55.44a1.2,1.2,0,0,0,0-2.39ZM15.63,51.07a1.16,1.16,0,0,1-1.19,1.19H7.74a1.19,1.19,0,0,1-1.09-.72,1.17,1.17,0,0,1,.23-1.28l4.8-5.08H7.74a1.19,1.19,0,0,1,0-2.38h6.7a1.19,1.19,0,0,1,.87,2l-4.8,5.07h3.93a1.19,1.19,0,0,1,1.19,1.19Z"
    }));
};
const $d148c52a5de812dc$export$b127726e56765aa4 = ({ className: className })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 66.58 66.63"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M8.36,51a3.67,3.67,0,0,1-2-4.79.88.88,0,0,0-.48-1.14.87.87,0,0,0-1.14.47,5.4,5.4,0,0,0,0,4.14,5.33,5.33,0,0,0,2.93,2.93.78.78,0,0,0,.33.07A.87.87,0,0,0,8.36,51Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M63.9,12.59a9.14,9.14,0,0,0-6.49-2.67l-.37,0a9.2,9.2,0,1,0-16.16,5.23L15,40.72a9.17,9.17,0,0,0-12.32.58A9.2,9.2,0,0,0,1.5,52.82a9,9,0,0,0,1.17,1.44,9.56,9.56,0,0,0,1.44,1.17,10.08,10.08,0,0,0,1.59.84,9.07,9.07,0,0,0,3.42.66,8.51,8.51,0,0,0,.88,0,9.2,9.2,0,1,0,16.4-5.16L51.59,26.14c.25.2.51.4.79.59a9.28,9.28,0,0,0,10.08,0,8.49,8.49,0,0,0,1.43-1.17,9.16,9.16,0,0,0,0-13ZM62.66,24.31a7.42,7.42,0,0,1-1.16,1,7.62,7.62,0,0,1-8.2,0,6.53,6.53,0,0,1-1.12-.92.9.9,0,0,0-.62-.25h0a.84.84,0,0,0-.62.26L25.19,50.46a9.44,9.44,0,0,0-1.41-1A.88.88,0,0,0,22.91,51,7.45,7.45,0,1,1,11.8,56.54a9.06,9.06,0,0,0,3.83-2.28A.88.88,0,1,0,14.39,53a7.27,7.27,0,0,1-3.55,2h0a7.89,7.89,0,0,1-1.69.19,7.68,7.68,0,0,1-1.4-.13,8.15,8.15,0,0,1-1.36-.4A7.5,7.5,0,0,1,3,51.86a7.46,7.46,0,0,1,1-9.32,7.41,7.41,0,0,1,10.48,0,.89.89,0,0,0,1.24,0L42.14,16.38a9.11,9.11,0,0,0,1.13.79.87.87,0,0,0,.44.11.87.87,0,0,0,.44-1.63A7.45,7.45,0,1,1,55.24,10.2a9.09,9.09,0,0,0-4.3,2.39.88.88,0,0,0,1.24,1.24A7.41,7.41,0,0,1,62.66,24.31Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("path", {
        d: "M45.48,23.05,24.37,44.49a.87.87,0,0,0,0,1.24A.9.9,0,0,0,25,46a.87.87,0,0,0,.62-.26L46.72,24.28a.87.87,0,1,0-1.24-1.23Z"
    }));
};


const $4a334272135d837d$var$Header = ({ pageIndex: pageIndex, backPage: backPage })=>{
    const headerText = ()=>{
        switch(pageIndex){
            case 1:
                return "ABOUT";
            case 2:
                return "LIFE";
            case 3:
                return "DIET";
            case 4:
                return "HEALTH";
            case 5:
                return "STACK";
            default:
                break;
        }
    };
    const trackerClass = ()=>{
        switch(pageIndex){
            case 1:
                return "kids-quiz__header__tracker__active--1";
            case 2:
                return "kids-quiz__header__tracker__active--2";
            case 3:
                return "kids-quiz__header__tracker__active--3";
            case 4:
                return "kids-quiz__header__tracker__active--4";
            case 5:
                return "kids-quiz__header__tracker__active--5";
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "kids-quiz__header"
    }, pageIndex !== 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "back-arrow",
        onClick: backPage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$4930a69c53a0063), null)) : "", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("h1", null, "Step ", pageIndex, " of 5: ", headerText()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "kids-quiz__header__tracker"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("span", {
        className: `kids-quiz__header__tracker__active ${trackerClass()}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("span", {
        className: "kids-quiz__header__tracker__gap"
    })));
};
var $4a334272135d837d$export$2e2bcd8739ae039 = $4a334272135d837d$var$Header;



var $5zKJZ = parcelRequire("5zKJZ");

const $000917754bc643fd$var$PageWelcome = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "kids-quiz__page kids-quiz__page--welcome"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("h1", null, "Getting to know you"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", null, "This comprehensive, 2-minute questionnaire is designed to gain insights into your physiology, dietary preferences, and wellness goals. This enables our experts to craft a nutrient stack that's perfectly aligned with your individual requirements."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "kids-quiz__question"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("label", null, "What's your name?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
        type: "text",
        onChange: (e)=>props.updateFirstName(e.target.value.replace(/(?:^|-)\S/g, (a)=>a.toUpperCase())),
        value: props.firstName
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: `${props.firstName ? "" : "disabled"} btn btn--primary btn--arrow btn--lg `,
        onClick: ()=>props.nextPage("0")
    }, "Get started"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$bd2518280c2f05c1), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("h5", null, "Truly Personalised"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", null, "Combine 7 nutrients with your flavour choice for your unique stack"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$bd2518280c2f05c1), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("h5", null, "7-in-1 Gummy"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", null, "That your body digests like food for higher absorption and efficacy"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$bd2518280c2f05c1), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("h5", null, "Freshly Made"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", null, "Made to order in the UK with ethically sourced, traceable ingredients"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$bd2518280c2f05c1), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("h5", null, "Plant Based"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", null, "Sugar-free and Vegan Society approved along with GMO free"))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "welcome-image",
        style: {
            backgroundImage: "url(https://cdn.shopify.com/s/files/1/0232/9618/0301/files/hand.jpg?v=1716542214)"
        }
    }));
};
var $000917754bc643fd$export$2e2bcd8739ae039 = $000917754bc643fd$var$PageWelcome;



var $5zKJZ = parcelRequire("5zKJZ");

const $4b6d6f9798ecf3a5$var$PageOne = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "kids-quiz__page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        id: "gender",
        className: "kids-quiz__question"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", {
        className: "question__title"
    }, "Are you..."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "answers-row--flex gender-question"
    }, props.renderGenderAnswers)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("a", {
        href: "#age",
        className: `question-divider ${props.gender ? "question-divider--show" : ""}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$2baabfc57bf5919a), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        id: "age",
        className: `kids-quiz__question ${props.gender ? "kids-quiz__question--show" : "kids-quiz__question--hidden"}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("label", {
        className: "question__title"
    }, "How old are you?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
        onChange: props.onChangeNumber,
        onBlur: props.checkAge,
        value: props.age,
        pattern: "\\d*"
    })), props.ageWarningMessage(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("a", {
        href: "#race",
        className: `question-divider ${props.suitableAge && props.age ? "question-divider--show" : ""}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$2baabfc57bf5919a), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        id: "race",
        className: `kids-quiz__question ${props.suitableAge && props.age ? "kids-quiz__question--show" : "kids-quiz__question--hidden"}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", {
        className: "question__title"
    }, "Would you consider yourself to be..."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "answers-row--flex race-question"
    }, props.renderRaceAnswers)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: `next-page ${props.race ? "next-page--show" : "next-page--hidden"}`,
        onClick: ()=>props.nextPage("1")
    }, "Continue"));
};
var $4b6d6f9798ecf3a5$export$2e2bcd8739ae039 = $4b6d6f9798ecf3a5$var$PageOne;



var $5zKJZ = parcelRequire("5zKJZ");
var $ebfaaab6f872e4e6$exports = {};
"use strict";
Object.defineProperty($ebfaaab6f872e4e6$exports, "__esModule", {
    value: true
});
var $787f65e211e86bca$exports = {};
"use strict";
Object.defineProperty($787f65e211e86bca$exports, "__esModule", {
    value: true
});
$787f65e211e86bca$exports.default = undefined;
var $787f65e211e86bca$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $787f65e211e86bca$var$_desc, $787f65e211e86bca$var$_value, $787f65e211e86bca$var$_class;

var $5zKJZ = parcelRequire("5zKJZ");
var $787f65e211e86bca$var$_react2 = $787f65e211e86bca$var$_interopRequireDefault($5zKJZ);
var $1c9b2ec60c53ae5a$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c9b2ec60c53ae5a$var$ReactIs, $1c9b2ec60c53ae5a$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$1c9b2ec60c53ae5a$exports = (parcelRequire("7w8Ih"))();


var $787f65e211e86bca$var$_propTypes2 = $787f65e211e86bca$var$_interopRequireDefault($1c9b2ec60c53ae5a$exports);
var $24eda65c7e4c5153$exports = {};
/**
 * @copyright 2015, Andrey Popp <8mayday@gmail.com>
 *
 * The decorator may be used on classes or methods
 * ```
 * @autobind
 * class FullBound {}
 *
 * class PartBound {
 *   @autobind
 *   method () {}
 * }
 * ```
 */ "use strict";
Object.defineProperty($24eda65c7e4c5153$exports, "__esModule", {
    value: true
});
$24eda65c7e4c5153$exports["default"] = $24eda65c7e4c5153$var$autobind;
function $24eda65c7e4c5153$var$autobind() {
    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if (args.length === 1) return $24eda65c7e4c5153$var$boundClass.apply(undefined, args);
    else return $24eda65c7e4c5153$var$boundMethod.apply(undefined, args);
}
/**
 * Use boundMethod to bind all methods on the target.prototype
 */ function $24eda65c7e4c5153$var$boundClass(target) {
    // (Using reflect to get all keys including symbols)
    var keys = undefined;
    // Use Reflect if exists
    if (typeof Reflect !== "undefined" && typeof Reflect.ownKeys === "function") keys = Reflect.ownKeys(target.prototype);
    else {
        keys = Object.getOwnPropertyNames(target.prototype);
        // use symbols if support is provided
        if (typeof Object.getOwnPropertySymbols === "function") keys = keys.concat(Object.getOwnPropertySymbols(target.prototype));
    }
    keys.forEach(function(key) {
        // Ignore special case target method
        if (key === "constructor") return;
        var descriptor = Object.getOwnPropertyDescriptor(target.prototype, key);
        // Only methods need binding
        if (typeof descriptor.value === "function") Object.defineProperty(target.prototype, key, $24eda65c7e4c5153$var$boundMethod(target, key, descriptor));
    });
    return target;
}
/**
 * Return a descriptor removing the value and returning a getter
 * The getter will return a .bind version of the function
 * and memoize the result against a symbol on the instance
 */ function $24eda65c7e4c5153$var$boundMethod(target, key, descriptor) {
    var fn = descriptor.value;
    if (typeof fn !== "function") throw new Error("@autobind decorator can only be applied to methods not: " + typeof fn);
    // In IE11 calling Object.defineProperty has a side-effect of evaluating the
    // getter for the property which is being replaced. This causes infinite
    // recursion and an "Out of stack space" error.
    var definingProperty = false;
    return {
        configurable: true,
        get: function get() {
            if (definingProperty || this === target.prototype || this.hasOwnProperty(key)) return fn;
            var boundFn = fn.bind(this);
            definingProperty = true;
            Object.defineProperty(this, key, {
                value: boundFn,
                configurable: true,
                writable: true
            });
            definingProperty = false;
            return boundFn;
        }
    };
}
$24eda65c7e4c5153$exports = $24eda65c7e4c5153$exports["default"];


var $787f65e211e86bca$var$_autobindDecorator2 = $787f65e211e86bca$var$_interopRequireDefault($24eda65c7e4c5153$exports);
var $07d6ee9d0cec4d9d$exports = {};
"use strict";
Object.defineProperty($07d6ee9d0cec4d9d$exports, "__esModule", {
    value: true
});
var $07d6ee9d0cec4d9d$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
$07d6ee9d0cec4d9d$exports.getPercentageFromPosition = $07d6ee9d0cec4d9d$var$getPercentageFromPosition;
$07d6ee9d0cec4d9d$exports.getValueFromPosition = $07d6ee9d0cec4d9d$var$getValueFromPosition;
$07d6ee9d0cec4d9d$exports.getValueFromProps = $07d6ee9d0cec4d9d$var$getValueFromProps;
$07d6ee9d0cec4d9d$exports.getPercentageFromValue = $07d6ee9d0cec4d9d$var$getPercentageFromValue;
$07d6ee9d0cec4d9d$exports.getPercentagesFromValues = $07d6ee9d0cec4d9d$var$getPercentagesFromValues;
$07d6ee9d0cec4d9d$exports.getPositionFromValue = $07d6ee9d0cec4d9d$var$getPositionFromValue;
$07d6ee9d0cec4d9d$exports.getPositionsFromValues = $07d6ee9d0cec4d9d$var$getPositionsFromValues;
$07d6ee9d0cec4d9d$exports.getPositionFromEvent = $07d6ee9d0cec4d9d$var$getPositionFromEvent;
$07d6ee9d0cec4d9d$exports.getStepValueFromValue = $07d6ee9d0cec4d9d$var$getStepValueFromValue;
var $48a4e0196a312e89$exports = {};
"use strict";
Object.defineProperty($48a4e0196a312e89$exports, "__esModule", {
    value: true
});
var $1294222069c7a49d$exports = {};
"use strict";
Object.defineProperty($1294222069c7a49d$exports, "__esModule", {
    value: true
});
$1294222069c7a49d$exports.default = $1294222069c7a49d$var$captialize;
/**
 * Captialize a string
 * @ignore
 * @param {string} string
 * @return {string}
 */ function $1294222069c7a49d$var$captialize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
$1294222069c7a49d$exports = $1294222069c7a49d$exports["default"];


Object.defineProperty($48a4e0196a312e89$exports, "captialize", {
    enumerable: true,
    get: function get() {
        return $48a4e0196a312e89$var$_interopRequireDefault($1294222069c7a49d$exports).default;
    }
});
var $760287568a9b4cc9$exports = {};
"use strict";
Object.defineProperty($760287568a9b4cc9$exports, "__esModule", {
    value: true
});
$760287568a9b4cc9$exports.default = $760287568a9b4cc9$var$clamp;
/**
 * Clamp a value between a min and max value
 * @ignore
 * @param {number} value
 * @param {number} min
 * @param {number} max
 * @return {number}
 */ function $760287568a9b4cc9$var$clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
$760287568a9b4cc9$exports = $760287568a9b4cc9$exports["default"];


Object.defineProperty($48a4e0196a312e89$exports, "clamp", {
    enumerable: true,
    get: function get() {
        return $48a4e0196a312e89$var$_interopRequireDefault($760287568a9b4cc9$exports).default;
    }
});
var $13ca1f1dcd3a3ecf$exports = {};
"use strict";
Object.defineProperty($13ca1f1dcd3a3ecf$exports, "__esModule", {
    value: true
});
$13ca1f1dcd3a3ecf$exports.default = $13ca1f1dcd3a3ecf$var$distanceTo;
/**
 * Calculate the distance between pointA and pointB
 * @ignore
 * @param {Point} pointA
 * @param {Point} pointB
 * @return {number} Distance
 */ function $13ca1f1dcd3a3ecf$var$distanceTo(pointA, pointB) {
    var xDiff = Math.pow(pointB.x - pointA.x, 2);
    var yDiff = Math.pow(pointB.y - pointA.y, 2);
    return Math.sqrt(xDiff + yDiff);
}
$13ca1f1dcd3a3ecf$exports = $13ca1f1dcd3a3ecf$exports["default"];


Object.defineProperty($48a4e0196a312e89$exports, "distanceTo", {
    enumerable: true,
    get: function get() {
        return $48a4e0196a312e89$var$_interopRequireDefault($13ca1f1dcd3a3ecf$exports).default;
    }
});
var $63457a67d43bf730$exports = {};
"use strict";
Object.defineProperty($63457a67d43bf730$exports, "__esModule", {
    value: true
});
$63457a67d43bf730$exports.default = $63457a67d43bf730$var$isDefined;
/**
 * Check if a value is defined
 * @ignore
 * @param {*} value
 * @return {boolean}
 */ function $63457a67d43bf730$var$isDefined(value) {
    return value !== undefined && value !== null;
}
$63457a67d43bf730$exports = $63457a67d43bf730$exports["default"];


Object.defineProperty($48a4e0196a312e89$exports, "isDefined", {
    enumerable: true,
    get: function get() {
        return $48a4e0196a312e89$var$_interopRequireDefault($63457a67d43bf730$exports).default;
    }
});
var $c774d207d733b094$exports = {};
"use strict";
Object.defineProperty($c774d207d733b094$exports, "__esModule", {
    value: true
});
$c774d207d733b094$exports.default = $c774d207d733b094$var$isNumber;
/**
 * Check if a value is a number
 * @ignore
 * @param {*} value
 * @return {boolean}
 */ function $c774d207d733b094$var$isNumber(value) {
    return typeof value === "number";
}
$c774d207d733b094$exports = $c774d207d733b094$exports["default"];


Object.defineProperty($48a4e0196a312e89$exports, "isNumber", {
    enumerable: true,
    get: function get() {
        return $48a4e0196a312e89$var$_interopRequireDefault($c774d207d733b094$exports).default;
    }
});
var $29da1e57ccc63c6a$exports = {};
"use strict";
Object.defineProperty($29da1e57ccc63c6a$exports, "__esModule", {
    value: true
});
var $29da1e57ccc63c6a$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
$29da1e57ccc63c6a$exports.default = $29da1e57ccc63c6a$var$isObject;
/**
 * Check if a value is an object
 * @ignore
 * @param {*} value
 * @return {boolean}
 */ function $29da1e57ccc63c6a$var$isObject(value) {
    return value !== null && (typeof value === "undefined" ? "undefined" : $29da1e57ccc63c6a$var$_typeof(value)) === "object";
}
$29da1e57ccc63c6a$exports = $29da1e57ccc63c6a$exports["default"];


Object.defineProperty($48a4e0196a312e89$exports, "isObject", {
    enumerable: true,
    get: function get() {
        return $48a4e0196a312e89$var$_interopRequireDefault($29da1e57ccc63c6a$exports).default;
    }
});
var $655026b15d63be43$exports = {};
"use strict";
Object.defineProperty($655026b15d63be43$exports, "__esModule", {
    value: true
});
$655026b15d63be43$exports.default = $655026b15d63be43$var$length;
/**
 * Calculate the absolute difference between two numbers
 * @ignore
 * @param {number} numA
 * @param {number} numB
 * @return {number}
 */ function $655026b15d63be43$var$length(numA, numB) {
    return Math.abs(numA - numB);
}
$655026b15d63be43$exports = $655026b15d63be43$exports["default"];


Object.defineProperty($48a4e0196a312e89$exports, "length", {
    enumerable: true,
    get: function get() {
        return $48a4e0196a312e89$var$_interopRequireDefault($655026b15d63be43$exports).default;
    }
});
function $48a4e0196a312e89$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}


/**
 * Convert a point into a percentage value
 * @ignore
 * @param {Point} position
 * @param {ClientRect} clientRect
 * @return {number} Percentage value
 */ function $07d6ee9d0cec4d9d$var$getPercentageFromPosition(position, clientRect) {
    var length = clientRect.width;
    var sizePerc = position.x / length;
    return sizePerc || 0;
}
/**
 * Convert a point into a model value
 * @ignore
 * @param {Point} position
 * @param {number} minValue
 * @param {number} maxValue
 * @param {ClientRect} clientRect
 * @return {number}
 */ function $07d6ee9d0cec4d9d$var$getValueFromPosition(position, minValue, maxValue, clientRect) {
    var sizePerc = $07d6ee9d0cec4d9d$var$getPercentageFromPosition(position, clientRect);
    var valueDiff = maxValue - minValue;
    return minValue + valueDiff * sizePerc;
}
/**
 * Convert props into a range value
 * @ignore
 * @param {Object} props
 * @param {boolean} isMultiValue
 * @return {Range}
 */ function $07d6ee9d0cec4d9d$var$getValueFromProps(props, isMultiValue) {
    if (isMultiValue) return $07d6ee9d0cec4d9d$var$_extends({}, props.value);
    return {
        min: props.minValue,
        max: props.value
    };
}
/**
 * Convert a model value into a percentage value
 * @ignore
 * @param {number} value
 * @param {number} minValue
 * @param {number} maxValue
 * @return {number}
 */ function $07d6ee9d0cec4d9d$var$getPercentageFromValue(value, minValue, maxValue) {
    var validValue = (0, $48a4e0196a312e89$exports.clamp)(value, minValue, maxValue);
    var valueDiff = maxValue - minValue;
    var valuePerc = (validValue - minValue) / valueDiff;
    return valuePerc || 0;
}
/**
 * Convert model values into percentage values
 * @ignore
 * @param {Range} values
 * @param {number} minValue
 * @param {number} maxValue
 * @return {Range}
 */ function $07d6ee9d0cec4d9d$var$getPercentagesFromValues(values, minValue, maxValue) {
    return {
        min: $07d6ee9d0cec4d9d$var$getPercentageFromValue(values.min, minValue, maxValue),
        max: $07d6ee9d0cec4d9d$var$getPercentageFromValue(values.max, minValue, maxValue)
    };
}
/**
 * Convert a value into a point
 * @ignore
 * @param {number} value
 * @param {number} minValue
 * @param {number} maxValue
 * @param {ClientRect} clientRect
 * @return {Point} Position
 */ function $07d6ee9d0cec4d9d$var$getPositionFromValue(value, minValue, maxValue, clientRect) {
    var length = clientRect.width;
    var valuePerc = $07d6ee9d0cec4d9d$var$getPercentageFromValue(value, minValue, maxValue);
    var positionValue = valuePerc * length;
    return {
        x: positionValue,
        y: 0
    };
}
/**
 * Convert a range of values into points
 * @ignore
 * @param {Range} values
 * @param {number} minValue
 * @param {number} maxValue
 * @param {ClientRect} clientRect
 * @return {Range}
 */ function $07d6ee9d0cec4d9d$var$getPositionsFromValues(values, minValue, maxValue, clientRect) {
    return {
        min: $07d6ee9d0cec4d9d$var$getPositionFromValue(values.min, minValue, maxValue, clientRect),
        max: $07d6ee9d0cec4d9d$var$getPositionFromValue(values.max, minValue, maxValue, clientRect)
    };
}
/**
 * Convert an event into a point
 * @ignore
 * @param {Event} event
 * @param {ClientRect} clientRect
 * @return {Point}
 */ function $07d6ee9d0cec4d9d$var$getPositionFromEvent(event, clientRect) {
    var length = clientRect.width;
    var _ref = event.touches ? event.touches[0] : event, clientX = _ref.clientX;
    return {
        x: (0, $48a4e0196a312e89$exports.clamp)(clientX - clientRect.left, 0, length),
        y: 0
    };
}
/**
 * Convert a value into a step value
 * @ignore
 * @param {number} value
 * @param {number} valuePerStep
 * @return {number}
 */ function $07d6ee9d0cec4d9d$var$getStepValueFromValue(value, valuePerStep) {
    return Math.round(value / valuePerStep) * valuePerStep;
}


var $787f65e211e86bca$var$valueTransformer = $787f65e211e86bca$var$_interopRequireWildcard($07d6ee9d0cec4d9d$exports);
var $41b18ae3f9bdd935$exports = {};
"use strict";
Object.defineProperty($41b18ae3f9bdd935$exports, "__esModule", {
    value: true
});
/**
 * Default CSS class names
 * @ignore
 * @type {InputRangeClassNames}
 */ var $41b18ae3f9bdd935$var$DEFAULT_CLASS_NAMES = {
    activeTrack: "input-range__track input-range__track--active",
    disabledInputRange: "input-range input-range--disabled",
    inputRange: "input-range",
    labelContainer: "input-range__label-container",
    maxLabel: "input-range__label input-range__label--max",
    minLabel: "input-range__label input-range__label--min",
    slider: "input-range__slider",
    sliderContainer: "input-range__slider-container",
    track: "input-range__track input-range__track--background",
    valueLabel: "input-range__label input-range__label--value"
};
$41b18ae3f9bdd935$exports.default = $41b18ae3f9bdd935$var$DEFAULT_CLASS_NAMES;
$41b18ae3f9bdd935$exports = $41b18ae3f9bdd935$exports["default"];


var $787f65e211e86bca$var$_defaultClassNames2 = $787f65e211e86bca$var$_interopRequireDefault($41b18ae3f9bdd935$exports);
var $f47af21a98bf982c$exports = {};
"use strict";
Object.defineProperty($f47af21a98bf982c$exports, "__esModule", {
    value: true
});
$f47af21a98bf982c$exports.default = $f47af21a98bf982c$var$Label;

var $5zKJZ = parcelRequire("5zKJZ");
var $f47af21a98bf982c$var$_react2 = $f47af21a98bf982c$var$_interopRequireDefault($5zKJZ);

var $f47af21a98bf982c$var$_propTypes2 = $f47af21a98bf982c$var$_interopRequireDefault($1c9b2ec60c53ae5a$exports);
function $f47af21a98bf982c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @ignore
 * @param {Object} props
 * @param {InputRangeClassNames} props.classNames
 * @param {Function} props.formatLabel
 * @param {string} props.type
 */ function $f47af21a98bf982c$var$Label(props) {
    var labelValue = props.formatLabel ? props.formatLabel(props.children, props.type) : props.children;
    return $f47af21a98bf982c$var$_react2.default.createElement("span", {
        className: props.classNames[props.type + "Label"]
    }, $f47af21a98bf982c$var$_react2.default.createElement("span", {
        className: props.classNames.labelContainer
    }, labelValue));
}
/**
 * @type {Object}
 * @property {Function} children
 * @property {Function} classNames
 * @property {Function} formatLabel
 * @property {Function} type
 */ $f47af21a98bf982c$var$Label.propTypes = {
    children: $f47af21a98bf982c$var$_propTypes2.default.node.isRequired,
    classNames: $f47af21a98bf982c$var$_propTypes2.default.objectOf($f47af21a98bf982c$var$_propTypes2.default.string).isRequired,
    formatLabel: $f47af21a98bf982c$var$_propTypes2.default.func,
    type: $f47af21a98bf982c$var$_propTypes2.default.string.isRequired
};
$f47af21a98bf982c$exports = $f47af21a98bf982c$exports["default"];


var $787f65e211e86bca$var$_label2 = $787f65e211e86bca$var$_interopRequireDefault($f47af21a98bf982c$exports);
var $03f468af91832f10$exports = {};
"use strict";
Object.defineProperty($03f468af91832f10$exports, "__esModule", {
    value: true
});
$03f468af91832f10$exports.default = $03f468af91832f10$var$rangePropType;

/**
 * @ignore
 * @param {Object} props - React component props
 * @return {?Error} Return Error if validation fails
 */ function $03f468af91832f10$var$rangePropType(props) {
    var maxValue = props.maxValue, minValue = props.minValue;
    if (!(0, $48a4e0196a312e89$exports.isNumber)(minValue) || !(0, $48a4e0196a312e89$exports.isNumber)(maxValue)) return new Error('"minValue" and "maxValue" must be a number');
    if (minValue >= maxValue) return new Error('"minValue" must be smaller than "maxValue"');
}
$03f468af91832f10$exports = $03f468af91832f10$exports["default"];


var $787f65e211e86bca$var$_rangePropType2 = $787f65e211e86bca$var$_interopRequireDefault($03f468af91832f10$exports);
var $9c5322ee69d1aef3$exports = {};
"use strict";
Object.defineProperty($9c5322ee69d1aef3$exports, "__esModule", {
    value: true
});
$9c5322ee69d1aef3$exports.default = $9c5322ee69d1aef3$var$valuePropType;

/**
 * @ignore
 * @param {Object} props
 * @return {?Error} Return Error if validation fails
 */ function $9c5322ee69d1aef3$var$valuePropType(props, propName) {
    var maxValue = props.maxValue, minValue = props.minValue;
    var value = props[propName];
    if (!(0, $48a4e0196a312e89$exports.isNumber)(value) && (!(0, $48a4e0196a312e89$exports.isObject)(value) || !(0, $48a4e0196a312e89$exports.isNumber)(value.min) || !(0, $48a4e0196a312e89$exports.isNumber)(value.max))) return new Error('"' + propName + '" must be a number or a range object');
    if ((0, $48a4e0196a312e89$exports.isNumber)(value) && (value < minValue || value > maxValue)) return new Error('"' + propName + '" must be in between "minValue" and "maxValue"');
    if ((0, $48a4e0196a312e89$exports.isObject)(value) && (value.min < minValue || value.min > maxValue || value.max < minValue || value.max > maxValue)) return new Error('"' + propName + '" must be in between "minValue" and "maxValue"');
}
$9c5322ee69d1aef3$exports = $9c5322ee69d1aef3$exports["default"];


var $787f65e211e86bca$var$_valuePropType2 = $787f65e211e86bca$var$_interopRequireDefault($9c5322ee69d1aef3$exports);
var $06afeb3ce45edee0$exports = {};
"use strict";
Object.defineProperty($06afeb3ce45edee0$exports, "__esModule", {
    value: true
});
$06afeb3ce45edee0$exports.default = undefined;
var $06afeb3ce45edee0$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $06afeb3ce45edee0$var$_desc, $06afeb3ce45edee0$var$_value, $06afeb3ce45edee0$var$_class;

var $5zKJZ = parcelRequire("5zKJZ");
var $06afeb3ce45edee0$var$_react2 = $06afeb3ce45edee0$var$_interopRequireDefault($5zKJZ);

var $06afeb3ce45edee0$var$_propTypes2 = $06afeb3ce45edee0$var$_interopRequireDefault($1c9b2ec60c53ae5a$exports);

var $06afeb3ce45edee0$var$_autobindDecorator2 = $06afeb3ce45edee0$var$_interopRequireDefault($24eda65c7e4c5153$exports);

var $06afeb3ce45edee0$var$_label2 = $06afeb3ce45edee0$var$_interopRequireDefault($f47af21a98bf982c$exports);
function $06afeb3ce45edee0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $06afeb3ce45edee0$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $06afeb3ce45edee0$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $06afeb3ce45edee0$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $06afeb3ce45edee0$var$_applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object["keys"](descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ("value" in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object["defineProperty"](target, property, desc);
        desc = null;
    }
    return desc;
}
/**
 * @ignore
 */ var $06afeb3ce45edee0$var$Slider = ($06afeb3ce45edee0$var$_class = function(_React$Component) {
    $06afeb3ce45edee0$var$_inherits(Slider, _React$Component);
    $06afeb3ce45edee0$var$_createClass(Slider, null, [
        {
            key: "propTypes",
            /**
     * Accepted propTypes of Slider
     * @override
     * @return {Object}
     * @property {Function} ariaLabelledby
     * @property {Function} ariaControls
     * @property {Function} className
     * @property {Function} formatLabel
     * @property {Function} maxValue
     * @property {Function} minValue
     * @property {Function} onSliderDrag
     * @property {Function} onSliderKeyDown
     * @property {Function} percentage
     * @property {Function} type
     * @property {Function} value
     */ get: function get() {
                return {
                    ariaLabelledby: $06afeb3ce45edee0$var$_propTypes2.default.string,
                    ariaControls: $06afeb3ce45edee0$var$_propTypes2.default.string,
                    classNames: $06afeb3ce45edee0$var$_propTypes2.default.objectOf($06afeb3ce45edee0$var$_propTypes2.default.string).isRequired,
                    formatLabel: $06afeb3ce45edee0$var$_propTypes2.default.func,
                    maxValue: $06afeb3ce45edee0$var$_propTypes2.default.number,
                    minValue: $06afeb3ce45edee0$var$_propTypes2.default.number,
                    onSliderDrag: $06afeb3ce45edee0$var$_propTypes2.default.func.isRequired,
                    onSliderKeyDown: $06afeb3ce45edee0$var$_propTypes2.default.func.isRequired,
                    percentage: $06afeb3ce45edee0$var$_propTypes2.default.number.isRequired,
                    type: $06afeb3ce45edee0$var$_propTypes2.default.string.isRequired,
                    value: $06afeb3ce45edee0$var$_propTypes2.default.number.isRequired
                };
            }
        }
    ]);
    function Slider(props) {
        $06afeb3ce45edee0$var$_classCallCheck(this, Slider);
        /**
     * @private
     * @type {?Component}
     */ var _this = $06afeb3ce45edee0$var$_possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));
        _this.node = null;
        return _this;
    }
    /**
   * @ignore
   * @override
   * @return {void}
   */ $06afeb3ce45edee0$var$_createClass(Slider, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.removeDocumentMouseMoveListener();
                this.removeDocumentMouseUpListener();
                this.removeDocumentTouchEndListener();
                this.removeDocumentTouchMoveListener();
            }
        },
        {
            key: "getStyle",
            value: function getStyle() {
                var perc = (this.props.percentage || 0) * 100;
                var style = {
                    position: "absolute",
                    left: perc + "%"
                };
                return style;
            }
        },
        {
            key: "addDocumentMouseMoveListener",
            value: function addDocumentMouseMoveListener() {
                this.removeDocumentMouseMoveListener();
                this.node.ownerDocument.addEventListener("mousemove", this.handleMouseMove);
            }
        },
        {
            key: "addDocumentMouseUpListener",
            value: function addDocumentMouseUpListener() {
                this.removeDocumentMouseUpListener();
                this.node.ownerDocument.addEventListener("mouseup", this.handleMouseUp);
            }
        },
        {
            key: "addDocumentTouchMoveListener",
            value: function addDocumentTouchMoveListener() {
                this.removeDocumentTouchMoveListener();
                this.node.ownerDocument.addEventListener("touchmove", this.handleTouchMove);
            }
        },
        {
            key: "addDocumentTouchEndListener",
            value: function addDocumentTouchEndListener() {
                this.removeDocumentTouchEndListener();
                this.node.ownerDocument.addEventListener("touchend", this.handleTouchEnd);
            }
        },
        {
            key: "removeDocumentMouseMoveListener",
            value: function removeDocumentMouseMoveListener() {
                this.node.ownerDocument.removeEventListener("mousemove", this.handleMouseMove);
            }
        },
        {
            key: "removeDocumentMouseUpListener",
            value: function removeDocumentMouseUpListener() {
                this.node.ownerDocument.removeEventListener("mouseup", this.handleMouseUp);
            }
        },
        {
            key: "removeDocumentTouchMoveListener",
            value: function removeDocumentTouchMoveListener() {
                this.node.ownerDocument.removeEventListener("touchmove", this.handleTouchMove);
            }
        },
        {
            key: "removeDocumentTouchEndListener",
            value: function removeDocumentTouchEndListener() {
                this.node.ownerDocument.removeEventListener("touchend", this.handleTouchEnd);
            }
        },
        {
            key: "handleMouseDown",
            value: function handleMouseDown() {
                this.addDocumentMouseMoveListener();
                this.addDocumentMouseUpListener();
            }
        },
        {
            key: "handleMouseUp",
            value: function handleMouseUp() {
                this.removeDocumentMouseMoveListener();
                this.removeDocumentMouseUpListener();
            }
        },
        {
            key: "handleMouseMove",
            value: function handleMouseMove(event) {
                this.props.onSliderDrag(event, this.props.type);
            }
        },
        {
            key: "handleTouchStart",
            value: function handleTouchStart() {
                this.addDocumentTouchEndListener();
                this.addDocumentTouchMoveListener();
            }
        },
        {
            key: "handleTouchMove",
            value: function handleTouchMove(event) {
                this.props.onSliderDrag(event, this.props.type);
            }
        },
        {
            key: "handleTouchEnd",
            value: function handleTouchEnd() {
                this.removeDocumentTouchMoveListener();
                this.removeDocumentTouchEndListener();
            }
        },
        {
            key: "handleKeyDown",
            value: function handleKeyDown(event) {
                this.props.onSliderKeyDown(event, this.props.type);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var style = this.getStyle();
                return $06afeb3ce45edee0$var$_react2.default.createElement("span", {
                    className: this.props.classNames.sliderContainer,
                    ref: function ref(node) {
                        _this2.node = node;
                    },
                    style: style
                }, $06afeb3ce45edee0$var$_react2.default.createElement($06afeb3ce45edee0$var$_label2.default, {
                    classNames: this.props.classNames,
                    formatLabel: this.props.formatLabel,
                    type: "value"
                }, this.props.value), $06afeb3ce45edee0$var$_react2.default.createElement("div", {
                    "aria-labelledby": this.props.ariaLabelledby,
                    "aria-controls": this.props.ariaControls,
                    "aria-valuemax": this.props.maxValue,
                    "aria-valuemin": this.props.minValue,
                    "aria-valuenow": this.props.value,
                    className: this.props.classNames.slider,
                    draggable: "false",
                    onKeyDown: this.handleKeyDown,
                    onMouseDown: this.handleMouseDown,
                    onTouchStart: this.handleTouchStart,
                    role: "slider",
                    tabIndex: "0"
                }));
            }
        }
    ]);
    return Slider;
}($06afeb3ce45edee0$var$_react2.default.Component), $06afeb3ce45edee0$var$_applyDecoratedDescriptor($06afeb3ce45edee0$var$_class.prototype, "handleMouseDown", [
    $06afeb3ce45edee0$var$_autobindDecorator2.default
], Object.getOwnPropertyDescriptor($06afeb3ce45edee0$var$_class.prototype, "handleMouseDown"), $06afeb3ce45edee0$var$_class.prototype), $06afeb3ce45edee0$var$_applyDecoratedDescriptor($06afeb3ce45edee0$var$_class.prototype, "handleMouseUp", [
    $06afeb3ce45edee0$var$_autobindDecorator2.default
], Object.getOwnPropertyDescriptor($06afeb3ce45edee0$var$_class.prototype, "handleMouseUp"), $06afeb3ce45edee0$var$_class.prototype), $06afeb3ce45edee0$var$_applyDecoratedDescriptor($06afeb3ce45edee0$var$_class.prototype, "handleMouseMove", [
    $06afeb3ce45edee0$var$_autobindDecorator2.default
], Object.getOwnPropertyDescriptor($06afeb3ce45edee0$var$_class.prototype, "handleMouseMove"), $06afeb3ce45edee0$var$_class.prototype), $06afeb3ce45edee0$var$_applyDecoratedDescriptor($06afeb3ce45edee0$var$_class.prototype, "handleTouchStart", [
    $06afeb3ce45edee0$var$_autobindDecorator2.default
], Object.getOwnPropertyDescriptor($06afeb3ce45edee0$var$_class.prototype, "handleTouchStart"), $06afeb3ce45edee0$var$_class.prototype), $06afeb3ce45edee0$var$_applyDecoratedDescriptor($06afeb3ce45edee0$var$_class.prototype, "handleTouchMove", [
    $06afeb3ce45edee0$var$_autobindDecorator2.default
], Object.getOwnPropertyDescriptor($06afeb3ce45edee0$var$_class.prototype, "handleTouchMove"), $06afeb3ce45edee0$var$_class.prototype), $06afeb3ce45edee0$var$_applyDecoratedDescriptor($06afeb3ce45edee0$var$_class.prototype, "handleTouchEnd", [
    $06afeb3ce45edee0$var$_autobindDecorator2.default
], Object.getOwnPropertyDescriptor($06afeb3ce45edee0$var$_class.prototype, "handleTouchEnd"), $06afeb3ce45edee0$var$_class.prototype), $06afeb3ce45edee0$var$_applyDecoratedDescriptor($06afeb3ce45edee0$var$_class.prototype, "handleKeyDown", [
    $06afeb3ce45edee0$var$_autobindDecorator2.default
], Object.getOwnPropertyDescriptor($06afeb3ce45edee0$var$_class.prototype, "handleKeyDown"), $06afeb3ce45edee0$var$_class.prototype), $06afeb3ce45edee0$var$_class);
$06afeb3ce45edee0$exports.default = $06afeb3ce45edee0$var$Slider;
$06afeb3ce45edee0$exports = $06afeb3ce45edee0$exports["default"];


var $787f65e211e86bca$var$_slider2 = $787f65e211e86bca$var$_interopRequireDefault($06afeb3ce45edee0$exports);
var $24fa8c5b9fa6f972$exports = {};
"use strict";
Object.defineProperty($24fa8c5b9fa6f972$exports, "__esModule", {
    value: true
});
$24fa8c5b9fa6f972$exports.default = undefined;
var $24fa8c5b9fa6f972$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $24fa8c5b9fa6f972$var$_desc, $24fa8c5b9fa6f972$var$_value, $24fa8c5b9fa6f972$var$_class;

var $5zKJZ = parcelRequire("5zKJZ");
var $24fa8c5b9fa6f972$var$_react2 = $24fa8c5b9fa6f972$var$_interopRequireDefault($5zKJZ);

var $24fa8c5b9fa6f972$var$_propTypes2 = $24fa8c5b9fa6f972$var$_interopRequireDefault($1c9b2ec60c53ae5a$exports);

var $24fa8c5b9fa6f972$var$_autobindDecorator2 = $24fa8c5b9fa6f972$var$_interopRequireDefault($24eda65c7e4c5153$exports);
function $24fa8c5b9fa6f972$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $24fa8c5b9fa6f972$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $24fa8c5b9fa6f972$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $24fa8c5b9fa6f972$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $24fa8c5b9fa6f972$var$_applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object["keys"](descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ("value" in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object["defineProperty"](target, property, desc);
        desc = null;
    }
    return desc;
}
/**
 * @ignore
 */ var $24fa8c5b9fa6f972$var$Track = ($24fa8c5b9fa6f972$var$_class = function(_React$Component) {
    $24fa8c5b9fa6f972$var$_inherits(Track, _React$Component);
    $24fa8c5b9fa6f972$var$_createClass(Track, null, [
        {
            key: "propTypes",
            /**
     * @override
     * @return {Object}
     * @property {Function} children
     * @property {Function} classNames
     * @property {Boolean} draggableTrack
     * @property {Function} onTrackDrag
     * @property {Function} onTrackMouseDown
     * @property {Function} percentages
     */ get: function get() {
                return {
                    children: $24fa8c5b9fa6f972$var$_propTypes2.default.node.isRequired,
                    classNames: $24fa8c5b9fa6f972$var$_propTypes2.default.objectOf($24fa8c5b9fa6f972$var$_propTypes2.default.string).isRequired,
                    draggableTrack: $24fa8c5b9fa6f972$var$_propTypes2.default.bool,
                    onTrackDrag: $24fa8c5b9fa6f972$var$_propTypes2.default.func,
                    onTrackMouseDown: $24fa8c5b9fa6f972$var$_propTypes2.default.func.isRequired,
                    percentages: $24fa8c5b9fa6f972$var$_propTypes2.default.objectOf($24fa8c5b9fa6f972$var$_propTypes2.default.number).isRequired
                };
            }
        }
    ]);
    function Track(props) {
        $24fa8c5b9fa6f972$var$_classCallCheck(this, Track);
        /**
     * @private
     * @type {?Component}
     */ var _this = $24fa8c5b9fa6f972$var$_possibleConstructorReturn(this, (Track.__proto__ || Object.getPrototypeOf(Track)).call(this, props));
        _this.node = null;
        _this.trackDragEvent = null;
        return _this;
    }
    /**
   * @private
   * @return {ClientRect}
   */ $24fa8c5b9fa6f972$var$_createClass(Track, [
        {
            key: "getClientRect",
            value: function getClientRect() {
                return this.node.getBoundingClientRect();
            }
        },
        {
            key: "getActiveTrackStyle",
            value: function getActiveTrackStyle() {
                var width = (this.props.percentages.max - this.props.percentages.min) * 100 + "%";
                var left = this.props.percentages.min * 100 + "%";
                return {
                    left: left,
                    width: width
                };
            }
        },
        {
            key: "addDocumentMouseMoveListener",
            value: function addDocumentMouseMoveListener() {
                this.removeDocumentMouseMoveListener();
                this.node.ownerDocument.addEventListener("mousemove", this.handleMouseMove);
            }
        },
        {
            key: "addDocumentMouseUpListener",
            value: function addDocumentMouseUpListener() {
                this.removeDocumentMouseUpListener();
                this.node.ownerDocument.addEventListener("mouseup", this.handleMouseUp);
            }
        },
        {
            key: "removeDocumentMouseMoveListener",
            value: function removeDocumentMouseMoveListener() {
                this.node.ownerDocument.removeEventListener("mousemove", this.handleMouseMove);
            }
        },
        {
            key: "removeDocumentMouseUpListener",
            value: function removeDocumentMouseUpListener() {
                this.node.ownerDocument.removeEventListener("mouseup", this.handleMouseUp);
            }
        },
        {
            key: "handleMouseMove",
            value: function handleMouseMove(event) {
                if (!this.props.draggableTrack) return;
                if (this.trackDragEvent !== null) this.props.onTrackDrag(event, this.trackDragEvent);
                this.trackDragEvent = event;
            }
        },
        {
            key: "handleMouseUp",
            value: function handleMouseUp() {
                if (!this.props.draggableTrack) return;
                this.removeDocumentMouseMoveListener();
                this.removeDocumentMouseUpListener();
                this.trackDragEvent = null;
            }
        },
        {
            key: "handleMouseDown",
            value: function handleMouseDown(event) {
                var clientX = event.touches ? event.touches[0].clientX : event.clientX;
                var trackClientRect = this.getClientRect();
                var position = {
                    x: clientX - trackClientRect.left,
                    y: 0
                };
                this.props.onTrackMouseDown(event, position);
                if (this.props.draggableTrack) {
                    this.addDocumentMouseMoveListener();
                    this.addDocumentMouseUpListener();
                }
            }
        },
        {
            key: "handleTouchStart",
            value: function handleTouchStart(event) {
                event.preventDefault();
                this.handleMouseDown(event);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var activeTrackStyle = this.getActiveTrackStyle();
                return $24fa8c5b9fa6f972$var$_react2.default.createElement("div", {
                    className: this.props.classNames.track,
                    onMouseDown: this.handleMouseDown,
                    onTouchStart: this.handleTouchStart,
                    ref: function ref(node) {
                        _this2.node = node;
                    }
                }, $24fa8c5b9fa6f972$var$_react2.default.createElement("div", {
                    style: activeTrackStyle,
                    className: this.props.classNames.activeTrack
                }), this.props.children);
            }
        }
    ]);
    return Track;
}($24fa8c5b9fa6f972$var$_react2.default.Component), $24fa8c5b9fa6f972$var$_applyDecoratedDescriptor($24fa8c5b9fa6f972$var$_class.prototype, "handleMouseMove", [
    $24fa8c5b9fa6f972$var$_autobindDecorator2.default
], Object.getOwnPropertyDescriptor($24fa8c5b9fa6f972$var$_class.prototype, "handleMouseMove"), $24fa8c5b9fa6f972$var$_class.prototype), $24fa8c5b9fa6f972$var$_applyDecoratedDescriptor($24fa8c5b9fa6f972$var$_class.prototype, "handleMouseUp", [
    $24fa8c5b9fa6f972$var$_autobindDecorator2.default
], Object.getOwnPropertyDescriptor($24fa8c5b9fa6f972$var$_class.prototype, "handleMouseUp"), $24fa8c5b9fa6f972$var$_class.prototype), $24fa8c5b9fa6f972$var$_applyDecoratedDescriptor($24fa8c5b9fa6f972$var$_class.prototype, "handleMouseDown", [
    $24fa8c5b9fa6f972$var$_autobindDecorator2.default
], Object.getOwnPropertyDescriptor($24fa8c5b9fa6f972$var$_class.prototype, "handleMouseDown"), $24fa8c5b9fa6f972$var$_class.prototype), $24fa8c5b9fa6f972$var$_applyDecoratedDescriptor($24fa8c5b9fa6f972$var$_class.prototype, "handleTouchStart", [
    $24fa8c5b9fa6f972$var$_autobindDecorator2.default
], Object.getOwnPropertyDescriptor($24fa8c5b9fa6f972$var$_class.prototype, "handleTouchStart"), $24fa8c5b9fa6f972$var$_class.prototype), $24fa8c5b9fa6f972$var$_class);
$24fa8c5b9fa6f972$exports.default = $24fa8c5b9fa6f972$var$Track;
$24fa8c5b9fa6f972$exports = $24fa8c5b9fa6f972$exports["default"];


var $787f65e211e86bca$var$_track2 = $787f65e211e86bca$var$_interopRequireDefault($24fa8c5b9fa6f972$exports);

var $bf50895f694b3ca9$exports = {};
"use strict";
Object.defineProperty($bf50895f694b3ca9$exports, "__esModule", {
    value: true
});
/** @ignore */ var $bf50895f694b3ca9$var$DOWN_ARROW = $bf50895f694b3ca9$exports.DOWN_ARROW = 40;
/** @ignore */ var $bf50895f694b3ca9$var$LEFT_ARROW = $bf50895f694b3ca9$exports.LEFT_ARROW = 37;
/** @ignore */ var $bf50895f694b3ca9$var$RIGHT_ARROW = $bf50895f694b3ca9$exports.RIGHT_ARROW = 39;
/** @ignore */ var $bf50895f694b3ca9$var$UP_ARROW = $bf50895f694b3ca9$exports.UP_ARROW = 38;


function $787f65e211e86bca$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $787f65e211e86bca$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $787f65e211e86bca$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $787f65e211e86bca$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $787f65e211e86bca$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $787f65e211e86bca$var$_applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object["keys"](descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ("value" in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object["defineProperty"](target, property, desc);
        desc = null;
    }
    return desc;
}
/**
 * A React component that allows users to input numeric values within a range
 * by dragging its sliders.
 */ var $787f65e211e86bca$var$InputRange = ($787f65e211e86bca$var$_class = function(_React$Component) {
    $787f65e211e86bca$var$_inherits(InputRange, _React$Component);
    $787f65e211e86bca$var$_createClass(InputRange, null, [
        {
            key: "propTypes",
            /**
     * @ignore
     * @override
     * @return {Object}
     */ get: function get() {
                return {
                    allowSameValues: $787f65e211e86bca$var$_propTypes2.default.bool,
                    ariaLabelledby: $787f65e211e86bca$var$_propTypes2.default.string,
                    ariaControls: $787f65e211e86bca$var$_propTypes2.default.string,
                    classNames: $787f65e211e86bca$var$_propTypes2.default.objectOf($787f65e211e86bca$var$_propTypes2.default.string),
                    disabled: $787f65e211e86bca$var$_propTypes2.default.bool,
                    draggableTrack: $787f65e211e86bca$var$_propTypes2.default.bool,
                    formatLabel: $787f65e211e86bca$var$_propTypes2.default.func,
                    maxValue: $787f65e211e86bca$var$_rangePropType2.default,
                    minValue: $787f65e211e86bca$var$_rangePropType2.default,
                    name: $787f65e211e86bca$var$_propTypes2.default.string,
                    onChangeStart: $787f65e211e86bca$var$_propTypes2.default.func,
                    onChange: $787f65e211e86bca$var$_propTypes2.default.func.isRequired,
                    onChangeComplete: $787f65e211e86bca$var$_propTypes2.default.func,
                    step: $787f65e211e86bca$var$_propTypes2.default.number,
                    value: $787f65e211e86bca$var$_valuePropType2.default
                };
            }
        },
        {
            key: "defaultProps",
            get: function get() {
                return {
                    allowSameValues: false,
                    classNames: $787f65e211e86bca$var$_defaultClassNames2.default,
                    disabled: false,
                    maxValue: 10,
                    minValue: 0,
                    step: 1
                };
            }
        }
    ]);
    function InputRange(props) {
        $787f65e211e86bca$var$_classCallCheck(this, InputRange);
        /**
     * @private
     * @type {?number}
     */ var _this = $787f65e211e86bca$var$_possibleConstructorReturn(this, (InputRange.__proto__ || Object.getPrototypeOf(InputRange)).call(this, props));
        _this.startValue = null;
        /**
     * @private
     * @type {?Component}
     */ _this.node = null;
        /**
     * @private
     * @type {?Component}
     */ _this.trackNode = null;
        /**
     * @private
     * @type {bool}
     */ _this.isSliderDragging = false;
        /**
     * @private
     * @type {?string}
     */ _this.lastKeyMoved = null;
        return _this;
    }
    /**
   * @ignore
   * @override
   * @return {void}
   */ $787f65e211e86bca$var$_createClass(InputRange, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.removeDocumentMouseUpListener();
                this.removeDocumentTouchEndListener();
            }
        },
        {
            key: "getComponentClassName",
            value: function getComponentClassName() {
                if (!this.props.disabled) return this.props.classNames.inputRange;
                return this.props.classNames.disabledInputRange;
            }
        },
        {
            key: "getTrackClientRect",
            value: function getTrackClientRect() {
                return this.trackNode.getClientRect();
            }
        },
        {
            key: "getKeyByPosition",
            value: function getKeyByPosition(position) {
                var values = $787f65e211e86bca$var$valueTransformer.getValueFromProps(this.props, this.isMultiValue());
                var positions = $787f65e211e86bca$var$valueTransformer.getPositionsFromValues(values, this.props.minValue, this.props.maxValue, this.getTrackClientRect());
                if (this.isMultiValue()) {
                    var distanceToMin = (0, $48a4e0196a312e89$exports.distanceTo)(position, positions.min);
                    var distanceToMax = (0, $48a4e0196a312e89$exports.distanceTo)(position, positions.max);
                    if (distanceToMin < distanceToMax) return "min";
                }
                return "max";
            }
        },
        {
            key: "getKeys",
            value: function getKeys() {
                if (this.isMultiValue()) return [
                    "min",
                    "max"
                ];
                return [
                    "max"
                ];
            }
        },
        {
            key: "hasStepDifference",
            value: function hasStepDifference(values) {
                var currentValues = $787f65e211e86bca$var$valueTransformer.getValueFromProps(this.props, this.isMultiValue());
                return (0, $48a4e0196a312e89$exports.length)(values.min, currentValues.min) >= this.props.step || (0, $48a4e0196a312e89$exports.length)(values.max, currentValues.max) >= this.props.step;
            }
        },
        {
            key: "isMultiValue",
            value: function isMultiValue() {
                return (0, $48a4e0196a312e89$exports.isObject)(this.props.value);
            }
        },
        {
            key: "isWithinRange",
            value: function isWithinRange(values) {
                if (this.isMultiValue()) return values.min >= this.props.minValue && values.max <= this.props.maxValue && this.props.allowSameValues ? values.min <= values.max : values.min < values.max;
                return values.max >= this.props.minValue && values.max <= this.props.maxValue;
            }
        },
        {
            key: "shouldUpdate",
            value: function shouldUpdate(values) {
                return this.isWithinRange(values) && this.hasStepDifference(values);
            }
        },
        {
            key: "updatePosition",
            value: function updatePosition(key, position) {
                var values = $787f65e211e86bca$var$valueTransformer.getValueFromProps(this.props, this.isMultiValue());
                var positions = $787f65e211e86bca$var$valueTransformer.getPositionsFromValues(values, this.props.minValue, this.props.maxValue, this.getTrackClientRect());
                positions[key] = position;
                this.lastKeyMoved = key;
                this.updatePositions(positions);
            }
        },
        {
            key: "updatePositions",
            value: function updatePositions(positions) {
                var values = {
                    min: $787f65e211e86bca$var$valueTransformer.getValueFromPosition(positions.min, this.props.minValue, this.props.maxValue, this.getTrackClientRect()),
                    max: $787f65e211e86bca$var$valueTransformer.getValueFromPosition(positions.max, this.props.minValue, this.props.maxValue, this.getTrackClientRect())
                };
                var transformedValues = {
                    min: $787f65e211e86bca$var$valueTransformer.getStepValueFromValue(values.min, this.props.step),
                    max: $787f65e211e86bca$var$valueTransformer.getStepValueFromValue(values.max, this.props.step)
                };
                this.updateValues(transformedValues);
            }
        },
        {
            key: "updateValue",
            value: function updateValue(key, value) {
                var values = $787f65e211e86bca$var$valueTransformer.getValueFromProps(this.props, this.isMultiValue());
                values[key] = value;
                this.updateValues(values);
            }
        },
        {
            key: "updateValues",
            value: function updateValues(values) {
                if (!this.shouldUpdate(values)) return;
                this.props.onChange(this.isMultiValue() ? values : values.max);
            }
        },
        {
            key: "incrementValue",
            value: function incrementValue(key) {
                var values = $787f65e211e86bca$var$valueTransformer.getValueFromProps(this.props, this.isMultiValue());
                var value = values[key] + this.props.step;
                this.updateValue(key, value);
            }
        },
        {
            key: "decrementValue",
            value: function decrementValue(key) {
                var values = $787f65e211e86bca$var$valueTransformer.getValueFromProps(this.props, this.isMultiValue());
                var value = values[key] - this.props.step;
                this.updateValue(key, value);
            }
        },
        {
            key: "addDocumentMouseUpListener",
            value: function addDocumentMouseUpListener() {
                this.removeDocumentMouseUpListener();
                this.node.ownerDocument.addEventListener("mouseup", this.handleMouseUp);
            }
        },
        {
            key: "addDocumentTouchEndListener",
            value: function addDocumentTouchEndListener() {
                this.removeDocumentTouchEndListener();
                this.node.ownerDocument.addEventListener("touchend", this.handleTouchEnd);
            }
        },
        {
            key: "removeDocumentMouseUpListener",
            value: function removeDocumentMouseUpListener() {
                this.node.ownerDocument.removeEventListener("mouseup", this.handleMouseUp);
            }
        },
        {
            key: "removeDocumentTouchEndListener",
            value: function removeDocumentTouchEndListener() {
                this.node.ownerDocument.removeEventListener("touchend", this.handleTouchEnd);
            }
        },
        {
            key: "handleSliderDrag",
            value: function handleSliderDrag(event, key) {
                var _this2 = this;
                if (this.props.disabled) return;
                var position = $787f65e211e86bca$var$valueTransformer.getPositionFromEvent(event, this.getTrackClientRect());
                this.isSliderDragging = true;
                requestAnimationFrame(function() {
                    return _this2.updatePosition(key, position);
                });
            }
        },
        {
            key: "handleTrackDrag",
            value: function handleTrackDrag(event, prevEvent) {
                if (this.props.disabled || !this.props.draggableTrack || this.isSliderDragging) return;
                var _props = this.props, maxValue = _props.maxValue, minValue = _props.minValue, _props$value = _props.value, max = _props$value.max, min = _props$value.min;
                var position = $787f65e211e86bca$var$valueTransformer.getPositionFromEvent(event, this.getTrackClientRect());
                var value = $787f65e211e86bca$var$valueTransformer.getValueFromPosition(position, minValue, maxValue, this.getTrackClientRect());
                var stepValue = $787f65e211e86bca$var$valueTransformer.getStepValueFromValue(value, this.props.step);
                var prevPosition = $787f65e211e86bca$var$valueTransformer.getPositionFromEvent(prevEvent, this.getTrackClientRect());
                var prevValue = $787f65e211e86bca$var$valueTransformer.getValueFromPosition(prevPosition, minValue, maxValue, this.getTrackClientRect());
                var prevStepValue = $787f65e211e86bca$var$valueTransformer.getStepValueFromValue(prevValue, this.props.step);
                var offset = prevStepValue - stepValue;
                var transformedValues = {
                    min: min - offset,
                    max: max - offset
                };
                this.updateValues(transformedValues);
            }
        },
        {
            key: "handleSliderKeyDown",
            value: function handleSliderKeyDown(event, key) {
                if (this.props.disabled) return;
                switch(event.keyCode){
                    case $bf50895f694b3ca9$exports.LEFT_ARROW:
                    case $bf50895f694b3ca9$exports.DOWN_ARROW:
                        event.preventDefault();
                        this.decrementValue(key);
                        break;
                    case $bf50895f694b3ca9$exports.RIGHT_ARROW:
                    case $bf50895f694b3ca9$exports.UP_ARROW:
                        event.preventDefault();
                        this.incrementValue(key);
                        break;
                    default:
                        break;
                }
            }
        },
        {
            key: "handleTrackMouseDown",
            value: function handleTrackMouseDown(event, position) {
                if (this.props.disabled) return;
                var _props2 = this.props, maxValue = _props2.maxValue, minValue = _props2.minValue, _props2$value = _props2.value, max = _props2$value.max, min = _props2$value.min;
                event.preventDefault();
                var value = $787f65e211e86bca$var$valueTransformer.getValueFromPosition(position, minValue, maxValue, this.getTrackClientRect());
                var stepValue = $787f65e211e86bca$var$valueTransformer.getStepValueFromValue(value, this.props.step);
                if (!this.props.draggableTrack || stepValue > max || stepValue < min) this.updatePosition(this.getKeyByPosition(position), position);
            }
        },
        {
            key: "handleInteractionStart",
            value: function handleInteractionStart() {
                if (this.props.onChangeStart) this.props.onChangeStart(this.props.value);
                if (this.props.onChangeComplete && !(0, $48a4e0196a312e89$exports.isDefined)(this.startValue)) this.startValue = this.props.value;
            }
        },
        {
            key: "handleInteractionEnd",
            value: function handleInteractionEnd() {
                if (this.isSliderDragging) this.isSliderDragging = false;
                if (!this.props.onChangeComplete || !(0, $48a4e0196a312e89$exports.isDefined)(this.startValue)) return;
                if (this.startValue !== this.props.value) this.props.onChangeComplete(this.props.value);
                this.startValue = null;
            }
        },
        {
            key: "handleKeyDown",
            value: function handleKeyDown(event) {
                this.handleInteractionStart(event);
            }
        },
        {
            key: "handleKeyUp",
            value: function handleKeyUp(event) {
                this.handleInteractionEnd(event);
            }
        },
        {
            key: "handleMouseDown",
            value: function handleMouseDown(event) {
                this.handleInteractionStart(event);
                this.addDocumentMouseUpListener();
            }
        },
        {
            key: "handleMouseUp",
            value: function handleMouseUp(event) {
                this.handleInteractionEnd(event);
                this.removeDocumentMouseUpListener();
            }
        },
        {
            key: "handleTouchStart",
            value: function handleTouchStart(event) {
                this.handleInteractionStart(event);
                this.addDocumentTouchEndListener();
            }
        },
        {
            key: "handleTouchEnd",
            value: function handleTouchEnd(event) {
                this.handleInteractionEnd(event);
                this.removeDocumentTouchEndListener();
            }
        },
        {
            key: "renderSliders",
            value: function renderSliders() {
                var _this3 = this;
                var values = $787f65e211e86bca$var$valueTransformer.getValueFromProps(this.props, this.isMultiValue());
                var percentages = $787f65e211e86bca$var$valueTransformer.getPercentagesFromValues(values, this.props.minValue, this.props.maxValue);
                var keys = this.props.allowSameValues && this.lastKeyMoved === "min" ? this.getKeys().reverse() : this.getKeys();
                return keys.map(function(key) {
                    var value = values[key];
                    var percentage = percentages[key];
                    var _props3 = _this3.props, maxValue = _props3.maxValue, minValue = _props3.minValue;
                    if (key === "min") maxValue = values.max;
                    else minValue = values.min;
                    var slider = $787f65e211e86bca$var$_react2.default.createElement($787f65e211e86bca$var$_slider2.default, {
                        ariaLabelledby: _this3.props.ariaLabelledby,
                        ariaControls: _this3.props.ariaControls,
                        classNames: _this3.props.classNames,
                        formatLabel: _this3.props.formatLabel,
                        key: key,
                        maxValue: maxValue,
                        minValue: minValue,
                        onSliderDrag: _this3.handleSliderDrag,
                        onSliderKeyDown: _this3.handleSliderKeyDown,
                        percentage: percentage,
                        type: key,
                        value: value
                    });
                    return slider;
                });
            }
        },
        {
            key: "renderHiddenInputs",
            value: function renderHiddenInputs() {
                var _this4 = this;
                if (!this.props.name) return [];
                var isMultiValue = this.isMultiValue();
                var values = $787f65e211e86bca$var$valueTransformer.getValueFromProps(this.props, isMultiValue);
                return this.getKeys().map(function(key) {
                    var value = values[key];
                    var name = isMultiValue ? "" + _this4.props.name + (0, $48a4e0196a312e89$exports.captialize)(key) : _this4.props.name;
                    return $787f65e211e86bca$var$_react2.default.createElement("input", {
                        key: key,
                        type: "hidden",
                        name: name,
                        value: value
                    });
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this5 = this;
                var componentClassName = this.getComponentClassName();
                var values = $787f65e211e86bca$var$valueTransformer.getValueFromProps(this.props, this.isMultiValue());
                var percentages = $787f65e211e86bca$var$valueTransformer.getPercentagesFromValues(values, this.props.minValue, this.props.maxValue);
                return $787f65e211e86bca$var$_react2.default.createElement("div", {
                    "aria-disabled": this.props.disabled,
                    ref: function ref(node) {
                        _this5.node = node;
                    },
                    className: componentClassName,
                    onKeyDown: this.handleKeyDown,
                    onKeyUp: this.handleKeyUp,
                    onMouseDown: this.handleMouseDown,
                    onTouchStart: this.handleTouchStart
                }, $787f65e211e86bca$var$_react2.default.createElement($787f65e211e86bca$var$_label2.default, {
                    classNames: this.props.classNames,
                    formatLabel: this.props.formatLabel,
                    type: "min"
                }, this.props.minValue), $787f65e211e86bca$var$_react2.default.createElement($787f65e211e86bca$var$_track2.default, {
                    classNames: this.props.classNames,
                    draggableTrack: this.props.draggableTrack,
                    ref: function ref(trackNode) {
                        _this5.trackNode = trackNode;
                    },
                    percentages: percentages,
                    onTrackDrag: this.handleTrackDrag,
                    onTrackMouseDown: this.handleTrackMouseDown
                }, this.renderSliders()), $787f65e211e86bca$var$_react2.default.createElement($787f65e211e86bca$var$_label2.default, {
                    classNames: this.props.classNames,
                    formatLabel: this.props.formatLabel,
                    type: "max"
                }, this.props.maxValue), this.renderHiddenInputs());
            }
        }
    ]);
    return InputRange;
}($787f65e211e86bca$var$_react2.default.Component), $787f65e211e86bca$var$_applyDecoratedDescriptor($787f65e211e86bca$var$_class.prototype, "handleSliderDrag", [
    $787f65e211e86bca$var$_autobindDecorator2.default
], Object.getOwnPropertyDescriptor($787f65e211e86bca$var$_class.prototype, "handleSliderDrag"), $787f65e211e86bca$var$_class.prototype), $787f65e211e86bca$var$_applyDecoratedDescriptor($787f65e211e86bca$var$_class.prototype, "handleTrackDrag", [
    $787f65e211e86bca$var$_autobindDecorator2.default
], Object.getOwnPropertyDescriptor($787f65e211e86bca$var$_class.prototype, "handleTrackDrag"), $787f65e211e86bca$var$_class.prototype), $787f65e211e86bca$var$_applyDecoratedDescriptor($787f65e211e86bca$var$_class.prototype, "handleSliderKeyDown", [
    $787f65e211e86bca$var$_autobindDecorator2.default
], Object.getOwnPropertyDescriptor($787f65e211e86bca$var$_class.prototype, "handleSliderKeyDown"), $787f65e211e86bca$var$_class.prototype), $787f65e211e86bca$var$_applyDecoratedDescriptor($787f65e211e86bca$var$_class.prototype, "handleTrackMouseDown", [
    $787f65e211e86bca$var$_autobindDecorator2.default
], Object.getOwnPropertyDescriptor($787f65e211e86bca$var$_class.prototype, "handleTrackMouseDown"), $787f65e211e86bca$var$_class.prototype), $787f65e211e86bca$var$_applyDecoratedDescriptor($787f65e211e86bca$var$_class.prototype, "handleInteractionStart", [
    $787f65e211e86bca$var$_autobindDecorator2.default
], Object.getOwnPropertyDescriptor($787f65e211e86bca$var$_class.prototype, "handleInteractionStart"), $787f65e211e86bca$var$_class.prototype), $787f65e211e86bca$var$_applyDecoratedDescriptor($787f65e211e86bca$var$_class.prototype, "handleInteractionEnd", [
    $787f65e211e86bca$var$_autobindDecorator2.default
], Object.getOwnPropertyDescriptor($787f65e211e86bca$var$_class.prototype, "handleInteractionEnd"), $787f65e211e86bca$var$_class.prototype), $787f65e211e86bca$var$_applyDecoratedDescriptor($787f65e211e86bca$var$_class.prototype, "handleKeyDown", [
    $787f65e211e86bca$var$_autobindDecorator2.default
], Object.getOwnPropertyDescriptor($787f65e211e86bca$var$_class.prototype, "handleKeyDown"), $787f65e211e86bca$var$_class.prototype), $787f65e211e86bca$var$_applyDecoratedDescriptor($787f65e211e86bca$var$_class.prototype, "handleKeyUp", [
    $787f65e211e86bca$var$_autobindDecorator2.default
], Object.getOwnPropertyDescriptor($787f65e211e86bca$var$_class.prototype, "handleKeyUp"), $787f65e211e86bca$var$_class.prototype), $787f65e211e86bca$var$_applyDecoratedDescriptor($787f65e211e86bca$var$_class.prototype, "handleMouseDown", [
    $787f65e211e86bca$var$_autobindDecorator2.default
], Object.getOwnPropertyDescriptor($787f65e211e86bca$var$_class.prototype, "handleMouseDown"), $787f65e211e86bca$var$_class.prototype), $787f65e211e86bca$var$_applyDecoratedDescriptor($787f65e211e86bca$var$_class.prototype, "handleMouseUp", [
    $787f65e211e86bca$var$_autobindDecorator2.default
], Object.getOwnPropertyDescriptor($787f65e211e86bca$var$_class.prototype, "handleMouseUp"), $787f65e211e86bca$var$_class.prototype), $787f65e211e86bca$var$_applyDecoratedDescriptor($787f65e211e86bca$var$_class.prototype, "handleTouchStart", [
    $787f65e211e86bca$var$_autobindDecorator2.default
], Object.getOwnPropertyDescriptor($787f65e211e86bca$var$_class.prototype, "handleTouchStart"), $787f65e211e86bca$var$_class.prototype), $787f65e211e86bca$var$_applyDecoratedDescriptor($787f65e211e86bca$var$_class.prototype, "handleTouchEnd", [
    $787f65e211e86bca$var$_autobindDecorator2.default
], Object.getOwnPropertyDescriptor($787f65e211e86bca$var$_class.prototype, "handleTouchEnd"), $787f65e211e86bca$var$_class.prototype), $787f65e211e86bca$var$_class);
$787f65e211e86bca$exports.default = $787f65e211e86bca$var$InputRange;
$787f65e211e86bca$exports = $787f65e211e86bca$exports["default"];


var $ebfaaab6f872e4e6$var$_inputRange2 = $ebfaaab6f872e4e6$var$_interopRequireDefault($787f65e211e86bca$exports);
function $ebfaaab6f872e4e6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @ignore
 * @typedef {Object} ClientRect
 * @property {number} height
 * @property {number} left
 * @property {number} top
 * @property {number} width
 */ /**
 * @typedef {Object} InputRangeClassNames
 * @property {string} activeTrack
 * @property {string} disabledInputRange
 * @property {string} inputRange
 * @property {string} labelContainer
 * @property {string} maxLabel
 * @property {string} minLabel
 * @property {string} slider
 * @property {string} sliderContainer
 * @property {string} track
 * @property {string} valueLabel
 */ /**
 * @typedef {Function} LabelFormatter
 * @param {number} value
 * @param {string} type
 * @return {string}
 */ /**
 * @ignore
 * @typedef {Object} Point
 * @property {number} x
 * @property {number} y
 */ /**
 * @typedef {Object} Range
 * @property {number} min - Min value
 * @property {number} max - Max value
 */ $ebfaaab6f872e4e6$exports.default = $ebfaaab6f872e4e6$var$_inputRange2.default;
$ebfaaab6f872e4e6$exports = $ebfaaab6f872e4e6$exports["default"];



const $dadfc48128bd0ddd$var$PageTwo = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "kids-quiz__page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "kids-quiz__question"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", {
        className: "question__title"
    }, "How are you feeling lately?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "range__selector"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebfaaab6f872e4e6$exports))), {
        maxValue: 100,
        minValue: 1,
        value: props.energySliderValue,
        onChange: (value)=>props.handleSlider(value, "energy")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "range__text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", null, "Really tired"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", null, "Full of beans"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "range__selector"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebfaaab6f872e4e6$exports))), {
        maxValue: 100,
        minValue: 1,
        value: props.activitySliderValue,
        onChange: (value)=>props.handleSlider(value, "activity")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "range__text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", null, "Not very active"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", null, "Gym junkie"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "range__selector"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebfaaab6f872e4e6$exports))), {
        maxValue: 100,
        minValue: 1,
        value: props.sleepSliderValue,
        onChange: (value)=>props.handleSlider(value, "sleep")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "range__text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", null, "Sleepless nights"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", null, "Sleep like a baby"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "range__selector"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebfaaab6f872e4e6$exports))), {
        maxValue: 100,
        minValue: 1,
        value: props.screenSliderValue,
        onChange: (value)=>props.handleSlider(value, "screen")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "range__text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", null, "Minimal screen time"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", null, "Lots of screen time")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("a", {
        href: "#workout",
        className: "question-divider question-divider--show"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$2baabfc57bf5919a), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        id: "workout",
        className: "kids-quiz__question kids-quiz__question--show"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", {
        className: "question__title"
    }, "When you exercise, what do you do?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "answers-row--flex"
    }, props.renderExerciseAnswers)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("a", {
        href: "#travel",
        className: `question-divider ${props.exerciseAnswersIndex.length > 0 ? "question-divider--show" : ""}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$2baabfc57bf5919a), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        id: "travel",
        className: `kids-quiz__question ${props.exerciseAnswersIndex.length > 0 ? "kids-quiz__question--show" : "kids-quiz__question--hidden"}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", {
        className: "question__title"
    }, "How often do you travel internationally each year?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "answers-row--flex"
    }, props.renderTravelAnswers)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: `next-page ${props.travelAnswersIndex.length > 0 ? "next-page--show" : "next-page--hidden"}`,
        onClick: ()=>props.nextPage("2")
    }, "Continue"));
};
var $dadfc48128bd0ddd$export$2e2bcd8739ae039 = $dadfc48128bd0ddd$var$PageTwo;



var $5zKJZ = parcelRequire("5zKJZ");

const $7d3818c10c1fdaa8$var$PageThree = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "kids-quiz__page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("h1", null, "Now, let's explore your diet."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "kids-quiz__question"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", {
        className: "question__title"
    }, "Do you follow a specific diet?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "radio-answers answers-row--2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
        type: "radio",
        name: "diet-radio",
        id: "dietYes",
        value: "yes",
        onChange: props.onSpecificDietClick,
        checked: props.specificDiet === "yes"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("label", {
        className: "answer-button",
        htmlFor: "dietYes"
    }, "Yes"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
        type: "radio",
        name: "diet-radio",
        id: "dietNo",
        value: "no",
        onChange: props.onSpecificDietClick,
        checked: props.specificDiet === "no"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("label", {
        className: "answer-button",
        htmlFor: "dietNo"
    }, "No"))), props.specificDiet === "yes" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("a", {
        href: "#diets",
        className: `question-divider ${props.specificDiet ? "question-divider--show" : ""}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$2baabfc57bf5919a), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        id: "diets",
        className: "kids-quiz__question"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", {
        className: "question__title"
    }, "Which diet?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "answers-row--flex diet-answers"
    }, props.renderDietAnswers))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("a", {
        href: "#cranky",
        className: `question-divider ${props.specificDiet ? "question-divider--show" : ""}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$2baabfc57bf5919a), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("a", {
        href: "#cranky",
        className: `question-divider ${props.dietAnswersIndex.length !== 0 ? "question-divider--show" : ""}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$2baabfc57bf5919a), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        id: "cranky",
        className: `kids-quiz__question ${props.specificDiet === "no" || props.specificDiet === "yes" && props.dietAnswersIndex.length !== 0 ? "kids-quiz__question--show" : "kids-quiz__question--hidden"}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", {
        className: "question__title"
    }, "During the day, do you get hungry or have energy dips between meals?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "radio-answers answers-row--2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
        type: "radio",
        name: "hungry",
        id: "hungryYes",
        value: "yes",
        onChange: props.logHungryAnswer,
        checked: props.hungryBetweenMeals === "yes"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("label", {
        className: "answer-button",
        htmlFor: "hungryYes"
    }, "Yes"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
        type: "radio",
        name: "hungry",
        id: "hungryNo",
        value: "no",
        onChange: props.logHungryAnswer,
        checked: props.hungryBetweenMeals === "no"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("label", {
        className: "answer-button",
        htmlFor: "hungryNo"
    }, "No"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("a", {
        href: "#foodGrid",
        className: `question-divider ${props.hungryBetweenMeals && props.specificDiet === "no" || props.hungryBetweenMeals && props.specificDiet === "yes" && props.dietAnswersIndex.length !== 0 ? "question-divider--show" : ""}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$2baabfc57bf5919a), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        id: "foodGrid",
        className: `kids-quiz__question 
        ${props.hungryBetweenMeals && props.specificDiet === "no" || props.hungryBetweenMeals && props.specificDiet === "yes" && props.dietAnswersIndex.length !== 0 ? "kids-quiz__question--show" : "kids-quiz__question--hidden"}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", {
        className: "question__title"
    }, "How often do you consume the below in an average day?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "foods-grid"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "foods-title foods-title--empty"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "foods-title foods-title--pf"
    }, "Processed food"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "foods-title foods-title--fv"
    }, "Fruit & veg"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "foods-category foods-category--rare"
    }, "Rarely"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "foods-category foods-category--1-2"
    }, "1-2 times a day"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "foods-category foods-category--3-4"
    }, "3-4 times a day"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "foods-category foods-category--5"
    }, "5+ times a day"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "foods-radio--pf--rare"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
        type: "radio",
        name: "processed-food",
        id: "processedFoodRarely",
        value: "yes",
        onChange: props.handleFoodRadios,
        checked: props.processedFoodAnswer === "processedFoodRarely"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("label", {
        htmlFor: "processedFoodRarely"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$bd2518280c2f05c1), {
        className: "radio-yes"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "foods-radio--pf--1-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
        type: "radio",
        name: "processed-food",
        id: "processedFood12",
        value: "yes",
        onChange: props.handleFoodRadios,
        checked: props.processedFoodAnswer === "processedFood12"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("label", {
        htmlFor: "processedFood12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$bd2518280c2f05c1), {
        className: "radio-yes"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "foods-radio--pf--3-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
        type: "radio",
        name: "processed-food",
        id: "processedFood34",
        value: "yes",
        onChange: props.handleFoodRadios,
        checked: props.processedFoodAnswer === "processedFood34"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("label", {
        htmlFor: "processedFood34"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$bd2518280c2f05c1), {
        className: "radio-yes"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "foods-radio--pf--5"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
        type: "radio",
        name: "processed-food",
        id: "processedFood5",
        value: "yes",
        onChange: props.handleFoodRadios,
        checked: props.processedFoodAnswer === "processedFood5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("label", {
        htmlFor: "processedFood5"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$bd2518280c2f05c1), {
        className: "radio-yes"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "foods-radio--fv--rare"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
        type: "radio",
        name: "fruit-veg",
        id: "fruitVegRarely",
        value: "yes",
        onChange: props.handleFoodRadios,
        checked: props.fruitVegAnswer === "fruitVegRarely"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("label", {
        htmlFor: "fruitVegRarely"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$bd2518280c2f05c1), {
        className: "radio-yes"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "foods-radio--fv--1-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
        type: "radio",
        name: "fruit-veg",
        id: "fruitVeg12",
        value: "yes",
        onChange: props.handleFoodRadios,
        checked: props.fruitVegAnswer === "fruitVeg12"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("label", {
        htmlFor: "fruitVeg12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$bd2518280c2f05c1), {
        className: "radio-yes"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "foods-radio--fv--3-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
        type: "radio",
        name: "fruit-veg",
        id: "fruitVeg34",
        value: "yes",
        onChange: props.handleFoodRadios,
        checked: props.fruitVegAnswer === "fruitVeg34"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("label", {
        htmlFor: "fruitVeg34"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$bd2518280c2f05c1), {
        className: "radio-yes"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "foods-radio--fv--5"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
        type: "radio",
        name: "fruit-veg",
        id: "fruitVeg5",
        value: "yes",
        onChange: props.handleFoodRadios,
        checked: props.fruitVegAnswer === "fruitVeg5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("label", {
        htmlFor: "fruitVeg5"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$bd2518280c2f05c1), {
        className: "radio-yes"
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("a", {
        href: "#alcohol",
        className: `question-divider ${props.processedFoodAnswer && props.fruitVegAnswer ? "question-divider--show" : ""}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$2baabfc57bf5919a), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        id: "alcohol",
        className: `kids-quiz__question ${props.processedFoodAnswer && props.fruitVegAnswer ? "kids-quiz__question--show" : "kids-quiz__question--hidden"}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", {
        className: "question__title"
    }, "How often do you drink alcohol?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "answers-row--flex"
    }, props.renderAlcoholAnswers)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("a", {
        href: "#vitamins",
        className: `question-divider ${props.alcoholAnswersIndex.length > 0 ? "question-divider--show" : ""}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$2baabfc57bf5919a), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        id: "vitamins",
        className: `kids-quiz__question ${props.alcoholAnswersIndex.length > 0 ? "kids-quiz__question--show" : "kids-quiz__question--hidden"}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", {
        className: "question__title"
    }, "Do you currently take vitamins?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "radio-answers answers-row--2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
        type: "radio",
        name: "vitamins",
        id: "vitaminsYes",
        value: "yes",
        onChange: props.currentVitamins,
        checked: props.vitaminsAnswer === "yes"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("label", {
        className: "answer-button",
        htmlFor: "vitaminsYes"
    }, "Yes"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
        type: "radio",
        name: "vitamins",
        id: "vitaminsNo",
        value: "no",
        onChange: props.currentVitamins,
        checked: props.vitaminsAnswer === "no"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("label", {
        className: "answer-button",
        htmlFor: "vitaminsNo"
    }, "No"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: `next-page ${props.vitaminsAnswer ? "next-page--show" : "next-page--hidden"}`,
        onClick: ()=>props.nextPage("3")
    }, "Continue"));
};
var $7d3818c10c1fdaa8$export$2e2bcd8739ae039 = $7d3818c10c1fdaa8$var$PageThree;



var $5zKJZ = parcelRequire("5zKJZ");


var $c1e84079c9071642$exports = {};
"use strict";
Object.defineProperty($c1e84079c9071642$exports, "__esModule", {
    value: true
});
var $9ab2d10924611cc0$exports = {};
"use strict";
Object.defineProperty($9ab2d10924611cc0$exports, "__esModule", {
    value: true
});
$9ab2d10924611cc0$exports.bodyOpenClassName = $9ab2d10924611cc0$exports.portalClassName = undefined;
var $9ab2d10924611cc0$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $9ab2d10924611cc0$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $5zKJZ = parcelRequire("5zKJZ");
var $9ab2d10924611cc0$var$_react2 = $9ab2d10924611cc0$var$_interopRequireDefault($5zKJZ);

var $9ab2d10924611cc0$var$_reactDom2 = $9ab2d10924611cc0$var$_interopRequireDefault($aa49bf5e460995f3$exports);

var $9ab2d10924611cc0$var$_propTypes2 = $9ab2d10924611cc0$var$_interopRequireDefault($1c9b2ec60c53ae5a$exports);
var $e030df1c7745f936$exports = {};
"use strict";
Object.defineProperty($e030df1c7745f936$exports, "__esModule", {
    value: true
});
var $e030df1c7745f936$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $e030df1c7745f936$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $e030df1c7745f936$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $5zKJZ = parcelRequire("5zKJZ");
var $e030df1c7745f936$var$_react2 = $e030df1c7745f936$var$_interopRequireDefault($5zKJZ);

var $e030df1c7745f936$var$_propTypes2 = $e030df1c7745f936$var$_interopRequireDefault($1c9b2ec60c53ae5a$exports);
var $509fcd50a26198d9$exports = {};
"use strict";
Object.defineProperty($509fcd50a26198d9$exports, "__esModule", {
    value: true
});
$509fcd50a26198d9$exports.handleBlur = $509fcd50a26198d9$var$handleBlur;
$509fcd50a26198d9$exports.handleFocus = $509fcd50a26198d9$var$handleFocus;
$509fcd50a26198d9$exports.markForFocusLater = $509fcd50a26198d9$var$markForFocusLater;
$509fcd50a26198d9$exports.returnFocus = $509fcd50a26198d9$var$returnFocus;
$509fcd50a26198d9$exports.popWithoutFocus = $509fcd50a26198d9$var$popWithoutFocus;
$509fcd50a26198d9$exports.setupScopedFocus = $509fcd50a26198d9$var$setupScopedFocus;
$509fcd50a26198d9$exports.teardownScopedFocus = $509fcd50a26198d9$var$teardownScopedFocus;
var $b633f74d2a8ea5e6$exports = {};
"use strict";
Object.defineProperty($b633f74d2a8ea5e6$exports, "__esModule", {
    value: true
});
$b633f74d2a8ea5e6$exports.default = $b633f74d2a8ea5e6$var$findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */ var $b633f74d2a8ea5e6$var$tabbableNode = /input|select|textarea|button|object/;
function $b633f74d2a8ea5e6$var$hidesContents(element) {
    var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
    // If the node is empty, this is good enough
    if (zeroSize && !element.innerHTML) return true;
    // Otherwise we need to check some styles
    var style = window.getComputedStyle(element);
    return zeroSize ? style.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
    element.scrollWidth <= 0 && element.scrollHeight <= 0 : style.getPropertyValue("display") == "none";
}
function $b633f74d2a8ea5e6$var$visible(element) {
    var parentElement = element;
    while(parentElement){
        if (parentElement === document.body) break;
        if ($b633f74d2a8ea5e6$var$hidesContents(parentElement)) return false;
        parentElement = parentElement.parentNode;
    }
    return true;
}
function $b633f74d2a8ea5e6$var$focusable(element, isTabIndexNotNaN) {
    var nodeName = element.nodeName.toLowerCase();
    var res = $b633f74d2a8ea5e6$var$tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
    return res && $b633f74d2a8ea5e6$var$visible(element);
}
function $b633f74d2a8ea5e6$var$tabbable(element) {
    var tabIndex = element.getAttribute("tabindex");
    if (tabIndex === null) tabIndex = undefined;
    var isTabIndexNaN = isNaN(tabIndex);
    return (isTabIndexNaN || tabIndex >= 0) && $b633f74d2a8ea5e6$var$focusable(element, !isTabIndexNaN);
}
function $b633f74d2a8ea5e6$var$findTabbableDescendants(element) {
    return [].slice.call(element.querySelectorAll("*"), 0).filter($b633f74d2a8ea5e6$var$tabbable);
}
$b633f74d2a8ea5e6$exports = $b633f74d2a8ea5e6$exports["default"];


var $509fcd50a26198d9$var$_tabbable2 = $509fcd50a26198d9$var$_interopRequireDefault($b633f74d2a8ea5e6$exports);
function $509fcd50a26198d9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $509fcd50a26198d9$var$focusLaterElements = [];
var $509fcd50a26198d9$var$modalElement = null;
var $509fcd50a26198d9$var$needToFocus = false;
function $509fcd50a26198d9$var$handleBlur() {
    $509fcd50a26198d9$var$needToFocus = true;
}
function $509fcd50a26198d9$var$handleFocus() {
    if ($509fcd50a26198d9$var$needToFocus) {
        $509fcd50a26198d9$var$needToFocus = false;
        if (!$509fcd50a26198d9$var$modalElement) return;
        // need to see how jQuery shims document.on('focusin') so we don't need the
        // setTimeout, firefox doesn't support focusin, if it did, we could focus
        // the element outside of a setTimeout. Side-effect of this implementation
        // is that the document.body gets focus, and then we focus our element right
        // after, seems fine.
        setTimeout(function() {
            if ($509fcd50a26198d9$var$modalElement.contains(document.activeElement)) return;
            var el = (0, $509fcd50a26198d9$var$_tabbable2.default)($509fcd50a26198d9$var$modalElement)[0] || $509fcd50a26198d9$var$modalElement;
            el.focus();
        }, 0);
    }
}
function $509fcd50a26198d9$var$markForFocusLater() {
    $509fcd50a26198d9$var$focusLaterElements.push(document.activeElement);
}
/* eslint-disable no-console */ function $509fcd50a26198d9$var$returnFocus() {
    var toFocus = null;
    try {
        if ($509fcd50a26198d9$var$focusLaterElements.length !== 0) {
            toFocus = $509fcd50a26198d9$var$focusLaterElements.pop();
            toFocus.focus();
        }
        return;
    } catch (e) {
        console.warn([
            "You tried to return focus to",
            toFocus,
            "but it is not in the DOM anymore"
        ].join(" "));
    }
}
/* eslint-enable no-console */ function $509fcd50a26198d9$var$popWithoutFocus() {
    $509fcd50a26198d9$var$focusLaterElements.length > 0 && $509fcd50a26198d9$var$focusLaterElements.pop();
}
function $509fcd50a26198d9$var$setupScopedFocus(element) {
    $509fcd50a26198d9$var$modalElement = element;
    if (window.addEventListener) {
        window.addEventListener("blur", $509fcd50a26198d9$var$handleBlur, false);
        document.addEventListener("focus", $509fcd50a26198d9$var$handleFocus, true);
    } else {
        window.attachEvent("onBlur", $509fcd50a26198d9$var$handleBlur);
        document.attachEvent("onFocus", $509fcd50a26198d9$var$handleFocus);
    }
}
function $509fcd50a26198d9$var$teardownScopedFocus() {
    $509fcd50a26198d9$var$modalElement = null;
    if (window.addEventListener) {
        window.removeEventListener("blur", $509fcd50a26198d9$var$handleBlur);
        document.removeEventListener("focus", $509fcd50a26198d9$var$handleFocus);
    } else {
        window.detachEvent("onBlur", $509fcd50a26198d9$var$handleBlur);
        document.detachEvent("onFocus", $509fcd50a26198d9$var$handleFocus);
    }
}


var $e030df1c7745f936$var$focusManager = $e030df1c7745f936$var$_interopRequireWildcard($509fcd50a26198d9$exports);
var $9f789bd43b6c8649$exports = {};
"use strict";
Object.defineProperty($9f789bd43b6c8649$exports, "__esModule", {
    value: true
});
$9f789bd43b6c8649$exports.default = $9f789bd43b6c8649$var$scopeTab;

var $9f789bd43b6c8649$var$_tabbable2 = $9f789bd43b6c8649$var$_interopRequireDefault($b633f74d2a8ea5e6$exports);
function $9f789bd43b6c8649$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9f789bd43b6c8649$var$scopeTab(node, event) {
    var tabbable = (0, $9f789bd43b6c8649$var$_tabbable2.default)(node);
    if (!tabbable.length) {
        // Do nothing, since there are no elements that can receive focus.
        event.preventDefault();
        return;
    }
    var shiftKey = event.shiftKey;
    var head = tabbable[0];
    var tail = tabbable[tabbable.length - 1];
    // proceed with default browser behavior on tab.
    // Focus on last element on shift + tab.
    if (node === document.activeElement) {
        if (!shiftKey) return;
        target = tail;
    }
    var target;
    if (tail === document.activeElement && !shiftKey) target = head;
    if (head === document.activeElement && shiftKey) target = tail;
    if (target) {
        event.preventDefault();
        target.focus();
        return;
    }
    // Safari radio issue.
    //
    // Safari does not move the focus to the radio button,
    // so we need to force it to really walk through all elements.
    //
    // This is very error prone, since we are trying to guess
    // if it is a safari browser from the first occurence between
    // chrome or safari.
    //
    // The chrome user agent contains the first ocurrence
    // as the 'chrome/version' and later the 'safari/version'.
    var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
    var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
    // If we are not in safari desktop, let the browser control
    // the focus
    if (!isSafariDesktop) return;
    var x = tabbable.indexOf(document.activeElement);
    if (x > -1) x += shiftKey ? -1 : 1;
    // If the tabbable element does not exist,
    // focus head/tail based on shiftKey
    if (typeof tabbable[x] === "undefined") {
        event.preventDefault();
        target = shiftKey ? tail : head;
        target.focus();
        return;
    }
    event.preventDefault();
    tabbable[x].focus();
}
$9f789bd43b6c8649$exports = $9f789bd43b6c8649$exports["default"];


var $e030df1c7745f936$var$_scopeTab2 = $e030df1c7745f936$var$_interopRequireDefault($9f789bd43b6c8649$exports);
var $1715b727bb982066$exports = {};
"use strict";
Object.defineProperty($1715b727bb982066$exports, "__esModule", {
    value: true
});
$1715b727bb982066$exports.assertNodeList = $1715b727bb982066$var$assertNodeList;
$1715b727bb982066$exports.setElement = $1715b727bb982066$var$setElement;
$1715b727bb982066$exports.validateElement = $1715b727bb982066$var$validateElement;
$1715b727bb982066$exports.hide = $1715b727bb982066$var$hide;
$1715b727bb982066$exports.show = $1715b727bb982066$var$show;
$1715b727bb982066$exports.documentNotReadyOrSSRTesting = $1715b727bb982066$var$documentNotReadyOrSSRTesting;
$1715b727bb982066$exports.resetForTesting = $1715b727bb982066$var$resetForTesting;
var $57f48089a2547dd4$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $57f48089a2547dd4$var$__DEV__ = false;
var $57f48089a2547dd4$var$warning = function() {};
if ($57f48089a2547dd4$var$__DEV__) {
    var $57f48089a2547dd4$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $57f48089a2547dd4$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $57f48089a2547dd4$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$57f48089a2547dd4$exports = $57f48089a2547dd4$var$warning;


var $1715b727bb982066$var$_warning2 = $1715b727bb982066$var$_interopRequireDefault($57f48089a2547dd4$exports);
var $dc852a86ca7cdb29$exports = {};
"use strict";
Object.defineProperty($dc852a86ca7cdb29$exports, "__esModule", {
    value: true
});
$dc852a86ca7cdb29$exports.canUseDOM = undefined;
var $2d2334d224927b46$exports = {};
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    "use strict";
    var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== "undefined",
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === "function" && typeof define.amd === "object" && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (0, $2d2334d224927b46$exports) $2d2334d224927b46$exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();


var $dc852a86ca7cdb29$var$_exenv2 = $dc852a86ca7cdb29$var$_interopRequireDefault($2d2334d224927b46$exports);
function $dc852a86ca7cdb29$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $dc852a86ca7cdb29$var$EE = $dc852a86ca7cdb29$var$_exenv2.default;
var $dc852a86ca7cdb29$var$SafeHTMLElement = $dc852a86ca7cdb29$var$EE.canUseDOM ? window.HTMLElement : {};
var $dc852a86ca7cdb29$var$canUseDOM = $dc852a86ca7cdb29$exports.canUseDOM = $dc852a86ca7cdb29$var$EE.canUseDOM;
$dc852a86ca7cdb29$exports.default = $dc852a86ca7cdb29$var$SafeHTMLElement;


function $1715b727bb982066$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1715b727bb982066$var$globalElement = null;
function $1715b727bb982066$var$assertNodeList(nodeList, selector) {
    if (!nodeList || !nodeList.length) throw new Error("react-modal: No elements were found for selector " + selector + ".");
}
function $1715b727bb982066$var$setElement(element) {
    var useElement = element;
    if (typeof useElement === "string" && $dc852a86ca7cdb29$exports.canUseDOM) {
        var el = document.querySelectorAll(useElement);
        $1715b727bb982066$var$assertNodeList(el, useElement);
        useElement = "length" in el ? el[0] : el;
    }
    $1715b727bb982066$var$globalElement = useElement || $1715b727bb982066$var$globalElement;
    return $1715b727bb982066$var$globalElement;
}
function $1715b727bb982066$var$validateElement(appElement) {
    if (!appElement && !$1715b727bb982066$var$globalElement) {
        (0, $1715b727bb982066$var$_warning2.default)(false, [
            "react-modal: App element is not defined.",
            "Please use `Modal.setAppElement(el)` or set `appElement={el}`.",
            "This is needed so screen readers don't see main content",
            "when modal is opened. It is not recommended, but you can opt-out",
            "by setting `ariaHideApp={false}`."
        ].join(" "));
        return false;
    }
    return true;
}
function $1715b727bb982066$var$hide(appElement) {
    if ($1715b727bb982066$var$validateElement(appElement)) (appElement || $1715b727bb982066$var$globalElement).setAttribute("aria-hidden", "true");
}
function $1715b727bb982066$var$show(appElement) {
    if ($1715b727bb982066$var$validateElement(appElement)) (appElement || $1715b727bb982066$var$globalElement).removeAttribute("aria-hidden");
}
function $1715b727bb982066$var$documentNotReadyOrSSRTesting() {
    $1715b727bb982066$var$globalElement = null;
}
function $1715b727bb982066$var$resetForTesting() {
    $1715b727bb982066$var$globalElement = null;
}


var $e030df1c7745f936$var$ariaAppHider = $e030df1c7745f936$var$_interopRequireWildcard($1715b727bb982066$exports);
var $a09ae2452ae41815$exports = {};
"use strict";
Object.defineProperty($a09ae2452ae41815$exports, "__esModule", {
    value: true
});
$a09ae2452ae41815$exports.dumpClassLists = $a09ae2452ae41815$var$dumpClassLists;
var $a09ae2452ae41815$var$htmlClassList = {};
var $a09ae2452ae41815$var$docBodyClassList = {};
function $a09ae2452ae41815$var$dumpClassLists() {
    var classes, buffer, x, _x;
}
/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var $a09ae2452ae41815$var$incrementReference = function incrementReference(poll, className) {
    if (!poll[className]) poll[className] = 0;
    poll[className] += 1;
    return className;
};
/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var $a09ae2452ae41815$var$decrementReference = function decrementReference(poll, className) {
    if (poll[className]) poll[className] -= 1;
    return className;
};
/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */ var $a09ae2452ae41815$var$trackClass = function trackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        $a09ae2452ae41815$var$incrementReference(poll, className);
        classListRef.add(className);
    });
};
/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */ var $a09ae2452ae41815$var$untrackClass = function untrackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        $a09ae2452ae41815$var$decrementReference(poll, className);
        poll[className] === 0 && classListRef.remove(className);
    });
};
/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var $a09ae2452ae41815$var$add = $a09ae2452ae41815$exports.add = function add(element, classString) {
    return $a09ae2452ae41815$var$trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? $a09ae2452ae41815$var$htmlClassList : $a09ae2452ae41815$var$docBodyClassList, classString.split(" "));
};
/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var $a09ae2452ae41815$var$remove = $a09ae2452ae41815$exports.remove = function remove(element, classString) {
    return $a09ae2452ae41815$var$untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? $a09ae2452ae41815$var$htmlClassList : $a09ae2452ae41815$var$docBodyClassList, classString.split(" "));
};


var $e030df1c7745f936$var$classList = $e030df1c7745f936$var$_interopRequireWildcard($a09ae2452ae41815$exports);

var $e030df1c7745f936$var$_safeHTMLElement2 = $e030df1c7745f936$var$_interopRequireDefault($dc852a86ca7cdb29$exports);
function $e030df1c7745f936$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $e030df1c7745f936$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e030df1c7745f936$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e030df1c7745f936$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $e030df1c7745f936$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// so that our CSS is statically analyzable
var $e030df1c7745f936$var$CLASS_NAMES = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
};
var $e030df1c7745f936$var$TAB_KEY = 9;
var $e030df1c7745f936$var$ESC_KEY = 27;
var $e030df1c7745f936$var$ariaHiddenInstances = 0;
var $e030df1c7745f936$var$ModalPortal = function(_Component) {
    $e030df1c7745f936$var$_inherits(ModalPortal, _Component);
    function ModalPortal(props) {
        $e030df1c7745f936$var$_classCallCheck(this, ModalPortal);
        var _this = $e030df1c7745f936$var$_possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));
        _this.setOverlayRef = function(overlay) {
            _this.overlay = overlay;
            _this.props.overlayRef && _this.props.overlayRef(overlay);
        };
        _this.setContentRef = function(content) {
            _this.content = content;
            _this.props.contentRef && _this.props.contentRef(content);
        };
        _this.afterClose = function() {
            var _this$props = _this.props, appElement = _this$props.appElement, ariaHideApp = _this$props.ariaHideApp, htmlOpenClassName = _this$props.htmlOpenClassName, bodyOpenClassName = _this$props.bodyOpenClassName;
            // Remove classes.
            bodyOpenClassName && $e030df1c7745f936$var$classList.remove(document.body, bodyOpenClassName);
            htmlOpenClassName && $e030df1c7745f936$var$classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);
            // Reset aria-hidden attribute if all modals have been removed
            if (ariaHideApp && $e030df1c7745f936$var$ariaHiddenInstances > 0) {
                $e030df1c7745f936$var$ariaHiddenInstances -= 1;
                if ($e030df1c7745f936$var$ariaHiddenInstances === 0) $e030df1c7745f936$var$ariaAppHider.show(appElement);
            }
            if (_this.props.shouldFocusAfterRender) {
                if (_this.props.shouldReturnFocusAfterClose) {
                    $e030df1c7745f936$var$focusManager.returnFocus();
                    $e030df1c7745f936$var$focusManager.teardownScopedFocus();
                } else $e030df1c7745f936$var$focusManager.popWithoutFocus();
            }
            if (_this.props.onAfterClose) _this.props.onAfterClose();
        };
        _this.open = function() {
            _this.beforeOpen();
            if (_this.state.afterOpen && _this.state.beforeClose) {
                clearTimeout(_this.closeTimer);
                _this.setState({
                    beforeClose: false
                });
            } else {
                if (_this.props.shouldFocusAfterRender) {
                    $e030df1c7745f936$var$focusManager.setupScopedFocus(_this.node);
                    $e030df1c7745f936$var$focusManager.markForFocusLater();
                }
                _this.setState({
                    isOpen: true
                }, function() {
                    _this.setState({
                        afterOpen: true
                    });
                    if (_this.props.isOpen && _this.props.onAfterOpen) _this.props.onAfterOpen({
                        overlayEl: _this.overlay,
                        contentEl: _this.content
                    });
                });
            }
        };
        _this.close = function() {
            if (_this.props.closeTimeoutMS > 0) _this.closeWithTimeout();
            else _this.closeWithoutTimeout();
        };
        _this.focusContent = function() {
            return _this.content && !_this.contentHasFocus() && _this.content.focus();
        };
        _this.closeWithTimeout = function() {
            var closesAt = Date.now() + _this.props.closeTimeoutMS;
            _this.setState({
                beforeClose: true,
                closesAt: closesAt
            }, function() {
                _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
            });
        };
        _this.closeWithoutTimeout = function() {
            _this.setState({
                beforeClose: false,
                isOpen: false,
                afterOpen: false,
                closesAt: null
            }, _this.afterClose);
        };
        _this.handleKeyDown = function(event) {
            if (event.keyCode === $e030df1c7745f936$var$TAB_KEY) (0, $e030df1c7745f936$var$_scopeTab2.default)(_this.content, event);
            if (_this.props.shouldCloseOnEsc && event.keyCode === $e030df1c7745f936$var$ESC_KEY) {
                event.stopPropagation();
                _this.requestClose(event);
            }
        };
        _this.handleOverlayOnClick = function(event) {
            if (_this.shouldClose === null) _this.shouldClose = true;
            if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
                if (_this.ownerHandlesClose()) _this.requestClose(event);
                else _this.focusContent();
            }
            _this.shouldClose = null;
        };
        _this.handleContentOnMouseUp = function() {
            _this.shouldClose = false;
        };
        _this.handleOverlayOnMouseDown = function(event) {
            if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) event.preventDefault();
        };
        _this.handleContentOnClick = function() {
            _this.shouldClose = false;
        };
        _this.handleContentOnMouseDown = function() {
            _this.shouldClose = false;
        };
        _this.requestClose = function(event) {
            return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
        };
        _this.ownerHandlesClose = function() {
            return _this.props.onRequestClose;
        };
        _this.shouldBeClosed = function() {
            return !_this.state.isOpen && !_this.state.beforeClose;
        };
        _this.contentHasFocus = function() {
            return document.activeElement === _this.content || _this.content.contains(document.activeElement);
        };
        _this.buildClassName = function(which, additional) {
            var classNames = (typeof additional === "undefined" ? "undefined" : $e030df1c7745f936$var$_typeof(additional)) === "object" ? additional : {
                base: $e030df1c7745f936$var$CLASS_NAMES[which],
                afterOpen: $e030df1c7745f936$var$CLASS_NAMES[which] + "--after-open",
                beforeClose: $e030df1c7745f936$var$CLASS_NAMES[which] + "--before-close"
            };
            var className = classNames.base;
            if (_this.state.afterOpen) className = className + " " + classNames.afterOpen;
            if (_this.state.beforeClose) className = className + " " + classNames.beforeClose;
            return typeof additional === "string" && additional ? className + " " + additional : className;
        };
        _this.attributesFromObject = function(prefix, items) {
            return Object.keys(items).reduce(function(acc, name) {
                acc[prefix + "-" + name] = items[name];
                return acc;
            }, {});
        };
        _this.state = {
            afterOpen: false,
            beforeClose: false
        };
        _this.shouldClose = null;
        _this.moveFromContentToOverlay = null;
        return _this;
    }
    $e030df1c7745f936$var$_createClass(ModalPortal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.isOpen) this.open();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.isOpen && !prevProps.isOpen) this.open();
                else if (!this.props.isOpen && prevProps.isOpen) this.close();
                // Focus only needs to be set once when the modal is being opened
                if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) this.focusContent();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.state.isOpen) this.afterClose();
                clearTimeout(this.closeTimer);
            }
        },
        {
            key: "beforeOpen",
            value: function beforeOpen() {
                var _props = this.props, appElement = _props.appElement, ariaHideApp = _props.ariaHideApp, htmlOpenClassName = _props.htmlOpenClassName, bodyOpenClassName = _props.bodyOpenClassName;
                // Add classes.
                bodyOpenClassName && $e030df1c7745f936$var$classList.add(document.body, bodyOpenClassName);
                htmlOpenClassName && $e030df1c7745f936$var$classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);
                if (ariaHideApp) {
                    $e030df1c7745f936$var$ariaHiddenInstances += 1;
                    $e030df1c7745f936$var$ariaAppHider.hide(appElement);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _props2 = this.props, id = _props2.id, className = _props2.className, overlayClassName = _props2.overlayClassName, defaultStyles = _props2.defaultStyles;
                var contentStyles = className ? {} : defaultStyles.content;
                var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
                return this.shouldBeClosed() ? null : $e030df1c7745f936$var$_react2.default.createElement("div", {
                    ref: this.setOverlayRef,
                    className: this.buildClassName("overlay", overlayClassName),
                    style: $e030df1c7745f936$var$_extends({}, overlayStyles, this.props.style.overlay),
                    onClick: this.handleOverlayOnClick,
                    onMouseDown: this.handleOverlayOnMouseDown
                }, $e030df1c7745f936$var$_react2.default.createElement("div", $e030df1c7745f936$var$_extends({
                    id: id,
                    ref: this.setContentRef,
                    style: $e030df1c7745f936$var$_extends({}, contentStyles, this.props.style.content),
                    className: this.buildClassName("content", className),
                    tabIndex: "-1",
                    onKeyDown: this.handleKeyDown,
                    onMouseDown: this.handleContentOnMouseDown,
                    onMouseUp: this.handleContentOnMouseUp,
                    onClick: this.handleContentOnClick,
                    role: this.props.role,
                    "aria-label": this.props.contentLabel
                }, this.attributesFromObject("aria", this.props.aria || {}), this.attributesFromObject("data", this.props.data || {}), {
                    "data-testid": this.props.testId
                }), this.props.children));
            }
        }
    ]);
    return ModalPortal;
}($5zKJZ.Component);
$e030df1c7745f936$var$ModalPortal.defaultProps = {
    style: {
        overlay: {},
        content: {}
    },
    defaultStyles: {}
};
$e030df1c7745f936$var$ModalPortal.propTypes = {
    isOpen: $e030df1c7745f936$var$_propTypes2.default.bool.isRequired,
    defaultStyles: $e030df1c7745f936$var$_propTypes2.default.shape({
        content: $e030df1c7745f936$var$_propTypes2.default.object,
        overlay: $e030df1c7745f936$var$_propTypes2.default.object
    }),
    style: $e030df1c7745f936$var$_propTypes2.default.shape({
        content: $e030df1c7745f936$var$_propTypes2.default.object,
        overlay: $e030df1c7745f936$var$_propTypes2.default.object
    }),
    className: $e030df1c7745f936$var$_propTypes2.default.oneOfType([
        $e030df1c7745f936$var$_propTypes2.default.string,
        $e030df1c7745f936$var$_propTypes2.default.object
    ]),
    overlayClassName: $e030df1c7745f936$var$_propTypes2.default.oneOfType([
        $e030df1c7745f936$var$_propTypes2.default.string,
        $e030df1c7745f936$var$_propTypes2.default.object
    ]),
    bodyOpenClassName: $e030df1c7745f936$var$_propTypes2.default.string,
    htmlOpenClassName: $e030df1c7745f936$var$_propTypes2.default.string,
    ariaHideApp: $e030df1c7745f936$var$_propTypes2.default.bool,
    appElement: $e030df1c7745f936$var$_propTypes2.default.instanceOf($e030df1c7745f936$var$_safeHTMLElement2.default),
    onAfterOpen: $e030df1c7745f936$var$_propTypes2.default.func,
    onAfterClose: $e030df1c7745f936$var$_propTypes2.default.func,
    onRequestClose: $e030df1c7745f936$var$_propTypes2.default.func,
    closeTimeoutMS: $e030df1c7745f936$var$_propTypes2.default.number,
    shouldFocusAfterRender: $e030df1c7745f936$var$_propTypes2.default.bool,
    shouldCloseOnOverlayClick: $e030df1c7745f936$var$_propTypes2.default.bool,
    shouldReturnFocusAfterClose: $e030df1c7745f936$var$_propTypes2.default.bool,
    role: $e030df1c7745f936$var$_propTypes2.default.string,
    contentLabel: $e030df1c7745f936$var$_propTypes2.default.string,
    aria: $e030df1c7745f936$var$_propTypes2.default.object,
    data: $e030df1c7745f936$var$_propTypes2.default.object,
    children: $e030df1c7745f936$var$_propTypes2.default.node,
    shouldCloseOnEsc: $e030df1c7745f936$var$_propTypes2.default.bool,
    overlayRef: $e030df1c7745f936$var$_propTypes2.default.func,
    contentRef: $e030df1c7745f936$var$_propTypes2.default.func,
    id: $e030df1c7745f936$var$_propTypes2.default.string,
    testId: $e030df1c7745f936$var$_propTypes2.default.string
};
$e030df1c7745f936$exports.default = $e030df1c7745f936$var$ModalPortal;
$e030df1c7745f936$exports = $e030df1c7745f936$exports["default"];


var $9ab2d10924611cc0$var$_ModalPortal2 = $9ab2d10924611cc0$var$_interopRequireDefault($e030df1c7745f936$exports);

var $9ab2d10924611cc0$var$ariaAppHider = $9ab2d10924611cc0$var$_interopRequireWildcard($1715b727bb982066$exports);

var $9ab2d10924611cc0$var$_safeHTMLElement2 = $9ab2d10924611cc0$var$_interopRequireDefault($dc852a86ca7cdb29$exports);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $a356fb8fe2fe9242$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $a356fb8fe2fe9242$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $a356fb8fe2fe9242$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$a356fb8fe2fe9242$var$componentWillMount.__suppressDeprecationWarning = true;
$a356fb8fe2fe9242$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$a356fb8fe2fe9242$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $a356fb8fe2fe9242$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error("Can only polyfill class components");
    if (typeof Component.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === "function") foundWillMountName = "componentWillMount";
    else if (typeof prototype.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
    if (typeof prototype.componentWillReceiveProps === "function") foundWillReceivePropsName = "componentWillReceiveProps";
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
    if (typeof prototype.componentWillUpdate === "function") foundWillUpdateName = "componentWillUpdate";
    else if (typeof prototype.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
        throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\n" + "https://fb.me/react-async-component-lifecycle-hooks");
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === "function") {
        prototype.componentWillMount = $a356fb8fe2fe9242$var$componentWillMount;
        prototype.componentWillReceiveProps = $a356fb8fe2fe9242$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === "function") {
        if (typeof prototype.componentDidUpdate !== "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
        prototype.componentWillUpdate = $a356fb8fe2fe9242$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}


function $9ab2d10924611cc0$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $9ab2d10924611cc0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9ab2d10924611cc0$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9ab2d10924611cc0$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $9ab2d10924611cc0$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $9ab2d10924611cc0$var$portalClassName = $9ab2d10924611cc0$exports.portalClassName = "ReactModalPortal";
var $9ab2d10924611cc0$var$bodyOpenClassName = $9ab2d10924611cc0$exports.bodyOpenClassName = "ReactModal__Body--open";
var $9ab2d10924611cc0$var$isReact16 = $9ab2d10924611cc0$var$_reactDom2.default.createPortal !== undefined;
var $9ab2d10924611cc0$var$getCreatePortal = function getCreatePortal() {
    return $9ab2d10924611cc0$var$isReact16 ? $9ab2d10924611cc0$var$_reactDom2.default.createPortal : $9ab2d10924611cc0$var$_reactDom2.default.unstable_renderSubtreeIntoContainer;
};
function $9ab2d10924611cc0$var$getParentElement(parentSelector) {
    return parentSelector();
}
var $9ab2d10924611cc0$var$Modal = function(_Component) {
    $9ab2d10924611cc0$var$_inherits(Modal, _Component);
    function Modal() {
        var _ref;
        var _temp, _this, _ret;
        $9ab2d10924611cc0$var$_classCallCheck(this, Modal);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $9ab2d10924611cc0$var$_possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.removePortal = function() {
            !$9ab2d10924611cc0$var$isReact16 && $9ab2d10924611cc0$var$_reactDom2.default.unmountComponentAtNode(_this.node);
            var parent = $9ab2d10924611cc0$var$getParentElement(_this.props.parentSelector);
            parent.removeChild(_this.node);
        }, _this.portalRef = function(ref) {
            _this.portal = ref;
        }, _this.renderPortal = function(props) {
            var createPortal = $9ab2d10924611cc0$var$getCreatePortal();
            var portal = createPortal(_this, $9ab2d10924611cc0$var$_react2.default.createElement($9ab2d10924611cc0$var$_ModalPortal2.default, $9ab2d10924611cc0$var$_extends({
                defaultStyles: Modal.defaultStyles
            }, props)), _this.node);
            _this.portalRef(portal);
        }, _temp), $9ab2d10924611cc0$var$_possibleConstructorReturn(_this, _ret);
    }
    $9ab2d10924611cc0$var$_createClass(Modal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!$dc852a86ca7cdb29$exports.canUseDOM) return;
                if (!$9ab2d10924611cc0$var$isReact16) this.node = document.createElement("div");
                this.node.className = this.props.portalClassName;
                var parent = $9ab2d10924611cc0$var$getParentElement(this.props.parentSelector);
                parent.appendChild(this.node);
                !$9ab2d10924611cc0$var$isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "getSnapshotBeforeUpdate",
            value: function getSnapshotBeforeUpdate(prevProps) {
                var prevParent = $9ab2d10924611cc0$var$getParentElement(prevProps.parentSelector);
                var nextParent = $9ab2d10924611cc0$var$getParentElement(this.props.parentSelector);
                return {
                    prevParent: prevParent,
                    nextParent: nextParent
                };
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, _, snapshot) {
                if (!$dc852a86ca7cdb29$exports.canUseDOM) return;
                var _props = this.props, isOpen = _props.isOpen, portalClassName = _props.portalClassName;
                if (prevProps.portalClassName !== portalClassName) this.node.className = portalClassName;
                var prevParent = snapshot.prevParent, nextParent = snapshot.nextParent;
                if (nextParent !== prevParent) {
                    prevParent.removeChild(this.node);
                    nextParent.appendChild(this.node);
                }
                // Stop unnecessary renders if modal is remaining closed
                if (!prevProps.isOpen && !isOpen) return;
                !$9ab2d10924611cc0$var$isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (!$dc852a86ca7cdb29$exports.canUseDOM || !this.node || !this.portal) return;
                var state = this.portal.state;
                var now = Date.now();
                var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
                if (closesAt) {
                    if (!state.beforeClose) this.portal.closeWithTimeout();
                    setTimeout(this.removePortal, closesAt - now);
                } else this.removePortal();
            }
        },
        {
            key: "render",
            value: function render() {
                if (!$dc852a86ca7cdb29$exports.canUseDOM || !$9ab2d10924611cc0$var$isReact16) return null;
                if (!this.node && $9ab2d10924611cc0$var$isReact16) this.node = document.createElement("div");
                var createPortal = $9ab2d10924611cc0$var$getCreatePortal();
                return createPortal($9ab2d10924611cc0$var$_react2.default.createElement($9ab2d10924611cc0$var$_ModalPortal2.default, $9ab2d10924611cc0$var$_extends({
                    ref: this.portalRef,
                    defaultStyles: Modal.defaultStyles
                }, this.props)), this.node);
            }
        }
    ], [
        {
            key: "setAppElement",
            value: function setAppElement(element) {
                $9ab2d10924611cc0$var$ariaAppHider.setElement(element);
            }
        }
    ]);
    return Modal;
}($5zKJZ.Component);
$9ab2d10924611cc0$var$Modal.propTypes = {
    isOpen: $9ab2d10924611cc0$var$_propTypes2.default.bool.isRequired,
    style: $9ab2d10924611cc0$var$_propTypes2.default.shape({
        content: $9ab2d10924611cc0$var$_propTypes2.default.object,
        overlay: $9ab2d10924611cc0$var$_propTypes2.default.object
    }),
    portalClassName: $9ab2d10924611cc0$var$_propTypes2.default.string,
    bodyOpenClassName: $9ab2d10924611cc0$var$_propTypes2.default.string,
    htmlOpenClassName: $9ab2d10924611cc0$var$_propTypes2.default.string,
    className: $9ab2d10924611cc0$var$_propTypes2.default.oneOfType([
        $9ab2d10924611cc0$var$_propTypes2.default.string,
        $9ab2d10924611cc0$var$_propTypes2.default.shape({
            base: $9ab2d10924611cc0$var$_propTypes2.default.string.isRequired,
            afterOpen: $9ab2d10924611cc0$var$_propTypes2.default.string.isRequired,
            beforeClose: $9ab2d10924611cc0$var$_propTypes2.default.string.isRequired
        })
    ]),
    overlayClassName: $9ab2d10924611cc0$var$_propTypes2.default.oneOfType([
        $9ab2d10924611cc0$var$_propTypes2.default.string,
        $9ab2d10924611cc0$var$_propTypes2.default.shape({
            base: $9ab2d10924611cc0$var$_propTypes2.default.string.isRequired,
            afterOpen: $9ab2d10924611cc0$var$_propTypes2.default.string.isRequired,
            beforeClose: $9ab2d10924611cc0$var$_propTypes2.default.string.isRequired
        })
    ]),
    appElement: $9ab2d10924611cc0$var$_propTypes2.default.instanceOf($9ab2d10924611cc0$var$_safeHTMLElement2.default),
    onAfterOpen: $9ab2d10924611cc0$var$_propTypes2.default.func,
    onRequestClose: $9ab2d10924611cc0$var$_propTypes2.default.func,
    closeTimeoutMS: $9ab2d10924611cc0$var$_propTypes2.default.number,
    ariaHideApp: $9ab2d10924611cc0$var$_propTypes2.default.bool,
    shouldFocusAfterRender: $9ab2d10924611cc0$var$_propTypes2.default.bool,
    shouldCloseOnOverlayClick: $9ab2d10924611cc0$var$_propTypes2.default.bool,
    shouldReturnFocusAfterClose: $9ab2d10924611cc0$var$_propTypes2.default.bool,
    parentSelector: $9ab2d10924611cc0$var$_propTypes2.default.func,
    aria: $9ab2d10924611cc0$var$_propTypes2.default.object,
    data: $9ab2d10924611cc0$var$_propTypes2.default.object,
    role: $9ab2d10924611cc0$var$_propTypes2.default.string,
    contentLabel: $9ab2d10924611cc0$var$_propTypes2.default.string,
    shouldCloseOnEsc: $9ab2d10924611cc0$var$_propTypes2.default.bool,
    overlayRef: $9ab2d10924611cc0$var$_propTypes2.default.func,
    contentRef: $9ab2d10924611cc0$var$_propTypes2.default.func
};
$9ab2d10924611cc0$var$Modal.defaultProps = {
    isOpen: false,
    portalClassName: $9ab2d10924611cc0$var$portalClassName,
    bodyOpenClassName: $9ab2d10924611cc0$var$bodyOpenClassName,
    role: "dialog",
    ariaHideApp: true,
    closeTimeoutMS: 0,
    shouldFocusAfterRender: true,
    shouldCloseOnEsc: true,
    shouldCloseOnOverlayClick: true,
    shouldReturnFocusAfterClose: true,
    parentSelector: function parentSelector() {
        return document.body;
    }
};
$9ab2d10924611cc0$var$Modal.defaultStyles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.75)"
    },
    content: {
        position: "absolute",
        top: "40px",
        left: "40px",
        right: "40px",
        bottom: "40px",
        border: "1px solid #ccc",
        background: "#fff",
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
        borderRadius: "4px",
        outline: "none",
        padding: "20px"
    }
};
(0, $a356fb8fe2fe9242$export$cea1c58a6db52bca)($9ab2d10924611cc0$var$Modal);
$9ab2d10924611cc0$exports.default = $9ab2d10924611cc0$var$Modal;


var $c1e84079c9071642$var$_Modal2 = $c1e84079c9071642$var$_interopRequireDefault($9ab2d10924611cc0$exports);
function $c1e84079c9071642$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$c1e84079c9071642$exports.default = $c1e84079c9071642$var$_Modal2.default;
$c1e84079c9071642$exports = $c1e84079c9071642$exports["default"];


const $01d17b32fe0e8a4e$var$customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        width: "90%",
        padding: "40px 20px",
        maxWidth: "500px",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        borderRadius: "10px"
    }
};
const $01d17b32fe0e8a4e$var$closeButton = {
    width: "30px"
};
(0, (/*@__PURE__*/$parcel$interopDefault($c1e84079c9071642$exports))).setAppElement("#root");
const $01d17b32fe0e8a4e$var$PageFour = (props)=>{
    const [modalIsOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).useState(false);
    function openModal() {
        setIsOpen(true);
    }
    function closeModal() {
        setIsOpen(false);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "kids-quiz__page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c1e84079c9071642$exports))), {
        isOpen: modalIsOpen,
        onRequestClose: closeModal,
        style: $01d17b32fe0e8a4e$var$customStyles,
        contentLabel: "Antidepressant question explanation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "close-modal",
        onClick: closeModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$830dad7b282f77fd), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "modal-copy"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", null, "Certain nourishments are not suitable to take alongside prescription medication so we will exclude them from your recommendation."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", null, "For more information please view our guidelines ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("a", {
        className: "modal-link",
        href: "/pages/help-centre-medical-dietary-guidelines",
        target: "_blank"
    }, "here"), ".")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        id: "eyesight",
        className: "kids-quiz__question"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", {
        className: "question__title"
    }, "Do you wear glasses or use contact lenses?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "radio-answers answers-row--2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
        type: "radio",
        name: "glasses",
        id: "glassesYes",
        value: "yes",
        onChange: props.logGlassesAnswer,
        checked: props.glassesAnswer === "yes"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("label", {
        className: "answer-button answer-button__glasses",
        htmlFor: "glassesYes"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$bd2518280c2f05c1), null), "Yes"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
        type: "radio",
        name: "glasses",
        id: "glassesNo",
        value: "no",
        onChange: props.logGlassesAnswer,
        checked: props.glassesAnswer === "no"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("label", {
        className: "answer-button answer-button__glasses",
        htmlFor: "glassesNo"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$830dad7b282f77fd), null), "No"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("a", {
        href: "#healthConditions",
        className: `question-divider ${props.glassesAnswer ? "question-divider--show" : ""}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$2baabfc57bf5919a), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        id: "healthConditions",
        className: `kids-quiz__question ${props.glassesAnswer ? "kids-quiz__question--show" : "kids-quiz__question--hidden"}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", {
        className: "question__title"
    }, "Do you suffer with any of the below?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "answers-row--flex health-answers"
    }, props.renderConditionsAnswers)), props.conditionsAnswerIndex.length > 0 && !props.conditionsAnswerIndex.includes("No") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("a", {
        href: "#hypothyroidism",
        className: `question-divider ${props.conditionsAnswerIndex.includes("Hypothyroidism") ? "question-divider--show" : ""}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$2baabfc57bf5919a), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        id: "hypothyroidism",
        className: `kids-quiz__question ${props.conditionsAnswerIndex.includes("Hypothyroidism") ? "kids-quiz__question--show" : "kids-quiz__question--none"}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", {
        className: "question__title"
    }, "Have you had your thyroid removed or should you be avoiding extra iodine in your diet?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "radio-answers answers-row--2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
        type: "radio",
        name: "iodine",
        id: "iodineYes",
        value: "yes",
        onChange: props.logIodineAnswer,
        checked: props.iodineAnswer === "yes"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("label", {
        className: "answer-button answer-button__glasses",
        htmlFor: "iodineYes"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$bd2518280c2f05c1), null), "Yes"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
        type: "radio",
        name: "iodine",
        id: "iodineNo",
        value: "no",
        onChange: props.logIodineAnswer,
        checked: props.iodineAnswer === "no"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("label", {
        className: "answer-button answer-button__glasses",
        htmlFor: "iodineNo"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$830dad7b282f77fd), null), "No"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("a", {
        href: "#healthConditionsSlider",
        className: `question-divider ${props.conditionsAnswerIndex.length > 0 ? "question-divider--show" : ""}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$2baabfc57bf5919a), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        id: "healthConditionsSlider",
        className: "kids-quiz__question"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", {
        className: "question__title"
    }, "How do these conditions effect your quality of life?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "range__selector"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebfaaab6f872e4e6$exports))), {
        maxValue: 100,
        minValue: 1,
        value: props.conditionsEffectSlider,
        onChange: (value)=>props.handleSlider(value, "conditionsSlider")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "range__text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", null, "No effect"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", null, "Daily struggle")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("a", {
        href: "#healthConditionsManage",
        className: `question-divider ${props.conditionsAnswerIndex.length > 0 ? "question-divider--show" : ""}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$2baabfc57bf5919a), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        id: "healthConditionsManage",
        className: "kids-quiz__question"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", {
        className: "question__title"
    }, "How do you manage your conditions?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "answers-row--flex health-answers"
    }, props.renderManageConditionsAnswers)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("a", {
        href: "#antiDepressants",
        className: `question-divider ${props.manageConditionsAnswerIndex.length > 0 ? "question-divider--show" : ""}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$2baabfc57bf5919a), null))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("a", {
        href: "#antiDepressants",
        className: `question-divider ${props.conditionsAnswerIndex.length > 0 ? "question-divider--show" : ""}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$2baabfc57bf5919a), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        id: "antiDepressants",
        className: `kids-quiz__question ${props.conditionsAnswerIndex.length > 0 && props.conditionsAnswerIndex.includes("No") || props.manageConditionsAnswerIndex.length > 0 ? "kids-quiz__question--show" : "kids-quiz__question--hidden"}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", {
        className: "question__title"
    }, "Are you currently taking prescription antidepressants for any medical condition? ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("span", {
        className: "open-modal-button",
        onClick: openModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$33b26d5f51359e1b), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "radio-answers answers-row--2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
        type: "radio",
        name: "antiDepressants",
        id: "antiDepressantsYes",
        value: "yes",
        onChange: props.logMedicationAnswer,
        checked: props.medicationAnswer === "yes"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("label", {
        className: "answer-button answer-button__glasses",
        htmlFor: "antiDepressantsYes"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$bd2518280c2f05c1), null), "Yes"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
        type: "radio",
        name: "antiDepressants",
        id: "antiDepressantsNo",
        value: "no",
        onChange: props.logMedicationAnswer,
        checked: props.medicationAnswer === "no"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("label", {
        className: "answer-button answer-button__glasses",
        htmlFor: "antiDepressantsNo"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$830dad7b282f77fd), null), "No"))), props.gender !== "male" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("a", {
        href: "#natal",
        className: `question-divider ${props.medicationAnswer ? "question-divider--show" : ""}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$2baabfc57bf5919a), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        id: "natal",
        className: `kids-quiz__question ${props.medicationAnswer ? "kids-quiz__question--show" : "kids-quiz__question--hidden"}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", {
        className: "question__title"
    }, "Are you pre/post natal, currently pregnant or breast feeding?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "answers-row--flex health-answers"
    }, props.renderNatalAnswers)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: `next-page ${props.natalAnswerIndex.length > 0 ? "next-page--show" : "next-page--hidden"}`,
        onClick: ()=>props.nextPage("4")
    }, "Continue")) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: `next-page ${props.medicationAnswer ? "next-page--show" : "next-page--hidden"}`,
        onClick: ()=>props.nextPage("4")
    }, "Continue"));
};
var $01d17b32fe0e8a4e$export$2e2bcd8739ae039 = $01d17b32fe0e8a4e$var$PageFour;



var $5zKJZ = parcelRequire("5zKJZ");
function $936eae2ecd19c455$export$2e2bcd8739ae039() {
    $936eae2ecd19c455$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $936eae2ecd19c455$export$2e2bcd8739ae039.apply(this, arguments);
}



var $5zKJZ = parcelRequire("5zKJZ");
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $156ad2d5dbfa8572$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $156ad2d5dbfa8572$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $156ad2d5dbfa8572$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($156ad2d5dbfa8572$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $156ad2d5dbfa8572$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


var $468637f8d41e4ff5$export$71ad59f2e432cfe8 = "-ms-";
var $468637f8d41e4ff5$export$2c0f367103c8d01c = "-moz-";
var $468637f8d41e4ff5$export$39dfd62a25e0fe93 = "-webkit-";
var $468637f8d41e4ff5$export$a29989082612d0d9 = "comm";
var $468637f8d41e4ff5$export$aa3a2e812ca8570d = "rule";
var $468637f8d41e4ff5$export$527d108ccf083c2b = "decl";
var $468637f8d41e4ff5$export$d3d35020fa5b54f0 = "@page";
var $468637f8d41e4ff5$export$500415a86c544f73 = "@media";
var $468637f8d41e4ff5$export$a763edbf796b780a = "@import";
var $468637f8d41e4ff5$export$2790aeb8b4e5c826 = "@charset";
var $468637f8d41e4ff5$export$1cc683e23b84b133 = "@viewport";
var $468637f8d41e4ff5$export$9447a5efea57e862 = "@supports";
var $468637f8d41e4ff5$export$ef011b4e114b1fba = "@document";
var $468637f8d41e4ff5$export$6aad947bda0f3f46 = "@namespace";
var $468637f8d41e4ff5$export$b44a8529a35fcb60 = "@keyframes";
var $468637f8d41e4ff5$export$2c16de31893252e6 = "@font-face";
var $468637f8d41e4ff5$export$3d846dd52e150c6f = "@counter-style";
var $468637f8d41e4ff5$export$22314bfbb57653fe = "@font-feature-values";
var $468637f8d41e4ff5$export$2335f513bbd82c6d = Math.abs;
var $468637f8d41e4ff5$export$6788812c4e6611e6 = String.fromCharCode;
var $468637f8d41e4ff5$export$e6e34fd1f2686227 = Object.assign;
function $468637f8d41e4ff5$export$d6af199866bfb566(e, r) {
    return (((r << 2 ^ $468637f8d41e4ff5$export$a9db5e087081082d(e, 0)) << 2 ^ $468637f8d41e4ff5$export$a9db5e087081082d(e, 1)) << 2 ^ $468637f8d41e4ff5$export$a9db5e087081082d(e, 2)) << 2 ^ $468637f8d41e4ff5$export$a9db5e087081082d(e, 3);
}
function $468637f8d41e4ff5$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $468637f8d41e4ff5$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $468637f8d41e4ff5$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $468637f8d41e4ff5$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $468637f8d41e4ff5$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $468637f8d41e4ff5$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $468637f8d41e4ff5$export$36776f635604f274(e) {
    return e.length;
}
function $468637f8d41e4ff5$export$f9084667e487ed46(e) {
    return e.length;
}
function $468637f8d41e4ff5$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $468637f8d41e4ff5$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $468637f8d41e4ff5$export$53f1d5ea8de3d7c = 1;
var $468637f8d41e4ff5$export$4e0c71f277ca26b3 = 1;
var $468637f8d41e4ff5$export$f24224f1c91d8156 = 0;
var $468637f8d41e4ff5$export$5880b8b5730aff45 = 0;
var $468637f8d41e4ff5$export$c0306caf338ac095 = 0;
var $468637f8d41e4ff5$export$30a86d91af8ff6e6 = "";
function $468637f8d41e4ff5$export$35059013cd4a06db(e, r, a, c, n, t, s) {
    return {
        value: e,
        root: r,
        parent: a,
        type: c,
        props: n,
        children: t,
        line: $468637f8d41e4ff5$export$53f1d5ea8de3d7c,
        column: $468637f8d41e4ff5$export$4e0c71f277ca26b3,
        length: s,
        return: ""
    };
}
function $468637f8d41e4ff5$export$784d13d8ee351f07(e, r) {
    return $468637f8d41e4ff5$export$e6e34fd1f2686227($468637f8d41e4ff5$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $468637f8d41e4ff5$export$eba6f6f03b0a92e7() {
    return $468637f8d41e4ff5$export$c0306caf338ac095;
}
function $468637f8d41e4ff5$export$232faf9add678146() {
    $468637f8d41e4ff5$export$c0306caf338ac095 = $468637f8d41e4ff5$export$5880b8b5730aff45 > 0 ? $468637f8d41e4ff5$export$a9db5e087081082d($468637f8d41e4ff5$export$30a86d91af8ff6e6, --$468637f8d41e4ff5$export$5880b8b5730aff45) : 0;
    if ($468637f8d41e4ff5$export$4e0c71f277ca26b3--, $468637f8d41e4ff5$export$c0306caf338ac095 === 10) $468637f8d41e4ff5$export$4e0c71f277ca26b3 = 1, $468637f8d41e4ff5$export$53f1d5ea8de3d7c--;
    return $468637f8d41e4ff5$export$c0306caf338ac095;
}
function $468637f8d41e4ff5$export$48cfd1e771a65c4f() {
    $468637f8d41e4ff5$export$c0306caf338ac095 = $468637f8d41e4ff5$export$5880b8b5730aff45 < $468637f8d41e4ff5$export$f24224f1c91d8156 ? $468637f8d41e4ff5$export$a9db5e087081082d($468637f8d41e4ff5$export$30a86d91af8ff6e6, $468637f8d41e4ff5$export$5880b8b5730aff45++) : 0;
    if ($468637f8d41e4ff5$export$4e0c71f277ca26b3++, $468637f8d41e4ff5$export$c0306caf338ac095 === 10) $468637f8d41e4ff5$export$4e0c71f277ca26b3 = 1, $468637f8d41e4ff5$export$53f1d5ea8de3d7c++;
    return $468637f8d41e4ff5$export$c0306caf338ac095;
}
function $468637f8d41e4ff5$export$4d3fb11e950abb9e() {
    return $468637f8d41e4ff5$export$a9db5e087081082d($468637f8d41e4ff5$export$30a86d91af8ff6e6, $468637f8d41e4ff5$export$5880b8b5730aff45);
}
function $468637f8d41e4ff5$export$e88cb2efb12ae807() {
    return $468637f8d41e4ff5$export$5880b8b5730aff45;
}
function $468637f8d41e4ff5$export$58adb3bec8346d0f(e, r) {
    return $468637f8d41e4ff5$export$2f35ab04d2335697($468637f8d41e4ff5$export$30a86d91af8ff6e6, e, r);
}
function $468637f8d41e4ff5$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $468637f8d41e4ff5$export$2de70f21292aac9e(e) {
    return $468637f8d41e4ff5$export$53f1d5ea8de3d7c = $468637f8d41e4ff5$export$4e0c71f277ca26b3 = 1, $468637f8d41e4ff5$export$f24224f1c91d8156 = $468637f8d41e4ff5$export$36776f635604f274($468637f8d41e4ff5$export$30a86d91af8ff6e6 = e), $468637f8d41e4ff5$export$5880b8b5730aff45 = 0, [];
}
function $468637f8d41e4ff5$export$45918ac1574455b1(e) {
    return $468637f8d41e4ff5$export$30a86d91af8ff6e6 = "", e;
}
function $468637f8d41e4ff5$export$410ac95b9ec204b8(e) {
    return $468637f8d41e4ff5$export$87c2784dc9fc4ab($468637f8d41e4ff5$export$58adb3bec8346d0f($468637f8d41e4ff5$export$5880b8b5730aff45 - 1, $468637f8d41e4ff5$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $468637f8d41e4ff5$export$660b2ee2d4fb4eff(e) {
    return $468637f8d41e4ff5$export$45918ac1574455b1($468637f8d41e4ff5$export$5f8c09e3ae6f64e1($468637f8d41e4ff5$export$2de70f21292aac9e(e)));
}
function $468637f8d41e4ff5$export$7af1228ff777d175(e) {
    while($468637f8d41e4ff5$export$c0306caf338ac095 = $468637f8d41e4ff5$export$4d3fb11e950abb9e())if ($468637f8d41e4ff5$export$c0306caf338ac095 < 33) $468637f8d41e4ff5$export$48cfd1e771a65c4f();
    else break;
    return $468637f8d41e4ff5$export$9e1725a4cfeada27(e) > 2 || $468637f8d41e4ff5$export$9e1725a4cfeada27($468637f8d41e4ff5$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $468637f8d41e4ff5$export$5f8c09e3ae6f64e1(e) {
    while($468637f8d41e4ff5$export$48cfd1e771a65c4f())switch($468637f8d41e4ff5$export$9e1725a4cfeada27($468637f8d41e4ff5$export$c0306caf338ac095)){
        case 0:
            $468637f8d41e4ff5$export$10d8903dec122b9d($468637f8d41e4ff5$export$c2ab62c7bf24634($468637f8d41e4ff5$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $468637f8d41e4ff5$export$10d8903dec122b9d($468637f8d41e4ff5$export$410ac95b9ec204b8($468637f8d41e4ff5$export$c0306caf338ac095), e);
            break;
        default:
            $468637f8d41e4ff5$export$10d8903dec122b9d($468637f8d41e4ff5$export$6788812c4e6611e6($468637f8d41e4ff5$export$c0306caf338ac095), e);
    }
    return e;
}
function $468637f8d41e4ff5$export$955ba06d119e085e(e, r) {
    while(--r && $468637f8d41e4ff5$export$48cfd1e771a65c4f())if ($468637f8d41e4ff5$export$c0306caf338ac095 < 48 || $468637f8d41e4ff5$export$c0306caf338ac095 > 102 || $468637f8d41e4ff5$export$c0306caf338ac095 > 57 && $468637f8d41e4ff5$export$c0306caf338ac095 < 65 || $468637f8d41e4ff5$export$c0306caf338ac095 > 70 && $468637f8d41e4ff5$export$c0306caf338ac095 < 97) break;
    return $468637f8d41e4ff5$export$58adb3bec8346d0f(e, $468637f8d41e4ff5$export$e88cb2efb12ae807() + (r < 6 && $468637f8d41e4ff5$export$4d3fb11e950abb9e() == 32 && $468637f8d41e4ff5$export$48cfd1e771a65c4f() == 32));
}
function $468637f8d41e4ff5$export$c889f2fcc19dbf12(e) {
    while($468637f8d41e4ff5$export$48cfd1e771a65c4f())switch($468637f8d41e4ff5$export$c0306caf338ac095){
        case e:
            return $468637f8d41e4ff5$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $468637f8d41e4ff5$export$c889f2fcc19dbf12($468637f8d41e4ff5$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $468637f8d41e4ff5$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $468637f8d41e4ff5$export$48cfd1e771a65c4f();
            break;
    }
    return $468637f8d41e4ff5$export$5880b8b5730aff45;
}
function $468637f8d41e4ff5$export$4254d4e2b3745c4c(e, r) {
    while($468637f8d41e4ff5$export$48cfd1e771a65c4f())if (e + $468637f8d41e4ff5$export$c0306caf338ac095 === 57) break;
    else if (e + $468637f8d41e4ff5$export$c0306caf338ac095 === 84 && $468637f8d41e4ff5$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $468637f8d41e4ff5$export$58adb3bec8346d0f(r, $468637f8d41e4ff5$export$5880b8b5730aff45 - 1) + "*" + $468637f8d41e4ff5$export$6788812c4e6611e6(e === 47 ? e : $468637f8d41e4ff5$export$48cfd1e771a65c4f());
}
function $468637f8d41e4ff5$export$c2ab62c7bf24634(e) {
    while(!$468637f8d41e4ff5$export$9e1725a4cfeada27($468637f8d41e4ff5$export$4d3fb11e950abb9e()))$468637f8d41e4ff5$export$48cfd1e771a65c4f();
    return $468637f8d41e4ff5$export$58adb3bec8346d0f(e, $468637f8d41e4ff5$export$5880b8b5730aff45);
}
function $468637f8d41e4ff5$export$ef7acd7185315e22(e) {
    return $468637f8d41e4ff5$export$45918ac1574455b1($468637f8d41e4ff5$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $468637f8d41e4ff5$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $468637f8d41e4ff5$export$98e6a39c04603d36(e, r, a, c, n, t, s, u, i) {
    var f = 0;
    var o = 0;
    var l = s;
    var v = 0;
    var h = 0;
    var p = 0;
    var b = 1;
    var w = 1;
    var $ = 1;
    var k = 0;
    var g = "";
    var m = n;
    var x = t;
    var y = c;
    var z = g;
    while(w)switch(p = k, k = $468637f8d41e4ff5$export$48cfd1e771a65c4f()){
        case 40:
            if (p != 108 && z.charCodeAt(l - 1) == 58) {
                if ($468637f8d41e4ff5$export$f8e21b1e77979a08(z += $468637f8d41e4ff5$export$77ad94ebf1c2b9ed($468637f8d41e4ff5$export$410ac95b9ec204b8(k), "&", "&\f"), "&\f") != -1) $ = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += $468637f8d41e4ff5$export$410ac95b9ec204b8(k);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += $468637f8d41e4ff5$export$7af1228ff777d175(p);
            break;
        case 92:
            z += $468637f8d41e4ff5$export$955ba06d119e085e($468637f8d41e4ff5$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($468637f8d41e4ff5$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $468637f8d41e4ff5$export$10d8903dec122b9d($468637f8d41e4ff5$export$4a34f930e789283c($468637f8d41e4ff5$export$4254d4e2b3745c4c($468637f8d41e4ff5$export$48cfd1e771a65c4f(), $468637f8d41e4ff5$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * b:
            u[f++] = $468637f8d41e4ff5$export$36776f635604f274(z) * $;
        case 125 * b:
        case 59:
        case 0:
            switch(k){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (h > 0 && $468637f8d41e4ff5$export$36776f635604f274(z) - l) $468637f8d41e4ff5$export$10d8903dec122b9d(h > 32 ? $468637f8d41e4ff5$export$f8483753829ec8f3(z + ";", c, a, l - 1) : $468637f8d41e4ff5$export$f8483753829ec8f3($468637f8d41e4ff5$export$77ad94ebf1c2b9ed(z, " ", "") + ";", c, a, l - 2), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $468637f8d41e4ff5$export$10d8903dec122b9d(y = $468637f8d41e4ff5$export$3307ffa7023ede1e(z, r, a, f, o, n, u, g, m = [], x = [], l), t);
                    if (k === 123) {
                        if (o === 0) $468637f8d41e4ff5$export$98e6a39c04603d36(z, r, y, y, m, t, l, u, x);
                        else switch(v){
                            case 100:
                            case 109:
                            case 115:
                                $468637f8d41e4ff5$export$98e6a39c04603d36(e, y, y, c && $468637f8d41e4ff5$export$10d8903dec122b9d($468637f8d41e4ff5$export$3307ffa7023ede1e(e, y, y, 0, 0, n, u, g, n, m = [], l), x), n, x, l, u, c ? m : x);
                                break;
                            default:
                                $468637f8d41e4ff5$export$98e6a39c04603d36(z, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = h = 0, b = $ = 1, g = z = "", l = s;
            break;
        case 58:
            l = 1 + $468637f8d41e4ff5$export$36776f635604f274(z), h = p;
        default:
            if (b < 1) {
                if (k == 123) --b;
                else if (k == 125 && b++ == 0 && $468637f8d41e4ff5$export$232faf9add678146() == 125) continue;
            }
            switch(z += $468637f8d41e4ff5$export$6788812c4e6611e6(k), k * b){
                case 38:
                    $ = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($468637f8d41e4ff5$export$36776f635604f274(z) - 1) * $, $ = 1;
                    break;
                case 64:
                    if ($468637f8d41e4ff5$export$4d3fb11e950abb9e() === 45) z += $468637f8d41e4ff5$export$410ac95b9ec204b8($468637f8d41e4ff5$export$48cfd1e771a65c4f());
                    v = $468637f8d41e4ff5$export$4d3fb11e950abb9e(), o = l = $468637f8d41e4ff5$export$36776f635604f274(g = z += $468637f8d41e4ff5$export$c2ab62c7bf24634($468637f8d41e4ff5$export$e88cb2efb12ae807())), k++;
                    break;
                case 45:
                    if (p === 45 && $468637f8d41e4ff5$export$36776f635604f274(z) == 2) b = 0;
            }
    }
    return t;
}
function $468637f8d41e4ff5$export$3307ffa7023ede1e(e, r, a, c, t, s, u, i, f, o, l) {
    var v = t - 1;
    var h = t === 0 ? s : [
        ""
    ];
    var p = $468637f8d41e4ff5$export$f9084667e487ed46(h);
    for(var b = 0, w = 0, $ = 0; b < c; ++b)for(var d = 0, g = $468637f8d41e4ff5$export$2f35ab04d2335697(e, v + 1, v = $468637f8d41e4ff5$export$2335f513bbd82c6d(w = u[b])), m = e; d < p; ++d)if (m = $468637f8d41e4ff5$export$87c2784dc9fc4ab(w > 0 ? h[d] + " " + g : $468637f8d41e4ff5$export$77ad94ebf1c2b9ed(g, /&\f/g, h[d]))) f[$++] = m;
    return $468637f8d41e4ff5$export$35059013cd4a06db(e, r, a, t === 0 ? $468637f8d41e4ff5$export$aa3a2e812ca8570d : i, f, o, l);
}
function $468637f8d41e4ff5$export$4a34f930e789283c(e, r, a) {
    return $468637f8d41e4ff5$export$35059013cd4a06db(e, r, a, $468637f8d41e4ff5$export$a29989082612d0d9, $468637f8d41e4ff5$export$6788812c4e6611e6($468637f8d41e4ff5$export$eba6f6f03b0a92e7()), $468637f8d41e4ff5$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $468637f8d41e4ff5$export$f8483753829ec8f3(e, r, a, c) {
    return $468637f8d41e4ff5$export$35059013cd4a06db(e, r, a, $468637f8d41e4ff5$export$527d108ccf083c2b, $468637f8d41e4ff5$export$2f35ab04d2335697(e, 0, c), $468637f8d41e4ff5$export$2f35ab04d2335697(e, c + 1, -1), c);
}
function $468637f8d41e4ff5$export$82e9f45cca5ba907(c, n) {
    switch($468637f8d41e4ff5$export$d6af199866bfb566(c, n)){
        case 5103:
            return $468637f8d41e4ff5$export$39dfd62a25e0fe93 + "print-" + c + c;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $468637f8d41e4ff5$export$39dfd62a25e0fe93 + c + c;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $468637f8d41e4ff5$export$39dfd62a25e0fe93 + c + $468637f8d41e4ff5$export$2c0f367103c8d01c + c + $468637f8d41e4ff5$export$71ad59f2e432cfe8 + c + c;
        case 6828:
        case 4268:
            return $468637f8d41e4ff5$export$39dfd62a25e0fe93 + c + $468637f8d41e4ff5$export$71ad59f2e432cfe8 + c + c;
        case 6165:
            return $468637f8d41e4ff5$export$39dfd62a25e0fe93 + c + $468637f8d41e4ff5$export$71ad59f2e432cfe8 + "flex-" + c + c;
        case 5187:
            return $468637f8d41e4ff5$export$39dfd62a25e0fe93 + c + $468637f8d41e4ff5$export$77ad94ebf1c2b9ed(c, /(\w+).+(:[^]+)/, $468637f8d41e4ff5$export$39dfd62a25e0fe93 + "box-$1$2" + $468637f8d41e4ff5$export$71ad59f2e432cfe8 + "flex-$1$2") + c;
        case 5443:
            return $468637f8d41e4ff5$export$39dfd62a25e0fe93 + c + $468637f8d41e4ff5$export$71ad59f2e432cfe8 + "flex-item-" + $468637f8d41e4ff5$export$77ad94ebf1c2b9ed(c, /flex-|-self/, "") + c;
        case 4675:
            return $468637f8d41e4ff5$export$39dfd62a25e0fe93 + c + $468637f8d41e4ff5$export$71ad59f2e432cfe8 + "flex-line-pack" + $468637f8d41e4ff5$export$77ad94ebf1c2b9ed(c, /align-content|flex-|-self/, "") + c;
        case 5548:
            return $468637f8d41e4ff5$export$39dfd62a25e0fe93 + c + $468637f8d41e4ff5$export$71ad59f2e432cfe8 + $468637f8d41e4ff5$export$77ad94ebf1c2b9ed(c, "shrink", "negative") + c;
        case 5292:
            return $468637f8d41e4ff5$export$39dfd62a25e0fe93 + c + $468637f8d41e4ff5$export$71ad59f2e432cfe8 + $468637f8d41e4ff5$export$77ad94ebf1c2b9ed(c, "basis", "preferred-size") + c;
        case 6060:
            return $468637f8d41e4ff5$export$39dfd62a25e0fe93 + "box-" + $468637f8d41e4ff5$export$77ad94ebf1c2b9ed(c, "-grow", "") + $468637f8d41e4ff5$export$39dfd62a25e0fe93 + c + $468637f8d41e4ff5$export$71ad59f2e432cfe8 + $468637f8d41e4ff5$export$77ad94ebf1c2b9ed(c, "grow", "positive") + c;
        case 4554:
            return $468637f8d41e4ff5$export$39dfd62a25e0fe93 + $468637f8d41e4ff5$export$77ad94ebf1c2b9ed(c, /([^-])(transform)/g, "$1" + $468637f8d41e4ff5$export$39dfd62a25e0fe93 + "$2") + c;
        case 6187:
            return $468637f8d41e4ff5$export$77ad94ebf1c2b9ed($468637f8d41e4ff5$export$77ad94ebf1c2b9ed($468637f8d41e4ff5$export$77ad94ebf1c2b9ed(c, /(zoom-|grab)/, $468637f8d41e4ff5$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $468637f8d41e4ff5$export$39dfd62a25e0fe93 + "$1"), c, "") + c;
        case 5495:
        case 3959:
            return $468637f8d41e4ff5$export$77ad94ebf1c2b9ed(c, /(image-set\([^]*)/, $468637f8d41e4ff5$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $468637f8d41e4ff5$export$77ad94ebf1c2b9ed($468637f8d41e4ff5$export$77ad94ebf1c2b9ed(c, /(.+:)(flex-)?(.*)/, $468637f8d41e4ff5$export$39dfd62a25e0fe93 + "box-pack:$3" + $468637f8d41e4ff5$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $468637f8d41e4ff5$export$39dfd62a25e0fe93 + c + c;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $468637f8d41e4ff5$export$77ad94ebf1c2b9ed(c, /(.+)-inline(.+)/, $468637f8d41e4ff5$export$39dfd62a25e0fe93 + "$1$2") + c;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($468637f8d41e4ff5$export$36776f635604f274(c) - 1 - n > 6) switch($468637f8d41e4ff5$export$a9db5e087081082d(c, n + 1)){
                case 109:
                    if ($468637f8d41e4ff5$export$a9db5e087081082d(c, n + 4) !== 45) break;
                case 102:
                    return $468637f8d41e4ff5$export$77ad94ebf1c2b9ed(c, /(.+:)(.+)-([^]+)/, "$1" + $468637f8d41e4ff5$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $468637f8d41e4ff5$export$2c0f367103c8d01c + ($468637f8d41e4ff5$export$a9db5e087081082d(c, n + 3) == 108 ? "$3" : "$2-$3")) + c;
                case 115:
                    return ~$468637f8d41e4ff5$export$f8e21b1e77979a08(c, "stretch") ? $468637f8d41e4ff5$export$82e9f45cca5ba907($468637f8d41e4ff5$export$77ad94ebf1c2b9ed(c, "stretch", "fill-available"), n) + c : c;
            }
            break;
        case 4949:
            if ($468637f8d41e4ff5$export$a9db5e087081082d(c, n + 1) !== 115) break;
        case 6444:
            switch($468637f8d41e4ff5$export$a9db5e087081082d(c, $468637f8d41e4ff5$export$36776f635604f274(c) - 3 - (~$468637f8d41e4ff5$export$f8e21b1e77979a08(c, "!important") && 10))){
                case 107:
                    return $468637f8d41e4ff5$export$77ad94ebf1c2b9ed(c, ":", ":" + $468637f8d41e4ff5$export$39dfd62a25e0fe93) + c;
                case 101:
                    return $468637f8d41e4ff5$export$77ad94ebf1c2b9ed(c, /(.+:)([^;!]+)(;|!.+)?/, "$1" + $468637f8d41e4ff5$export$39dfd62a25e0fe93 + ($468637f8d41e4ff5$export$a9db5e087081082d(c, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $468637f8d41e4ff5$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $468637f8d41e4ff5$export$71ad59f2e432cfe8 + "$2box$3") + c;
            }
            break;
        case 5936:
            switch($468637f8d41e4ff5$export$a9db5e087081082d(c, n + 11)){
                case 114:
                    return $468637f8d41e4ff5$export$39dfd62a25e0fe93 + c + $468637f8d41e4ff5$export$71ad59f2e432cfe8 + $468637f8d41e4ff5$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "tb") + c;
                case 108:
                    return $468637f8d41e4ff5$export$39dfd62a25e0fe93 + c + $468637f8d41e4ff5$export$71ad59f2e432cfe8 + $468637f8d41e4ff5$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "tb-rl") + c;
                case 45:
                    return $468637f8d41e4ff5$export$39dfd62a25e0fe93 + c + $468637f8d41e4ff5$export$71ad59f2e432cfe8 + $468637f8d41e4ff5$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "lr") + c;
            }
            return $468637f8d41e4ff5$export$39dfd62a25e0fe93 + c + $468637f8d41e4ff5$export$71ad59f2e432cfe8 + c + c;
    }
    return c;
}
function $468637f8d41e4ff5$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var c = $468637f8d41e4ff5$export$f9084667e487ed46(e);
    for(var n = 0; n < c; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function $468637f8d41e4ff5$export$fac44ee5b035f737(e, r, a, s) {
    switch(e.type){
        case $468637f8d41e4ff5$export$a763edbf796b780a:
        case $468637f8d41e4ff5$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $468637f8d41e4ff5$export$a29989082612d0d9:
            return "";
        case $468637f8d41e4ff5$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $468637f8d41e4ff5$export$dfdc1655ccc5b9cb(e.children, s) + "}";
        case $468637f8d41e4ff5$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $468637f8d41e4ff5$export$36776f635604f274(a = $468637f8d41e4ff5$export$dfdc1655ccc5b9cb(e.children, s)) ? e.return = e.value + "{" + a + "}" : "";
}
function $468637f8d41e4ff5$export$5a7767152ae0305f(e) {
    var r = $468637f8d41e4ff5$export$f9084667e487ed46(e);
    return function(a, c, n, t) {
        var s = "";
        for(var u = 0; u < r; u++)s += e[u](a, c, n, t) || "";
        return s;
    };
}
function $468637f8d41e4ff5$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $468637f8d41e4ff5$export$e08c7d021b829b7a(c, s, u, i) {
    if (c.length > -1) {
        if (!c.return) switch(c.type){
            case $468637f8d41e4ff5$export$527d108ccf083c2b:
                c.return = $468637f8d41e4ff5$export$82e9f45cca5ba907(c.value, c.length);
                break;
            case $468637f8d41e4ff5$export$b44a8529a35fcb60:
                return $468637f8d41e4ff5$export$dfdc1655ccc5b9cb([
                    $468637f8d41e4ff5$export$784d13d8ee351f07(c, {
                        value: $468637f8d41e4ff5$export$77ad94ebf1c2b9ed(c.value, "@", "@" + $468637f8d41e4ff5$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $468637f8d41e4ff5$export$aa3a2e812ca8570d:
                if (c.length) return $468637f8d41e4ff5$export$1be1fc439b849fdf(c.props, function(n) {
                    switch($468637f8d41e4ff5$export$4659b591c19bdf3d(n, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $468637f8d41e4ff5$export$dfdc1655ccc5b9cb([
                                $468637f8d41e4ff5$export$784d13d8ee351f07(c, {
                                    props: [
                                        $468637f8d41e4ff5$export$77ad94ebf1c2b9ed(n, /:(read-\w+)/, ":" + $468637f8d41e4ff5$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $468637f8d41e4ff5$export$dfdc1655ccc5b9cb([
                                $468637f8d41e4ff5$export$784d13d8ee351f07(c, {
                                    props: [
                                        $468637f8d41e4ff5$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, ":" + $468637f8d41e4ff5$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $468637f8d41e4ff5$export$784d13d8ee351f07(c, {
                                    props: [
                                        $468637f8d41e4ff5$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, ":" + $468637f8d41e4ff5$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $468637f8d41e4ff5$export$784d13d8ee351f07(c, {
                                    props: [
                                        $468637f8d41e4ff5$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, $468637f8d41e4ff5$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $468637f8d41e4ff5$export$76a88f7de6507443(e) {
    switch(e.type){
        case $468637f8d41e4ff5$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $468637f8d41e4ff5$export$1be1fc439b849fdf($468637f8d41e4ff5$export$660b2ee2d4fb4eff(r), function(r, a, c) {
                    switch($468637f8d41e4ff5$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $468637f8d41e4ff5$export$2f35ab04d2335697(r, 1, $468637f8d41e4ff5$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (c[++a] === "global") c[a] = "", c[++a] = "\f" + $468637f8d41e4ff5$export$2f35ab04d2335697(c[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $468637f8d41e4ff5$export$f9084667e487ed46(c) > 1 ? "" : r;
                                case a = $468637f8d41e4ff5$export$f9084667e487ed46(c) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $8e293d91e7091581$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $8e293d91e7091581$export$2e2bcd8739ae039 = $8e293d91e7091581$var$weakMemoize;


function $5c4241f2a5e5d524$var$memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $5c4241f2a5e5d524$export$2e2bcd8739ae039 = $5c4241f2a5e5d524$var$memoize;


var $f191ef1b0704aca6$var$last = function last(arr) {
    return arr.length ? arr[arr.length - 1] : null;
}; // based on https://github.com/thysultan/stylis.js/blob/e6843c373ebcbbfade25ebcc23f540ed8508da0a/src/Tokenizer.js#L239-L244
var $f191ef1b0704aca6$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $468637f8d41e4ff5$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $468637f8d41e4ff5$export$9e1725a4cfeada27)(character)) break;
        (0, $468637f8d41e4ff5$export$48cfd1e771a65c4f)();
    }
    return (0, $468637f8d41e4ff5$export$58adb3bec8346d0f)(begin, (0, $468637f8d41e4ff5$export$5880b8b5730aff45));
};
var $f191ef1b0704aca6$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $468637f8d41e4ff5$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $468637f8d41e4ff5$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $f191ef1b0704aca6$var$identifierWithPointTracking((0, $468637f8d41e4ff5$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $468637f8d41e4ff5$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $468637f8d41e4ff5$export$4d3fb11e950abb9e)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $468637f8d41e4ff5$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $468637f8d41e4ff5$export$48cfd1e771a65c4f)());
    return parsed;
};
var $f191ef1b0704aca6$var$getRules = function getRules(value, points) {
    return (0, $468637f8d41e4ff5$export$45918ac1574455b1)($f191ef1b0704aca6$var$toRules((0, $468637f8d41e4ff5$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $f191ef1b0704aca6$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $f191ef1b0704aca6$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$f191ef1b0704aca6$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $f191ef1b0704aca6$var$fixedElements.set(element, true);
    var points = [];
    var rules = $f191ef1b0704aca6$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $f191ef1b0704aca6$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $f191ef1b0704aca6$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $f191ef1b0704aca6$var$isIgnoringComment = function isIgnoringComment(element) {
    return !!element && element.type === "comm" && element.children.indexOf($f191ef1b0704aca6$var$ignoreFlag) > -1;
};
var $f191ef1b0704aca6$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule") return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses && cache.compat !== true) {
            var prevElement = index > 0 ? children[index - 1] : null;
            if (prevElement && $f191ef1b0704aca6$var$isIgnoringComment($f191ef1b0704aca6$var$last(prevElement.children))) return;
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $f191ef1b0704aca6$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $f191ef1b0704aca6$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$f191ef1b0704aca6$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $f191ef1b0704aca6$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $f191ef1b0704aca6$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$f191ef1b0704aca6$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $f191ef1b0704aca6$var$nullifyElement(element);
    } else if ($f191ef1b0704aca6$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $f191ef1b0704aca6$var$nullifyElement(element);
    }
};
var $f191ef1b0704aca6$var$defaultStylisPlugins = [
    (0, $468637f8d41e4ff5$export$e08c7d021b829b7a)
];
var $f191ef1b0704aca6$var$createCache = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $f191ef1b0704aca6$var$defaultStylisPlugins;
    var inserted = {}; // $FlowFixMe
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $f191ef1b0704aca6$var$compat,
        $f191ef1b0704aca6$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $468637f8d41e4ff5$export$fac44ee5b035f737),
        (0, $468637f8d41e4ff5$export$38bcb760f1d4871c)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $468637f8d41e4ff5$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $468637f8d41e4ff5$export$dfdc1655ccc5b9cb)((0, $468637f8d41e4ff5$export$ef7acd7185315e22)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $156ad2d5dbfa8572$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};
var $f191ef1b0704aca6$export$2e2bcd8739ae039 = $f191ef1b0704aca6$var$createCache;



var $5zKJZ = parcelRequire("5zKJZ");



var $7b92e226b602c261$exports = {};
"use strict";
var $b0ed9578f98a2359$exports = {};
"use strict";

$b0ed9578f98a2359$exports = (parcelRequire("dP366"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $7b92e226b602c261$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $7b92e226b602c261$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $7b92e226b602c261$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $7b92e226b602c261$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $7b92e226b602c261$var$TYPE_STATICS = {};
$7b92e226b602c261$var$TYPE_STATICS[$b0ed9578f98a2359$exports.ForwardRef] = $7b92e226b602c261$var$FORWARD_REF_STATICS;
$7b92e226b602c261$var$TYPE_STATICS[$b0ed9578f98a2359$exports.Memo] = $7b92e226b602c261$var$MEMO_STATICS;
function $7b92e226b602c261$var$getStatics(component) {
    // React v16.11 and below
    if ($b0ed9578f98a2359$exports.isMemo(component)) return $7b92e226b602c261$var$MEMO_STATICS;
     // React v16.12 and above
    return $7b92e226b602c261$var$TYPE_STATICS[component["$$typeof"]] || $7b92e226b602c261$var$REACT_STATICS;
}
var $7b92e226b602c261$var$defineProperty = Object.defineProperty;
var $7b92e226b602c261$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $7b92e226b602c261$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $7b92e226b602c261$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $7b92e226b602c261$var$getPrototypeOf = Object.getPrototypeOf;
var $7b92e226b602c261$var$objectPrototype = Object.prototype;
function $7b92e226b602c261$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($7b92e226b602c261$var$objectPrototype) {
            var inheritedComponent = $7b92e226b602c261$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $7b92e226b602c261$var$objectPrototype) $7b92e226b602c261$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $7b92e226b602c261$var$getOwnPropertyNames(sourceComponent);
        if ($7b92e226b602c261$var$getOwnPropertySymbols) keys = keys.concat($7b92e226b602c261$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $7b92e226b602c261$var$getStatics(targetComponent);
        var sourceStatics = $7b92e226b602c261$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$7b92e226b602c261$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $7b92e226b602c261$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $7b92e226b602c261$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$7b92e226b602c261$exports = $7b92e226b602c261$var$hoistNonReactStatics;


// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $1147ae0182abdd23$var$hoistNonReactStatics = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7b92e226b602c261$exports)))(targetComponent, sourceComponent);
};
var $1147ae0182abdd23$export$2e2bcd8739ae039 = $1147ae0182abdd23$var$hoistNonReactStatics;


var $d203079f33c57e72$var$isBrowser = true;
function $d203079f33c57e72$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $d203079f33c57e72$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $d203079f33c57e72$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $9f180c6930195542$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $9f180c6930195542$export$2e2bcd8739ae039 = $9f180c6930195542$var$murmur2;


var $a8046da71bd9150e$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $a8046da71bd9150e$export$2e2bcd8739ae039 = $a8046da71bd9150e$var$unitlessKeys;



var $a0f74fb27bc92963$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $a0f74fb27bc92963$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $a0f74fb27bc92963$var$hyphenateRegex = /[A-Z]|^ms/g;
var $a0f74fb27bc92963$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $a0f74fb27bc92963$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $a0f74fb27bc92963$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $a0f74fb27bc92963$var$processStyleName = /* #__PURE__ */ (0, $5c4241f2a5e5d524$export$2e2bcd8739ae039)(function(styleName) {
    return $a0f74fb27bc92963$var$isCustomProperty(styleName) ? styleName : styleName.replace($a0f74fb27bc92963$var$hyphenateRegex, "-$&").toLowerCase();
});
var $a0f74fb27bc92963$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($a0f74fb27bc92963$var$animationRegex, function(match, p1, p2) {
                $a0f74fb27bc92963$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $a0f74fb27bc92963$var$cursor
                };
                return p1;
            });
    }
    if ((0, $a8046da71bd9150e$export$2e2bcd8739ae039)[key] !== 1 && !$a0f74fb27bc92963$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $a0f74fb27bc92963$var$contentValuePattern, $a0f74fb27bc92963$var$contentValues, $a0f74fb27bc92963$var$oldProcessStyleValue, $a0f74fb27bc92963$var$msPattern, $a0f74fb27bc92963$var$hyphenPattern, $a0f74fb27bc92963$var$hyphenatedCache;
function $a0f74fb27bc92963$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $a0f74fb27bc92963$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $a0f74fb27bc92963$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $a0f74fb27bc92963$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $a0f74fb27bc92963$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $a0f74fb27bc92963$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $a0f74fb27bc92963$var$cursor;
                var result = interpolation(mergedProps);
                $a0f74fb27bc92963$var$cursor = previousCursor;
                return $a0f74fb27bc92963$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $a0f74fb27bc92963$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $a0f74fb27bc92963$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($a0f74fb27bc92963$var$isProcessableValue(value)) string += $a0f74fb27bc92963$var$processStyleName(_key) + ":" + $a0f74fb27bc92963$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($a0f74fb27bc92963$var$isProcessableValue(value[_i])) string += $a0f74fb27bc92963$var$processStyleName(_key) + ":" + $a0f74fb27bc92963$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $a0f74fb27bc92963$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $a0f74fb27bc92963$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $a0f74fb27bc92963$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $a0f74fb27bc92963$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $a0f74fb27bc92963$var$cursor;
var $a0f74fb27bc92963$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $a0f74fb27bc92963$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $a0f74fb27bc92963$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $a0f74fb27bc92963$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $a0f74fb27bc92963$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $a0f74fb27bc92963$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $9f180c6930195542$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $a0f74fb27bc92963$var$cursor
    };
};


var $4a4e7cb45334005e$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $4a4e7cb45334005e$var$EmotionCacheContext = /* #__PURE__ */ (0, $5zKJZ.createContext)(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $f191ef1b0704aca6$export$2e2bcd8739ae039)({
    key: "css"
}) : null);
var $4a4e7cb45334005e$export$e7094788287c5e9b = $4a4e7cb45334005e$var$EmotionCacheContext.Provider;
var $4a4e7cb45334005e$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $5zKJZ.useContext)($4a4e7cb45334005e$var$EmotionCacheContext);
};
var $4a4e7cb45334005e$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $5zKJZ.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $5zKJZ.useContext)($4a4e7cb45334005e$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var $4a4e7cb45334005e$export$971d5caa766a69d7 = /* #__PURE__ */ (0, $5zKJZ.createContext)({});
var $4a4e7cb45334005e$export$3b14a55fb2447963 = function useTheme() {
    return (0, $5zKJZ.useContext)($4a4e7cb45334005e$export$971d5caa766a69d7);
};
var $4a4e7cb45334005e$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $4a4e7cb45334005e$var$createCacheWithTheme = /* #__PURE__ */ (0, $8e293d91e7091581$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $8e293d91e7091581$export$2e2bcd8739ae039)(function(theme) {
        return $4a4e7cb45334005e$var$getTheme(outerTheme, theme);
    });
});
var $4a4e7cb45334005e$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = (0, $5zKJZ.useContext)($4a4e7cb45334005e$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $4a4e7cb45334005e$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ (0, $5zKJZ.createElement)($4a4e7cb45334005e$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $4a4e7cb45334005e$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = (0, $5zKJZ.useContext)($4a4e7cb45334005e$export$971d5caa766a69d7);
        return /*#__PURE__*/ (0, $5zKJZ.createElement)(Component, (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ (0, $5zKJZ.forwardRef)(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $1147ae0182abdd23$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $4a4e7cb45334005e$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) {
        // The match may be something like 'Object.createEmotionProps'
        var parts = match[1].split(".");
        return parts[parts.length - 1];
    } // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return match[1];
    return undefined;
};
var $4a4e7cb45334005e$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $4a4e7cb45334005e$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $4a4e7cb45334005e$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $4a4e7cb45334005e$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($4a4e7cb45334005e$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $4a4e7cb45334005e$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $4a4e7cb45334005e$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $4a4e7cb45334005e$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $4a4e7cb45334005e$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($4a4e7cb45334005e$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$4a4e7cb45334005e$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $4a4e7cb45334005e$var$Noop = function Noop() {
    return null;
};
var $4a4e7cb45334005e$export$a9c23c6ac3fc3eca = /* #__PURE__ */ $4a4e7cb45334005e$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var type = props[$4a4e7cb45334005e$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $d203079f33c57e72$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $a0f74fb27bc92963$export$6321afa313b251b5)(registeredStyles, undefined, (0, $5zKJZ.useContext)($4a4e7cb45334005e$export$971d5caa766a69d7));
    var labelFromStack;
    var rules = (0, $d203079f33c57e72$export$6f077d94b33a01aa)(cache, serialized, typeof type === "string");
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($4a4e7cb45334005e$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $4a4e7cb45334005e$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    var ele = /*#__PURE__*/ (0, $5zKJZ.createElement)(type, newProps);
    var possiblyStyleElement = /*#__PURE__*/ (0, $5zKJZ.createElement)($4a4e7cb45334005e$var$Noop, null);
    return /*#__PURE__*/ (0, $5zKJZ.createElement)((0, $5zKJZ.Fragment), null, possiblyStyleElement, ele);
});


var $88e6b2439765d9ee$exports = {};
function $88e6b2439765d9ee$var$_extends() {
    $88e6b2439765d9ee$exports = $88e6b2439765d9ee$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, $88e6b2439765d9ee$exports.__esModule = true, $88e6b2439765d9ee$exports["default"] = $88e6b2439765d9ee$exports;
    return $88e6b2439765d9ee$var$_extends.apply(this, arguments);
}
$88e6b2439765d9ee$exports = $88e6b2439765d9ee$var$_extends, $88e6b2439765d9ee$exports.__esModule = true, $88e6b2439765d9ee$exports["default"] = $88e6b2439765d9ee$exports;








var $655e6e02649f7fec$var$pkg = {
    name: "@emotion/react",
    version: "11.7.1",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.cjs.js": "./dist/emotion-react.browser.cjs.js",
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.js",
        "macro.d.ts",
        "macro.js.flow"
    ],
    sideEffects: false,
    author: "mitchellhamilton <mitchell@mitchellhamilton.me>",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.13.10",
        "@emotion/cache": "^11.7.1",
        "@emotion/serialize": "^1.0.2",
        "@emotion/sheet": "^1.1.0",
        "@emotion/utils": "^1.0.0",
        "@emotion/weak-memoize": "^0.2.5",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        "@babel/core": "^7.0.0",
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@babel/core": {
            optional: true
        },
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@babel/core": "^7.13.10",
        "@emotion/css": "11.7.1",
        "@emotion/css-prettifier": "1.0.1",
        "@emotion/server": "11.4.0",
        "@emotion/styled": "11.6.0",
        "@types/react": "^16.9.11",
        dtslint: "^0.3.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact"
    }
};
var $655e6e02649f7fec$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $4a4e7cb45334005e$export$dda1d9f60106f0e9).call(props, "css")) // $FlowFixMe
    return (0, $5zKJZ.createElement).apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $4a4e7cb45334005e$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $4a4e7cb45334005e$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return (0, $5zKJZ.createElement).apply(null, createElementArgArray);
};
var $655e6e02649f7fec$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $655e6e02649f7fec$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $4a4e7cb45334005e$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $a0f74fb27bc92963$export$6321afa313b251b5)([
        styles
    ], undefined, (0, $5zKJZ.useContext)((0, $4a4e7cb45334005e$export$971d5caa766a69d7)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = (0, $5zKJZ.useRef)();
    (0, $5zKJZ.useLayoutEffect)(function() {
        var key = cache.key + "-global";
        var sheet = new (0, $156ad2d5dbfa8572$export$9d753cd7ae895cce)({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $5zKJZ.useLayoutEffect)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $d203079f33c57e72$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $655e6e02649f7fec$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $a0f74fb27bc92963$export$6321afa313b251b5)(args);
}
var $655e6e02649f7fec$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $655e6e02649f7fec$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $655e6e02649f7fec$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $655e6e02649f7fec$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $d203079f33c57e72$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $655e6e02649f7fec$var$Noop = function Noop() {
    return null;
};
var $655e6e02649f7fec$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $4a4e7cb45334005e$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $a0f74fb27bc92963$export$6321afa313b251b5)(args, cache.registered);
        (0, $d203079f33c57e72$export$6f077d94b33a01aa)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $655e6e02649f7fec$var$merge(cache.registered, css, $655e6e02649f7fec$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: (0, $5zKJZ.useContext)((0, $4a4e7cb45334005e$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    var possiblyStyleElement = /*#__PURE__*/ (0, $5zKJZ.createElement)($655e6e02649f7fec$var$Noop, null);
    return /*#__PURE__*/ (0, $5zKJZ.createElement)((0, $5zKJZ.Fragment), null, possiblyStyleElement, ele);
});
var $655e6e02649f7fec$var$isBrowser, $655e6e02649f7fec$var$isJest, $655e6e02649f7fec$var$globalContext, $655e6e02649f7fec$var$globalKey;


function $8ef6dfb049dce1a7$export$2e2bcd8739ae039(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}


function $f25ad4247afa2104$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $295b61ec8f7276fc$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $f25ad4247afa2104$export$2e2bcd8739ae039)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}


function $ba8615be6ea804a7$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $ba8615be6ea804a7$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $ba8615be6ea804a7$export$2e2bcd8739ae039(obj);
}


function $59343b2a3f79b18d$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4d5516f5455b2884$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4d5516f5455b2884$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $4d5516f5455b2884$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4d5516f5455b2884$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}


function $df0fa350c014a99a$export$2e2bcd8739ae039(o, p) {
    $df0fa350c014a99a$export$2e2bcd8739ae039 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $df0fa350c014a99a$export$2e2bcd8739ae039(o, p);
}


function $f194ac009f84f33f$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $df0fa350c014a99a$export$2e2bcd8739ae039)(subClass, superClass);
}


function $0f067ba935bc17df$export$2e2bcd8739ae039(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}



var $5zKJZ = parcelRequire("5zKJZ");

function $105b4e425347a1bb$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $105b4e425347a1bb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $105b4e425347a1bb$export$407448d2b89b1813(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $105b4e425347a1bb$var$ownKeys(Object(source), true).forEach(function(key) {
            $105b4e425347a1bb$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $105b4e425347a1bb$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $105b4e425347a1bb$var$_getPrototypeOf(o) {
    $105b4e425347a1bb$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $105b4e425347a1bb$var$_getPrototypeOf(o);
}
function $105b4e425347a1bb$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $105b4e425347a1bb$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $105b4e425347a1bb$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    return $105b4e425347a1bb$var$_assertThisInitialized(self);
}
function $105b4e425347a1bb$export$71511d61b312f219(Derived) {
    var hasNativeReflectConstruct = $105b4e425347a1bb$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $105b4e425347a1bb$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $105b4e425347a1bb$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $105b4e425347a1bb$var$_possibleConstructorReturn(this, result);
    };
}
var $105b4e425347a1bb$var$_excluded$3 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $105b4e425347a1bb$export$3466f893ebf79586 = function noop() {};
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $105b4e425347a1bb$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === "-") return prefix + name;
    else return prefix + "__" + name;
}
function $105b4e425347a1bb$export$a9c23c6ac3fc3eca(prefix, state, className) {
    var arr = [
        className
    ];
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($105b4e425347a1bb$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(" ");
} // ==============================
// Clean Value
// ==============================
var $105b4e425347a1bb$export$9bb611d729802a56 = function cleanValue(value) {
    if ($105b4e425347a1bb$var$isArray(value)) return value.filter(Boolean);
    if ((0, $ba8615be6ea804a7$export$2e2bcd8739ae039)(value) === "object" && value !== null) return [
        value
    ];
    return [];
}; // ==============================
// Clean Common Props
// ==============================
var $105b4e425347a1bb$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $295b61ec8f7276fc$export$2e2bcd8739ae039)(props, $105b4e425347a1bb$var$_excluded$3);
    return $105b4e425347a1bb$export$407448d2b89b1813({}, innerProps);
}; // ==============================
// Handle Input Change
// ==============================
function $105b4e425347a1bb$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === "string") return _newValue;
    }
    return inputValue;
} // ==============================
// Scroll Helpers
// ==============================
function $105b4e425347a1bb$export$7f8ddf7c7c20b3cd(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
} // Normalized Scroll Top
// ------------------------------
function $105b4e425347a1bb$var$getScrollTop(el) {
    if ($105b4e425347a1bb$export$7f8ddf7c7c20b3cd(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $105b4e425347a1bb$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($105b4e425347a1bb$export$7f8ddf7c7c20b3cd(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
} // Get Scroll Parent
// ------------------------------
function $105b4e425347a1bb$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === "absolute";
    var overflowRx = /(auto|scroll)/;
    if (style.position === "fixed") return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === "static") continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
} // Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $105b4e425347a1bb$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $105b4e425347a1bb$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $105b4e425347a1bb$export$3466f893ebf79586;
    var start = $105b4e425347a1bb$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $105b4e425347a1bb$var$easeOutCubic(currentTime, start, change, duration);
        $105b4e425347a1bb$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
} // Scroll Into View
// ------------------------------
function $105b4e425347a1bb$export$b4171a6734a65d42(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $105b4e425347a1bb$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $105b4e425347a1bb$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
} // ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $105b4e425347a1bb$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// Touch Capability Detector
// ==============================
function $105b4e425347a1bb$export$df995fae86a55f06() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
} // ==============================
// Mobile Device Detector
// ==============================
function $105b4e425347a1bb$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
} // ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $105b4e425347a1bb$var$passiveOptionAccessed = false;
var $105b4e425347a1bb$var$options = {
    get passive () {
        return $105b4e425347a1bb$var$passiveOptionAccessed = true;
    }
}; // check for SSR
var $105b4e425347a1bb$var$w = typeof window !== "undefined" ? window : {};
if ($105b4e425347a1bb$var$w.addEventListener && $105b4e425347a1bb$var$w.removeEventListener) {
    $105b4e425347a1bb$var$w.addEventListener("p", $105b4e425347a1bb$export$3466f893ebf79586, $105b4e425347a1bb$var$options);
    $105b4e425347a1bb$var$w.removeEventListener("p", $105b4e425347a1bb$export$3466f893ebf79586, false);
}
var $105b4e425347a1bb$export$2408f22a0fab9ae5 = $105b4e425347a1bb$var$passiveOptionAccessed;
function $105b4e425347a1bb$export$2329c99376c9d0a4(item) {
    return item != null;
}
function $105b4e425347a1bb$var$isArray(arg) {
    return Array.isArray(arg);
}
function $105b4e425347a1bb$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $105b4e425347a1bb$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $105b4e425347a1bb$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
function $105b4e425347a1bb$var$getMenuPlacement(_ref) {
    var maxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, placement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, theme = _ref.theme;
    var spacing = theme.spacing;
    var scrollParent = $105b4e425347a1bb$var$getScrollParent(menuEl);
    var defaultState = {
        placement: "bottom",
        maxHeight: maxHeight
    }; // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = window.innerHeight;
    var scrollTop = $105b4e425347a1bb$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(placement){
        case "auto":
        case "bottom":
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: "bottom",
                maxHeight: maxHeight
            };
             // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $105b4e425347a1bb$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: "bottom",
                    maxHeight: maxHeight
                };
            } // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $105b4e425347a1bb$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                 // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: "bottom",
                    maxHeight: constrainedHeight
                };
            } // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (placement === "auto" || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = maxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight
                };
            } // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (placement === "bottom") {
                if (shouldScroll) $105b4e425347a1bb$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: "bottom",
                    maxHeight: maxHeight
                };
            }
            break;
        case "top":
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: "top",
                maxHeight: maxHeight
            };
             // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $105b4e425347a1bb$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: maxHeight
                };
            } // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $105b4e425347a1bb$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight2
                };
            } // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: "bottom",
                maxHeight: maxHeight
            };
        default:
            throw new Error('Invalid placement provided "'.concat(placement, '".'));
    }
    return defaultState;
} // Menu Component
// ------------------------------
function $105b4e425347a1bb$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: "top",
        top: "bottom"
    };
    return placement ? placementToCSSProp[placement] : "bottom";
}
var $105b4e425347a1bb$var$coercePlacement = function coercePlacement(p) {
    return p === "auto" ? "bottom" : p;
};
var $105b4e425347a1bb$export$7ccc53e8f1e7dfc5 = function menuCSS(_ref2) {
    var _ref3;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return _ref3 = {
        label: "menu"
    }, (0, $0f067ba935bc17df$export$2e2bcd8739ae039)(_ref3, $105b4e425347a1bb$var$alignToControl(placement), "100%"), (0, $0f067ba935bc17df$export$2e2bcd8739ae039)(_ref3, "backgroundColor", colors.neutral0), (0, $0f067ba935bc17df$export$2e2bcd8739ae039)(_ref3, "borderRadius", borderRadius), (0, $0f067ba935bc17df$export$2e2bcd8739ae039)(_ref3, "boxShadow", "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)"), (0, $0f067ba935bc17df$export$2e2bcd8739ae039)(_ref3, "marginBottom", spacing.menuGutter), (0, $0f067ba935bc17df$export$2e2bcd8739ae039)(_ref3, "marginTop", spacing.menuGutter), (0, $0f067ba935bc17df$export$2e2bcd8739ae039)(_ref3, "position", "absolute"), (0, $0f067ba935bc17df$export$2e2bcd8739ae039)(_ref3, "width", "100%"), (0, $0f067ba935bc17df$export$2e2bcd8739ae039)(_ref3, "zIndex", 1), _ref3;
};
var $105b4e425347a1bb$var$PortalPlacementContext = /*#__PURE__*/ (0, $5zKJZ.createContext)({
    getPortalPlacement: null
}); // NOTE: internal only
var $105b4e425347a1bb$export$3a1a48c8f6ef640e = /*#__PURE__*/ function(_Component) {
    (0, $f194ac009f84f33f$export$2e2bcd8739ae039)(MenuPlacer, _Component);
    var _super = $105b4e425347a1bb$export$71511d61b312f219(MenuPlacer);
    function MenuPlacer() {
        var _this;
        (0, $59343b2a3f79b18d$export$2e2bcd8739ae039)(this, MenuPlacer);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {
            maxHeight: _this.props.maxMenuHeight,
            placement: null
        };
        _this.context = void 0;
        _this.getPlacement = function(ref) {
            var _this$props = _this.props, minMenuHeight = _this$props.minMenuHeight, maxMenuHeight = _this$props.maxMenuHeight, menuPlacement = _this$props.menuPlacement, menuPosition = _this$props.menuPosition, menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView, theme = _this$props.theme;
            if (!ref) return; // DO NOT scroll if position is fixed
            var isFixedPosition = menuPosition === "fixed";
            var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
            var state = $105b4e425347a1bb$var$getMenuPlacement({
                maxHeight: maxMenuHeight,
                menuEl: ref,
                minHeight: minMenuHeight,
                placement: menuPlacement,
                shouldScroll: shouldScroll,
                isFixedPosition: isFixedPosition,
                theme: theme
            });
            var getPortalPlacement = _this.context.getPortalPlacement;
            if (getPortalPlacement) getPortalPlacement(state);
            _this.setState(state);
        };
        _this.getUpdatedProps = function() {
            var menuPlacement = _this.props.menuPlacement;
            var placement = _this.state.placement || $105b4e425347a1bb$var$coercePlacement(menuPlacement);
            return $105b4e425347a1bb$export$407448d2b89b1813($105b4e425347a1bb$export$407448d2b89b1813({}, _this.props), {}, {
                placement: placement,
                maxHeight: _this.state.maxHeight
            });
        };
        return _this;
    }
    (0, $4d5516f5455b2884$export$2e2bcd8739ae039)(MenuPlacer, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return children({
                    ref: this.getPlacement,
                    placerProps: this.getUpdatedProps()
                });
            }
        }
    ]);
    return MenuPlacer;
}((0, $5zKJZ.Component));
$105b4e425347a1bb$export$3a1a48c8f6ef640e.contextType = $105b4e425347a1bb$var$PortalPlacementContext;
var $105b4e425347a1bb$var$Menu = function Menu(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)("div", (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({
        css: getStyles("menu", props),
        className: cx({
            menu: true
        }, className),
        ref: innerRef
    }, innerProps), children);
};
// Menu List
// ==============================
var $105b4e425347a1bb$export$ae1af26003f05816 = function menuListCSS(_ref4) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return {
        maxHeight: maxHeight,
        overflowY: "auto",
        paddingBottom: baseUnit,
        paddingTop: baseUnit,
        position: "relative",
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: "touch"
    };
};
var $105b4e425347a1bb$var$MenuList = function MenuList(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)("div", (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({
        css: getStyles("menuList", props),
        className: cx({
            "menu-list": true,
            "menu-list--is-multi": isMulti
        }, className),
        ref: innerRef
    }, innerProps), children);
}; // ==============================
// Menu Notices
// ==============================
var $105b4e425347a1bb$var$noticeCSS = function noticeCSS(_ref5) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px"),
        textAlign: "center"
    };
};
var $105b4e425347a1bb$export$3b14a55fb2447963 = $105b4e425347a1bb$var$noticeCSS;
var $105b4e425347a1bb$export$953cecd6e717a553 = $105b4e425347a1bb$var$noticeCSS;
var $105b4e425347a1bb$var$NoOptionsMessage = function NoOptionsMessage(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)("div", (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({
        css: getStyles("noOptionsMessage", props),
        className: cx({
            "menu-notice": true,
            "menu-notice--no-options": true
        }, className)
    }, innerProps), children);
};
$105b4e425347a1bb$var$NoOptionsMessage.defaultProps = {
    children: "No options"
};
var $105b4e425347a1bb$var$LoadingMessage = function LoadingMessage(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)("div", (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({
        css: getStyles("loadingMessage", props),
        className: cx({
            "menu-notice": true,
            "menu-notice--loading": true
        }, className)
    }, innerProps), children);
};
$105b4e425347a1bb$var$LoadingMessage.defaultProps = {
    children: "Loading..."
}; // ==============================
// Menu Portal
// ==============================
var $105b4e425347a1bb$export$ffb5f4729a158638 = function menuPortalCSS(_ref6) {
    var rect = _ref6.rect, offset = _ref6.offset, position = _ref6.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $105b4e425347a1bb$var$MenuPortal = /*#__PURE__*/ function(_Component2) {
    (0, $f194ac009f84f33f$export$2e2bcd8739ae039)(MenuPortal, _Component2);
    var _super2 = $105b4e425347a1bb$export$71511d61b312f219(MenuPortal);
    function MenuPortal() {
        var _this2;
        (0, $59343b2a3f79b18d$export$2e2bcd8739ae039)(this, MenuPortal);
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        _this2.state = {
            placement: null
        };
        _this2.getPortalPlacement = function(_ref7) {
            var placement = _ref7.placement;
            var initialPlacement = $105b4e425347a1bb$var$coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed
            if (placement !== initialPlacement) _this2.setState({
                placement: placement
            });
        };
        return _this2;
    }
    (0, $4d5516f5455b2884$export$2e2bcd8739ae039)(MenuPortal, [
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, appendTo = _this$props2.appendTo, children = _this$props2.children, className = _this$props2.className, controlElement = _this$props2.controlElement, cx = _this$props2.cx, innerProps = _this$props2.innerProps, menuPlacement = _this$props2.menuPlacement, position = _this$props2.menuPosition, getStyles = _this$props2.getStyles;
                var isFixed = position === "fixed"; // bail early if required elements aren't present
                if (!appendTo && !isFixed || !controlElement) return null;
                var placement = this.state.placement || $105b4e425347a1bb$var$coercePlacement(menuPlacement);
                var rect = $105b4e425347a1bb$var$getBoundingClientObj(controlElement);
                var scrollDistance = isFixed ? 0 : window.pageYOffset;
                var offset = rect[placement] + scrollDistance;
                var state = {
                    offset: offset,
                    position: position,
                    rect: rect
                }; // same wrapper element whether fixed or portalled
                var menuWrapper = (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)("div", (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({
                    css: getStyles("menuPortal", state),
                    className: cx({
                        "menu-portal": true
                    }, className)
                }, innerProps), children);
                return (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)($105b4e425347a1bb$var$PortalPlacementContext.Provider, {
                    value: {
                        getPortalPlacement: this.getPortalPlacement
                    }
                }, appendTo ? /*#__PURE__*/ (0, $aa49bf5e460995f3$exports.createPortal)(menuWrapper, appendTo) : menuWrapper);
            }
        }
    ]);
    return MenuPortal;
}((0, $5zKJZ.Component));
var $105b4e425347a1bb$export$4368d992c4eafac0 = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: "container",
        direction: isRtl ? "rtl" : undefined,
        pointerEvents: isDisabled ? "none" : undefined,
        // cancel mouse events when disabled
        position: "relative"
    };
};
var $105b4e425347a1bb$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)("div", (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({
        css: getStyles("container", props),
        className: cx({
            "--is-disabled": isDisabled,
            "--is-rtl": isRtl
        }, className)
    }, innerProps), children);
}; // ==============================
// Value Container
// ==============================
var $105b4e425347a1bb$export$4a5767248b18ef41 = function valueContainerCSS(_ref2) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return {
        alignItems: "center",
        display: isMulti && hasValue && controlShouldRenderValue ? "flex" : "grid",
        flex: 1,
        flexWrap: "wrap",
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px"),
        WebkitOverflowScrolling: "touch",
        position: "relative",
        overflow: "hidden"
    };
};
var $105b4e425347a1bb$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, className = props.className, cx = props.cx, innerProps = props.innerProps, isMulti = props.isMulti, getStyles = props.getStyles, hasValue = props.hasValue;
    return (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)("div", (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({
        css: getStyles("valueContainer", props),
        className: cx({
            "value-container": true,
            "value-container--is-multi": isMulti,
            "value-container--has-value": hasValue
        }, className)
    }, innerProps), children);
}; // ==============================
// Indicator Container
// ==============================
var $105b4e425347a1bb$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: "center",
        alignSelf: "stretch",
        display: "flex",
        flexShrink: 0
    };
};
var $105b4e425347a1bb$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, className = props.className, cx = props.cx, innerProps = props.innerProps, getStyles = props.getStyles;
    return (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)("div", (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({
        css: getStyles("indicatorsContainer", props),
        className: cx({
            indicators: true
        }, className)
    }, innerProps), children);
};
var $105b4e425347a1bb$var$_templateObject;
var $105b4e425347a1bb$var$_excluded$2 = [
    "size"
];
function $105b4e425347a1bb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $105b4e425347a1bb$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
// ==============================
// Dropdown & Clear Icons
// ==============================
var $105b4e425347a1bb$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $295b61ec8f7276fc$export$2e2bcd8739ae039)(_ref, $105b4e425347a1bb$var$_excluded$2);
    return (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)("svg", (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $105b4e425347a1bb$var$_ref2
    }, props));
};
var $105b4e425347a1bb$var$CrossIcon = function CrossIcon(props) {
    return (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)($105b4e425347a1bb$var$Svg, (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $105b4e425347a1bb$var$DownChevron = function DownChevron(props) {
    return (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)($105b4e425347a1bb$var$Svg, (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
}; // ==============================
// Dropdown & Clear Buttons
// ==============================
var $105b4e425347a1bb$var$baseCSS = function baseCSS(_ref3) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return {
        label: "indicatorContainer",
        color: isFocused ? colors.neutral60 : colors.neutral20,
        display: "flex",
        padding: baseUnit * 2,
        transition: "color 150ms",
        ":hover": {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    };
};
var $105b4e425347a1bb$export$2d1720544b23b823 = $105b4e425347a1bb$var$baseCSS;
var $105b4e425347a1bb$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)("div", (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({
        css: getStyles("dropdownIndicator", props),
        className: cx({
            indicator: true,
            "dropdown-indicator": true
        }, className)
    }, innerProps), children || (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)($105b4e425347a1bb$var$DownChevron, null));
};
var $105b4e425347a1bb$export$8b22cf2602fb60ce = $105b4e425347a1bb$var$baseCSS;
var $105b4e425347a1bb$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)("div", (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({
        css: getStyles("clearIndicator", props),
        className: cx({
            indicator: true,
            "clear-indicator": true
        }, className)
    }, innerProps), children || (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)($105b4e425347a1bb$var$CrossIcon, null));
}; // ==============================
// Separator
// ==============================
var $105b4e425347a1bb$export$35e795649ee09318 = function indicatorSeparatorCSS(_ref4) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return {
        label: "indicatorSeparator",
        alignSelf: "stretch",
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2,
        width: 1
    };
};
var $105b4e425347a1bb$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)("span", (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({}, innerProps, {
        css: getStyles("indicatorSeparator", props),
        className: cx({
            "indicator-separator": true
        }, className)
    }));
}; // ==============================
// Loading
// ==============================
var $105b4e425347a1bb$var$loadingDotAnimations = (0, $655e6e02649f7fec$export$d25ddfdf17c3ad3e)($105b4e425347a1bb$var$_templateObject || ($105b4e425347a1bb$var$_templateObject = (0, $8ef6dfb049dce1a7$export$2e2bcd8739ae039)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $105b4e425347a1bb$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return {
        label: "loadingIndicator",
        color: isFocused ? colors.neutral60 : colors.neutral20,
        display: "flex",
        padding: baseUnit * 2,
        transition: "color 150ms",
        alignSelf: "center",
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: "center",
        verticalAlign: "middle"
    };
};
var $105b4e425347a1bb$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)("span", {
        css: /*#__PURE__*/ (0, $655e6e02649f7fec$export$dbf350e5966cf602)({
            animation: "".concat($105b4e425347a1bb$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: "currentColor",
            borderRadius: "1em",
            display: "inline-block",
            marginLeft: offset ? "1em" : undefined,
            height: "1em",
            verticalAlign: "top",
            width: "1em"
        }, "", "")
    });
};
var $105b4e425347a1bb$var$LoadingIndicator = function LoadingIndicator(props) {
    var className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps, isRtl = props.isRtl;
    return (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)("div", (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({
        css: getStyles("loadingIndicator", props),
        className: cx({
            indicator: true,
            "loading-indicator": true
        }, className)
    }, innerProps), (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)($105b4e425347a1bb$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)($105b4e425347a1bb$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)($105b4e425347a1bb$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
$105b4e425347a1bb$var$LoadingIndicator.defaultProps = {
    size: 4
};
var $105b4e425347a1bb$export$f1e1789686576879 = function css(_ref) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return {
        label: "control",
        alignItems: "center",
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: "solid",
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        cursor: "default",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        minHeight: spacing.controlHeight,
        outline: "0 !important",
        position: "relative",
        transition: "all 100ms",
        "&:hover": {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    };
};
var $105b4e425347a1bb$var$Control = function Control(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, className = props.className, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)("div", (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({
        ref: innerRef,
        css: getStyles("control", props),
        className: cx({
            control: true,
            "control--is-disabled": isDisabled,
            "control--is-focused": isFocused,
            "control--menu-is-open": menuIsOpen
        }, className)
    }, innerProps), children);
};
var $105b4e425347a1bb$var$_excluded$1 = [
    "data"
];
var $105b4e425347a1bb$export$39b482c5e57630a8 = function groupCSS(_ref) {
    var spacing = _ref.theme.spacing;
    return {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $105b4e425347a1bb$var$Group = function Group(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)("div", (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({
        css: getStyles("group", props),
        className: cx({
            group: true
        }, className)
    }, innerProps), (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)(Heading, (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        cx: cx
    }), label), (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)("div", null, children));
};
var $105b4e425347a1bb$export$dda1d9f60106f0e9 = function groupHeadingCSS(_ref2) {
    var spacing = _ref2.theme.spacing;
    return {
        label: "group",
        color: "#999",
        cursor: "default",
        display: "block",
        fontSize: "75%",
        fontWeight: 500,
        marginBottom: "0.25em",
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: "uppercase"
    };
};
var $105b4e425347a1bb$var$GroupHeading = function GroupHeading(props) {
    var getStyles = props.getStyles, cx = props.cx, className = props.className;
    var _cleanCommonProps = $105b4e425347a1bb$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $295b61ec8f7276fc$export$2e2bcd8739ae039)(_cleanCommonProps, $105b4e425347a1bb$var$_excluded$1);
    return (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)("div", (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({
        css: getStyles("groupHeading", props),
        className: cx({
            "group-heading": true
        }, className)
    }, innerProps));
};
var $105b4e425347a1bb$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $105b4e425347a1bb$export$342063e11d6c3cad = function inputCSS(_ref) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return $105b4e425347a1bb$export$407448d2b89b1813({
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        visibility: isDisabled ? "hidden" : "visible",
        color: colors.neutral80,
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? "translateZ(0)" : ""
    }, $105b4e425347a1bb$var$containerStyle);
};
var $105b4e425347a1bb$var$spacingStyle = {
    gridArea: "1 / 2",
    font: "inherit",
    minWidth: "2px",
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $105b4e425347a1bb$var$containerStyle = {
    flex: "1 1 auto",
    display: "inline-grid",
    gridArea: "1 / 1 / 2 / 3",
    gridTemplateColumns: "0 min-content",
    "&:after": $105b4e425347a1bb$export$407448d2b89b1813({
        content: 'attr(data-value) " "',
        visibility: "hidden",
        whiteSpace: "pre"
    }, $105b4e425347a1bb$var$spacingStyle)
};
var $105b4e425347a1bb$var$inputStyle = function inputStyle(isHidden) {
    return $105b4e425347a1bb$export$407448d2b89b1813({
        label: "input",
        color: "inherit",
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: "100%"
    }, $105b4e425347a1bb$var$spacingStyle);
};
var $105b4e425347a1bb$var$Input = function Input(props) {
    var className = props.className, cx = props.cx, getStyles = props.getStyles, value = props.value;
    var _cleanCommonProps = $105b4e425347a1bb$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $295b61ec8f7276fc$export$2e2bcd8739ae039)(_cleanCommonProps, $105b4e425347a1bb$var$_excluded);
    return (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)("div", {
        className: cx({
            "input-container": true
        }, className),
        css: getStyles("input", props),
        "data-value": value || ""
    }, (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)("input", (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $105b4e425347a1bb$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $105b4e425347a1bb$export$9e5f44173e64f162 = function multiValueCSS(_ref) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return {
        label: "multiValue",
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        display: "flex",
        margin: spacing.baseUnit / 2,
        minWidth: 0 // resolves flex/text-overflow bug
    };
};
var $105b4e425347a1bb$export$43caf9889c228507 = function multiValueLabelCSS(_ref2) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: "85%",
        overflow: "hidden",
        padding: 3,
        paddingLeft: 6,
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? "ellipsis" : undefined,
        whiteSpace: "nowrap"
    };
};
var $105b4e425347a1bb$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return {
        alignItems: "center",
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        display: "flex",
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ":hover": {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    };
};
var $105b4e425347a1bb$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)("div", innerProps, children);
};
var $105b4e425347a1bb$var$MultiValueContainer = $105b4e425347a1bb$var$MultiValueGeneric;
var $105b4e425347a1bb$var$MultiValueLabel = $105b4e425347a1bb$var$MultiValueGeneric;
function $105b4e425347a1bb$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)("div", (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({
        role: "button"
    }, innerProps), children || (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)($105b4e425347a1bb$var$CrossIcon, {
        size: 14
    }));
}
var $105b4e425347a1bb$var$MultiValue = function MultiValue(props) {
    var children = props.children, className = props.className, components = props.components, cx = props.cx, data = props.data, getStyles = props.getStyles, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)((0, $655e6e02649f7fec$export$9b9c0f9d9f3552b8), null, function(_ref6) {
        var css = _ref6.css, emotionCx = _ref6.cx;
        return (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)(Container, {
            data: data,
            innerProps: $105b4e425347a1bb$export$407448d2b89b1813({
                className: emotionCx(css(getStyles("multiValue", props)), cx({
                    "multi-value": true,
                    "multi-value--is-disabled": isDisabled
                }, className))
            }, innerProps),
            selectProps: selectProps
        }, (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)(Label, {
            data: data,
            innerProps: {
                className: emotionCx(css(getStyles("multiValueLabel", props)), cx({
                    "multi-value__label": true
                }, className))
            },
            selectProps: selectProps
        }, children), (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)(Remove, {
            data: data,
            innerProps: $105b4e425347a1bb$export$407448d2b89b1813({
                className: emotionCx(css(getStyles("multiValueRemove", props)), cx({
                    "multi-value__remove": true
                }, className)),
                "aria-label": "Remove ".concat(children || "option")
            }, removeProps),
            selectProps: selectProps
        }));
    });
};
var $105b4e425347a1bb$export$90a7f3efeed30595 = function optionCSS(_ref) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return {
        label: "option",
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : "transparent",
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : "inherit",
        cursor: "default",
        display: "block",
        fontSize: "inherit",
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        width: "100%",
        userSelect: "none",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
        // provide some affordance on touch devices
        ":active": {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    };
};
var $105b4e425347a1bb$var$Option = function Option(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)("div", (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({
        css: getStyles("option", props),
        className: cx({
            option: true,
            "option--is-disabled": isDisabled,
            "option--is-focused": isFocused,
            "option--is-selected": isSelected
        }, className),
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $105b4e425347a1bb$export$efccba1c4a2ef57b = function placeholderCSS(_ref) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return {
        label: "placeholder",
        color: colors.neutral50,
        gridArea: "1 / 1 / 2 / 3",
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    };
};
var $105b4e425347a1bb$var$Placeholder = function Placeholder(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)("div", (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({
        css: getStyles("placeholder", props),
        className: cx({
            placeholder: true
        }, className)
    }, innerProps), children);
};
var $105b4e425347a1bb$export$d141bba7fdc215a3 = function css(_ref) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return {
        label: "singleValue",
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        gridArea: "1 / 1 / 2 / 3",
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2,
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    };
};
var $105b4e425347a1bb$var$SingleValue = function SingleValue(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)("div", (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({
        css: getStyles("singleValue", props),
        className: cx({
            "single-value": true,
            "single-value--is-disabled": isDisabled
        }, className)
    }, innerProps), children);
};
var $105b4e425347a1bb$export$db3b6bfb95261072 = {
    ClearIndicator: $105b4e425347a1bb$var$ClearIndicator,
    Control: $105b4e425347a1bb$var$Control,
    DropdownIndicator: $105b4e425347a1bb$var$DropdownIndicator,
    DownChevron: $105b4e425347a1bb$var$DownChevron,
    CrossIcon: $105b4e425347a1bb$var$CrossIcon,
    Group: $105b4e425347a1bb$var$Group,
    GroupHeading: $105b4e425347a1bb$var$GroupHeading,
    IndicatorsContainer: $105b4e425347a1bb$var$IndicatorsContainer,
    IndicatorSeparator: $105b4e425347a1bb$var$IndicatorSeparator,
    Input: $105b4e425347a1bb$var$Input,
    LoadingIndicator: $105b4e425347a1bb$var$LoadingIndicator,
    Menu: $105b4e425347a1bb$var$Menu,
    MenuList: $105b4e425347a1bb$var$MenuList,
    MenuPortal: $105b4e425347a1bb$var$MenuPortal,
    LoadingMessage: $105b4e425347a1bb$var$LoadingMessage,
    NoOptionsMessage: $105b4e425347a1bb$var$NoOptionsMessage,
    MultiValue: $105b4e425347a1bb$var$MultiValue,
    MultiValueContainer: $105b4e425347a1bb$var$MultiValueContainer,
    MultiValueLabel: $105b4e425347a1bb$var$MultiValueLabel,
    MultiValueRemove: $105b4e425347a1bb$var$MultiValueRemove,
    Option: $105b4e425347a1bb$var$Option,
    Placeholder: $105b4e425347a1bb$var$Placeholder,
    SelectContainer: $105b4e425347a1bb$var$SelectContainer,
    SingleValue: $105b4e425347a1bb$var$SingleValue,
    ValueContainer: $105b4e425347a1bb$var$ValueContainer
};
var $105b4e425347a1bb$export$d66501df72047452 = function defaultComponents(props) {
    return $105b4e425347a1bb$export$407448d2b89b1813($105b4e425347a1bb$export$407448d2b89b1813({}, $105b4e425347a1bb$export$db3b6bfb95261072), props.components);
};


function $64d3d2774f4e9255$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}


function $7c9966671324dbb4$export$2e2bcd8739ae039(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $344684fb7dd2a22e$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $cc85bc0c04cc8e39$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $344684fb7dd2a22e$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $344684fb7dd2a22e$export$2e2bcd8739ae039)(o, minLen);
}


function $c9139f5dc07a04e3$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $549b5fd2afdd591d$export$2e2bcd8739ae039(arr, i) {
    return (0, $64d3d2774f4e9255$export$2e2bcd8739ae039)(arr) || (0, $7c9966671324dbb4$export$2e2bcd8739ae039)(arr, i) || (0, $cc85bc0c04cc8e39$export$2e2bcd8739ae039)(arr, i) || (0, $c9139f5dc07a04e3$export$2e2bcd8739ae039)();
}




var $5zKJZ = parcelRequire("5zKJZ");
var $cab5745653a7ca05$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $cab5745653a7ca05$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? "" : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $295b61ec8f7276fc$export$2e2bcd8739ae039)(_ref, $cab5745653a7ca05$var$_excluded);
    var _useState = (0, $5zKJZ.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $549b5fd2afdd591d$export$2e2bcd8739ae039)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $5zKJZ.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $549b5fd2afdd591d$export$2e2bcd8739ae039)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $5zKJZ.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $549b5fd2afdd591d$export$2e2bcd8739ae039)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $5zKJZ.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === "function") propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $5zKJZ.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === "function") newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $5zKJZ.useCallback)(function() {
        if (typeof propsOnMenuOpen === "function") propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $5zKJZ.useCallback)(function() {
        if (typeof propsOnMenuClose === "function") propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $105b4e425347a1bb$export$407448d2b89b1813)((0, $105b4e425347a1bb$export$407448d2b89b1813)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}




var $5zKJZ = parcelRequire("5zKJZ");






function $1d4434e5fd87474d$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $344684fb7dd2a22e$export$2e2bcd8739ae039)(arr);
}


function $69ea3bbc59d02d70$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}



function $3d86340be009758c$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $f0c3cc8daf8fcd5a$export$2e2bcd8739ae039(arr) {
    return (0, $1d4434e5fd87474d$export$2e2bcd8739ae039)(arr) || (0, $69ea3bbc59d02d70$export$2e2bcd8739ae039)(arr) || (0, $cc85bc0c04cc8e39$export$2e2bcd8739ae039)(arr) || (0, $3d86340be009758c$export$2e2bcd8739ae039)();
}



var $5zKJZ = parcelRequire("5zKJZ");

var $f5e0dace09547a05$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $f5e0dace09547a05$var$isEqual(first, second) {
    if (first === second) return true;
    if ($f5e0dace09547a05$var$safeIsNaN(first) && $f5e0dace09547a05$var$safeIsNaN(second)) return true;
    return false;
}
function $f5e0dace09547a05$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$f5e0dace09547a05$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $f5e0dace09547a05$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $f5e0dace09547a05$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $f5e0dace09547a05$export$2e2bcd8739ae039 = $f5e0dace09547a05$var$memoizeOne;



function $6b9e34e8d679831f$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $6b9e34e8d679831f$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $6b9e34e8d679831f$var$A11yText = function A11yText(props) {
    return (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)("span", (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({
        css: $6b9e34e8d679831f$var$_ref
    }, props));
};
var $6b9e34e8d679831f$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
        switch(context){
            case "menu":
                return "Use Up and Down to choose options".concat(isDisabled ? "" : ", press Enter to select the currently focused option", ", press Escape to exit the menu").concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");
            case "input":
                return "".concat(props["aria-label"] || "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "");
            case "value":
                return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
            default:
                return "";
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? "" : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case "deselect-option":
            case "pop-value":
            case "remove-value":
                return "option ".concat(label, ", deselected.");
            case "clear":
                return "All selected options have been cleared.";
            case "initial-input-focus":
                return "option".concat(labels.length > 1 ? "s" : "", " ").concat(labels.join(","), ", selected.");
            case "select-option":
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return "";
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? "" : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : "";
        };
        if (context === "value" && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === "menu") {
            var disabled = isDisabled ? " disabled" : "";
            var status = "".concat(isSelected ? "selected" : "focused").concat(disabled);
            return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return "";
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
    }
};
var $6b9e34e8d679831f$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
    var ariaLabel = selectProps["aria-label"];
    var ariaLive = selectProps["aria-live"]; // Update aria live message configuration when prop changes
    var messages = (0, $5zKJZ.useMemo)(function() {
        return (0, $105b4e425347a1bb$export$407448d2b89b1813)((0, $105b4e425347a1bb$export$407448d2b89b1813)({}, $6b9e34e8d679831f$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]); // Update aria live selected option when prop changes
    var ariaSelected = (0, $5zKJZ.useMemo)(function() {
        var message = "";
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value; // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            }; // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : ""; // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $105b4e425347a1bb$export$407448d2b89b1813)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $5zKJZ.useMemo)(function() {
        var focusMsg = "";
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: options,
                context: focused === focusedOption ? "menu" : "value",
                selectValue: selectValue
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        options,
        selectValue
    ]);
    var ariaResults = (0, $5zKJZ.useMemo)(function() {
        var resultsMsg = "";
        if (menuIsOpen && options.length && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus
    ]);
    var ariaGuidance = (0, $5zKJZ.useMemo)(function() {
        var guidanceMsg = "";
        if (messages.guidance) {
            var context = focusedValue ? "value" : menuIsOpen ? "menu" : "input";
            guidanceMsg = messages.guidance({
                "aria-label": ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue
    ]);
    var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
    var ScreenReaderText = (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)((0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).Fragment, null, (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)("span", {
        id: "aria-context"
    }, ariaContext));
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus";
    return (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)((0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).Fragment, null, (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)($6b9e34e8d679831f$var$A11yText, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)($6b9e34e8d679831f$var$A11yText, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $6b9e34e8d679831f$var$diacritics = [
    {
        base: "A",
        letters: "A\u24B6\uFF21\xc0\xc1\xc2\u1EA6\u1EA4\u1EAA\u1EA8\xc3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xc4\u01DE\u1EA2\xc5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: "AA",
        letters: "\uA732"
    },
    {
        base: "AE",
        letters: "\xc6\u01FC\u01E2"
    },
    {
        base: "AO",
        letters: "\uA734"
    },
    {
        base: "AU",
        letters: "\uA736"
    },
    {
        base: "AV",
        letters: "\uA738\uA73A"
    },
    {
        base: "AY",
        letters: "\uA73C"
    },
    {
        base: "B",
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: "C",
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xc7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: "D",
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: "DZ",
        letters: "\u01F1\u01C4"
    },
    {
        base: "Dz",
        letters: "\u01F2\u01C5"
    },
    {
        base: "E",
        letters: "E\u24BA\uFF25\xc8\xc9\xca\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xcb\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: "F",
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: "G",
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: "H",
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: "I",
        letters: "I\u24BE\uFF29\xcc\xcd\xce\u0128\u012A\u012C\u0130\xcf\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: "J",
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: "K",
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: "L",
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: "LJ",
        letters: "\u01C7"
    },
    {
        base: "Lj",
        letters: "\u01C8"
    },
    {
        base: "M",
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: "N",
        letters: "N\u24C3\uFF2E\u01F8\u0143\xd1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: "NJ",
        letters: "\u01CA"
    },
    {
        base: "Nj",
        letters: "\u01CB"
    },
    {
        base: "O",
        letters: "O\u24C4\uFF2F\xd2\xd3\xd4\u1ED2\u1ED0\u1ED6\u1ED4\xd5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xd6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xd8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: "OI",
        letters: "\u01A2"
    },
    {
        base: "OO",
        letters: "\uA74E"
    },
    {
        base: "OU",
        letters: "\u0222"
    },
    {
        base: "P",
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: "Q",
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: "R",
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: "S",
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: "T",
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: "TZ",
        letters: "\uA728"
    },
    {
        base: "U",
        letters: "U\u24CA\uFF35\xd9\xda\xdb\u0168\u1E78\u016A\u1E7A\u016C\xdc\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: "V",
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: "VY",
        letters: "\uA760"
    },
    {
        base: "W",
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: "X",
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: "Y",
        letters: "Y\u24CE\uFF39\u1EF2\xdd\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: "Z",
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: "a",
        letters: "a\u24D0\uFF41\u1E9A\xe0\xe1\xe2\u1EA7\u1EA5\u1EAB\u1EA9\xe3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xe4\u01DF\u1EA3\xe5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: "aa",
        letters: "\uA733"
    },
    {
        base: "ae",
        letters: "\xe6\u01FD\u01E3"
    },
    {
        base: "ao",
        letters: "\uA735"
    },
    {
        base: "au",
        letters: "\uA737"
    },
    {
        base: "av",
        letters: "\uA739\uA73B"
    },
    {
        base: "ay",
        letters: "\uA73D"
    },
    {
        base: "b",
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: "c",
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xe7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: "d",
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: "dz",
        letters: "\u01F3\u01C6"
    },
    {
        base: "e",
        letters: "e\u24D4\uFF45\xe8\xe9\xea\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xeb\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: "f",
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: "g",
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: "h",
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: "hv",
        letters: "\u0195"
    },
    {
        base: "i",
        letters: "i\u24D8\uFF49\xec\xed\xee\u0129\u012B\u012D\xef\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: "j",
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: "k",
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: "l",
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: "lj",
        letters: "\u01C9"
    },
    {
        base: "m",
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: "n",
        letters: "n\u24DD\uFF4E\u01F9\u0144\xf1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: "nj",
        letters: "\u01CC"
    },
    {
        base: "o",
        letters: "o\u24DE\uFF4F\xf2\xf3\xf4\u1ED3\u1ED1\u1ED7\u1ED5\xf5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xf6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xf8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: "oi",
        letters: "\u01A3"
    },
    {
        base: "ou",
        letters: "\u0223"
    },
    {
        base: "oo",
        letters: "\uA74F"
    },
    {
        base: "p",
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: "q",
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: "r",
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: "s",
        letters: "s\u24E2\uFF53\xdf\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: "t",
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: "tz",
        letters: "\uA729"
    },
    {
        base: "u",
        letters: "u\u24E4\uFF55\xf9\xfa\xfb\u0169\u1E79\u016B\u1E7B\u016D\xfc\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: "v",
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: "vy",
        letters: "\uA761"
    },
    {
        base: "w",
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: "x",
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: "y",
        letters: "y\u24E8\uFF59\u1EF3\xfd\u0177\u1EF9\u0233\u1E8F\xff\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: "z",
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $6b9e34e8d679831f$var$anyDiacritic = new RegExp("[" + $6b9e34e8d679831f$var$diacritics.map(function(d) {
    return d.letters;
}).join("") + "]", "g");
var $6b9e34e8d679831f$var$diacriticToBase = {};
for(var $6b9e34e8d679831f$var$i = 0; $6b9e34e8d679831f$var$i < $6b9e34e8d679831f$var$diacritics.length; $6b9e34e8d679831f$var$i++){
    var $6b9e34e8d679831f$var$diacritic = $6b9e34e8d679831f$var$diacritics[$6b9e34e8d679831f$var$i];
    for(var $6b9e34e8d679831f$var$j = 0; $6b9e34e8d679831f$var$j < $6b9e34e8d679831f$var$diacritic.letters.length; $6b9e34e8d679831f$var$j++)$6b9e34e8d679831f$var$diacriticToBase[$6b9e34e8d679831f$var$diacritic.letters[$6b9e34e8d679831f$var$j]] = $6b9e34e8d679831f$var$diacritic.base;
}
var $6b9e34e8d679831f$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($6b9e34e8d679831f$var$anyDiacritic, function(match) {
        return $6b9e34e8d679831f$var$diacriticToBase[match];
    });
};
var $6b9e34e8d679831f$var$memoizedStripDiacriticsForInput = (0, $f5e0dace09547a05$export$2e2bcd8739ae039)($6b9e34e8d679831f$var$stripDiacritics);
var $6b9e34e8d679831f$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, "");
};
var $6b9e34e8d679831f$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $6b9e34e8d679831f$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $105b4e425347a1bb$export$407448d2b89b1813)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $6b9e34e8d679831f$var$defaultStringify,
            trim: true,
            matchFrom: "any"
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $6b9e34e8d679831f$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $6b9e34e8d679831f$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $6b9e34e8d679831f$var$memoizedStripDiacriticsForInput(input);
            candidate = $6b9e34e8d679831f$var$stripDiacritics(candidate);
        }
        return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $6b9e34e8d679831f$var$_excluded = [
    "innerRef"
];
function $6b9e34e8d679831f$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $295b61ec8f7276fc$export$2e2bcd8739ae039)(_ref, $6b9e34e8d679831f$var$_excluded);
    return (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)("input", (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({
        ref: innerRef
    }, props, {
        css: /*#__PURE__*/ (0, $655e6e02649f7fec$export$dbf350e5966cf602)({
            label: "dummyInput",
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: "transparent",
            fontSize: "inherit",
            gridArea: "1 / 1 / 2 / 3",
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: "transparent",
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: "relative",
            transform: "scale(.01)"
        }, "", "")
    }));
}
var $6b9e34e8d679831f$var$cancelScroll = function cancelScroll(event) {
    event.preventDefault();
    event.stopPropagation();
};
function $6b9e34e8d679831f$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $5zKJZ.useRef)(false);
    var isTop = (0, $5zKJZ.useRef)(false);
    var touchStart = (0, $5zKJZ.useRef)(0);
    var scrollTarget = (0, $5zKJZ.useRef)(null);
    var handleEventDelta = (0, $5zKJZ.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false; // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        } // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true; // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        } // cancel scroll
        if (shouldCancelScroll) $6b9e34e8d679831f$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $5zKJZ.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $5zKJZ.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $5zKJZ.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $5zKJZ.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $105b4e425347a1bb$export$2408f22a0fab9ae5) ? {
            passive: false
        } : false;
        el.addEventListener("wheel", onWheel, notPassive);
        el.addEventListener("touchstart", onTouchStart, notPassive);
        el.addEventListener("touchmove", onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $5zKJZ.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener("wheel", onWheel, false);
        el.removeEventListener("touchstart", onTouchStart, false);
        el.removeEventListener("touchmove", onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $5zKJZ.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $6b9e34e8d679831f$var$STYLE_KEYS = [
    "boxSizing",
    "height",
    "overflow",
    "paddingRight",
    "position"
];
var $6b9e34e8d679831f$var$LOCK_STYLES = {
    boxSizing: "border-box",
    // account for possible declaration `width: 100%;` on body
    overflow: "hidden",
    position: "relative",
    height: "100%"
};
function $6b9e34e8d679831f$var$preventTouchMove(e) {
    e.preventDefault();
}
function $6b9e34e8d679831f$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $6b9e34e8d679831f$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
} // `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $6b9e34e8d679831f$var$isTouchDevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
var $6b9e34e8d679831f$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $6b9e34e8d679831f$var$activeScrollLocks = 0;
var $6b9e34e8d679831f$var$listenerOptions = {
    capture: false,
    passive: false
};
function $6b9e34e8d679831f$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $5zKJZ.useRef)({});
    var scrollTarget = (0, $5zKJZ.useRef)(null);
    var addScrollLock = (0, $5zKJZ.useCallback)(function(touchScrollTarget) {
        if (!$6b9e34e8d679831f$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $6b9e34e8d679831f$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
         // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $6b9e34e8d679831f$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($6b9e34e8d679831f$var$LOCK_STYLES).forEach(function(key) {
                var val = $6b9e34e8d679831f$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        } // account for touch devices
        if (target && $6b9e34e8d679831f$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener("touchmove", $6b9e34e8d679831f$var$preventTouchMove, $6b9e34e8d679831f$var$listenerOptions); // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener("touchstart", $6b9e34e8d679831f$var$preventInertiaScroll, $6b9e34e8d679831f$var$listenerOptions);
                touchScrollTarget.addEventListener("touchmove", $6b9e34e8d679831f$var$allowTouchMove, $6b9e34e8d679831f$var$listenerOptions);
            }
        } // increment active scroll locks
        $6b9e34e8d679831f$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $5zKJZ.useCallback)(function(touchScrollTarget) {
        if (!$6b9e34e8d679831f$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style; // safely decrement active scroll locks
        $6b9e34e8d679831f$var$activeScrollLocks = Math.max($6b9e34e8d679831f$var$activeScrollLocks - 1, 0); // reapply original body styles, if any
        if (accountForScrollbars && $6b9e34e8d679831f$var$activeScrollLocks < 1) $6b9e34e8d679831f$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
         // remove touch listeners
        if (target && $6b9e34e8d679831f$var$isTouchDevice()) {
            target.removeEventListener("touchmove", $6b9e34e8d679831f$var$preventTouchMove, $6b9e34e8d679831f$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener("touchstart", $6b9e34e8d679831f$var$preventInertiaScroll, $6b9e34e8d679831f$var$listenerOptions);
                touchScrollTarget.removeEventListener("touchmove", $6b9e34e8d679831f$var$allowTouchMove, $6b9e34e8d679831f$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $5zKJZ.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $6b9e34e8d679831f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $6b9e34e8d679831f$var$blurSelectInput = function blurSelectInput() {
    return document.activeElement && document.activeElement.blur();
};
var $6b9e34e8d679831f$var$_ref2 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $6b9e34e8d679831f$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $6b9e34e8d679831f$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $6b9e34e8d679831f$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)((0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).Fragment, null, lockEnabled && (0, $655e6e02649f7fec$export$c8a8987d4410bf2d)("div", {
        onClick: $6b9e34e8d679831f$var$blurSelectInput,
        css: $6b9e34e8d679831f$var$_ref2
    }), children(targetRef));
}
var $6b9e34e8d679831f$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $6b9e34e8d679831f$export$407448d2b89b1813 = function getOptionLabel(option) {
    return option.label;
};
var $6b9e34e8d679831f$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $6b9e34e8d679831f$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $6b9e34e8d679831f$var$defaultStyles = {
    clearIndicator: (0, $105b4e425347a1bb$export$8b22cf2602fb60ce),
    container: (0, $105b4e425347a1bb$export$4368d992c4eafac0),
    control: (0, $105b4e425347a1bb$export$f1e1789686576879),
    dropdownIndicator: (0, $105b4e425347a1bb$export$2d1720544b23b823),
    group: (0, $105b4e425347a1bb$export$39b482c5e57630a8),
    groupHeading: (0, $105b4e425347a1bb$export$dda1d9f60106f0e9),
    indicatorsContainer: (0, $105b4e425347a1bb$export$23f2a1d2818174ef),
    indicatorSeparator: (0, $105b4e425347a1bb$export$35e795649ee09318),
    input: (0, $105b4e425347a1bb$export$342063e11d6c3cad),
    loadingIndicator: (0, $105b4e425347a1bb$export$882b5998b3b9117c),
    loadingMessage: (0, $105b4e425347a1bb$export$953cecd6e717a553),
    menu: (0, $105b4e425347a1bb$export$7ccc53e8f1e7dfc5),
    menuList: (0, $105b4e425347a1bb$export$ae1af26003f05816),
    menuPortal: (0, $105b4e425347a1bb$export$ffb5f4729a158638),
    multiValue: (0, $105b4e425347a1bb$export$9e5f44173e64f162),
    multiValueLabel: (0, $105b4e425347a1bb$export$43caf9889c228507),
    multiValueRemove: (0, $105b4e425347a1bb$export$625550452a3fa3ec),
    noOptionsMessage: (0, $105b4e425347a1bb$export$3b14a55fb2447963),
    option: (0, $105b4e425347a1bb$export$90a7f3efeed30595),
    placeholder: (0, $105b4e425347a1bb$export$efccba1c4a2ef57b),
    singleValue: (0, $105b4e425347a1bb$export$d141bba7fdc215a3),
    valueContainer: (0, $105b4e425347a1bb$export$4a5767248b18ef41)
}; // Merge Utility
// Allows consumers to extend a base Select with additional styles
function $6b9e34e8d679831f$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $105b4e425347a1bb$export$407448d2b89b1813)({}, source); // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $6b9e34e8d679831f$var$colors = {
    primary: "#2684FF",
    primary75: "#4C9AFF",
    primary50: "#B2D4FF",
    primary25: "#DEEBFF",
    danger: "#DE350B",
    dangerLight: "#FFBDAD",
    neutral0: "hsl(0, 0%, 100%)",
    neutral5: "hsl(0, 0%, 95%)",
    neutral10: "hsl(0, 0%, 90%)",
    neutral20: "hsl(0, 0%, 80%)",
    neutral30: "hsl(0, 0%, 70%)",
    neutral40: "hsl(0, 0%, 60%)",
    neutral50: "hsl(0, 0%, 50%)",
    neutral60: "hsl(0, 0%, 40%)",
    neutral70: "hsl(0, 0%, 30%)",
    neutral80: "hsl(0, 0%, 20%)",
    neutral90: "hsl(0, 0%, 10%)"
};
var $6b9e34e8d679831f$var$borderRadius = 4; // Used to calculate consistent margin/padding on elements
var $6b9e34e8d679831f$var$baseUnit = 4; // The minimum height of the control
var $6b9e34e8d679831f$var$controlHeight = 38; // The amount of space between the control and menu */
var $6b9e34e8d679831f$var$menuGutter = $6b9e34e8d679831f$var$baseUnit * 2;
var $6b9e34e8d679831f$var$spacing = {
    baseUnit: $6b9e34e8d679831f$var$baseUnit,
    controlHeight: $6b9e34e8d679831f$var$controlHeight,
    menuGutter: $6b9e34e8d679831f$var$menuGutter
};
var $6b9e34e8d679831f$export$4368d992c4eafac0 = {
    borderRadius: $6b9e34e8d679831f$var$borderRadius,
    colors: $6b9e34e8d679831f$var$colors,
    spacing: $6b9e34e8d679831f$var$spacing
};
var $6b9e34e8d679831f$export$8b22cf2602fb60ce = {
    "aria-live": "polite",
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $105b4e425347a1bb$export$df995fae86a55f06)(),
    captureMenuScroll: !(0, $105b4e425347a1bb$export$df995fae86a55f06)(),
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $6b9e34e8d679831f$export$db3b6bfb95261072(),
    formatGroupLabel: $6b9e34e8d679831f$var$formatGroupLabel,
    getOptionLabel: $6b9e34e8d679831f$export$407448d2b89b1813,
    getOptionValue: $6b9e34e8d679831f$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $6b9e34e8d679831f$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return "Loading...";
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: "bottom",
    menuPosition: "absolute",
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $105b4e425347a1bb$export$ebd11618f299a286)(),
    noOptionsMessage: function noOptionsMessage() {
        return "No options";
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: "Select...",
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? "s" : "", " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true
};
function $6b9e34e8d679831f$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $6b9e34e8d679831f$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $6b9e34e8d679831f$var$_isOptionSelected(props, option, selectValue);
    var label = $6b9e34e8d679831f$var$getOptionLabel(props, option);
    var value = $6b9e34e8d679831f$var$getOptionValue(props, option);
    return {
        type: "option",
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $6b9e34e8d679831f$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ("options" in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $6b9e34e8d679831f$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $6b9e34e8d679831f$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: "group",
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $6b9e34e8d679831f$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $6b9e34e8d679831f$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $105b4e425347a1bb$export$2329c99376c9d0a4));
}
function $6b9e34e8d679831f$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $f0c3cc8daf8fcd5a$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $6b9e34e8d679831f$var$buildFocusableOptions(props, selectValue) {
    return $6b9e34e8d679831f$var$buildFocusableOptionsFromCategorizedOptions($6b9e34e8d679831f$var$buildCategorizedOptions(props, selectValue));
}
function $6b9e34e8d679831f$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$6b9e34e8d679831f$var$shouldHideSelectedOptions(props) || !isSelected) && $6b9e34e8d679831f$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $6b9e34e8d679831f$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $6b9e34e8d679831f$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $6b9e34e8d679831f$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $6b9e34e8d679831f$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $6b9e34e8d679831f$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option, selectValue) : false;
}
function $6b9e34e8d679831f$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === "function") return props.isOptionSelected(option, selectValue);
    var candidate = $6b9e34e8d679831f$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $6b9e34e8d679831f$var$getOptionValue(props, i) === candidate;
    });
}
function $6b9e34e8d679831f$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $6b9e34e8d679831f$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $6b9e34e8d679831f$var$instanceId = 1;
var $6b9e34e8d679831f$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $f194ac009f84f33f$export$2e2bcd8739ae039)(Select, _Component);
    var _super = (0, $105b4e425347a1bb$export$71511d61b312f219)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $59343b2a3f79b18d$export$2e2bcd8739ae039)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.instancePrefix = "";
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange("", {
                action: "set-value",
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $105b4e425347a1bb$export$ef35774e6d314e91)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), "deselect-option", newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $105b4e425347a1bb$export$ef35774e6d314e91)([].concat((0, $f0c3cc8daf8fcd5a$export$2e2bcd8739ae039)(selectValue), [
                    newValue
                ])), "select-option", newValue);
                else _this.setValue((0, $105b4e425347a1bb$export$e7094788287c5e9b)(newValue), "select-option");
            } else {
                _this.ariaOnChange((0, $105b4e425347a1bb$export$e7094788287c5e9b)(newValue), {
                    action: "select-option",
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $105b4e425347a1bb$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "remove-value",
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $105b4e425347a1bb$export$96f57966bedc81b4)(_this.props.isMulti, [], null), {
                action: "clear",
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $105b4e425347a1bb$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "pop-value",
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $105b4e425347a1bb$export$a9c23c6ac3fc3eca).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $6b9e34e8d679831f$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $6b9e34e8d679831f$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var base = $6b9e34e8d679831f$var$defaultStyles[key](props);
            base.boxSizing = "border-box";
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $105b4e425347a1bb$export$d66501df72047452)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $6b9e34e8d679831f$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $6b9e34e8d679831f$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $105b4e425347a1bb$export$407448d2b89b1813)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu("first");
            } else if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") _this.onMenuClose();
            if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu("first");
            event.preventDefault();
            event.stopPropagation();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            event.stopPropagation();
            _this.openAfterFocus = false;
            if (event.type === "touchend") _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === "boolean") {
                if (event.target instanceof HTMLElement && (0, $105b4e425347a1bb$export$7f8ddf7c7c20b3cd)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === "function") {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return; // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
             // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: "input-change",
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu("first");
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange("", {
                action: "input-blur",
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $6b9e34e8d679831f$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === "function") {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            } // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case "ArrowLeft":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("previous");
                    break;
                case "ArrowRight":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("next");
                    break;
                case "Delete":
                case "Backspace":
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case "Tab":
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case "Enter":
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case "Escape":
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange("", {
                            action: "menu-close",
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case " ":
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu("first");
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case "ArrowUp":
                    if (menuIsOpen) _this.focusOption("up");
                    else _this.openMenu("last");
                    break;
                case "ArrowDown":
                    if (menuIsOpen) _this.focusOption("down");
                    else _this.openMenu("first");
                    break;
                case "PageUp":
                    if (!menuIsOpen) return;
                    _this.focusOption("pageup");
                    break;
                case "PageDown":
                    if (!menuIsOpen) return;
                    _this.focusOption("pagedown");
                    break;
                case "Home":
                    if (!menuIsOpen) return;
                    _this.focusOption("first");
                    break;
                case "End":
                    if (!menuIsOpen) return;
                    _this.focusOption("last");
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.instancePrefix = "react-select-" + (_this.props.instanceId || ++$6b9e34e8d679831f$var$instanceId);
        _this.state.selectValue = (0, $105b4e425347a1bb$export$9bb611d729802a56)(_props.value);
        return _this;
    }
    (0, $4d5516f5455b2884$export$2e2bcd8739ae039)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener("scroll", this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                 // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $105b4e425347a1bb$export$b4171a6734a65d42)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener("scroll", this.onScroll, true);
            } // ==============================
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange("", {
                    action: "menu-close",
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            } // ==============================
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            } // aliased for consumers
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                } // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex]
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue; // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case "previous":
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case "next":
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "first";
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === "up") nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === "down") nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === "pageup") {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === "pagedown") {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === "last") nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
            }
        },
        {
            key: "getTheme",
            value: // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customizations.
                if (!this.props.theme) return $6b9e34e8d679831f$export$4368d992c4eafac0;
                 // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === "function") return this.props.theme($6b9e34e8d679831f$export$4368d992c4eafac0);
                 // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $105b4e425347a1bb$export$407448d2b89b1813)((0, $105b4e425347a1bb$export$407448d2b89b1813)({}, $6b9e34e8d679831f$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti; // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $6b9e34e8d679831f$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $6b9e34e8d679831f$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $6b9e34e8d679831f$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === "function") {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            } // ==============================
        },
        {
            key: "startListeningComposition",
            value: // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener("compositionstart", this.onCompositionStart, false);
                    document.addEventListener("compositionend", this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("compositionstart", this.onCompositionStart);
                    document.removeEventListener("compositionend", this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener("touchstart", this.onTouchStart, false);
                    document.addEventListener("touchmove", this.onTouchMove, false);
                    document.addEventListener("touchend", this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("touchstart", this.onTouchStart);
                    document.removeEventListener("touchmove", this.onTouchMove);
                    document.removeEventListener("touchend", this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId("input"); // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $105b4e425347a1bb$export$407448d2b89b1813)((0, $105b4e425347a1bb$export$407448d2b89b1813)({
                    "aria-autocomplete": "list",
                    "aria-expanded": menuIsOpen,
                    "aria-haspopup": true,
                    "aria-controls": this.getElementId("listbox"),
                    "aria-owns": this.getElementId("listbox"),
                    "aria-errormessage": this.props["aria-errormessage"],
                    "aria-invalid": this.props["aria-invalid"],
                    "aria-label": this.props["aria-label"],
                    "aria-labelledby": this.props["aria-labelledby"],
                    role: "combobox"
                }, !isSearchable && {
                    "aria-readonly": true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus" && {
                    "aria-describedby": this.getElementId("live-region")
                } : {
                    "aria-describedby": this.getElementId("placeholder")
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement($6b9e34e8d679831f$var$DummyInput, (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $105b4e425347a1bb$export$3466f893ebf79586),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement(Input, (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement(Placeholder, (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId("placeholder")
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement(MultiValue, (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, "value"));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement(SingleValue, (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, "value"));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement(ClearIndicator, (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement(LoadingIndicator, (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement(IndicatorSeparator, (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement(DropdownIndicator, (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null; // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId("option"), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    };
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement(Option, (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, "menu"));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === "group") {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId("group"), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement(Group, (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === "option") return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $105b4e425347a1bb$export$3a1a48c8f6ef640e), (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement(Menu, (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove,
                            id: _this4.getElementId("listbox")
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement($6b9e34e8d679831f$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement(MenuList, (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                }); // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === "fixed" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement(MenuPortal, (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name;
                var selectValue = this.state.selectValue;
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
                            name: name,
                            type: "hidden"
                        });
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement($6b9e34e8d679831f$var$LiveRegion, (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({}, commonProps, {
                    id: this.getElementId("live-region"),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement(SelectContainer, (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement(Control, (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement(ValueContainer, (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement(IndicatorsContainer, (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $105b4e425347a1bb$export$9bb611d729802a56)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $6b9e34e8d679831f$var$buildFocusableOptions(props, selectValue) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $6b9e34e8d679831f$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $6b9e34e8d679831f$var$getNextFocusedOption(state, focusableOptions);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                } // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $105b4e425347a1bb$export$96f57966bedc81b4)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: "initial-input-focus"
                    };
                    hasKeptFocus = !prevWasFocused;
                } // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus") newAriaSelection = null;
                return (0, $105b4e425347a1bb$export$407448d2b89b1813)((0, $105b4e425347a1bb$export$407448d2b89b1813)((0, $105b4e425347a1bb$export$407448d2b89b1813)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $5zKJZ.Component));
$6b9e34e8d679831f$export$25ce5a424b770e84.defaultProps = $6b9e34e8d679831f$export$8b22cf2602fb60ce;









var $8844402caba8799a$exports = {};
var $814640de3cb35e00$exports = {};
function $814640de3cb35e00$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
$814640de3cb35e00$exports = $814640de3cb35e00$var$_arrayWithHoles, $814640de3cb35e00$exports.__esModule = true, $814640de3cb35e00$exports["default"] = $814640de3cb35e00$exports;


var $523911cd50e59409$exports = {};
function $523911cd50e59409$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
$523911cd50e59409$exports = $523911cd50e59409$var$_iterableToArrayLimit, $523911cd50e59409$exports.__esModule = true, $523911cd50e59409$exports["default"] = $523911cd50e59409$exports;


var $16c7538dad3d9722$exports = {};
var $3cd88b56fa1e1aa2$exports = {};
function $3cd88b56fa1e1aa2$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
$3cd88b56fa1e1aa2$exports = $3cd88b56fa1e1aa2$var$_arrayLikeToArray, $3cd88b56fa1e1aa2$exports.__esModule = true, $3cd88b56fa1e1aa2$exports["default"] = $3cd88b56fa1e1aa2$exports;


function $16c7538dad3d9722$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3cd88b56fa1e1aa2$exports(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3cd88b56fa1e1aa2$exports(o, minLen);
}
$16c7538dad3d9722$exports = $16c7538dad3d9722$var$_unsupportedIterableToArray, $16c7538dad3d9722$exports.__esModule = true, $16c7538dad3d9722$exports["default"] = $16c7538dad3d9722$exports;


var $3ad2ec3effb95006$exports = {};
function $3ad2ec3effb95006$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$3ad2ec3effb95006$exports = $3ad2ec3effb95006$var$_nonIterableRest, $3ad2ec3effb95006$exports.__esModule = true, $3ad2ec3effb95006$exports["default"] = $3ad2ec3effb95006$exports;


function $8844402caba8799a$var$_slicedToArray(arr, i) {
    return $814640de3cb35e00$exports(arr) || $523911cd50e59409$exports(arr, i) || $16c7538dad3d9722$exports(arr, i) || $3ad2ec3effb95006$exports();
}
$8844402caba8799a$exports = $8844402caba8799a$var$_slicedToArray, $8844402caba8799a$exports.__esModule = true, $8844402caba8799a$exports["default"] = $8844402caba8799a$exports;


var $aa052e0832b0e2da$exports = {};
var $014e6659835ae2e6$exports = {};
function $014e6659835ae2e6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
$014e6659835ae2e6$exports = $014e6659835ae2e6$var$_objectWithoutPropertiesLoose, $014e6659835ae2e6$exports.__esModule = true, $014e6659835ae2e6$exports["default"] = $014e6659835ae2e6$exports;


function $aa052e0832b0e2da$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $014e6659835ae2e6$exports(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
$aa052e0832b0e2da$exports = $aa052e0832b0e2da$var$_objectWithoutProperties, $aa052e0832b0e2da$exports.__esModule = true, $aa052e0832b0e2da$exports["default"] = $aa052e0832b0e2da$exports;


var $f3e0ad59f029ed87$exports = {};
var $c24999dffd20dbd6$exports = {};

function $c24999dffd20dbd6$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $3cd88b56fa1e1aa2$exports(arr);
}
$c24999dffd20dbd6$exports = $c24999dffd20dbd6$var$_arrayWithoutHoles, $c24999dffd20dbd6$exports.__esModule = true, $c24999dffd20dbd6$exports["default"] = $c24999dffd20dbd6$exports;


var $896459ab33acb843$exports = {};
function $896459ab33acb843$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
$896459ab33acb843$exports = $896459ab33acb843$var$_iterableToArray, $896459ab33acb843$exports.__esModule = true, $896459ab33acb843$exports["default"] = $896459ab33acb843$exports;



var $bab8553c331ff8a2$exports = {};
function $bab8553c331ff8a2$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$bab8553c331ff8a2$exports = $bab8553c331ff8a2$var$_nonIterableSpread, $bab8553c331ff8a2$exports.__esModule = true, $bab8553c331ff8a2$exports["default"] = $bab8553c331ff8a2$exports;


function $f3e0ad59f029ed87$var$_toConsumableArray(arr) {
    return $c24999dffd20dbd6$exports(arr) || $896459ab33acb843$exports(arr) || $16c7538dad3d9722$exports(arr) || $bab8553c331ff8a2$exports();
}
$f3e0ad59f029ed87$exports = $f3e0ad59f029ed87$var$_toConsumableArray, $f3e0ad59f029ed87$exports.__esModule = true, $f3e0ad59f029ed87$exports["default"] = $f3e0ad59f029ed87$exports;


var $ac99a75e47913ae4$exports = {};
function $ac99a75e47913ae4$var$_taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
$ac99a75e47913ae4$exports = $ac99a75e47913ae4$var$_taggedTemplateLiteral, $ac99a75e47913ae4$exports.__esModule = true, $ac99a75e47913ae4$exports["default"] = $ac99a75e47913ae4$exports;


var $1f0b0a0372821270$exports = {};
function $1f0b0a0372821270$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $1f0b0a0372821270$exports = $1f0b0a0372821270$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $1f0b0a0372821270$exports.__esModule = true, $1f0b0a0372821270$exports["default"] = $1f0b0a0372821270$exports, $1f0b0a0372821270$var$_typeof(obj);
}
$1f0b0a0372821270$exports = $1f0b0a0372821270$var$_typeof, $1f0b0a0372821270$exports.__esModule = true, $1f0b0a0372821270$exports["default"] = $1f0b0a0372821270$exports;


var $ccb09c56ca14b0ee$exports = {};
function $ccb09c56ca14b0ee$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
$ccb09c56ca14b0ee$exports = $ccb09c56ca14b0ee$var$_defineProperty, $ccb09c56ca14b0ee$exports.__esModule = true, $ccb09c56ca14b0ee$exports["default"] = $ccb09c56ca14b0ee$exports;



var $d4d4787208c54054$var$StateManagedSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).forwardRef(function(props, ref) {
    var baseSelectProps = (0, $cab5745653a7ca05$export$3b14a55fb2447963)(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $6b9e34e8d679831f$export$25ce5a424b770e84), (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({
        ref: ref
    }, baseSelectProps));
});
var $d4d4787208c54054$export$a7deb1594c5ce10e = /*#__PURE__*/ function(_Component) {
    (0, $f194ac009f84f33f$export$2e2bcd8739ae039)(NonceProvider, _Component);
    var _super = (0, $105b4e425347a1bb$export$71511d61b312f219)(NonceProvider);
    function NonceProvider(props) {
        var _this;
        (0, $59343b2a3f79b18d$export$2e2bcd8739ae039)(this, NonceProvider);
        _this = _super.call(this, props);
        _this.createEmotionCache = function(nonce, key) {
            return (0, $f191ef1b0704aca6$export$2e2bcd8739ae039)({
                nonce: nonce,
                key: key
            });
        };
        _this.createEmotionCache = (0, $f5e0dace09547a05$export$2e2bcd8739ae039)(_this.createEmotionCache);
        return _this;
    }
    (0, $4d5516f5455b2884$export$2e2bcd8739ae039)(NonceProvider, [
        {
            key: "render",
            value: function render() {
                var emotionCache = this.createEmotionCache(this.props.nonce, this.props.cacheKey);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $4a4e7cb45334005e$export$e7094788287c5e9b), {
                    value: emotionCache
                }, this.props.children);
            }
        }
    ]);
    return NonceProvider;
}((0, $5zKJZ.Component));
var $d4d4787208c54054$export$2e2bcd8739ae039 = $d4d4787208c54054$var$StateManagedSelect;






var $5zKJZ = parcelRequire("5zKJZ");






function $50c188165e9b6e5f$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $df0fa350c014a99a$export$2e2bcd8739ae039)(subClass, superClass);
}




var $5zKJZ = parcelRequire("5zKJZ");

var $84d4ddd9ce1ab237$export$2e2bcd8739ae039 = {
    disabled: false
};




var $5zKJZ = parcelRequire("5zKJZ");
var $0dcf9facdcf61fd7$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createContext(null);


var $1fbc5359f8440395$export$bb38bb9a1161268 = "unmounted";
var $1fbc5359f8440395$export$84cbff306f539230 = "exited";
var $1fbc5359f8440395$export$df38205c966be359 = "entering";
var $1fbc5359f8440395$export$78e9e6e3e014d60a = "entered";
var $1fbc5359f8440395$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $1fbc5359f8440395$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $50c188165e9b6e5f$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $1fbc5359f8440395$export$84cbff306f539230;
                _this.appearStatus = $1fbc5359f8440395$export$df38205c966be359;
            } else initialStatus = $1fbc5359f8440395$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $1fbc5359f8440395$export$bb38bb9a1161268;
        else initialStatus = $1fbc5359f8440395$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $1fbc5359f8440395$export$bb38bb9a1161268) return {
            status: $1fbc5359f8440395$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $1fbc5359f8440395$export$df38205c966be359 && status !== $1fbc5359f8440395$export$78e9e6e3e014d60a) nextStatus = $1fbc5359f8440395$export$df38205c966be359;
            } else if (status === $1fbc5359f8440395$export$df38205c966be359 || status === $1fbc5359f8440395$export$78e9e6e3e014d60a) nextStatus = $1fbc5359f8440395$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $1fbc5359f8440395$export$df38205c966be359) this.performEnter(mounting);
            else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $1fbc5359f8440395$export$84cbff306f539230) this.setState({
            status: $1fbc5359f8440395$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($aa49bf5e460995f3$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $84d4ddd9ce1ab237$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $1fbc5359f8440395$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $1fbc5359f8440395$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $1fbc5359f8440395$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($aa49bf5e460995f3$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $84d4ddd9ce1ab237$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $1fbc5359f8440395$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $1fbc5359f8440395$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $1fbc5359f8440395$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($aa49bf5e460995f3$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $1fbc5359f8440395$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $f25ad4247afa2104$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $0dcf9facdcf61fd7$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).Component);
$1fbc5359f8440395$var$Transition.contextType = (0, $0dcf9facdcf61fd7$export$2e2bcd8739ae039);
$1fbc5359f8440395$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $1fbc5359f8440395$var$noop() {}
$1fbc5359f8440395$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $1fbc5359f8440395$var$noop,
    onEntering: $1fbc5359f8440395$var$noop,
    onEntered: $1fbc5359f8440395$var$noop,
    onExit: $1fbc5359f8440395$var$noop,
    onExiting: $1fbc5359f8440395$var$noop,
    onExited: $1fbc5359f8440395$var$noop
};
$1fbc5359f8440395$var$Transition.UNMOUNTED = $1fbc5359f8440395$export$bb38bb9a1161268;
$1fbc5359f8440395$var$Transition.EXITED = $1fbc5359f8440395$export$84cbff306f539230;
$1fbc5359f8440395$var$Transition.ENTERING = $1fbc5359f8440395$export$df38205c966be359;
$1fbc5359f8440395$var$Transition.ENTERED = $1fbc5359f8440395$export$78e9e6e3e014d60a;
$1fbc5359f8440395$var$Transition.EXITING = $1fbc5359f8440395$export$4aacc83d4d59139f;
var $1fbc5359f8440395$export$2e2bcd8739ae039 = $1fbc5359f8440395$var$Transition;



function $879476aa3c612bf0$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}





var $5zKJZ = parcelRequire("5zKJZ");


var $5zKJZ = parcelRequire("5zKJZ");
function $476d89b8e66ed17e$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $5zKJZ.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $5zKJZ.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $476d89b8e66ed17e$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $476d89b8e66ed17e$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $476d89b8e66ed17e$export$fa71e2345c31d7a2(props, onExited) {
    return $476d89b8e66ed17e$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $5zKJZ.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $476d89b8e66ed17e$var$getProp(child, "appear", props),
            enter: $476d89b8e66ed17e$var$getProp(child, "enter", props),
            exit: $476d89b8e66ed17e$var$getProp(child, "exit", props)
        });
    });
}
function $476d89b8e66ed17e$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $476d89b8e66ed17e$export$bbc8a025727ea824(nextProps.children);
    var children = $476d89b8e66ed17e$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $5zKJZ.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $5zKJZ.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $5zKJZ.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $476d89b8e66ed17e$var$getProp(child, "exit", nextProps),
            enter: $476d89b8e66ed17e$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $5zKJZ.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $5zKJZ.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $5zKJZ.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $476d89b8e66ed17e$var$getProp(child, "exit", nextProps),
            enter: $476d89b8e66ed17e$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}


var $e9734c229445255f$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $e9734c229445255f$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $e9734c229445255f$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $50c188165e9b6e5f$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $879476aa3c612bf0$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $476d89b8e66ed17e$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $476d89b8e66ed17e$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $476d89b8e66ed17e$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $f25ad4247afa2104$export$2e2bcd8739ae039)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $e9734c229445255f$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $0dcf9facdcf61fd7$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $0dcf9facdcf61fd7$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).Component);
$e9734c229445255f$var$TransitionGroup.propTypes = {};
$e9734c229445255f$var$TransitionGroup.defaultProps = $e9734c229445255f$var$defaultProps;
var $e9734c229445255f$export$2e2bcd8739ae039 = $e9734c229445255f$var$TransitionGroup;








var $30bb44caf3b98f87$var$_excluded$4 = [
    "in",
    "onExited",
    "appear",
    "enter",
    "exit"
];
// strip transition props off before spreading onto select component
var $30bb44caf3b98f87$var$AnimatedInput = function AnimatedInput(WrappedComponent) {
    return function(_ref) {
        _ref.in;
        _ref.onExited;
        _ref.appear;
        _ref.enter;
        _ref.exit;
        var props = (0, $295b61ec8f7276fc$export$2e2bcd8739ae039)(_ref, $30bb44caf3b98f87$var$_excluded$4);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement(WrappedComponent, props);
    };
};
var $30bb44caf3b98f87$var$_excluded$3 = [
    "component",
    "duration",
    "in",
    "onExited"
];
var $30bb44caf3b98f87$var$Fade = function Fade(_ref) {
    var Tag = _ref.component, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 1 : _ref$duration, inProp = _ref.in;
    _ref.onExited;
    var props = (0, $295b61ec8f7276fc$export$2e2bcd8739ae039)(_ref, $30bb44caf3b98f87$var$_excluded$3);
    var nodeRef = (0, $5zKJZ.useRef)(null);
    var transition = {
        entering: {
            opacity: 0
        },
        entered: {
            opacity: 1,
            transition: "opacity ".concat(duration, "ms")
        },
        exiting: {
            opacity: 0
        },
        exited: {
            opacity: 0
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $1fbc5359f8440395$export$2e2bcd8739ae039), {
        mountOnEnter: true,
        unmountOnExit: true,
        in: inProp,
        timeout: duration,
        nodeRef: nodeRef
    }, function(state) {
        var innerProps = {
            style: (0, $105b4e425347a1bb$export$407448d2b89b1813)({}, transition[state]),
            ref: nodeRef
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement(Tag, (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({
            innerProps: innerProps
        }, props));
    });
}; // ==============================
// Collapse Transition
// ==============================
var $30bb44caf3b98f87$var$collapseDuration = 260;
// wrap each MultiValue with a collapse transition; decreases width until
// finally removing from DOM
var $30bb44caf3b98f87$var$Collapse = /*#__PURE__*/ function(_Component) {
    (0, $f194ac009f84f33f$export$2e2bcd8739ae039)(Collapse, _Component);
    var _super = (0, $105b4e425347a1bb$export$71511d61b312f219)(Collapse);
    function Collapse() {
        var _this;
        (0, $59343b2a3f79b18d$export$2e2bcd8739ae039)(this, Collapse);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.duration = $30bb44caf3b98f87$var$collapseDuration;
        _this.rafID = void 0;
        _this.state = {
            width: "auto"
        };
        _this.transition = {
            exiting: {
                width: 0,
                transition: "width ".concat(_this.duration, "ms ease-out")
            },
            exited: {
                width: 0
            }
        };
        _this.nodeRef = /*#__PURE__*/ (0, $5zKJZ.createRef)();
        _this.getStyle = function(width) {
            return {
                overflow: "hidden",
                whiteSpace: "nowrap",
                width: width
            };
        };
        _this.getTransition = function(state) {
            return _this.transition[state];
        };
        return _this;
    }
    (0, $4d5516f5455b2884$export$2e2bcd8739ae039)(Collapse, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                var ref = this.nodeRef.current;
                /*
        A check on existence of ref should not be necessary at this point,
        but TypeScript demands it.
      */ if (ref) /*
          Here we're invoking requestAnimationFrame with a callback invoking our
          call to getBoundingClientRect and setState in order to resolve an edge case
          around portalling. Certain portalling solutions briefly remove children from the DOM
          before appending them to the target node. This is to avoid us trying to call getBoundingClientrect
          while the Select component is in this state.
        */ // cannot use `offsetWidth` because it is rounded
                this.rafID = window.requestAnimationFrame(function() {
                    var _ref$getBoundingClien = ref.getBoundingClientRect(), width = _ref$getBoundingClien.width;
                    _this2.setState({
                        width: width
                    });
                });
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.rafID) window.cancelAnimationFrame(this.rafID);
            } // get base styles
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props = this.props, children = _this$props.children, inProp = _this$props.in, onExited = _this$props.onExited;
                var exitedProp = function exitedProp() {
                    if (_this3.nodeRef.current && onExited) onExited(_this3.nodeRef.current);
                };
                var width = this.state.width;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $1fbc5359f8440395$export$2e2bcd8739ae039), {
                    enter: false,
                    mountOnEnter: true,
                    unmountOnExit: true,
                    in: inProp,
                    onExited: exitedProp,
                    timeout: this.duration,
                    nodeRef: this.nodeRef
                }, function(state) {
                    var style = (0, $105b4e425347a1bb$export$407448d2b89b1813)((0, $105b4e425347a1bb$export$407448d2b89b1813)({}, _this3.getStyle(width)), _this3.getTransition(state));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
                        ref: _this3.nodeRef,
                        style: style
                    }, children);
                });
            }
        }
    ]);
    return Collapse;
}((0, $5zKJZ.Component));
var $30bb44caf3b98f87$var$_excluded$2 = [
    "in",
    "onExited"
];
// strip transition props off before spreading onto actual component
var $30bb44caf3b98f87$var$AnimatedMultiValue = function AnimatedMultiValue(WrappedComponent) {
    return function(_ref) {
        var inProp = _ref.in, onExited = _ref.onExited, props = (0, $295b61ec8f7276fc$export$2e2bcd8739ae039)(_ref, $30bb44caf3b98f87$var$_excluded$2);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement($30bb44caf3b98f87$var$Collapse, {
            in: inProp,
            onExited: onExited
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement(WrappedComponent, (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({
            cropWithEllipsis: inProp
        }, props)));
    };
};
// fade in when last multi-value removed, otherwise instant
var $30bb44caf3b98f87$var$AnimatedPlaceholder = function AnimatedPlaceholder(WrappedComponent) {
    return function(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement($30bb44caf3b98f87$var$Fade, (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({
            component: WrappedComponent,
            duration: props.isMulti ? $30bb44caf3b98f87$var$collapseDuration : 1
        }, props));
    };
};
// instant fade; all transition-group children must be transitions
var $30bb44caf3b98f87$var$AnimatedSingleValue = function AnimatedSingleValue(WrappedComponent) {
    return function(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement($30bb44caf3b98f87$var$Fade, (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({
            component: WrappedComponent
        }, props));
    };
};
var $30bb44caf3b98f87$var$_excluded$1 = [
    "component"
], $30bb44caf3b98f87$var$_excluded2 = [
    "children"
];
// make ValueContainer a transition group
var $30bb44caf3b98f87$var$AnimatedValueContainer = function AnimatedValueContainer(WrappedComponent) {
    return function(props) {
        return props.isMulti ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement($30bb44caf3b98f87$var$IsMultiValueContainer, (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({
            component: WrappedComponent
        }, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $e9734c229445255f$export$2e2bcd8739ae039), (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({
            component: WrappedComponent
        }, props));
    };
};
var $30bb44caf3b98f87$var$IsMultiValueContainer = function IsMultiValueContainer(_ref) {
    var component = _ref.component, restProps = (0, $295b61ec8f7276fc$export$2e2bcd8739ae039)(_ref, $30bb44caf3b98f87$var$_excluded$1);
    var multiProps = $30bb44caf3b98f87$var$useIsMultiValueContainer(restProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $e9734c229445255f$export$2e2bcd8739ae039), (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({
        component: component
    }, multiProps));
};
var $30bb44caf3b98f87$var$useIsMultiValueContainer = function useIsMultiValueContainer(_ref2) {
    var children = _ref2.children, props = (0, $295b61ec8f7276fc$export$2e2bcd8739ae039)(_ref2, $30bb44caf3b98f87$var$_excluded2);
    var isMulti = props.isMulti, hasValue = props.hasValue, innerProps = props.innerProps, _props$selectProps = props.selectProps, components = _props$selectProps.components, controlShouldRenderValue = _props$selectProps.controlShouldRenderValue;
    var _useState = (0, $5zKJZ.useState)(isMulti && controlShouldRenderValue && hasValue), _useState2 = (0, $549b5fd2afdd591d$export$2e2bcd8739ae039)(_useState, 2), cssDisplayFlex = _useState2[0], setCssDisplayFlex = _useState2[1];
    var _useState3 = (0, $5zKJZ.useState)(false), _useState4 = (0, $549b5fd2afdd591d$export$2e2bcd8739ae039)(_useState3, 2), removingValue = _useState4[0], setRemovingValue = _useState4[1];
    (0, $5zKJZ.useEffect)(function() {
        if (hasValue && !cssDisplayFlex) setCssDisplayFlex(true);
    }, [
        hasValue,
        cssDisplayFlex
    ]);
    (0, $5zKJZ.useEffect)(function() {
        if (removingValue && !hasValue && cssDisplayFlex) setCssDisplayFlex(false);
        setRemovingValue(false);
    }, [
        removingValue,
        hasValue,
        cssDisplayFlex
    ]);
    var onExited = function onExited() {
        return setRemovingValue(true);
    };
    var childMapper = function childMapper(child) {
        if (isMulti && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).isValidElement(child)) {
            // Add onExited callback to MultiValues
            if (child.type === components.MultiValue) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).cloneElement(child, {
                onExited: onExited
            });
             // While container flexed, Input cursor is shown after Placeholder text,
            // so remove Placeholder until display is set back to grid
            if (child.type === components.Placeholder && cssDisplayFlex) return null;
        }
        return child;
    };
    var newInnerProps = (0, $105b4e425347a1bb$export$407448d2b89b1813)((0, $105b4e425347a1bb$export$407448d2b89b1813)({}, innerProps), {}, {
        style: (0, $105b4e425347a1bb$export$407448d2b89b1813)((0, $105b4e425347a1bb$export$407448d2b89b1813)({}, innerProps === null || innerProps === void 0 ? void 0 : innerProps.style), {}, {
            display: cssDisplayFlex ? "flex" : "grid"
        })
    });
    var newProps = (0, $105b4e425347a1bb$export$407448d2b89b1813)((0, $105b4e425347a1bb$export$407448d2b89b1813)({}, props), {}, {
        innerProps: newInnerProps,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).Children.toArray(children).map(childMapper)
    });
    return newProps;
};
var $30bb44caf3b98f87$var$_excluded = [
    "Input",
    "MultiValue",
    "Placeholder",
    "SingleValue",
    "ValueContainer"
];
var $30bb44caf3b98f87$var$makeAnimated = function makeAnimated() {
    var externalComponents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var components = (0, $105b4e425347a1bb$export$d66501df72047452)({
        components: externalComponents
    });
    var Input = components.Input, MultiValue = components.MultiValue, Placeholder = components.Placeholder, SingleValue = components.SingleValue, ValueContainer = components.ValueContainer, rest = (0, $295b61ec8f7276fc$export$2e2bcd8739ae039)(components, $30bb44caf3b98f87$var$_excluded);
    return (0, $105b4e425347a1bb$export$407448d2b89b1813)({
        Input: $30bb44caf3b98f87$var$AnimatedInput(Input),
        MultiValue: $30bb44caf3b98f87$var$AnimatedMultiValue(MultiValue),
        Placeholder: $30bb44caf3b98f87$var$AnimatedPlaceholder(Placeholder),
        SingleValue: $30bb44caf3b98f87$var$AnimatedSingleValue(SingleValue),
        ValueContainer: $30bb44caf3b98f87$var$AnimatedValueContainer(ValueContainer)
    }, rest);
};
var $30bb44caf3b98f87$var$AnimatedComponents = $30bb44caf3b98f87$var$makeAnimated();
var $30bb44caf3b98f87$export$f5b8910cec6cf069 = $30bb44caf3b98f87$var$AnimatedComponents.Input;
var $30bb44caf3b98f87$export$419cdf50db8b579 = $30bb44caf3b98f87$var$AnimatedComponents.MultiValue;
var $30bb44caf3b98f87$export$84712d0562a614b8 = $30bb44caf3b98f87$var$AnimatedComponents.Placeholder;
var $30bb44caf3b98f87$export$1949dac661ba6e3a = $30bb44caf3b98f87$var$AnimatedComponents.SingleValue;
var $30bb44caf3b98f87$export$4dc9f58ad9a1a000 = $30bb44caf3b98f87$var$AnimatedComponents.ValueContainer;
var $30bb44caf3b98f87$var$index = (0, $f5e0dace09547a05$export$2e2bcd8739ae039)($30bb44caf3b98f87$var$makeAnimated);
var $30bb44caf3b98f87$export$2e2bcd8739ae039 = $30bb44caf3b98f87$var$index;




const $3a0d1b0945cde333$var$vitaminOptions = [
    {
        value: "5-htp",
        label: "5-HTP"
    },
    {
        value: "apple-cider-vinegar",
        label: "Apple Cider Vinegar"
    },
    {
        value: "ashwagandha-extract",
        label: "Ashwagandha Extract"
    },
    {
        value: "beetroot-powder",
        label: "Beetroot"
    },
    {
        value: "beta-glucan",
        label: "Beta Glucan"
    },
    {
        value: "bpl1-ht",
        label: "BPL1\xae HT"
    },
    {
        value: "careflow-mango-powder",
        label: "Careflow\u2122 Mango Powder"
    },
    {
        value: "coq10",
        label: "CoQ10"
    },
    {
        value: "cordyceps",
        label: "Cordyceps"
    },
    {
        value: "folic-acid",
        label: "Folic Acid"
    },
    {
        value: "ginger-extract",
        label: "Ginger Extract"
    },
    {
        value: "ginseng",
        label: "Ginseng"
    },
    {
        value: "hydrocurc-pepperine",
        label: "HydroCurc\u2122 & Black Pepper Extract"
    },
    {
        value: "inositol",
        label: "Inositol"
    },
    {
        value: "inositol-2",
        label: "Inositol (second layer)",
        disabled: true
    },
    {
        value: "iodine",
        label: "Iodine"
    },
    {
        value: "iron",
        label: "Iron"
    },
    {
        value: "k2-vital-delta",
        label: "K2 Vital Delta\u2122"
    },
    {
        value: "lactospore-probiotic",
        label: "LactoSpore\xae Probiotic"
    },
    {
        value: "lutemax",
        label: "Lutemax"
    },
    {
        value: "lycopene",
        label: "Lycopene"
    },
    {
        value: "maca-powder",
        label: "Maca Powder"
    },
    {
        value: "milk-thistle-extract",
        label: "Milk Thistle Extract"
    },
    {
        value: "nourished-greens",
        label: "Nourished Greens"
    },
    {
        value: "resveratrol",
        label: "Resveratrol"
    },
    {
        value: "scutellup",
        label: "Scutell'Up"
    },
    {
        value: "selenium",
        label: "Selenium"
    },
    {
        value: "silica",
        label: "Silica"
    },
    {
        value: "tart-cherry",
        label: "Tart Cherry"
    },
    {
        value: "vegan-vitamin-d3",
        label: "Vegan Vitamin D3"
    },
    {
        value: "vegan-vitamin-d3-2",
        label: "Vegan Vitamin D3 (second layer)",
        disabled: true
    },
    {
        value: "vitamin-a",
        label: "Vitamin A"
    },
    {
        value: "b12",
        label: "Vitamin B12"
    },
    {
        value: "vitamin-c",
        label: "Vitamin C"
    },
    {
        value: "vitamin-e",
        label: "Vitamin E"
    },
    {
        value: "white-kidney-extract",
        label: "White Kidney Bean Extract"
    },
    {
        value: "zinc",
        label: "Zinc"
    }
];
var $3a0d1b0945cde333$export$2e2bcd8739ae039 = $3a0d1b0945cde333$var$vitaminOptions;


const $40daaaf0c6bad90c$var$customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        width: "90%",
        padding: "40px 20px",
        maxWidth: "500px",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        borderRadius: "10px"
    }
};
const $40daaaf0c6bad90c$var$closeButton = {
    width: "30px"
};
(0, (/*@__PURE__*/$parcel$interopDefault($c1e84079c9071642$exports))).setAppElement("#root");
const $40daaaf0c6bad90c$var$animatedComponents = (0, $30bb44caf3b98f87$export$2e2bcd8739ae039)();
const $40daaaf0c6bad90c$var$PageFive = (props)=>{
    const [modalIsOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).useState(false);
    const [maxVitamins, setMaxVitamins] = (0, $5zKJZ.useState)(0);
    const [flavoursHidden, setFlavoursHidden] = (0, $5zKJZ.useState)(true);
    let vitOptions = (0, $3a0d1b0945cde333$export$2e2bcd8739ae039);
    function openModal() {
        setIsOpen(true);
    }
    function closeModal() {
        setIsOpen(false);
    }
    function updateVitaminValues(vitamins) {
        // loop through vitamins and see if inositol or vegan-vitamin-d3 is selected
        // if so, update vitOptions by removing 'disabled: true' from inositol-2 vegan-vitamin-d3-2 respectively
        for(let i = 0; i < vitamins.length; i++){
            if (vitamins[i].value == "inositol") {
                for(let j = 0; j < vitOptions.length; j++)if (vitOptions[j].value == "inositol-2") vitOptions[j].disabled = false;
            }
            if (vitamins[i].value == "vegan-vitamin-d3") {
                for(let j = 0; j < vitOptions.length; j++)if (vitOptions[j].value == "vegan-vitamin-d3-2") vitOptions[j].disabled = false;
            }
        }
        setMaxVitamins(vitamins.length);
        props.setSelectedVitamins(vitamins);
        props.updateQuestionUrl(`selected-${vitamins.length}`);
    } // If the user is pregnant,
    // remove Vitamin A and 5-HTP as options for them to select
    if (props.natalAnswerIndex.length === 0 || props.natalAnswerIndex[0] === "No") ;
    else for(let i = 0; i < (0, $3a0d1b0945cde333$export$2e2bcd8739ae039).length; i++){
        if ((0, $3a0d1b0945cde333$export$2e2bcd8739ae039)[i].value == "vitamin-a") (0, $3a0d1b0945cde333$export$2e2bcd8739ae039).splice(i, 1);
        if ((0, $3a0d1b0945cde333$export$2e2bcd8739ae039)[i].value == "5-htp") (0, $3a0d1b0945cde333$export$2e2bcd8739ae039).splice(i, 1);
    }
     // If the user said yes to anti depressant medication,
    // remove 5-HTP option
    if (props.medicationAnswer === "yes") for(let i = 0; i < (0, $3a0d1b0945cde333$export$2e2bcd8739ae039).length; i++){
        if ((0, $3a0d1b0945cde333$export$2e2bcd8739ae039)[i].value == "5-htp") (0, $3a0d1b0945cde333$export$2e2bcd8739ae039).splice(i, 1);
        if ((0, $3a0d1b0945cde333$export$2e2bcd8739ae039)[i].value == "iodine") (0, $3a0d1b0945cde333$export$2e2bcd8739ae039).splice(i, 1);
    }
    const hidButton = ()=>{
        const button = document.querySelector(".show-more-flavours");
        button.style.display = "none";
    };
    const showMoreFlavours = ()=>{
        setFlavoursHidden(false);
        hidButton();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "kids-quiz__page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c1e84079c9071642$exports))), {
        isOpen: modalIsOpen,
        onRequestClose: closeModal,
        style: $40daaaf0c6bad90c$var$customStyles,
        contentLabel: "Antidepressant question explanation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "close-modal",
        onClick: closeModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$830dad7b282f77fd), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "modal-copy"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", null, "If you would like to guarantee specific nourishments are included in your personalised vitamin, we have given you the option to select them here."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", null, "Any nourishments you select will be treated as a priority. Our recommended blend will then make up the rest of your 7-layered vitamin, to ensure that your gummy stack is perfectly suited to your mind and body.")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "kids-quiz__question"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", {
        className: "question__title"
    }, "Are there any specific nourishments we should include in your stack? ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("span", {
        className: "open-modal-button",
        onClick: openModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$33b26d5f51359e1b), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d4d4787208c54054$export$2e2bcd8739ae039), {
        isMulti: true,
        className: "vitamin-selector",
        placeholder: "No, I'd like to see Nourished suggestions",
        components: $40daaaf0c6bad90c$var$animatedComponents,
        onChange: updateVitaminValues,
        options: vitOptions,
        isOptionDisabled: (option)=>option.disabled == true || maxVitamins > 6,
        defaultValue: props.selectedVitamins
    }), maxVitamins > 6 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", null, "Maximum number of layers selected") : ""), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("a", {
        href: "#goals",
        className: "question-divider question-divider--show"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$2baabfc57bf5919a), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        id: "goals",
        className: "kids-quiz__question"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", {
        className: "question__title"
    }, "Which of the below are your top two priorities in the upcoming months?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "answers-row--flex"
    }, props.renderGoalAnswers)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("a", {
        href: "#coating",
        className: `question-divider ${props.activeGoalsAnswer.length > 1 ? "question-divider--show" : ""}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$2baabfc57bf5919a), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        id: "coating",
        className: `kids-quiz__question ${props.activeGoalsAnswer.length > 1 ? "kids-quiz__question--show" : "kids-quiz__question--hidden"}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", {
        className: "question__title"
    }, "What flavour would you like on your stack?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "radio-answers answers-row--5 wide coating-options"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
        type: "radio",
        name: "flavour",
        id: "flavourStrawberry",
        value: "strawberry",
        onChange: props.selectFlavour,
        checked: props.flavour === "strawberry"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("label", {
        className: "answer-button answer-button__flavour answer-button__flavour--strawberry",
        htmlFor: "flavourStrawberry"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$e253430465890a3), null), "Strawberry"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
        type: "radio",
        name: "flavour",
        id: "flavourCola",
        value: "cola",
        onChange: props.selectFlavour,
        checked: props.flavour === "cola"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("label", {
        className: "answer-button answer-button__flavour answer-button__flavour--cola",
        htmlFor: "flavourCola"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$b7e6b5d1de1ef699), null), "Cola"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
        type: "radio",
        name: "flavour",
        id: "flavourCitrus",
        value: "citrus",
        onChange: props.selectFlavour,
        checked: props.flavour === "citrus"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("label", {
        className: "answer-button answer-button__flavour answer-button__flavour--citrus",
        htmlFor: "flavourCitrus"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$3d7c840e09ca691b), null), "Citrus"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
        type: "radio",
        name: "flavour",
        id: "flavourPineapple",
        value: "pineapple",
        onChange: props.selectFlavour,
        checked: props.flavour === "pineapple"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("label", {
        className: "answer-button answer-button__flavour answer-button__flavour--pineapple",
        htmlFor: "flavourPineapple"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$c95748fd3bdade58), null), "Pineapple"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
        type: "radio",
        name: "flavour",
        id: "flavourBlackcurrant",
        value: "blackcurrant",
        onChange: props.selectFlavour,
        checked: props.flavour === "blackcurrant"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("label", {
        className: `answer-button answer-button__flavour answer-button__flavour--blackcurrant ${flavoursHidden ? "answer-button__flavour--hidden" : ""}`,
        htmlFor: "flavourBlackcurrant"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$418b5b912aaff436), null), "Blackcurrant"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
        type: "radio",
        name: "flavour",
        id: "flavourOrange",
        value: "orange",
        onChange: props.selectFlavour,
        checked: props.flavour === "orange"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("label", {
        className: `answer-button answer-button__flavour answer-button__flavour--orange ${flavoursHidden ? "answer-button__flavour--hidden" : ""}`,
        htmlFor: "flavourOrange"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$a8e2843f0fe527f4), null), "Orange"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
        type: "radio",
        name: "flavour",
        id: "flavourPeach",
        value: "peach",
        onChange: props.selectFlavour,
        checked: props.flavour === "peach"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("label", {
        className: `answer-button answer-button__flavour answer-button__flavour--peach ${flavoursHidden ? "answer-button__flavour--hidden" : ""}`,
        htmlFor: "flavourPeach"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$d747a27c388f98fc), null), "Peach"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
        type: "radio",
        name: "flavour",
        id: "flavourOriginal",
        value: "original",
        onChange: props.selectFlavour,
        checked: props.flavour === "original"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("label", {
        className: `answer-button answer-button__flavour answer-button__flavour--original ${flavoursHidden ? "answer-button__flavour--hidden" : ""}`,
        htmlFor: "flavourOriginal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$631a1297e3dadc04), null), "Original"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
        type: "radio",
        name: "flavour",
        id: "flavourWatermelon",
        value: "watermelon",
        onChange: props.selectFlavour,
        checked: props.flavour === "watermelon"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("label", {
        className: `answer-button answer-button__flavour answer-button__flavour--watermelon ${flavoursHidden ? "answer-button__flavour--hidden" : ""}`,
        htmlFor: "flavourWatermelon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$1dcf734be4e793d), null), "Watermelon")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: `show-more-flavours`,
        onClick: showMoreFlavours
    }, "Show more flavour options ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$8775cfa3ec2fac83), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: `line-divider ${props.flavour ? "line-divider--show" : "line-divider--hidden"}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: `coating-answers radio-answers answers-row--2 kids-quiz__question ${props.flavour ? "kids-quiz__question--show" : "kids-quiz__question--hidden"}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
        type: "radio",
        name: "coating",
        id: "coatingSweet",
        value: "sweet",
        onChange: props.selectCoating,
        checked: props.coating === "sweet"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("label", {
        className: "answer-button",
        htmlFor: "coatingSweet"
    }, "Sweet"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
        type: "radio",
        name: "coating",
        id: "coatingSour",
        value: "sour",
        onChange: props.selectCoating,
        checked: props.coating === "sour"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("label", {
        className: "answer-button",
        htmlFor: "coatingSour"
    }, "Sour"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("a", {
        href: "#email",
        className: `question-divider ${props.coating ? "question-divider--show" : ""}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$2baabfc57bf5919a), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        id: "email",
        className: `kids-quiz__question ${props.coating ? "kids-quiz__question--show" : "kids-quiz__question--hidden"}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("label", null, "And finally, what is your email address?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
        onChange: (e)=>props.setEmail(e.target.value),
        placeholder: "Email address (optional)",
        value: props.email
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: "checkbox",
        onChange: ()=>props.setConsent(!props.consent)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("input", {
        id: "email",
        name: "consent",
        className: "checkbox__input",
        type: "checkbox",
        value: "email"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("label", {
        htmlFor: "email",
        className: "checkbox__label"
    }, "I agree to receive personalised email communications from Nourished based on my answers in this quiz"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        className: `next-page ${props.coating ? "next-page--show" : "next-page--hidden"}`,
        onClick: ()=>props.nextPage("5")
    }, "Get results"));
};
var $40daaaf0c6bad90c$export$2e2bcd8739ae039 = $40daaaf0c6bad90c$var$PageFive;







/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $0c9339751aa30afe$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $bf5753933d859b35$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $0c9339751aa30afe$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}


function $300ed6ce3f85a624$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function $300ed6ce3f85a624$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $300ed6ce3f85a624$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $300ed6ce3f85a624$var$replaceClassName(element.className && element.className.baseVal || "", className));
}



var $5zKJZ = parcelRequire("5zKJZ");


var $cdb09eb748d98e60$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $bf5753933d859b35$export$2e2bcd8739ae039)(node, c);
    });
};
var $cdb09eb748d98e60$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $300ed6ce3f85a624$export$2e2bcd8739ae039)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $cdb09eb748d98e60$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $50c188165e9b6e5f$export$2e2bcd8739ae039)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, "exit");
            _this.addClass(node, appearing ? "appear" : "enter", "base");
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? "appear" : "enter";
            _this.addClass(node, type, "active");
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? "appear" : "enter";
            _this.removeClasses(node, type);
            _this.addClass(node, type, "done");
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            _this.addClass(node, "exit", "base");
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, "exit", "active");
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, "exit");
            _this.addClass(node, "exit", "done");
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames("enter"), doneClassName = _this$getClassNames.doneClassName;
        if (type === "appear" && phase === "done" && doneClassName) className += " " + doneClassName;
         // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === "active") /* eslint-disable no-unused-expressions */ node && node.scrollTop;
        if (className) {
            this.appliedClasses[type][phase] = className;
            $cdb09eb748d98e60$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $cdb09eb748d98e60$var$removeClass(node, baseClassName);
        if (activeClassName) $cdb09eb748d98e60$var$removeClass(node, activeClassName);
        if (doneClassName) $cdb09eb748d98e60$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $f25ad4247afa2104$export$2e2bcd8739ae039)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $1fbc5359f8440395$export$2e2bcd8739ae039), (0, $936eae2ecd19c455$export$2e2bcd8739ae039)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).Component);
$cdb09eb748d98e60$var$CSSTransition.defaultProps = {
    classNames: ""
};
$cdb09eb748d98e60$var$CSSTransition.propTypes = {};
var $cdb09eb748d98e60$export$2e2bcd8739ae039 = $cdb09eb748d98e60$var$CSSTransition;


var $d7242149beef4c78$exports = {};

$parcel$export($d7242149beef4c78$exports, "extract", function () { return $d7242149beef4c78$export$f9380c9a627682d3; }, function (v) { return $d7242149beef4c78$export$f9380c9a627682d3 = v; });
$parcel$export($d7242149beef4c78$exports, "parse", function () { return $d7242149beef4c78$export$98e6a39c04603d36; }, function (v) { return $d7242149beef4c78$export$98e6a39c04603d36 = v; });
$parcel$export($d7242149beef4c78$exports, "stringify", function () { return $d7242149beef4c78$export$fac44ee5b035f737; }, function (v) { return $d7242149beef4c78$export$fac44ee5b035f737 = v; });
$parcel$export($d7242149beef4c78$exports, "parseUrl", function () { return $d7242149beef4c78$export$7a5253c0f62e0150; }, function (v) { return $d7242149beef4c78$export$7a5253c0f62e0150 = v; });
$parcel$export($d7242149beef4c78$exports, "stringifyUrl", function () { return $d7242149beef4c78$export$a8c1621ea79325d3; }, function (v) { return $d7242149beef4c78$export$a8c1621ea79325d3 = v; });
var $d7242149beef4c78$export$f9380c9a627682d3;
var $d7242149beef4c78$export$98e6a39c04603d36;
var $d7242149beef4c78$export$fac44ee5b035f737;
var $d7242149beef4c78$export$7a5253c0f62e0150;
var $d7242149beef4c78$export$a8c1621ea79325d3;
"use strict";
var $f49ee2982ebd355b$exports = {};
"use strict";
$f49ee2982ebd355b$exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);


var $f584c0059e36280a$exports = {};
"use strict";
var $f584c0059e36280a$var$token = "%[a-f0-9]{2}";
var $f584c0059e36280a$var$singleMatcher = new RegExp($f584c0059e36280a$var$token, "gi");
var $f584c0059e36280a$var$multiMatcher = new RegExp("(" + $f584c0059e36280a$var$token + ")+", "gi");
function $f584c0059e36280a$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return decodeURIComponent(components.join(""));
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $f584c0059e36280a$var$decodeComponents(left), $f584c0059e36280a$var$decodeComponents(right));
}
function $f584c0059e36280a$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($f584c0059e36280a$var$singleMatcher);
        for(var i = 1; i < tokens.length; i++){
            input = $f584c0059e36280a$var$decodeComponents(tokens, i).join("");
            tokens = input.match($f584c0059e36280a$var$singleMatcher);
        }
        return input;
    }
}
function $f584c0059e36280a$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        "%FE%FF": "\uFFFD\uFFFD",
        "%FF%FE": "\uFFFD\uFFFD"
    };
    var match = $f584c0059e36280a$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $f584c0059e36280a$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $f584c0059e36280a$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "\uFFFD";
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    }
    return input;
}
$f584c0059e36280a$exports = function(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        encodedURI = encodedURI.replace(/\+/g, " ");
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $f584c0059e36280a$var$customDecodeURIComponent(encodedURI);
    }
};


var $8ea5fa6b24c7e140$exports = {};
"use strict";
$8ea5fa6b24c7e140$exports = (string, separator)=>{
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (separator === "") return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};


function $d7242149beef4c78$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null) return result;
                    if (value === null) return [
                        ...result,
                        [
                            $d7242149beef4c78$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $d7242149beef4c78$var$encode(key, options),
                            "[",
                            $d7242149beef4c78$var$encode(index, options),
                            "]=",
                            $d7242149beef4c78$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null) return result;
                    if (value === null) return [
                        ...result,
                        [
                            $d7242149beef4c78$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $d7242149beef4c78$var$encode(key, options),
                            "[]=",
                            $d7242149beef4c78$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
            return (key)=>(result, value)=>{
                    if (value === null || value === undefined || value.length === 0) return result;
                    if (result.length === 0) return [
                        [
                            $d7242149beef4c78$var$encode(key, options),
                            "=",
                            $d7242149beef4c78$var$encode(value, options)
                        ].join("")
                    ];
                    return [
                        [
                            result,
                            $d7242149beef4c78$var$encode(value, options)
                        ].join(",")
                    ];
                };
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null) return result;
                    if (value === null) return [
                        ...result,
                        $d7242149beef4c78$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $d7242149beef4c78$var$encode(key, options),
                            "=",
                            $d7242149beef4c78$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $d7242149beef4c78$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.split("").indexOf(",") > -1;
                const newValue = isArray ? value.split(",") : value;
                accumulator[key] = newValue;
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $d7242149beef4c78$var$encode(value, options) {
    if (options.encode) return options.strict ? $f49ee2982ebd355b$exports(value) : encodeURIComponent(value);
    return value;
}
function $d7242149beef4c78$var$decode(value, options) {
    if (options.decode) return $f584c0059e36280a$exports(value);
    return value;
}
function $d7242149beef4c78$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $d7242149beef4c78$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $d7242149beef4c78$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $d7242149beef4c78$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $d7242149beef4c78$var$extract(input) {
    input = $d7242149beef4c78$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $d7242149beef4c78$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $d7242149beef4c78$var$parse(input, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    const formatter = $d7242149beef4c78$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof input !== "string") return ret;
    input = input.trim().replace(/^[?#&]/, "");
    if (!input) return ret;
    for (const param of input.split("&")){
        let [key, value] = $8ea5fa6b24c7e140$exports(options.decode ? param.replace(/\+/g, " ") : param, "=");
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : $d7242149beef4c78$var$decode(value, options);
        formatter($d7242149beef4c78$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === "object" && value !== null) for (const k of Object.keys(value))value[k] = $d7242149beef4c78$var$parseValue(value[k], options);
        else ret[key] = $d7242149beef4c78$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $d7242149beef4c78$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$d7242149beef4c78$export$f9380c9a627682d3 = $d7242149beef4c78$var$extract;
$d7242149beef4c78$export$98e6a39c04603d36 = $d7242149beef4c78$var$parse;
$d7242149beef4c78$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none"
    }, options);
    const formatter = $d7242149beef4c78$var$encoderForArrayFormat(options);
    const objectCopy = Object.assign({}, object);
    if (options.skipNull) {
        for (const key of Object.keys(objectCopy))if (objectCopy[key] === undefined || objectCopy[key] === null) delete objectCopy[key];
    }
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $d7242149beef4c78$var$encode(key, options);
        if (Array.isArray(value)) return value.reduce(formatter(key), []).join("&");
        return $d7242149beef4c78$var$encode(key, options) + "=" + $d7242149beef4c78$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
};
$d7242149beef4c78$export$7a5253c0f62e0150 = (input, options)=>{
    return {
        url: $d7242149beef4c78$var$removeHash(input).split("?")[0] || "",
        query: $d7242149beef4c78$var$parse($d7242149beef4c78$var$extract(input), options)
    };
};
$d7242149beef4c78$export$a8c1621ea79325d3 = (input, options)=>{
    const url = $d7242149beef4c78$var$removeHash(input.url).split("?")[0] || "";
    const queryFromUrl = $d7242149beef4c78$export$f9380c9a627682d3(input.url);
    const parsedQueryFromUrl = $d7242149beef4c78$export$98e6a39c04603d36(queryFromUrl);
    const hash = $d7242149beef4c78$var$getHash(input.url);
    const query = Object.assign(parsedQueryFromUrl, input.query);
    let queryString = $d7242149beef4c78$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    return `${url}${queryString}${hash}`;
};


const $f85291adedab9e91$var$apiQuiz = "https://app.get-nourished.com/api/klaviyo/quiz--uk";
const $f85291adedab9e91$var$CoreQuiz = ()=>{
    const [pageIndex, setPageIndex] = (0, $5zKJZ.useState)(0);
    const [firstName, setFirstName] = (0, $5zKJZ.useState)("");
    const [gender, setGender] = (0, $5zKJZ.useState)("");
    const [age, setAge] = (0, $5zKJZ.useState)("");
    const [race, setRace] = (0, $5zKJZ.useState)("");
    const [suitableAge, setSuitableAge] = (0, $5zKJZ.useState)(true);
    const [weightingAnswers, setWeightingsAnswers] = (0, $5zKJZ.useState)([]);
    const [activeGoalsAnswer, setActiveGoalsAnswer] = (0, $5zKJZ.useState)([]);
    const [exerciseAnswersIndex, setExerciseAnswersIndex] = (0, $5zKJZ.useState)([]);
    const [travelAnswersIndex, setTravelAnswersIndex] = (0, $5zKJZ.useState)([]);
    const [specificDiet, setSpecificDiet] = (0, $5zKJZ.useState)("");
    const [dietAnswersIndex, setDietAnswersIndex] = (0, $5zKJZ.useState)([]);
    const [hungryBetweenMeals, setHungryBetweenMeals] = (0, $5zKJZ.useState)("");
    const [processedFoodAnswer, setProcessedFoodAnswer] = (0, $5zKJZ.useState)("");
    const [fruitVegAnswer, setFruitVegAnswer] = (0, $5zKJZ.useState)("");
    const [alcoholAnswersIndex, setAlcoholAnswersIndex] = (0, $5zKJZ.useState)([]);
    const [glassesAnswer, setGlassesAnswer] = (0, $5zKJZ.useState)("");
    const [iodineAnswer, setIodineAnswer] = (0, $5zKJZ.useState)("");
    const [medicationAnswer, setMedicationAnswer] = (0, $5zKJZ.useState)("");
    const [vitaminsAnswer, setVitaminsAnswer] = (0, $5zKJZ.useState)("");
    const [energySliderValue, setEnergySliderValue] = (0, $5zKJZ.useState)(50);
    const [activitySliderValue, setActivitySliderValue] = (0, $5zKJZ.useState)(50);
    const [sleepSliderValue, setSleepSliderValue] = (0, $5zKJZ.useState)(50);
    const [screenSliderValue, setScreenSliderValue] = (0, $5zKJZ.useState)(50);
    const [conditionsAnswerIndex, setConditionsAnswerIndex] = (0, $5zKJZ.useState)([]);
    const [conditionsEffectSlider, setConditionsEffectSlider] = (0, $5zKJZ.useState)(50);
    const [manageConditionsAnswerIndex, setManageConditionsAnswerIndex] = (0, $5zKJZ.useState)([]);
    const [natalAnswerIndex, setNatalAnswerIndex] = (0, $5zKJZ.useState)([]);
    const [selectedVitamins, setSelectedVitamins] = (0, $5zKJZ.useState)([]);
    const [flavour, setFlavour] = (0, $5zKJZ.useState)("");
    const [coating, setCoating] = (0, $5zKJZ.useState)("");
    const [email, setEmail] = (0, $5zKJZ.useState)("");
    const [consent, setConsent] = (0, $5zKJZ.useState)(false);
    const [questionGA, setQuestionGA] = (0, $5zKJZ.useState)("");
    const [quizID, setQuizID] = (0, $5zKJZ.useState)("");
    (0, $5zKJZ.useEffect)(()=>{
        const currentUrl = window.location.href;
        const activeStepUrl = (0, (/*@__PURE__*/$parcel$interopDefault($d7242149beef4c78$exports))).stringifyUrl({
            url: currentUrl,
            query: {
                page: `${pageIndex}`
            }
        });
        if (typeof ga !== "undefined") {
            history.replaceState({}, null, activeStepUrl);
            ga("send", "pageview", location.href);
        }
    }, [
        pageIndex
    ]);
    const updateQuestionUrl = (value)=>{
        const currentUrl = window.location.href;
        const activeStepUrl = (0, (/*@__PURE__*/$parcel$interopDefault($d7242149beef4c78$exports))).stringifyUrl({
            url: currentUrl,
            query: {
                page: `${pageIndex}-${value}`
            }
        });
        if (value !== questionGA && typeof ga !== "undefined") {
            history.replaceState({}, null, activeStepUrl);
            ga("send", "pageview", location.href);
        }
        setQuestionGA(value);
    };
    const updateFirstName = (answer)=>{
        setFirstName(answer);
        updateQuestionUrl("first-name");
    };
    const genderAnswers = [
        {
            "name": "gender",
            "label": "Male",
            "value": "male"
        },
        {
            "name": "gender",
            "label": "Female",
            "value": "female"
        },
        {
            "name": "gender",
            "label": "Non-binary",
            "value": "NonBinary"
        },
        {
            "name": "gender",
            "label": "Prefer not to say",
            "value": "opt-out"
        }
    ];
    const raceAnswers = [
        {
            "name": "race",
            "label": "White",
            "value": "white"
        },
        {
            "name": "race",
            "label": "Mixed",
            "value": "mixed"
        },
        {
            "name": "race",
            "label": "Asian",
            "value": "asain"
        },
        {
            "name": "race",
            "label": "Black, African, Caribbean",
            "value": "blackAfricanCaribbean"
        },
        {
            "name": "race",
            "label": "Other",
            "value": "other"
        }
    ];
    const exerciseQuestion = {
        "answers": [
            {
                "label": "Running or cardio",
                "questionId": "exercise",
                "products": [
                    {
                        "b12": 5000
                    },
                    {
                        "beetroot-powder": 2000
                    },
                    {
                        "cordyceps": 5000
                    },
                    {
                        "hydrocurc-pepperine": 5000
                    },
                    {
                        "k2-vital-delta": 2500
                    },
                    {
                        "maca-powder": 1000
                    },
                    {
                        "silica": 5000
                    },
                    {
                        "tart-cherry": 99999
                    }
                ]
            },
            {
                "label": "Weights",
                "questionId": "exercise",
                "products": [
                    {
                        "b12": 5000
                    },
                    {
                        "beetroot-powder": 2000
                    },
                    {
                        "cordyceps": 2000
                    },
                    {
                        "hydrocurc-pepperine": 5000
                    },
                    {
                        "k2-vital-delta": 2500
                    },
                    {
                        "maca-powder": 2500
                    },
                    {
                        "silica": 9999
                    },
                    {
                        "tart-cherry": 99999
                    }
                ]
            },
            {
                "label": "Classes",
                "questionId": "exercise",
                "products": [
                    {
                        "b12": 5000
                    },
                    {
                        "beetroot-powder": 3000
                    },
                    {
                        "cordyceps": 5000
                    },
                    {
                        "hydrocurc-pepperine": 2500
                    },
                    {
                        "k2-vital-delta": 2500
                    },
                    {
                        "maca-powder": 2500
                    },
                    {
                        "silica": 2000
                    },
                    {
                        "tart-cherry": 5000
                    }
                ]
            },
            {
                "label": "Organised sports",
                "questionId": "exercise",
                "products": [
                    {
                        "b12": 5000
                    },
                    {
                        "beetroot-powder": 4000
                    },
                    {
                        "cordyceps": 5000
                    },
                    {
                        "hydrocurc-pepperine": 5000
                    },
                    {
                        "k2-vital-delta": 2500
                    },
                    {
                        "maca-powder": 5000
                    },
                    {
                        "silica": 2000
                    },
                    {
                        "tart-cherry": 99999
                    }
                ]
            },
            {
                "label": "Crossfit",
                "questionId": "exercise",
                "products": [
                    {
                        "b12": 5000
                    },
                    {
                        "beetroot-powder": 5000
                    },
                    {
                        "cordyceps": 5000
                    },
                    {
                        "hydrocurc-pepperine": 5000
                    },
                    {
                        "k2-vital-delta": 2500
                    },
                    {
                        "maca-powder": 5000
                    },
                    {
                        "silica": 5000
                    },
                    {
                        "tart-cherry": 5000
                    }
                ]
            },
            {
                "label": "Boxing",
                "questionId": "exercise",
                "products": [
                    {
                        "b12": 5000
                    },
                    {
                        "beetroot-powder": 6000
                    },
                    {
                        "cordyceps": 5000
                    },
                    {
                        "hydrocurc-pepperine": 5000
                    },
                    {
                        "k2-vital-delta": 2500
                    },
                    {
                        "maca-powder": 5000
                    },
                    {
                        "silica": 5000
                    },
                    {
                        "tart-cherry": 99999
                    }
                ]
            },
            {
                "label": "Walking",
                "questionId": "exercise",
                "products": [
                    {
                        "b12": 5000
                    },
                    {
                        "beetroot-powder": 2000
                    },
                    {
                        "cordyceps": 5000
                    },
                    {
                        "k2-vital-delta": 2500
                    },
                    {
                        "silica": 5000
                    },
                    {
                        "tart-cherry": 5000
                    }
                ]
            },
            {
                "label": "Other",
                "questionId": "exercise"
            },
            {
                "label": "None",
                "questionId": "exercise"
            }
        ]
    };
    const travelQuestion = {
        "answers": [
            {
                "label": "Never",
                "questionId": "travel",
                "products": [
                    {
                        "lactospore-probiotic": 1000
                    }
                ]
            },
            {
                "label": "1-2 times a year",
                "questionId": "travel",
                "products": [
                    {
                        "lactospore-probiotic": 2000
                    }
                ]
            },
            {
                "label": "2-5 times a year",
                "questionId": "travel",
                "products": [
                    {
                        "ashwagandha-extract": 2500
                    },
                    {
                        "beta-glucan": 5000
                    },
                    {
                        "hydrocurc-pepperine": 5000
                    },
                    {
                        "lactospore-probiotic": 3000
                    }
                ]
            },
            {
                "label": "5-10 times a year",
                "questionId": "travel",
                "products": [
                    {
                        "ashwagandha-extract": 5000
                    },
                    {
                        "beta-glucan": 9999
                    },
                    {
                        "ginger-extract": 4500
                    },
                    {
                        "hydrocurc-pepperine": 7500
                    },
                    {
                        "lycopene": 2000
                    },
                    {
                        "lactospore-probiotic": 5000
                    },
                    {
                        "resveratrol": 5000
                    },
                    {
                        "tart-cherry": 5000
                    }
                ]
            },
            {
                "label": "10 or more times a year",
                "questionId": "travel",
                "products": [
                    {
                        "ashwagandha-extract": 8000
                    },
                    {
                        "b12": 99999
                    },
                    {
                        "beta-glucan": 99999
                    },
                    {
                        "ginger-extract": 9999
                    },
                    {
                        "hydrocurc-pepperine": 9999
                    },
                    {
                        "lycopene": 3000
                    },
                    {
                        "lactospore-probiotic": 9998
                    },
                    {
                        "resveratrol": 9999
                    },
                    {
                        "tart-cherry": 9999
                    }
                ]
            }
        ]
    };
    const alcoholQuestion = {
        "answers": [
            {
                "label": "Never",
                "questionId": "alcohol"
            },
            {
                "label": "Rarely",
                "questionId": "alcohol"
            },
            {
                "label": "Once or twice a month",
                "questionId": "alcohol",
                "products": [
                    {
                        "milk-thistle-extract": 2500
                    },
                    {
                        "vitamin-a": 2500
                    }
                ]
            },
            {
                "label": "Once or twice a week",
                "questionId": "alcohol",
                "products": [
                    {
                        "k2-vital-delta": 1000
                    },
                    {
                        "milk-thistle-extract": 5000
                    },
                    {
                        "vitamin-a": 5000
                    },
                    {
                        "apple-cider-vinegar": 2500
                    }
                ]
            },
            {
                "label": "Most nights",
                "questionId": "alcohol",
                "products": [
                    {
                        "ginger-extract": 5000
                    },
                    {
                        "hydrocurc-pepperine": 7000
                    },
                    {
                        "k2-vital-delta": 2000
                    },
                    {
                        "milk-thistle-extract": 9999
                    },
                    {
                        "lactospore-probiotic": 5000
                    },
                    {
                        "vitamin-a": 9999
                    },
                    {
                        "apple-cider-vinegar": 5000
                    }
                ]
            }
        ]
    };
    const goalsQuestion = {
        "question": `What would you say is the number one goal for ${firstName}'s health for the next 3 months?`,
        "answers": [
            {
                "label": "Lose weight or tone up",
                "icon": "weight",
                "questionId": "goals",
                "products": [
                    {
                        "inositol": 9999
                    },
                    {
                        "bpl1-ht": 99999
                    },
                    {
                        "b12": 99999
                    },
                    {
                        "careflow-mango-powder": 9999
                    },
                    {
                        "folic-acid": 5000
                    },
                    {
                        "white-kidney-extract": 99999
                    },
                    {
                        "apple-cider-vinegar": 99999
                    }
                ]
            },
            {
                "label": "More energy",
                "icon": "energy",
                "questionId": "goals",
                "products": [
                    {
                        "b12": 99999
                    },
                    {
                        "beetroot-powder": 5000
                    },
                    {
                        "coq10": 5000
                    },
                    {
                        "cordyceps": 7000
                    },
                    {
                        "folic-acid": 5000
                    },
                    {
                        "ginseng": 9999
                    },
                    {
                        "iron": 5000
                    },
                    {
                        "maca-powder": 9999
                    },
                    {
                        "tart-cherry": 99999
                    },
                    {
                        "vitamin-c": 99999
                    },
                    {
                        "iodine": 9999
                    }
                ]
            },
            {
                "label": "Better immunity",
                "icon": "immunity",
                "questionId": "goals",
                "products": [
                    {
                        "b12": 50000
                    },
                    {
                        "beta-glucan": 9999
                    },
                    {
                        "folic-acid": 9999
                    },
                    {
                        "ginger-extract": 2500
                    },
                    {
                        "iron": 5000
                    },
                    {
                        "lycopene": 5000
                    },
                    {
                        "lactospore-probiotic": 9999
                    },
                    {
                        "vegan-vitamin-d3": 9999
                    },
                    {
                        "vitamin-a": 9999
                    },
                    {
                        "vitamin-c": 9999
                    },
                    {
                        "zinc": 9999
                    }
                ]
            },
            {
                "label": "Better focus & memory",
                "icon": "focus",
                "questionId": "goals",
                "products": [
                    {
                        "ashwagandha-extract": 7000
                    },
                    {
                        "5-htp": 2500
                    },
                    {
                        "b12": 50000
                    },
                    {
                        "coq10": 7000
                    },
                    {
                        "folic-acid": 2500
                    },
                    {
                        "ginseng": 5000
                    },
                    {
                        "iron": 9999
                    },
                    {
                        "maca-powder": 2500
                    },
                    {
                        "milk-thistle-extract": 1000
                    },
                    {
                        "resveratrol": 5000
                    },
                    {
                        "zinc": 99999
                    },
                    {
                        "iodine": 9999
                    },
                    {
                        "vitamin-a": 99999
                    }
                ]
            },
            {
                "label": "Improve skin",
                "icon": "face",
                "questionId": "goals",
                "products": [
                    {
                        "coq10": 2500
                    },
                    {
                        "lycopene": 5000
                    },
                    {
                        "resveratrol": 9999
                    },
                    {
                        "selenium": 9999
                    },
                    {
                        "silica": 99999
                    },
                    {
                        "vitamin-c": 99999
                    },
                    {
                        "vitamin-e": 7500
                    },
                    {
                        "zinc": 9999
                    },
                    {
                        "iodine": 5000
                    },
                    {
                        "vitamin-a": 9999
                    }
                ]
            },
            {
                "label": "Healthier hair & nails",
                "icon": "improveHair",
                "questionId": "goals",
                "products": [
                    {
                        "coq10": 9999
                    },
                    {
                        "folic-acid": 7500
                    },
                    {
                        "lycopene": 5000
                    },
                    {
                        "selenium": 9999
                    },
                    {
                        "silica": 99999
                    },
                    {
                        "vitamin-c": 2500
                    },
                    {
                        "iodine": 9999
                    },
                    {
                        "vitamin-a": 9999
                    }
                ]
            },
            {
                "label": "Tackle excess hair",
                "icon": "excessHair",
                "questionId": "goals",
                "products": [
                    {
                        "inositol": 9999999
                    },
                    {
                        "coq10": 9999
                    },
                    {
                        "vegan-vitamin-d3": 99999
                    },
                    {
                        "zinc": 99999
                    }
                ]
            },
            {
                "label": "Menstrual cycle health",
                "icon": "periodHealth",
                "questionId": "goals",
                "nonMale": true,
                "products": [
                    {
                        "inositol": 99999
                    }
                ]
            },
            {
                "label": "Reduce hot flashes & sweating",
                "icon": "hotFlash",
                "questionId": "goals",
                "products": [
                    {
                        "ginseng": 99999
                    },
                    {
                        "milk-thistle-extract": 99999
                    }
                ]
            },
            {
                "label": "Gut health & digestion",
                "icon": "gut",
                "questionId": "goals",
                "products": [
                    {
                        "ginger-extract": 9999
                    },
                    {
                        "k2-vital-delta": 5000
                    },
                    {
                        "lactospore-probiotic": 99999
                    },
                    {
                        "vegan-vitamin-d3": 5000
                    },
                    {
                        "apple-cider-vinegar": 99999
                    }
                ]
            },
            {
                "label": "Increase libido / sexual health",
                "icon": "sexualHealth",
                "questionId": "goals",
                "products": [
                    {
                        "ashwagandha-extract": 5000
                    },
                    {
                        "lycopene": 5000
                    },
                    {
                        "maca-powder": 99999
                    },
                    {
                        "vegan-vitamin-d3": 5000
                    },
                    {
                        "zinc": 999999
                    }
                ]
            },
            {
                "label": "Improve sleep quality",
                "icon": "sleep",
                "questionId": "goals",
                "products": [
                    {
                        "inositol": 5000
                    },
                    {
                        "ashwagandha-extract": 9999
                    },
                    {
                        "5-htp": 9999
                    },
                    {
                        "selenium": 99999
                    },
                    {
                        "tart-cherry": 99999
                    }
                ]
            },
            {
                "label": "Bone & joint health",
                "icon": "bone",
                "questionId": "goals",
                "products": [
                    {
                        "k2-vital-delta": 9999
                    },
                    {
                        "lycopene": 5000
                    },
                    {
                        "milk-thistle-extract": 9999
                    },
                    {
                        "resveratrol": 99999
                    },
                    {
                        "selenium": 9999
                    },
                    {
                        "vegan-vitamin-d3": 9999
                    },
                    {
                        "vitamin-c": 9999
                    },
                    {
                        "zinc": 9999
                    }
                ]
            },
            {
                "label": "Better stress management & mental wellbeing",
                "icon": "smile",
                "questionId": "goals",
                "products": [
                    {
                        "inositol": 6000
                    },
                    {
                        "ashwagandha-extract": 9999
                    },
                    {
                        "5-htp": 9999
                    },
                    {
                        "b12": 99999
                    },
                    {
                        "coq10": 7500
                    },
                    {
                        "folic-acid": 9999
                    },
                    {
                        "hydrocurc-pepperine": 5000
                    },
                    {
                        "lycopene": 5000
                    },
                    {
                        "lactospore-probiotic": 5000
                    },
                    {
                        "maca-powder": 2500
                    },
                    {
                        "vegan-vitamin-d3": 5000
                    },
                    {
                        "zinc": 99999
                    },
                    {
                        "iodine": 5000
                    }
                ]
            },
            {
                "label": "Delay signs of aging",
                "icon": "aging",
                "questionId": "goals",
                "products": [
                    {
                        "b12": 5000
                    },
                    {
                        "coq10": 6000
                    },
                    {
                        "folic-acid": 5000
                    },
                    {
                        "ginger-extract": 6000
                    },
                    {
                        "lycopene": 5000
                    },
                    {
                        "milk-thistle-extract": 1000
                    },
                    {
                        "resveratrol": 99999
                    },
                    {
                        "selenium": 9999
                    },
                    {
                        "silica": 99999
                    },
                    {
                        "tart-cherry": 5000
                    },
                    {
                        "vegan-vitamin-d3": 3500
                    },
                    {
                        "vitamin-c": 9999
                    },
                    {
                        "vitamin-e": 9999
                    },
                    {
                        "zinc": 9999
                    }
                ]
            },
            {
                "label": "Cardiovascular health",
                "icon": "heart",
                "questionId": "goals",
                "products": [
                    {
                        "b12": 9999
                    },
                    {
                        "careflow-mango-powder": 9999
                    },
                    {
                        "coq10": 9999
                    },
                    {
                        "cordyceps": 5000
                    },
                    {
                        "folic-acid": 5500
                    },
                    {
                        "ginger-extract": 4500
                    },
                    {
                        "iron": 9999
                    },
                    {
                        "k2-vital-delta": 9999
                    },
                    {
                        "lycopene": 5000
                    },
                    {
                        "nourished-greens": 5000
                    },
                    {
                        "selenium": 2500
                    },
                    {
                        "tart-cherry": 99999
                    },
                    {
                        "vitamin-c": 9999
                    }
                ]
            },
            {
                "label": "Improve performance, endurance & recovery",
                "icon": "shoe",
                "questionId": "goals",
                "products": [
                    {
                        "ashwagandha-extract": 2500
                    },
                    {
                        "b12": 9999
                    },
                    {
                        "beetroot-powder": 9999
                    },
                    {
                        "cordyceps": 9999
                    },
                    {
                        "ginger-extract": 5000
                    },
                    {
                        "ginseng": 9999
                    },
                    {
                        "hydrocurc-pepperine": 9999
                    },
                    {
                        "iron": 5000
                    },
                    {
                        "maca-powder": 2500
                    },
                    {
                        "tart-cherry": 99999
                    }
                ]
            }
        ]
    };
    const dietsQuestion = {
        "question": "Which diet?",
        "subText": "Either by choice or becuase of allergies",
        "answers": [
            {
                "label": "Low carb",
                "questionId": "diet"
            },
            {
                "label": "Low fat",
                "questionId": "diet"
            },
            {
                "label": "Vegetarian",
                "questionId": "diet",
                "products": [
                    {
                        "b12": 99999
                    },
                    {
                        "folic-acid": 99999
                    },
                    {
                        "iron": 9998
                    },
                    {
                        "vegan-vitamin-d3": 9999
                    },
                    {
                        "zinc": 7000
                    }
                ]
            },
            {
                "label": "Vegan",
                "questionId": "diet",
                "products": [
                    {
                        "b12": 99999
                    },
                    {
                        "folic-acid": 99999
                    },
                    {
                        "iron": 5000
                    },
                    {
                        "lactospore-probiotic": 5000
                    },
                    {
                        "vegan-vitamin-d3": 5000
                    },
                    {
                        "zinc": 9000
                    }
                ]
            },
            {
                "label": "Pescatarian",
                "questionId": "diet",
                "products": [
                    {
                        "iron": 3500
                    },
                    {
                        "vegan-vitamin-d3": 2500
                    },
                    {
                        "zinc": 5000
                    }
                ]
            },
            {
                "label": "Dairy free",
                "questionId": "diet"
            },
            {
                "label": "Gluten free",
                "questionId": "diet"
            },
            {
                "label": "Nut free",
                "questionId": "diet"
            },
            {
                "label": "Reducetarian",
                "questionId": "diet",
                "products": [
                    {
                        "nourished-greens": 5000
                    }
                ]
            }
        ]
    };
    const conditionsQuestion = {
        "question": "Does your child suffer from any of the below?",
        "answers": [
            {
                "label": "Long Covid",
                "questionId": "conditions",
                "products": [
                    {
                        "vitamin-c": 999999999999999
                    },
                    {
                        "vegan-vitamin-d3": 999999999999999
                    },
                    {
                        "zinc": 999999999999999
                    },
                    {
                        "coq10": 999999999999999
                    },
                    {
                        "lactospore-probiotic": 999999999999999
                    },
                    {
                        "b12": 999999999999999
                    },
                    {
                        "vitamin-a": 999999999999999
                    }
                ]
            },
            {
                "label": "PCOS",
                "questionId": "conditions",
                "nonMale": true,
                "products": [
                    {
                        "inositol": 999999
                    },
                    {
                        "coq10": 9999
                    },
                    {
                        "vegan-vitamin-d3": 99999
                    },
                    {
                        "zinc": 9999
                    }
                ]
            },
            {
                "label": "Hypothyroidism",
                "questionId": "conditions",
                "products": [
                    {
                        "iodine": 1000000
                    }
                ]
            },
            {
                "label": "Hyperthyroidism",
                "questionId": "conditions"
            },
            {
                "label": "Endometriosis",
                "questionId": "conditions",
                "nonMale": true
            },
            {
                "label": "Period concerns (PMS/PMDD)",
                "questionId": "conditions",
                "nonMale": true
            },
            {
                "label": "ADHD",
                "questionId": "conditions",
                "products": [
                    {
                        "b12": 7500
                    },
                    {
                        "coq10": 2500
                    },
                    {
                        "vegan-vitamin-d3": 5000
                    },
                    {
                        "vitamin-a": 2500
                    },
                    {
                        "vitamin-c": 2500
                    },
                    {
                        "vitamin-e": 2500
                    },
                    {
                        "zinc": 2500
                    }
                ]
            },
            {
                "label": "Asthma",
                "questionId": "conditions",
                "products": [
                    {
                        "b12": 5000
                    },
                    {
                        "beta-glucan": 99999
                    },
                    {
                        "folic-acid": 500
                    },
                    {
                        "ginger-extract": 2500
                    },
                    {
                        "hydrocurc-pepperine": 2500
                    },
                    {
                        "selenium": 5000
                    },
                    {
                        "vitamin-c": 5000
                    }
                ]
            },
            {
                "label": "Coeliac disease",
                "questionId": "conditions",
                "products": [
                    {
                        "b12": 9999
                    },
                    {
                        "hydrocurc-pepperine": 9999
                    },
                    {
                        "lactospore-probiotic": 9999
                    }
                ]
            },
            {
                "label": "Depression",
                "questionId": "conditions",
                "products": [
                    {
                        "ashwagandha-extract": 2500
                    },
                    {
                        "5-htp": 9999
                    },
                    {
                        "b12": 99999
                    },
                    {
                        "hydrocurc-pepperine": 5000
                    },
                    {
                        "vegan-vitamin-d3": 5000
                    },
                    {
                        "vitamin-c": 2000
                    },
                    {
                        "zinc": 2500
                    },
                    {
                        "iodine": 5000
                    }
                ]
            },
            {
                "label": "Diabetes",
                "questionId": "conditions",
                "products": [
                    {
                        "iodine": 5000
                    }
                ]
            },
            {
                "label": "Frequent colds or flus",
                "questionId": "conditions",
                "products": [
                    {
                        "lactospore-probiotic": 9998
                    },
                    {
                        "vegan-vitamin-d3": 2500
                    },
                    {
                        "vitamin-a": 2500
                    },
                    {
                        "vitamin-c": 2500
                    },
                    {
                        "vitamin-e": 2500
                    },
                    {
                        "zinc": 2500
                    }
                ]
            },
            {
                "label": "Hayfever & seasonal allergies",
                "questionId": "conditions",
                "products": [
                    {
                        "beta-glucan": 9999
                    },
                    {
                        "b12": 9999
                    },
                    {
                        "ginger-extract": 2500
                    },
                    {
                        "hydrocurc-pepperine": 2500
                    },
                    {
                        "lactospore-probiotic": 5000
                    },
                    {
                        "selenium": 5000
                    },
                    {
                        "vegan-vitamin-d3": 2500
                    },
                    {
                        "vitamin-a": 2500
                    },
                    {
                        "vitamin-c": 2500
                    },
                    {
                        "vitamin-e": 2500
                    }
                ]
            },
            {
                "label": "High blood pressure",
                "questionId": "conditions",
                "products": [
                    {
                        "beetroot-powder": 9999
                    },
                    {
                        "beta-glucan": 99999
                    },
                    {
                        "careflow-mango-powder": 9999
                    },
                    {
                        "coq10": 5000
                    },
                    {
                        "k2-vital-delta": 9999
                    },
                    {
                        "resveratrol": 2500
                    },
                    {
                        "lycopene": 5000
                    },
                    {
                        "selenium": 8000
                    },
                    {
                        "tart-cherry": 5000
                    },
                    {
                        "vegan-vitamin-d3": 5000
                    },
                    {
                        "vitamin-c": 2500
                    }
                ]
            },
            {
                "label": "High cholestrol",
                "questionId": "conditions",
                "products": [
                    {
                        "ashwagandha-extract": 9999
                    },
                    {
                        "beetroot-powder": 9999
                    },
                    {
                        "careflow-mango-powder": 5000
                    },
                    {
                        "coq10": 5000
                    },
                    {
                        "k2-vital-delta": 5000
                    },
                    {
                        "lycopene": 5000
                    },
                    {
                        "selenium": 7000
                    }
                ]
            },
            {
                "label": "Hypertension",
                "questionId": "conditions",
                "products": [
                    {
                        "beta-glucan": 99999
                    },
                    {
                        "careflow-mango-powder": 5000
                    },
                    {
                        "coq10": 5000
                    },
                    {
                        "k2-vital-delta": 9999
                    },
                    {
                        "lycopene": 5000
                    },
                    {
                        "resveratrol": 2500
                    },
                    {
                        "selenium": 5000
                    },
                    {
                        "silica": 1000
                    },
                    {
                        "tart-cherry": 99999
                    },
                    {
                        "vitamin-c": 2500
                    }
                ]
            },
            {
                "label": "IBS",
                "questionId": "conditions",
                "products": [
                    {
                        "bpl1-ht": 5000
                    },
                    {
                        "hydrocurc-pepperine": 9999
                    },
                    {
                        "lactospore-probiotic": 9999
                    }
                ]
            },
            {
                "label": "Low libido",
                "questionId": "conditions",
                "products": [
                    {
                        "ashwagandha-extract": 5000
                    },
                    {
                        "5-htp": 9999
                    },
                    {
                        "lycopene": 2500
                    },
                    {
                        "maca-powder": 9999
                    },
                    {
                        "vegan-vitamin-d3": 1500
                    },
                    {
                        "vitamin-a": 1500
                    },
                    {
                        "vitamin-c": 1500
                    },
                    {
                        "vitamin-e": 1500
                    },
                    {
                        "zinc": 1500
                    }
                ]
            },
            {
                "label": "Menopause or pre-menopause",
                "questionId": "conditions",
                "nonMale": true,
                "products": [
                    {
                        "b12": 9999
                    },
                    {
                        "folic-acid": 99999
                    },
                    {
                        "ginseng": 99999
                    },
                    {
                        "milk-thistle-extract": 99999
                    }
                ]
            },
            {
                "label": "Migraines",
                "questionId": "conditions",
                "products": [
                    {
                        "5-htp": 5000
                    },
                    {
                        "coq10": 99999
                    }
                ]
            },
            {
                "label": "Obesity",
                "questionId": "conditions",
                "products": [
                    {
                        "bpl1-ht": 99999
                    },
                    {
                        "5-htp": 5000
                    },
                    {
                        "careflow-mango-powder": 9999
                    },
                    {
                        "hydrocurc-pepperine": 2500
                    },
                    {
                        "tart-cherry": 9999
                    },
                    {
                        "white-kidney-extract": 9999
                    },
                    {
                        "apple-cider-vinegar": 9999
                    }
                ]
            },
            {
                "label": "Osteoporosis",
                "questionId": "conditions",
                "products": [
                    {
                        "k2-vital-delta": 1000
                    },
                    {
                        "lycopene": 5000
                    },
                    {
                        "milk-thistle-extract": 2500
                    },
                    {
                        "silica": 9999
                    },
                    {
                        "vegan-vitamin-d3": 5000
                    },
                    {
                        "vitamin-a": 2500
                    },
                    {
                        "vitamin-c": 2500
                    },
                    {
                        "vitamin-e": 5000
                    }
                ]
            },
            {
                "label": "No",
                "questionId": "conditions",
                "products": []
            }
        ]
    };
    const manageConditionsQuestion = {
        "question": "How do you manage your conditions",
        "answers": [
            {
                "label": "Lifestyle",
                "questionId": "manageConditions"
            },
            {
                "label": "Prescriptions",
                "questionId": "manageConditions"
            },
            {
                "label": "Supplements",
                "questionId": "manageConditions"
            },
            {
                "label": "Something else",
                "questionId": "manageConditions"
            }
        ]
    };
    const natalQuestion = {
        "answers": [
            {
                "label": "No",
                "value": "No",
                "questionId": "natal",
                "products": [
                    {
                        "beta-glucan": 103
                    },
                    {
                        "lactospore-probiotic": 102
                    }
                ]
            },
            {
                "label": "I'm pregnant",
                "value": "pregnant",
                "questionId": "natal",
                "products": [
                    {
                        "beta-glucan": 500
                    },
                    {
                        "folic-acid": 99999
                    },
                    {
                        "ginger-extract": 99999
                    },
                    {
                        "iron": 9999
                    },
                    {
                        "k2-vital-delta": 9999
                    },
                    {
                        "milk-thistle-extract": 9999
                    },
                    {
                        "lactospore-probiotic": 9999
                    },
                    {
                        "vegan-vitamin-d3": 9999
                    },
                    {
                        "iodine": 9999
                    }
                ]
            },
            {
                "label": "I'm breastfeeding",
                "value": "breastfeeding",
                "questionId": "natal",
                "products": [
                    {
                        "folic-acid": 99999
                    },
                    {
                        "ginger-extract": 99999
                    },
                    {
                        "iron": 9999
                    },
                    {
                        "k2-vital-delta": 9999
                    },
                    {
                        "milk-thistle-extract": 9999
                    },
                    {
                        "lactospore-probiotic": 9999
                    },
                    {
                        "vegan-vitamin-d3": 9999
                    }
                ]
            },
            {
                "label": "I'm postnatal",
                "value": "postnatal",
                "questionId": "natal",
                "products": [
                    {
                        "beta-glucan": 50
                    },
                    {
                        "folic-acid": 99999
                    },
                    {
                        "ginger-extract": 99999
                    },
                    {
                        "iron": 9999
                    },
                    {
                        "k2-vital-delta": 9999
                    },
                    {
                        "milk-thistle-extract": 9999
                    },
                    {
                        "lactospore-probiotic": 9999
                    },
                    {
                        "vegan-vitamin-d3": 9999
                    }
                ]
            },
            {
                "label": "I'm trying to conceive",
                "value": "trying to conceive",
                "questionId": "natal",
                "products": [
                    {
                        "iodine": 9999
                    },
                    {
                        "ashwagandha-extract": 9999
                    },
                    {
                        "beta-glucan": 500
                    },
                    {
                        "folic-acid": 99999
                    },
                    {
                        "ginger-extract": 99999
                    },
                    {
                        "iron": 9999
                    },
                    {
                        "k2-vital-delta": 9999
                    },
                    {
                        "milk-thistle-extract": 9999
                    },
                    {
                        "lactospore-probiotic": 9999
                    },
                    {
                        "vegan-vitamin-d3": 9999
                    }
                ]
            }
        ]
    };
    const renderGenderAnswers = genderAnswers.map((answer)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("button", {
            key: answer.value,
            className: `answer-button ${gender === answer.value ? "answer-button--active" : ""}`,
            name: answer.name,
            onClick: ()=>updateGender(answer.value)
        }, answer.label);
    });
    const renderRaceAnswers = raceAnswers.map((answer)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("button", {
            key: answer.value,
            className: `answer-button ${race === answer.value ? "answer-button--active" : ""}`,
            name: answer.name,
            onClick: ()=>updateRace(answer.value)
        }, answer.label);
    });
    const updateGender = (answer)=>{
        setGender(answer);
        updateQuestionUrl("gender");
    };
    const updateRace = (answer)=>{
        setRace(answer);
        updateQuestionUrl("race");
    };
    const onChangeNumber = (e)=>{
        const re = /^[0-9\b]+$/; // make sure that only numbers can be input into the age field
        if (e.target.value === "" || re.test(e.target.value)) setAge(e.target.value);
        updateQuestionUrl("age");
    };
    const checkAge = ()=>{
        if (age && age < 17) setSuitableAge(false);
        else setSuitableAge(true);
    };
    const ageWarningMessage = ()=>{
        if (!suitableAge) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("p", null, "We recommend the Kids Quiz for people under the age of 17, please click the button below to proceed"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("a", {
            href: "/pages/kids-quiz",
            className: "next-page"
        }, "Kids Quiz"));
        else return;
    };
    const renderGoalAnswers = goalsQuestion.answers.map((answer, index)=>{
        const disabled = activeGoalsAnswer.indexOf(answer.label) == -1 && activeGoalsAnswer.length > 1;
        if (answer.nonMale && gender === "male") return;
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
            key: index,
            className: `answer-button answer-button__icon ${activeGoalsAnswer.indexOf(answer.label) !== -1 ? "answer-button--active" : activeGoalsAnswer.length > 1 ? "answer-button--disabled" : ""}`,
            onClick: (e)=>disabled ? "" : logAnswers(answer, answer.label, answer.questionId),
            disabled: disabled
        }, answer.icon === "aging" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$2367fa6760bbf24f), null) : "", answer.icon === "weight" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$9645f8076f429e5c), null) : "", answer.icon === "energy" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$c0b625f57a647728), null) : "", answer.icon === "immunity" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$4e113aba5b63d4e4), null) : "", answer.icon === "focus" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$807a7eae502106e7), null) : "", answer.icon === "face" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$aa6504bc3c7c25a1), null) : "", answer.icon === "eye" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$c42ab4f9cd72fed3), null) : "", answer.icon === "smile" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$bb054b93339f5c0f), null) : "", answer.icon === "gut" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$dd7722943dfbf00b), null) : "", answer.icon === "fruit" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$10faa5aa86038e33), null) : "", answer.icon === "shoe" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$c93a55722a55728f), null) : "", answer.icon === "heart" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$def5cd084dfd2c36), null) : "", answer.icon === "periodHealth" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$343c7a79674dcea0), null) : "", answer.icon === "excessHair" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$6bed359a46fab1ef), null) : "", answer.icon === "improveHair" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$3543d1682e6cc172), null) : "", answer.icon === "hotFlash" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$5cb3920d094765b3), null) : "", answer.icon === "sexualHealth" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$6d708b0d320d59), null) : "", answer.icon === "sleep" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$127fba7ec6c5c4a6), null) : "", answer.icon === "bone" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $d148c52a5de812dc$export$b127726e56765aa4), null) : "", answer.label);
    });
    const logAnswers = (answer, index, questionId)=>{
        updateQuestionUrl("goals"); // If answer is already selected...
        if (activeGoalsAnswer.indexOf(index) !== -1) {
            const newActiveGoalsAnswer = activeGoalsAnswer.filter((item)=>item !== index);
            setActiveGoalsAnswer(newActiveGoalsAnswer);
            let weightingsToKeep = [];
            weightingAnswers[questionId].forEach((element)=>{
                if (element.label !== index) weightingsToKeep.push(element);
            });
            setWeightingsAnswers((prevWeightings)=>({
                    ...prevWeightings,
                    [questionId]: weightingsToKeep
                }));
        } else {
            setActiveGoalsAnswer((prevAnswers)=>[
                    ...prevAnswers,
                    index
                ]);
            if (answer.products !== undefined) {
                if (weightingAnswers[questionId] && weightingAnswers[questionId].length > 0) {
                    const updatedAnswer = [
                        ...weightingAnswers[questionId],
                        answer
                    ];
                    setWeightingsAnswers((prevWeightings)=>({
                            ...prevWeightings,
                            [questionId]: updatedAnswer
                        }));
                } else setWeightingsAnswers((prevWeightings)=>({
                        ...prevWeightings,
                        [questionId]: [
                            answer
                        ]
                    }));
            }
        }
    };
    const logExerciseAnswers = (answer, index, questionId)=>{
        updateQuestionUrl("exercise"); // If answer is already selected...
        if (exerciseAnswersIndex.indexOf(index) !== -1) {
            // remove it from the index tracker
            const newExerciseAnswersIndex = exerciseAnswersIndex.filter((item)=>item !== index);
            setExerciseAnswersIndex(newExerciseAnswersIndex);
            let weightingsToKeep = [];
            weightingAnswers[questionId].forEach((element)=>{
                if (element.label !== index) weightingsToKeep.push(element);
            });
            setWeightingsAnswers((prevWeightings)=>({
                    ...prevWeightings,
                    [questionId]: weightingsToKeep
                }));
        } else if (index === "None") {
            setExerciseAnswersIndex([
                index
            ]);
            setWeightingsAnswers((prevWeightings)=>({
                    ...prevWeightings,
                    [questionId]: {}
                }));
        } else {
            setExerciseAnswersIndex((prevAnswers)=>{
                let newAnswers = prevAnswers;
                if (prevAnswers.indexOf("None") !== -1) newAnswers = newAnswers.filter((item)=>item !== "None");
                return [
                    ...newAnswers,
                    index
                ];
            });
            if (answer.products !== undefined) {
                if (weightingAnswers[questionId] && weightingAnswers[questionId].length > 0) {
                    const updatedAnswer = [
                        ...weightingAnswers[questionId],
                        answer
                    ];
                    setWeightingsAnswers((prevWeightings)=>({
                            ...prevWeightings,
                            [questionId]: updatedAnswer
                        }));
                } else setWeightingsAnswers((prevWeightings)=>({
                        ...prevWeightings,
                        [questionId]: [
                            answer
                        ]
                    }));
            }
        }
    };
    const logTravelAnswers = (answer, index, questionId)=>{
        updateQuestionUrl("travel");
        if (travelAnswersIndex === index) {
            setTravelAnswersIndex([]);
            setWeightingsAnswers((prevWeightings)=>({
                    ...prevWeightings,
                    [questionId]: {}
                }));
        } else {
            setTravelAnswersIndex(index);
            if (answer.products !== undefined) setWeightingsAnswers((prevWeightings)=>({
                    ...prevWeightings,
                    [questionId]: answer
                }));
            else setWeightingsAnswers((prevWeightings)=>({
                    ...prevWeightings,
                    [questionId]: {}
                }));
        }
    };
    const logAlcoholAnswers = (answer, index, questionId)=>{
        updateQuestionUrl("alcohol");
        if (alcoholAnswersIndex === index) {
            setAlcoholAnswersIndex([]);
            setWeightingsAnswers((prevWeightings)=>({
                    ...prevWeightings,
                    [questionId]: {}
                }));
        } else {
            setAlcoholAnswersIndex(index);
            if (answer.products !== undefined) setWeightingsAnswers((prevWeightings)=>({
                    ...prevWeightings,
                    [questionId]: answer
                }));
            else setWeightingsAnswers((prevWeightings)=>({
                    ...prevWeightings,
                    [questionId]: {}
                }));
        }
    };
    const logMultipleAnswers = (answer, index, questionId)=>{
        updateQuestionUrl("dietSelection"); // If answer is already selected...
        if (dietAnswersIndex.indexOf(index) !== -1) {
            // remove it from the index tracker
            const newDietAnswersIndex = dietAnswersIndex.filter((item)=>item !== index);
            setDietAnswersIndex(newDietAnswersIndex); //remove the weighting
            let weightingsToKeep = [];
            weightingAnswers[questionId].forEach((element)=>{
                if (element.label !== index) weightingsToKeep.push(element);
            });
            setWeightingsAnswers((prevWeightings)=>({
                    ...prevWeightings,
                    [questionId]: weightingsToKeep
                }));
        } else {
            setDietAnswersIndex((prevAnswers)=>[
                    ...prevAnswers,
                    index
                ]);
            if (answer.products !== undefined) {
                if (weightingAnswers[questionId] && weightingAnswers[questionId].length > 0) {
                    const updatedAnswer = [
                        ...weightingAnswers[questionId],
                        answer
                    ];
                    setWeightingsAnswers((prevWeightings)=>({
                            ...prevWeightings,
                            [questionId]: updatedAnswer
                        }));
                } else setWeightingsAnswers((prevWeightings)=>({
                        ...prevWeightings,
                        [questionId]: [
                            answer
                        ]
                    }));
            }
        }
    };
    const logMultipleConditionsAnswers = (answer, index, questionId)=>{
        updateQuestionUrl("conditions"); // If answer is already selected...
        if (conditionsAnswerIndex.indexOf(index) !== -1) {
            // remove it from the index tracker
            const newConditionsAnswerIndex = conditionsAnswerIndex.filter((item)=>item !== index);
            setConditionsAnswerIndex(newConditionsAnswerIndex); //remove the weighting
            let weightingsToKeep = [];
            weightingAnswers[questionId].forEach((element)=>{
                if (element.label !== index) weightingsToKeep.push(element);
            });
            setWeightingsAnswers((prevWeightings)=>({
                    ...prevWeightings,
                    [questionId]: weightingsToKeep
                }));
        } else if (index === "No") {
            setConditionsAnswerIndex([
                index
            ]);
            setWeightingsAnswers((prevWeightings)=>({
                    ...prevWeightings,
                    [questionId]: {}
                }));
        } else {
            setConditionsAnswerIndex((prevAnswers)=>{
                let newAnswers = prevAnswers;
                if (prevAnswers.indexOf("No") !== -1) newAnswers = newAnswers.filter((item)=>item !== "No");
                return [
                    ...newAnswers,
                    index
                ];
            });
            if (answer.products !== undefined) {
                if (weightingAnswers[questionId] && weightingAnswers[questionId].length > 0) {
                    const updatedAnswer = [
                        ...weightingAnswers[questionId],
                        answer
                    ];
                    setWeightingsAnswers((prevWeightings)=>({
                            ...prevWeightings,
                            [questionId]: updatedAnswer
                        }));
                } else setWeightingsAnswers((prevWeightings)=>({
                        ...prevWeightings,
                        [questionId]: [
                            answer
                        ]
                    }));
            }
        }
    };
    const logManageConditions = (answer, index, questionId)=>{
        updateQuestionUrl("manageConditions"); // If answer is already selected...
        if (manageConditionsAnswerIndex.indexOf(index) !== -1) {
            // remove it from the index tracker
            const newManageConditionsAnswerIndex = manageConditionsAnswerIndex.filter((item)=>item !== index);
            setManageConditionsAnswerIndex(newManageConditionsAnswerIndex);
        } else setManageConditionsAnswerIndex((prevAnswers)=>{
            let newAnswers = prevAnswers;
            return [
                ...newAnswers,
                index
            ];
        });
    };
    const logNatalAnswers = (answer, index, questionId)=>{
        updateQuestionUrl("natal"); // If answer is already selected...
        if (natalAnswerIndex.indexOf(index) !== -1) {
            // remove it from the index tracker
            const newNatalAnswerIndex = natalAnswerIndex.filter((item)=>item !== index);
            setNatalAnswerIndex(newNatalAnswerIndex); //remove the weighting
            let weightingsToKeep = [];
            weightingAnswers[questionId].forEach((element)=>{
                if (element.label !== index) weightingsToKeep.push(element);
            });
            setWeightingsAnswers((prevWeightings)=>({
                    ...prevWeightings,
                    [questionId]: weightingsToKeep
                }));
        } else if (index === "No") {
            setNatalAnswerIndex([
                index
            ]);
            setWeightingsAnswers((prevWeightings)=>({
                    ...prevWeightings,
                    [questionId]: {}
                }));
        } else {
            setNatalAnswerIndex((prevAnswers)=>{
                let newAnswers = prevAnswers;
                if (index === `I'm trying to conceive`) {
                    if (prevAnswers.indexOf(`I'm pregnant`) !== -1) newAnswers = newAnswers.filter((item)=>item !== `I'm pregnant`);
                } else if (index === `I'm pregnant`) {
                    if (prevAnswers.indexOf(`I'm trying to conceive`) !== -1) newAnswers = newAnswers.filter((item)=>item !== `I'm trying to conceive`);
                }
                if (prevAnswers.indexOf("No") !== -1) newAnswers = newAnswers.filter((item)=>item !== "No");
                return [
                    ...newAnswers,
                    index
                ];
            });
            if (answer.products !== undefined) {
                if (weightingAnswers[questionId] && weightingAnswers[questionId].length > 0) {
                    let updatedAnswer = [
                        ...weightingAnswers[questionId],
                        answer
                    ];
                    if (index === `I'm trying to conceive`) updatedAnswer = updatedAnswer.filter((option)=>option.value !== "pregnant");
                    else if (index === `I'm pregnant`) updatedAnswer = updatedAnswer.filter((option)=>option.value !== "trying to conceive");
                    setWeightingsAnswers((prevWeightings)=>({
                            ...prevWeightings,
                            [questionId]: updatedAnswer
                        }));
                } else setWeightingsAnswers((prevWeightings)=>({
                        ...prevWeightings,
                        [questionId]: [
                            answer
                        ]
                    }));
            }
        }
    };
    const logHungryAnswer = (event)=>{
        updateQuestionUrl("hungry");
        const radioValue = event.target.value;
        if (radioValue === "yes") {
            setWeightingsAnswers((prevWeightings)=>({
                    ...prevWeightings,
                    "hungry": {
                        "products": [
                            {
                                "ashwagandha-extract": 5000
                            },
                            {
                                "b12": 99999
                            },
                            {
                                "beetroot-powder": 7500
                            },
                            {
                                "maca-powder": 5000
                            },
                            {
                                "white-kidney-extract": 2000
                            },
                            {
                                "iodine": 5000
                            }
                        ]
                    }
                }));
            setHungryBetweenMeals("yes");
        } else {
            setWeightingsAnswers((prevWeightings)=>({
                    ...prevWeightings,
                    "hungry": {}
                }));
            setHungryBetweenMeals("no");
        }
    };
    const logGlassesAnswer = (event)=>{
        updateQuestionUrl("glasses");
        const radioValue = event.target.value;
        if (radioValue === "yes") {
            setWeightingsAnswers((prevWeightings)=>({
                    ...prevWeightings,
                    "glasses": {
                        "products": [
                            {
                                "lycopene": 9999
                            },
                            {
                                "vegan-vitamin-d3": 5000
                            },
                            {
                                "vitamin-a": 9999
                            },
                            {
                                "vitamin-c": 5000
                            },
                            {
                                "vitamin-e": 7000
                            }
                        ]
                    }
                }));
            setGlassesAnswer(radioValue);
        } else {
            setWeightingsAnswers((prevWeightings)=>({
                    ...prevWeightings,
                    "glasses": {}
                }));
            setGlassesAnswer(radioValue);
        }
    };
    const logIodineAnswer = (event)=>{
        const radioValue = event.target.value;
        setIodineAnswer(radioValue);
        updateQuestionUrl("iodine");
    };
    const logMedicationAnswer = (event)=>{
        const radioValue = event.target.value;
        setMedicationAnswer(radioValue);
        updateQuestionUrl("medication");
    };
    const onSpecificDietClick = (event)=>{
        updateQuestionUrl("specificDiet");
        if (event.target.value === "no") {
            setDietAnswersIndex([]);
            setWeightingsAnswers((prevWeightings)=>({
                    ...prevWeightings,
                    "diet": []
                }));
            setSpecificDiet("no");
        } else setSpecificDiet("yes");
    };
    const renderExerciseAnswers = exerciseQuestion.answers.map((answer)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
            key: answer.label,
            className: `answer-button ${exerciseAnswersIndex.indexOf(answer.label) !== -1 ? "answer-button--active" : ""}`,
            onClick: (e)=>logExerciseAnswers(answer, answer.label, answer.questionId)
        }, answer.label);
    });
    const renderTravelAnswers = travelQuestion.answers.map((answer)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
            key: answer.label,
            className: `answer-button ${travelAnswersIndex.indexOf(answer.label) !== -1 ? "answer-button--active" : ""}`,
            onClick: (e)=>logTravelAnswers(answer, answer.label, answer.questionId)
        }, answer.label);
    });
    const renderDietAnswers = dietsQuestion.answers.map((answer)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
            key: answer.label,
            className: `answer-button ${dietAnswersIndex.indexOf(answer.label) !== -1 ? "answer-button--active" : ""}`,
            onClick: (e)=>logMultipleAnswers(answer, answer.label, answer.questionId)
        }, answer.label);
    });
    const renderAlcoholAnswers = alcoholQuestion.answers.map((answer)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
            key: answer.label,
            className: `answer-button ${alcoholAnswersIndex.indexOf(answer.label) !== -1 ? "answer-button--active" : ""}`,
            onClick: (e)=>logAlcoholAnswers(answer, answer.label, answer.questionId)
        }, answer.label);
    });
    const currentVitamins = (e)=>{
        updateQuestionUrl("vitamins");
        setVitaminsAnswer(e.target.value);
    };
    const renderConditionsAnswers = conditionsQuestion.answers.map((answer)=>{
        if (answer.nonMale && gender === "male") return;
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
            key: answer.label,
            className: `answer-button ${conditionsAnswerIndex.indexOf(answer.label) !== -1 ? "answer-button--active" : ""}`,
            onClick: (e)=>logMultipleConditionsAnswers(answer, answer.label, answer.questionId)
        }, answer.label);
    });
    const renderManageConditionsAnswers = manageConditionsQuestion.answers.map((answer)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
            key: answer.label,
            className: `answer-button ${manageConditionsAnswerIndex.indexOf(answer.label) !== -1 ? "answer-button--active" : ""}`,
            onClick: (e)=>logManageConditions(answer, answer.label, answer.questionId)
        }, answer.label);
    });
    const renderNatalAnswers = natalQuestion.answers.map((answer)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
            key: answer.label,
            className: `answer-button ${natalAnswerIndex.indexOf(answer.label) !== -1 ? "answer-button--active" : ""}`,
            onClick: (e)=>logNatalAnswers(answer, answer.label, answer.questionId)
        }, answer.label);
    });
    const handleFoodRadios = (e)=>{
        updateQuestionUrl("foodRadio");
        switch(e.target.id){
            case "processedFoodRarely":
                setWeightingsAnswers((prevWeightings)=>({
                        ...prevWeightings,
                        "processedFood": {}
                    }));
                setProcessedFoodAnswer(e.target.id);
                break;
            case "processedFood12":
                setWeightingsAnswers((prevWeightings)=>({
                        ...prevWeightings,
                        "processedFood": {}
                    }));
                setProcessedFoodAnswer(e.target.id);
                break;
            case "processedFood34":
                setWeightingsAnswers((prevWeightings)=>({
                        ...prevWeightings,
                        "processedFood": {
                            "products": [
                                {
                                    "nourished-greens": 2000
                                },
                                {
                                    "lactospore-probiotic": 2500
                                }
                            ]
                        }
                    }));
                setProcessedFoodAnswer(e.target.id);
                break;
            case "processedFood5":
                setWeightingsAnswers((prevWeightings)=>({
                        ...prevWeightings,
                        "processedFood": {
                            "products": [
                                {
                                    "bpl1-ht": 9999
                                },
                                {
                                    "hydrocurc-pepperine": 2500
                                },
                                {
                                    "nourished-greens": 9999
                                },
                                {
                                    "lactospore-probiotic": 5000
                                },
                                {
                                    "white-kidney-extract": 7000
                                },
                                {
                                    "apple-cider-vinegar": 9999
                                }
                            ]
                        }
                    }));
                setProcessedFoodAnswer(e.target.id);
                break;
            case "fruitVegRarely":
                setWeightingsAnswers((prevWeightings)=>({
                        ...prevWeightings,
                        "fruitVeg": {
                            "products": [
                                {
                                    "bpl1-ht": 9999
                                },
                                {
                                    "beetroot-powder": 2500
                                },
                                {
                                    "cordyceps": 5000
                                },
                                {
                                    "lycopene": 5000
                                },
                                {
                                    "nourished-greens": 9999
                                },
                                {
                                    "tart-cherry": 5000
                                },
                                {
                                    "apple-cider-vinegar": 5000
                                }
                            ]
                        }
                    }));
                setFruitVegAnswer(e.target.id);
                break;
            case "fruitVeg12":
                setWeightingsAnswers((prevWeightings)=>({
                        ...prevWeightings,
                        "fruitVeg": {
                            "products": [
                                {
                                    "cordyceps": 5000
                                },
                                {
                                    "lycopene": 2500
                                },
                                {
                                    "nourished-greens": 2500
                                },
                                {
                                    "tart-cherry": 2500
                                },
                                {
                                    "apple-cider-vinegar": 2500
                                }
                            ]
                        }
                    }));
                setFruitVegAnswer(e.target.id);
                break;
            case "fruitVeg34":
                setWeightingsAnswers((prevWeightings)=>({
                        ...prevWeightings,
                        "fruitVeg": {
                            "products": [
                                {
                                    "cordyceps": 2500
                                }
                            ]
                        }
                    }));
                setFruitVegAnswer(e.target.id);
                break;
            case "fruitVeg5":
                setWeightingsAnswers((prevWeightings)=>({
                        ...prevWeightings,
                        "fruitVeg": {}
                    }));
                setFruitVegAnswer(e.target.id);
                break;
            default:
                break;
        }
    };
    const handleSlider = (value, sliderId)=>{
        const sliderValue = value;
        switch(sliderId){
            case "energy":
                updateQuestionUrl("energy");
                setEnergySliderValue(sliderValue);
                if (sliderValue < 34) setWeightingsAnswers((prevWeightings)=>({
                        ...prevWeightings,
                        "energySlider": {
                            "products": [
                                {
                                    "iodine": 9999
                                },
                                {
                                    "5-htp": 50
                                },
                                {
                                    "b12": 99999
                                },
                                {
                                    "beetroot-powder": 5000
                                },
                                {
                                    "coq10": 9999
                                },
                                {
                                    "ginseng": 5000
                                },
                                {
                                    "iron": 99999
                                },
                                {
                                    "maca-powder": 5000
                                },
                                {
                                    "tart-cherry": 99999
                                }
                            ]
                        }
                    }));
                else if (sliderValue < 67) setWeightingsAnswers((prevWeightings)=>({
                        ...prevWeightings,
                        "energySlider": {
                            "products": [
                                {
                                    "iodine": 5000
                                },
                                {
                                    "5-htp": 250
                                },
                                {
                                    "b12": 75000
                                },
                                {
                                    "beetroot-powder": 2500
                                },
                                {
                                    "coq10": 5000
                                },
                                {
                                    "ginseng": 2500
                                },
                                {
                                    "iron": 5000
                                },
                                {
                                    "maca-powder": 2500
                                },
                                {
                                    "tart-cherry": 50000
                                }
                            ]
                        }
                    }));
                else setWeightingsAnswers((prevWeightings)=>({
                        ...prevWeightings,
                        "energySlider": {}
                    }));
                break;
            case "activity":
                updateQuestionUrl("activity");
                setActivitySliderValue(sliderValue);
                if (sliderValue < 34) setWeightingsAnswers((prevWeightings)=>({
                        ...prevWeightings,
                        "activitySlider": {
                            "products": [
                                {
                                    "bpl1-ht": 9999
                                }
                            ]
                        }
                    }));
                else if (sliderValue < 67) setWeightingsAnswers((prevWeightings)=>({
                        ...prevWeightings,
                        "activitySlider": {
                            "products": [
                                {
                                    "b12": 5000
                                },
                                {
                                    "cordyceps": 3500
                                },
                                {
                                    "k2-vital-delta": 500
                                },
                                {
                                    "tart-cherry": 5000
                                }
                            ]
                        }
                    }));
                else setWeightingsAnswers((prevWeightings)=>({
                        ...prevWeightings,
                        "activitySlider": {
                            "products": [
                                {
                                    "b12": 7000
                                },
                                {
                                    "beetroot-powder": 9000
                                },
                                {
                                    "cordyceps": 7500
                                },
                                {
                                    "ginseng": 2500
                                },
                                {
                                    "hydrocurc-pepperine": 5000
                                },
                                {
                                    "k2-vital-delta": 1000
                                },
                                {
                                    "maca-powder": 5000
                                },
                                {
                                    "silica": 9998
                                },
                                {
                                    "tart-cherry": 99999
                                }
                            ]
                        }
                    }));
                break;
            case "sleep":
                updateQuestionUrl("sleep");
                setSleepSliderValue(sliderValue);
                if (sliderValue < 34) setWeightingsAnswers((prevWeightings)=>({
                        ...prevWeightings,
                        "sleepSlider": {
                            "products": [
                                {
                                    "5-htp": 9999
                                },
                                {
                                    "b12": 7500
                                },
                                {
                                    "tart-cherry": 99999
                                }
                            ]
                        }
                    }));
                else if (sliderValue < 67) setWeightingsAnswers((prevWeightings)=>({
                        ...prevWeightings,
                        "sleepSlider": {
                            "products": [
                                {
                                    "ashwagandha-extract": 7500
                                },
                                {
                                    "5-htp": 5000
                                },
                                {
                                    "b12": 5000
                                },
                                {
                                    "tart-cherry": 5000
                                }
                            ]
                        }
                    }));
                else setWeightingsAnswers((prevWeightings)=>({
                        ...prevWeightings,
                        "sleepSlider": {
                            "products": [
                                {
                                    "ashwagandha-extract": 9999
                                }
                            ]
                        }
                    }));
                break;
            case "screen":
                updateQuestionUrl("screen");
                setScreenSliderValue(sliderValue);
                if (sliderValue < 34) setWeightingsAnswers((prevWeightings)=>({
                        ...prevWeightings,
                        "screenSlider": {}
                    }));
                else if (sliderValue < 67) setWeightingsAnswers((prevWeightings)=>({
                        ...prevWeightings,
                        "screenSlider": {
                            "products": [
                                {
                                    "b12": 5000
                                },
                                {
                                    "coq10": 2500
                                },
                                {
                                    "folic-acid": 2500
                                },
                                {
                                    "lycopene": 5000
                                },
                                {
                                    "selenium": 5000
                                },
                                {
                                    "vitamin-a": 99999
                                },
                                {
                                    "vitamin-c": 5000
                                },
                                {
                                    "vitamin-e": 2500
                                }
                            ]
                        }
                    }));
                else setWeightingsAnswers((prevWeightings)=>({
                        ...prevWeightings,
                        "screenSlider": {
                            "products": [
                                {
                                    "b12": 99999
                                },
                                {
                                    "coq10": 5000
                                },
                                {
                                    "folic-acid": 5000
                                },
                                {
                                    "lycopene": 9000
                                },
                                {
                                    "selenium": 9999
                                },
                                {
                                    "vitamin-a": 99999
                                },
                                {
                                    "vitamin-c": 9999
                                },
                                {
                                    "vitamin-e": 5000
                                }
                            ]
                        }
                    }));
                break;
            case "conditionsSlider":
                updateQuestionUrl("conditionsSlider");
                setConditionsEffectSlider(sliderValue);
                break;
            default:
                break;
        }
    };
    const selectFlavour = (e)=>{
        updateQuestionUrl("flavour");
        setFlavour(e.target.value);
    };
    const selectCoating = (e)=>{
        updateQuestionUrl("coating");
        setCoating(e.target.value);
    };
    const calculateWeights = async ()=>{
        let weights = {};
        const addToWeighting = (product, weighting)=>{
            weights[product] ? weights[product] += weighting : weights[product] = weighting;
        };
        (function retrieveWeights(obj) {
            for (const [key, value] of Object.entries(obj)){
                switch(key){
                    case "ashwagandha-extract":
                        addToWeighting(key, value);
                        break;
                    case "b12":
                        addToWeighting(key, value);
                        break;
                    case "beetroot-powder":
                        addToWeighting(key, value);
                        break;
                    case "beta-glucan":
                        addToWeighting(key, value);
                        break;
                    case "careflow-mango-powder":
                        addToWeighting(key, value);
                        break;
                    case "coq10":
                        addToWeighting(key, value);
                        break;
                    case "cordyceps":
                        addToWeighting(key, value);
                        break;
                    case "folic-acid":
                        addToWeighting(key, value);
                        break;
                    case "ginger-extract":
                        addToWeighting(key, value);
                        break;
                    case "ginseng":
                        addToWeighting(key, value);
                        break;
                    case "hydrocurc-pepperine":
                        addToWeighting(key, value);
                        break;
                    case "iron":
                        addToWeighting(key, value);
                        break;
                    case "k2-vital-delta":
                        addToWeighting(key, value);
                        break;
                    case "lutemax":
                        addToWeighting(key, value);
                        break;
                    case "lycopene":
                        addToWeighting(key, value);
                        break;
                    case "maca-powder":
                        addToWeighting(key, value);
                        break;
                    case "milk-thistle-extract":
                        addToWeighting(key, value);
                        break;
                    case "nourished-greens":
                        addToWeighting(key, value);
                        break;
                    case "lactospore-probiotic":
                        addToWeighting(key, value);
                        break;
                    case "resveratrol":
                        addToWeighting(key, value);
                        break;
                    case "scutellup":
                        addToWeighting(key, value);
                        break;
                    case "selenium":
                        addToWeighting(key, value);
                        break;
                    case "silica":
                        addToWeighting(key, value);
                        break;
                    case "tart-cherry":
                        addToWeighting(key, value);
                        break;
                    case "vegan-vitamin-d3":
                        addToWeighting(key, value);
                        break;
                    case "vitamin-a":
                        addToWeighting(key, value);
                        break;
                    case "vitamin-c":
                        addToWeighting(key, value);
                        break;
                    case "vitamin-e":
                        addToWeighting(key, value);
                        break;
                    case "white-kidney-extract":
                        addToWeighting(key, value);
                        break;
                    case "zinc":
                        addToWeighting(key, value);
                        break;
                    case "apple-cider-vinegar":
                        addToWeighting(key, value);
                        break;
                    case "bpl1-ht":
                        addToWeighting(key, value);
                        break;
                    case "5-htp":
                        addToWeighting(key, value);
                        break;
                    case "iodine":
                        addToWeighting(key, value);
                        break;
                    case "inositol":
                        addToWeighting(key, value);
                        break;
                    default:
                        break;
                }
                if (typeof value === "object") retrieveWeights(value);
            }
        })(weightingAnswers);
        function findTopSeven(obj) {
            return Object.keys(obj).sort((a, b)=>{
                return obj[b] - obj[a];
            }).slice(0, 7);
        } // If there are any pregnancy concerns,
        // remove Vitmin A and 5-HTP
        if (natalAnswerIndex.length !== 0 && natalAnswerIndex[0] !== "No") {
            delete weights["vitamin-a"];
            delete weights["5-htp"];
        } // If the user takes any medication,
        // remove 5-HTP
        if (medicationAnswer === "yes") delete weights["5-htp"];
        if (iodineAnswer === "yes" || conditionsAnswerIndex.includes("Hyperthyroidism")) delete weights["iodine"];
        delete weights["k2-vital-delta"]; // while stock is low
        // Get the top 7 weightings
        let suggestedInclusions = findTopSeven(weights); // If inositiol is in the top 7 weightins, make it a double layer
        if (suggestedInclusions.includes("inositol")) {
            suggestedInclusions.splice(suggestedInclusions.indexOf("inositol"), 0, "inositol");
            suggestedInclusions = suggestedInclusions.slice(0, 7);
        } // If the user has selected any vitamins that they want in their stack,
        // give those vitimins priority over the weightings
        if (selectedVitamins.length > 0) {
            let inositiolCount = 0;
            let vitaminDCount = 0;
            let sortedInclusions = [];
            selectedVitamins.forEach((vitamin)=>{
                if (vitamin.value.includes("inositol")) {
                    inositiolCount++;
                    return;
                }
                if (vitamin.value.includes("vitamin-d")) {
                    vitaminDCount++;
                    return;
                } // check that the vitamin isn't already present in the weightings to ensure no double up
                if (suggestedInclusions.includes(vitamin.value)) // if the vitamin is already present, remove it so that it can be added to the beginning of the list
                suggestedInclusions.splice(suggestedInclusions.indexOf(vitamin.value), 1);
                suggestedInclusions.unshift(vitamin.value);
            }); // Check if inositol is present in the array
            while(suggestedInclusions.some((inclusion)=>inclusion.startsWith("inositol")) && inositiolCount > 0){
                // Move the first occurrence of a string that starts with 'inositol' to the beginning of the array
                sortedInclusions.unshift(suggestedInclusions.splice(suggestedInclusions.findIndex((inclusion)=>inclusion.startsWith("inositol")), 1)[0]);
                inositiolCount--;
            } // Check if vegan-vitamin-d3 is present in the array
            while(suggestedInclusions.some((inclusion)=>inclusion.startsWith("vegan-vitamin-d3")) && vitaminDCount > 0){
                // Move the first occurrence of a string that starts with 'vegan-vitamin-d3' to the beginning of the array
                sortedInclusions.unshift(suggestedInclusions.splice(suggestedInclusions.findIndex((inclusion)=>inclusion.startsWith("vegan-vitamin-d3")), 1)[0]);
                vitaminDCount--;
            }
            while(inositiolCount > 0){
                sortedInclusions.unshift("inositol");
                inositiolCount--;
            }
            while(vitaminDCount > 0){
                sortedInclusions.unshift("vegan-vitamin-d3");
                vitaminDCount--;
            }
            suggestedInclusions = sortedInclusions.concat(suggestedInclusions); // Trim down to 7 inclusions
            suggestedInclusions = suggestedInclusions.slice(0, 7);
        }
        let selectedDiets = "";
        if (dietAnswersIndex.length > 0) selectedDiets = dietAnswersIndex.join(", ");
        let natalAnswers = "";
        if (natalAnswerIndex.length > 0) natalAnswers = natalAnswerIndex.join(", ");
        let payload = {
            firstName: firstName,
            priority: activeGoalsAnswer,
            age: age,
            gender: gender,
            selectedDiets: selectedDiets,
            natalAnswers: natalAnswers,
            flavour: flavour,
            coating: coating,
            handles: suggestedInclusions,
            quizID: quizID,
            timestamp: Date.now()
        }; // console.log(JSON.stringify(payload));
        // console.log(payload);
        if (email !== "" && consent) await klaviyoData(suggestedInclusions);
        let selelctedVitaminsArray = [];
        let userSelectedVitamins = "";
        if (selectedVitamins.length > 0) {
            selectedVitamins.forEach((vitamin)=>{
                selelctedVitaminsArray.unshift(vitamin.value);
            });
            userSelectedVitamins = selelctedVitaminsArray.join(", ");
        } // Record quiz amount in session and local storage
        let quizSession;
        let quizLocal;
        let currentSessionCount = sessionStorage.getItem("quizSession");
        let currentLocalCount = localStorage.getItem("quizLocal");
        if (currentSessionCount) {
            quizSession = parseInt(currentSessionCount) + 1;
            sessionStorage.setItem("quizSession", quizSession);
        } else {
            quizSession = 1;
            sessionStorage.setItem("quizSession", quizSession);
        }
        if (currentLocalCount) {
            quizLocal = parseInt(currentLocalCount) + 1;
            localStorage.setItem("quizLocal", quizLocal);
        } else {
            quizLocal = 1;
            localStorage.setItem("quizLocal", quizLocal);
        }
        const dataToSend = {
            "1": `${gender}`,
            "2": `${age}`,
            "3": `${race}`,
            "4": `${energySliderValue}`,
            "5": `${activitySliderValue}`,
            "6": `${sleepSliderValue}`,
            "7": `${screenSliderValue}`,
            "8": `${exerciseAnswersIndex}`,
            "9": `${travelAnswersIndex}`,
            "10": `${specificDiet}`,
            "11": `${dietAnswersIndex}`,
            "12": `${hungryBetweenMeals}`,
            "13": `${processedFoodAnswer}`,
            "14": `${fruitVegAnswer}`,
            "15": `${alcoholAnswersIndex}`,
            "16": `${vitaminsAnswer}`,
            "17": `${glassesAnswer}`,
            "18": `${conditionsAnswerIndex}`,
            "19": `${conditionsEffectSlider}`,
            "20": `${manageConditionsAnswerIndex}`,
            "21": `${medicationAnswer}`,
            "22": `${natalAnswerIndex}`,
            "23": `${selelctedVitaminsArray}`,
            "24": `${activeGoalsAnswer}`,
            "25": `${flavour}`,
            "26": `${coating}`,
            "27": `${consent}`,
            "28": `${suggestedInclusions[0]}`,
            "29": `${suggestedInclusions[1]}`,
            "30": `${suggestedInclusions[2]}`,
            "31": `${suggestedInclusions[3]}`,
            "32": `${suggestedInclusions[4]}`,
            "33": `${suggestedInclusions[5]}`,
            "34": `${suggestedInclusions[6]}`,
            "35": `${new Date().toLocaleString("en-GB")}`,
            "36": `${Date.now()}`,
            "37": `${quizSession}`,
            "38": `${quizLocal}`,
            "39": `${quizID}`
        };
        const controller = new AbortController();
        const timeoutId = setTimeout(()=>controller.abort(), 5000); // Send data to google sheets
        // avoid test data
        if (firstName.toLowerCase() !== "test" || firstName !== "") fetch(`https://script.google.com/macros/s/AKfycbwtEijjmga7mUOr1DLo0LuQZ7ESxQF8i2o51LY5LCFw26JFoQ-gfm6fpoZKgMycd8zmjw/exec`, {
            method: "POST",
            headers: {
                "Content-Type": "text/plain;charset=utf-8"
            },
            body: JSON.stringify(dataToSend),
            signal: controller.signal
        }).then(function(res) {
            window.localStorage.setItem("nourished-core-quiz-results", JSON.stringify(payload));
            window.location = "/pages/quiz-results";
        }).catch(function(err) {
            window.localStorage.setItem("nourished-core-quiz-results", JSON.stringify(payload));
            window.location = "/pages/quiz-results";
        });
        else {
            window.localStorage.setItem("nourished-core-quiz-results", JSON.stringify(payload));
            window.location = "/pages/quiz-results";
        }
    };
    const klaviyoData = (resultsInclusions)=>{
        return new Promise((resolve, reject)=>{
            let handlesString = "Error in handles";
            let exercise = "non selected";
            let selectedDiets = "non selected";
            let healthConditions = "non selected";
            let manageHealthConditions = "non selected";
            let natal = "not specificed";
            let userSelectedVitamins = "none";
            let goals = "non selected";
            let prioritiesNumbers = [];
            let dietsNumbers = [];
            let handlesNumbers = [];
            let resultsLink = "?";
            if (resultsInclusions.length > 0) {
                handlesString = resultsInclusions.join(", ");
                resultsInclusions.forEach((handle)=>{
                    switch(handle){
                        case "5-htp":
                            handlesNumbers.push("1");
                            break;
                        case "apple-cider-vinegar":
                            handlesNumbers.push("2");
                            break;
                        case "ashwagandha-extract":
                            handlesNumbers.push("3");
                            break;
                        case "beetroot-powder":
                            handlesNumbers.push("4");
                            break;
                        case "beta-glucan":
                            handlesNumbers.push("5");
                            break;
                        case "careflow-mango-powder":
                            handlesNumbers.push("6");
                            break;
                        case "coq10":
                            handlesNumbers.push("7");
                            break;
                        case "cordyceps":
                            handlesNumbers.push("8");
                            break;
                        case "folic-acid":
                            handlesNumbers.push("9");
                            break;
                        case "ginger-extract":
                            handlesNumbers.push("10");
                            break;
                        case "ginseng":
                            handlesNumbers.push("11");
                            break;
                        case "bpl1-ht":
                            handlesNumbers.push("12");
                            break;
                        case "hydrocurc-pepperine":
                            handlesNumbers.push("13");
                            break;
                        case "iron":
                            handlesNumbers.push("14");
                            break;
                        case "k2-vital-delta":
                            handlesNumbers.push("15");
                            break;
                        case "lactospore-probiotic":
                            handlesNumbers.push("16");
                            break;
                        case "lycopene":
                            handlesNumbers.push("17");
                            break;
                        case "maca-powder":
                            handlesNumbers.push("18");
                            break;
                        case "milk-thistle-extract":
                            handlesNumbers.push("19");
                            break;
                        case "nourished-greens":
                            handlesNumbers.push("20");
                            break;
                        case "resveratrol":
                            handlesNumbers.push("21");
                            break;
                        case "scutellup":
                            handlesNumbers.push("22");
                            break;
                        case "selenium":
                            handlesNumbers.push("23");
                            break;
                        case "silica":
                            handlesNumbers.push("24");
                            break;
                        case "tart-cherry":
                            handlesNumbers.push("25");
                            break;
                        case "vegan-vitamin-d3":
                            handlesNumbers.push("26");
                            break;
                        case "vitamin-a":
                            handlesNumbers.push("27");
                            break;
                        case "b12":
                            handlesNumbers.push("28");
                            break;
                        case "vitamin-c":
                            handlesNumbers.push("29");
                            break;
                        case "vitamin-e":
                            handlesNumbers.push("30");
                            break;
                        case "white-kidney-extract":
                            handlesNumbers.push("31");
                            break;
                        case "zinc":
                            handlesNumbers.push("32");
                            break;
                        case "inositol":
                            handlesNumbers.push("33");
                            break;
                        case "lutemax":
                            handlesNumbers.push("35");
                            break;
                        case "iodine":
                            handlesNumbers.push("36");
                            break;
                        default:
                            break;
                    }
                });
            }
            if (exerciseAnswersIndex.length > 0) exercise = exerciseAnswersIndex.join(", ");
            if (dietAnswersIndex.length > 0) {
                selectedDiets = dietAnswersIndex.join(", ");
                dietAnswersIndex.forEach((diet)=>{
                    switch(diet){
                        case "Vegetarian":
                            dietsNumbers.push("1");
                            break;
                        case "Vegan":
                            dietsNumbers.push("2");
                            break;
                        case "Pescatarian":
                            dietsNumbers.push("3");
                            break;
                        case "Dairy free":
                            dietsNumbers.push("4");
                            break;
                        case "Gluten free":
                            dietsNumbers.push("5");
                            break;
                        case "Nut free":
                            dietsNumbers.push("6");
                            break;
                        case "Reducetarian":
                            dietsNumbers.push("7");
                            break;
                        default:
                            break;
                    }
                });
            }
            let natalAnswers = []; // loop through natal answers index
            // for each value, add a corresponding value to natalAnswers
            // if the value is 'No', add '0'
            // if the value contains 'pregnant', add '1'
            // if the value contains 'breastfeeding', add '2'
            // if the value contains 'post natal', add '3'
            // if the value contains 'conceive', add '4'
            natalAnswerIndex.forEach((answer)=>{
                if (answer === "No") natalAnswers.push("0");
                else if (answer.includes(`I'm pregnant`)) natalAnswers.push("1");
                else if (answer.includes(`I'm breastfeeding`)) natalAnswers.push("2");
                else if (answer.includes(`I'm postnatal`)) natalAnswers.push("3");
                else if (answer.includes(`I'm trying to conceive`)) natalAnswers.push("4");
            });
            if (conditionsAnswerIndex.length > 0) healthConditions = conditionsAnswerIndex.join(", ");
            if (manageConditionsAnswerIndex.length > 0) manageHealthConditions = manageConditionsAnswerIndex.join(", ");
            if (natalAnswerIndex.length > 0) natal = natalAnswerIndex.join(", ");
            if (selectedVitamins.length > 0) {
                let selelctedVitaminsArray = [];
                selectedVitamins.forEach((vitamin)=>{
                    selelctedVitaminsArray.unshift(vitamin.value);
                });
                userSelectedVitamins = selelctedVitaminsArray.join(", ");
            }
            if (activeGoalsAnswer.length > 0) {
                goals = activeGoalsAnswer.join(", ");
                activeGoalsAnswer.forEach((priority)=>{
                    switch(priority){
                        case "Lose weight or tone up":
                            prioritiesNumbers.push("1");
                            break;
                        case "More energy":
                            prioritiesNumbers.push("2");
                            break;
                        case "Better immunity":
                            prioritiesNumbers.push("3");
                            break;
                        case "Better focus & memory":
                            prioritiesNumbers.push("4");
                            break;
                        case "Improve skin":
                            prioritiesNumbers.push("5");
                            break;
                        case "Better stress management & mental wellbeing":
                            prioritiesNumbers.push("6");
                            break;
                        case "Delay signs of aging":
                            prioritiesNumbers.push("7");
                            break;
                        case "Cardiovascular health":
                            prioritiesNumbers.push("8");
                            break;
                        case "Improve performance, endurance & recovery":
                            prioritiesNumbers.push("9");
                            break;
                        case "Healthier hair & nails":
                            prioritiesNumbers.push("10");
                            break;
                        case "Tackle excess hair":
                            prioritiesNumbers.push("11");
                            break;
                        case "Menstrual cycle health":
                            prioritiesNumbers.push("12");
                            break;
                        case "Reduce hot flashes & sweating":
                            prioritiesNumbers.push("13");
                            break;
                        case "Gut health & digestion":
                            prioritiesNumbers.push("14");
                            break;
                        case "Increase libido / sexual health":
                            prioritiesNumbers.push("15");
                            break;
                        case "Improve sleep quality":
                            prioritiesNumbers.push("16");
                            break;
                        case "Bone & joint health":
                            prioritiesNumbers.push("17");
                            break;
                        default:
                            break;
                    }
                });
            }
            resultsLink += `fe=${firstName}`;
            resultsLink += `&priority=${prioritiesNumbers.join(",")}`;
            resultsLink += `&ae=${age}`;
            resultsLink += `&ge=${gender}`;
            resultsLink += `&selectedDiets=${dietsNumbers.join(",")}`;
            resultsLink += `&na=${natalAnswers}`;
            resultsLink += `&flavour=${flavour}`;
            resultsLink += `&coating=${coating}`;
            resultsLink += `&handles=${handlesNumbers}`;
            resultsLink += `&quizID=${quizID}`;
            const responses = {
                "responses": [
                    {
                        "question": "Name",
                        "answers": `${firstName}`
                    },
                    {
                        "question": "Gender",
                        "answers": `${gender}`
                    },
                    {
                        "question": "Race",
                        "answers": `${race}`
                    },
                    {
                        "question": "Age",
                        "answers": `${age}`
                    },
                    {
                        "question": "Energy slider value:",
                        "answers": `${energySliderValue}`
                    },
                    {
                        "question": "Activity slider value:",
                        "answers": `${activitySliderValue}`
                    },
                    {
                        "question": "Sleep slider value:",
                        "answers": `${sleepSliderValue}`
                    },
                    {
                        "question": "Screen slider value:",
                        "answers": `${screenSliderValue}`
                    },
                    {
                        "question": "What exercise:",
                        "answers": `${exercise}`
                    },
                    {
                        "question": "Travel:",
                        "answers": `${travelAnswersIndex}`
                    },
                    {
                        "question": "Do you follow a specific diet?:",
                        "answers": `${specificDiet}`
                    },
                    {
                        "question": "Do you have any dietary requirements?:",
                        "answers": `${selectedDiets}`
                    },
                    {
                        "question": "Do you get hungry or have dips in energy between meals?",
                        "answers": `${hungryBetweenMeals}`
                    },
                    {
                        "question": "Processes food frequency:",
                        "answers": `${processedFoodAnswer}`
                    },
                    {
                        "question": "Fruit & Veg frequency:",
                        "answers": `${fruitVegAnswer}`
                    },
                    {
                        "question": "How often do you drink alcohol?:",
                        "answers": `${alcoholAnswersIndex}`
                    },
                    {
                        "question": "Do you currently take vitamins?:",
                        "answers": `${vitaminsAnswer}`
                    },
                    {
                        "question": "Wear glasses or contacts?",
                        "answers": `${glassesAnswer}`
                    },
                    {
                        "question": "Do you suffer from any of these health conditions?:",
                        "answers": `${healthConditions}`
                    },
                    {
                        "question": "Quality of life slider value:",
                        "answers": `${conditionsEffectSlider}`
                    },
                    {
                        "question": "How do you manage your conditions?:",
                        "answers": `${manageHealthConditions}`
                    },
                    {
                        "question": "Are you pre/post natal, currently pregnant or breast feeding?",
                        "answers": `${natal}`
                    },
                    {
                        "question": "User seleced vitamins:",
                        "answers": `${userSelectedVitamins}`
                    },
                    {
                        "question": "Which of the below are your top two priorities in the upcoming months?",
                        "answers": `${goals}`
                    },
                    {
                        "question": "Flavour",
                        "answers": `${flavour}`
                    },
                    {
                        "question": "Coating",
                        "answers": `${coating}`
                    },
                    {
                        "question": "Results",
                        "answers": `${handlesString}`
                    },
                    {
                        "question": "Results link",
                        "answers": `${resultsLink}`
                    },
                    {
                        "question": "Quiz ID",
                        "answers": `${quizID}`
                    }
                ]
            };
            const cusomerData = {
                email: email
            };
            let submittedPayload = [];
            submittedPayload.push(cusomerData, responses);
            if (email !== "") fetch($f85291adedab9e91$var$apiQuiz, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(submittedPayload)
            }).then(function(res) {
                resolve(res);
            }).catch(function(error) {
                reject(error);
            });
        });
    };
    const nextPage = (continueIndex)=>{
        let quizRoot = document.getElementById("root");
        quizRoot.scrollIntoView();
        switch(continueIndex){
            case "0":
                setPageIndex(pageIndex + 1);
                break;
            case "1":
                setPageIndex(pageIndex + 1); // Create a QuizID if they show intent on continuing
                setQuizID(Math.floor(Date.now() + Math.random() * 100));
                break;
            case "2":
                setPageIndex(pageIndex + 1);
                break;
            case "3":
                setPageIndex(pageIndex + 1);
                break;
            case "4":
                setPageIndex(pageIndex + 1);
                if (localStorage.getItem("selectedNourishments")) {
                    setSelectedVitamins(JSON.parse(localStorage.getItem("selectedNourishments")));
                    toastHandler("Imported your selected nourishments", 5000);
                    let userSelectedVitamins = JSON.parse(localStorage.getItem("selectedNourishments"));
                    if (natalAnswerIndex.length !== 0 && natalAnswerIndex[0] !== "No") userSelectedVitamins = userSelectedVitamins.filter((vitamin)=>vitamin.value !== "vitamin-a" && vitamin.value !== "5-htp");
                    setSelectedVitamins(userSelectedVitamins);
                }
                break;
            case "5":
                calculateWeights(weightingAnswers);
                break;
            default:
                break;
        }
    };
    const backPage = ()=>{
        let quizRoot = document.getElementById("root");
        quizRoot.scrollIntoView();
        if (pageIndex > 0) setPageIndex(pageIndex - 1);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement("div", {
        id: "coreQuiz",
        className: `kids-quiz kids-quiz--${pageIndex}`
    }, pageIndex > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $4a334272135d837d$export$2e2bcd8739ae039), {
        pageIndex: pageIndex,
        backPage: backPage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $e9734c229445255f$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $cdb09eb748d98e60$export$2e2bcd8739ae039), {
        key: pageIndex,
        in: true,
        appear: true,
        timeout: 1000,
        classNames: "slide"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).Fragment, null, {
        0: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $000917754bc643fd$export$2e2bcd8739ae039), {
            firstName: firstName,
            updateFirstName: updateFirstName,
            nextPage: nextPage
        }),
        1: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $4b6d6f9798ecf3a5$export$2e2bcd8739ae039), {
            renderGenderAnswers: renderGenderAnswers,
            gender: gender,
            onChangeNumber: onChangeNumber,
            checkAge: checkAge,
            age: age,
            ageWarningMessage: ageWarningMessage,
            renderRaceAnswers: renderRaceAnswers,
            race: race,
            nextPage: nextPage,
            suitableAge: suitableAge
        }),
        2: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $dadfc48128bd0ddd$export$2e2bcd8739ae039), {
            energySliderValue: energySliderValue,
            activitySliderValue: activitySliderValue,
            sleepSliderValue: sleepSliderValue,
            screenSliderValue: screenSliderValue,
            handleSlider: handleSlider,
            renderExerciseAnswers: renderExerciseAnswers,
            exerciseAnswersIndex: exerciseAnswersIndex,
            renderTravelAnswers: renderTravelAnswers,
            travelAnswersIndex: travelAnswersIndex,
            nextPage: nextPage
        }),
        3: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $7d3818c10c1fdaa8$export$2e2bcd8739ae039), {
            firstName: firstName,
            gender: gender,
            onSpecificDietClick: onSpecificDietClick,
            specificDiet: specificDiet,
            renderDietAnswers: renderDietAnswers,
            dietAnswersIndex: dietAnswersIndex,
            logHungryAnswer: logHungryAnswer,
            hungryBetweenMeals: hungryBetweenMeals,
            handleFoodRadios: handleFoodRadios,
            processedFoodAnswer: processedFoodAnswer,
            fruitVegAnswer: fruitVegAnswer,
            renderAlcoholAnswers: renderAlcoholAnswers,
            alcoholAnswersIndex: alcoholAnswersIndex,
            vitaminsAnswer: vitaminsAnswer,
            currentVitamins: currentVitamins,
            nextPage: nextPage
        }),
        4: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $01d17b32fe0e8a4e$export$2e2bcd8739ae039), {
            gender: gender,
            logGlassesAnswer: logGlassesAnswer,
            glassesAnswer: glassesAnswer,
            renderConditionsAnswers: renderConditionsAnswers,
            conditionsAnswerIndex: conditionsAnswerIndex,
            logIodineAnswer: logIodineAnswer,
            iodineAnswer: iodineAnswer,
            conditionsEffectSlider: conditionsEffectSlider,
            handleSlider: handleSlider,
            renderManageConditionsAnswers: renderManageConditionsAnswers,
            manageConditionsAnswerIndex: manageConditionsAnswerIndex,
            logMedicationAnswer: logMedicationAnswer,
            medicationAnswer: medicationAnswer,
            renderNatalAnswers: renderNatalAnswers,
            natalAnswerIndex: natalAnswerIndex,
            nextPage: nextPage
        }),
        5: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $40daaaf0c6bad90c$export$2e2bcd8739ae039), {
            updateQuestionUrl: updateQuestionUrl,
            natalAnswerIndex: natalAnswerIndex,
            medicationAnswer: medicationAnswer,
            selectedVitamins: selectedVitamins,
            setSelectedVitamins: setSelectedVitamins,
            selectFlavour: selectFlavour,
            flavour: flavour,
            selectCoating: selectCoating,
            coating: coating,
            renderGoalAnswers: renderGoalAnswers,
            activeGoalsAnswer: activeGoalsAnswer,
            setEmail: setEmail,
            email: email,
            consent: consent,
            setConsent: setConsent,
            nextPage: nextPage
        })
    }[pageIndex]))));
};
var $f85291adedab9e91$export$2e2bcd8739ae039 = $f85291adedab9e91$var$CoreQuiz;


(0, (/*@__PURE__*/$parcel$interopDefault($aa49bf5e460995f3$exports))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5zKJZ))).createElement((0, $f85291adedab9e91$export$2e2bcd8739ae039), null), document.querySelector("#root"));

})();
//# sourceMappingURL=core-quiz.js.map
